import { CreditCard } from './CreditCard';
import { RawCardData } from '../types/CardData';

export const EditedRawCreditCardData: Record<CreditCard, RawCardData> = {
  [CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD]: {
    id: CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD,
    name: 'Chase Freedom Unlimited\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H58Y&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/cash-back-credit-cards/freedom/unlimited?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56029.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/freedom_unlimited_card_alt.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on all purchases, plus additional cash back on dining, drugstores, and travel purchased through Chase Travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'drugstore',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 5.0,
        excludeMerchants: [
          'gift cards',
          'car rentals',
          'vehicle service centers',
          'miscellaneous fees',
          'other Lyft products and services',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Chase Freedom Unlimited\u00ae Credit Card offers unlimited 1.5% cash back on all purchases, with bonus rewards on dining, drugstores, and travel booked through Chase Travel.  There's no annual fee, and cash back rewards don't expire.",
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'travel_insurance',
        value: 6000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 bonus after you spend $500 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'chase_freedom_unlimited_credit_card.png',
  },
  [CreditCard.CHASE_FREEDOM_FLEX_CREDIT_CARD]: {
    id: CreditCard.CHASE_FREEDOM_FLEX_CREDIT_CARD,
    name: 'Chase Freedom Flex\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H58B&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/cash-back-credit-cards/freedom/flex?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56022.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/freedom_flex_card_alt.png',
    rewardsSummary:
      'Earn 5% cash back on up to $1,500 on combined purchases in bonus categories each quarter you activate, plus 5% on travel purchased through Chase Travel\u2120, 3% on dining and drugstores, and 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'amazon',
        earnRate: 5.0,
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'streaming',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'drugstore',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Chase Freedom Flex\u00ae Credit Card offers a $200 bonus after spending $500 in the first 3 months.  It earns 5% cash back on up to $1,500 in bonus categories each quarter you activate, plus 5% on Chase Travel, 3% on dining and drugstores, and 1% on all other purchases. There is no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Zero Liability Protection',
        description:
          "Means you won't be held responsible for unauthorized charges made with your card or account information.",
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          'Get up to $800 per claim and $1,000 per 12-month period in cell phone protection against covered theft or damage for cell phones listed on your monthly cell phone bill when you pay it with your eligible credit card. Maximum of 2 claims in a 12-month period with a $50 deductible per claim.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24/7 Fraud Monitoring',
        description:
          'We help safeguard your credit card purchases using sophisticated fraud monitoring. We monitor for fraud 24/7 and can text, email or call you if there are unusual purchases on your credit card.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 bonus after you spend $500 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'chase_freedom_flex_credit_card.png',
  },
  [CreditCard.CHASE_FREEDOM_RISE_CREDIT_CARD]: {
    id: CreditCard.CHASE_FREEDOM_RISE_CREDIT_CARD,
    name: 'Chase Freedom Rise\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HB5Y&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/cash-back-credit-cards/freedom/rise?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC57233.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/freedom_rise_alt_card2.png',
    rewardsSummary: 'Earn 1.5% cash back on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 3.5,
        excludeMerchants: [
          'gift cards',
          'car rentals',
          'vehicle service centers',
          'miscellaneous fees',
          'other Lyft products and services',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Start building credit while earning 1.5% cash back on all purchases.  Get a $25 statement credit after you set up automatic payments within the first three months of opening your account and remain enrolled for at least 90 days. There is no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Statement Credit',
        description:
          'Earn a $25 statement credit when you sign up for automatic payments within the first three months of opening your account and remain enrolled for at least 90 days.',
        benefit_type: 'statement_credit',
        value: 25.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Credit Limit Increase',
        description:
          "As a Freedom Rise cardmember, you'll be evaluated for a credit line increase in as soon as 6 months.",
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'travel_insurance',
        value: 6000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Complimentary 6 months of DashPass',
        description:
          'When the membership is activated for the first time between 02/01/2025 and 12/31/2027, your Chase Freedom Rise account will receive 6 months of complimentary DashPass for use on both the DoorDash and Caviar applications during the same membership period based on the first activation date.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Earn Up to $10 Off Quarterly on DoorDash Non-Restaurant Orders',
        description:
          'Once you have activated your Chase Freedom, Chase Freedom Unlimited, Chase Freedom Student, Chase Freedom Flex, or Chase Freedom Rise DashPass membership, you will receive a $10 off discount each calendar quarter at checkout on one qualifying non-restaurant order on Doordash as long as you remain enrolled in a DashPass membership.',
        benefit_type: 'statement_credit',
        value: 10.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'chase_freedom_rise_credit_card.png',
  },
  [CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD]: {
    id: CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD,
    name: 'Chase Sapphire Preferred\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HJHB&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/rewards-credit-cards/sapphire/preferred?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59299.html',
    bank_name: 'Chase',
    rewardsType: 'chase_ur',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/sapphire_preferred_card.png',
    rewardsSummary:
      'The Chase Sapphire Preferred card earns 5x points on travel purchased through Chase Ultimate Rewards, 3x points on dining and select streaming services, and 2x points on other travel purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'streaming',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Chase Sapphire Preferred\u00ae Credit Card offers premium dining and travel rewards, earning 5x points on travel purchased through Chase Travel, 3x on dining and select streaming services, and 2x on other travel purchases.  It also includes a $50 annual hotel credit and a 25% bonus when redeeming points for travel.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Hotel Credit',
        description:
          'Earn up to $50 in statement credits each account anniversary year for hotel stays purchased through Chase Travel.',
        benefit_type: 'travel_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '25% More Value on Travel Redemptions',
        description:
          'Get 25% more value when redeeming points for travel through Chase Travel.',
        benefit_type: 'travel_credit',
        value: 0.25,
        value_unit: 'percentage',
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus Points',
        description:
          "Each account anniversary you'll earn bonus points equal to 10% of your total purchases made the previous year.",
        benefit_type: 'anniversary_bonus',
        value: 0.1,
        value_unit: 'percentage',
        spend_requirement: null,
      },
      {
        name: 'Chase Pay Over Time\u00ae',
        description:
          'Eligible cardmembers can break up card purchases of $100 or more into fixed monthly payments with Chase Pay Over Time\u00ae. No interest, just a fixed monthly fee.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $10,000 per covered traveler and $20,000 per trip for your pre-paid, non-refundable travel expenses, including passenger fares, tours, and hotels.',
        benefit_type: 'travel_insurance',
        value: 20000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 5 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: 1.0,
        value_unit: 'year',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points after you spend $4,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'chase_sapphire_preferred_credit_card.png',
  },
  [CreditCard.CHASE_SAPPHIRE_RESERVE_CREDIT_CARD]: {
    id: CreditCard.CHASE_SAPPHIRE_RESERVE_CREDIT_CARD,
    name: 'Chase Sapphire Reserve\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HJH5&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/rewards-credit-cards/sapphire/reserve?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59298.html',
    bank_name: 'Chase',
    rewardsType: 'chase_ur',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/sapphire_reserve_card.png',
    rewardsSummary:
      'Earn 5x total points on flights and 10x total points on hotels and car rentals when you purchase travel through Chase Travel after the first $300 is spent on travel purchases annually.',
    rewardsEarnRates: [
      {
        category: 'travel.travelPortal',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: 300.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'travel.hotel',
        earnRate: 10.0,
        excludeMerchants: ['The Edit\u2122'],
        spendCap: 300.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 300.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 300.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Chase Sapphire Reserve\u00ae card offers 60,000 bonus points after you spend $4,000 in the first 3 months.  It earns 5x points on flights and 10x points on hotels and car rentals through Chase Travel, plus 3x on dining and other travel.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Travel Credit',
        description:
          'Receive up to $300 in statement credits as reimbursement for travel purchases charged to your card each account anniversary year.',
        benefit_type: 'travel_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Airport Lounge Access',
        description:
          'Complimentary access to 1,300+ airport lounges worldwide with up to two guests, plus every Chase Sapphire Lounge by The Club location, after an easy one-time enrollment in Priority Pass\u2122 Select.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae or NEXUS Fee Credit',
        description:
          'Receive one statement credit of up to $120 every four years as reimbursement for the application fee charged to your card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary and provides reimbursement up to $75,000 for theft and collision damage for most rental vehicles in the U.S. and abroad.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 75000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $10,000 per covered traveler and $20,000 per trip for your pre-paid, non-refundable travel expenses, including passenger fares, tours, and hotels.',
        benefit_type: 'trip_cancellation_protection',
        value: 20000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 6 hours (for Infinite) or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'When you pay for your air, bus, train or cruise transportation with your card, you are eligible to receive up to $1,000,000 in accidental death or dismemberment coverage.',
        benefit_type: 'travel_insurance',
        value: 1000000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 5 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Emergency Evacuation and Transportation',
        description:
          'If you or a covered traveler are injured or become sick during a trip 100 miles or more from home that results in an emergency evacuation, you can be covered for medical services and transportation up to $100,000.',
        benefit_type: 'travel_insurance',
        value: 100000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          "If you have a roadside emergency, you can call for a tow, battery assistance, tire change, locksmith or gas. You're covered up to $50 per incident 4 times a year.",
        benefit_type: 'travel_insurance',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Emergency Medical and Dental',
        description:
          "If you or an immediate family member become sick or injured while you're 100 miles or more from home on a trip, you can be reimbursed up to $2,500 for medical expenses, subject to a $50 deductible.",
        benefit_type: 'travel_insurance',
        value: 2500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Return Protection',
        description:
          "You can be reimbursed for eligible items that the store won't accept within 90 days of purchase, up to $500 per item, $1,000 per 12-month period.",
        benefit_type: 'return_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'DashPass',
        description:
          'Get complimentary access to DashPass - a membership for both DoorDash and Caviar - which unlocks $0 delivery fees and lower service fees on eligible orders for a minimum of one year when you activate by Dec 31, 2027.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points after you spend $4,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'chase_sapphire_reserve_credit_card.png',
  },
  [CreditCard.SLATE_EDGE_CREDIT_CARD]: {
    id: CreditCard.SLATE_EDGE_CREDIT_CARD,
    name: 'Slate Edge\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H5BR&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/balance-transfer-credit-cards/slate/edge?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56053.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/slate_edge_card_alt.png',
    rewardsSummary:
      'This card offers a low introductory APR for 18 months on purchases and balance transfers, and the potential for a 2% APR reduction each year.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The Chase Slate Edge credit card offers an 18-month 0% intro APR on purchases and balance transfers, a $0 annual fee, and the possibility of a 2% APR reduction each year with on-time payments and $1,000 in spending.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability Protection',
        description:
          "Zero Liability Protection means you won't be held responsible for unauthorized charges made with your card or account information. If you see an unauthorized charge, simply call the number on the back of your card.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'If you have a roadside emergency, call the service provider to dispatch the help you need. Roadside service fees will be billed to your card at time of dispatch.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Credit Limit Increase',
        description:
          'Special welcome offer: Get an automatic review for a higher credit limit when you pay on time and spend $500 in your first six months.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: 500,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'slate_edge_credit_card.png',
  },
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD]: {
    id: CreditCard.SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD,
    name: 'Southwest Rapid Rewards\u00ae Plus Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H72Q&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/southwest/plus?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56419.html',
    bank_name: 'Chase',
    rewardsType: 'southwest',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_plus_card-1.png',
    rewardsSummary:
      'Earn 2X points on Southwest purchases and 1X points on all other purchases, plus a 50,000-point bonus after spending $1,000 in the first 3 months.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.southwest',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Southwest Rapid Rewards Plus Credit Card earns 2X points on Southwest purchases and 1X points on all other purchases.  It offers a 50,000-point bonus after spending $1,000 in the first 3 months and 3,000 anniversary points each year.',
    cardNetwork: 'Visa',
    issuer: 'Chase',
    selectableCategories: [],
    benefits: [
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'anniversary_bonus',
        description: '3,000 points every year on your Cardmember anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 3000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'airline_inflight_purchase_discount',
        description: '25% back on inflight purchases.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 0.25,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Companion Pass Qualifying Points Boost',
        description: '10,000 Companion Pass qualifying points boost each year.',
        benefit_type: 'anniversary_bonus',
        value: 10000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'points',
        description:
          'Earn 50,000 bonus points after you spend $1,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'southwest_rapid_rewards_plus_credit_card.png',
  },
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PRIORITY__CREDIT_CARD]: {
    id: CreditCard.SOUTHWEST_RAPID_REWARDS_PRIORITY__CREDIT_CARD,
    name: 'Southwest Rapid Rewards\u00ae Priority Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H6XY&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/southwest/priority?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56407.html',
    bank_name: 'Chase',
    rewardsType: 'southwest',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_priority_card-2.png',
    rewardsSummary:
      'Earn 3X points on Southwest purchases, 2X points on Rapid Rewards\u00ae hotel and car rental partners, local transit and commuting, and select streaming, and 1X point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.southwest',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.rideshare',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 50,000 bonus points after you spend $1,000 on purchases in the first 3 months from account opening.  Receive a $75 annual Southwest\u00ae travel credit and 7,500 anniversary points each year. Plus, earn 3X points on Southwest purchases.',
    cardNetwork: 'Visa',
    issuer: 'Chase',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Travel Credit',
        description: 'Receive a $75 annual Southwest\u00ae travel credit.',
        benefit_type: 'travel_credit',
        value: 75.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus',
        description: 'Receive 7,500 anniversary points each year.',
        benefit_type: 'anniversary_bonus',
        value: 7500.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'Airline Priority Boarding',
        description: '4 Upgraded Boardings per year when available.',
        benefit_type: 'airline_priority_boarding',
        value: 4,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Airline Inflight Purchase Discount',
        description: '25% back on inflight purchases.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 25.0,
        value_unit: 'percent',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000.0,
        bonusValueUnit: 'points',
        description:
          'Earn 50,000 bonus points after you spend $1,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'southwest_rapid_rewards_priority__credit_card.png',
  },
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD]: {
    id: CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD,
    name: 'Southwest Rapid Rewards\u00ae Premier Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H6YW&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/southwest/premier?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56414.html',
    bank_name: 'Chase',
    rewardsType: 'southwest',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_premier_card.png',
    rewardsSummary:
      'Earn 3X points on Southwest purchases, 2X points on Rapid Rewards\u00ae hotel and car rental partners, local transit and commuting, and select streaming, and 1X point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.southwest',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 50,000 bonus points after you spend $1,000 on purchases in the first 3 months from account opening. Plus, earn 3X points on Southwest\u00ae purchases and 1X points on all other purchases.  Enjoy all the benefits of flying Southwest, including bags fly free\u00ae and no change fees.',
    cardNetwork: 'Visa',
    issuer: 'Chase',
    selectableCategories: [],
    benefits: [
      {
        name: 'Anniversary Bonus',
        description:
          'Receive 6,000 bonus points each account anniversary year.',
        benefit_type: 'anniversary_bonus',
        value: 6000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'EarlyBird Check-In\u00ae',
        description: 'Receive 2 EarlyBird Check-In\u00ae each year.',
        benefit_type: 'airline_priority_boarding',
        value: 2,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Unlimited Tier Qualifying Points (TQPs)',
        description:
          'Earn 1,500 TQPs toward A-List status for every $5,000 you spend.',
        benefit_type: 'airline_status',
        value: 1500.0,
        value_unit: 'TQPs',
        spend_requirement: 5000.0,
      },
      {
        name: 'Inflight Purchase Discount',
        description: 'Receive 25% back on inflight purchases.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 0.25,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Companion Pass\u00ae Qualifying Points Boost',
        description:
          'Earn 10,000 Companion Pass\u00ae qualifying points boost each year.',
        benefit_type: 'anniversary_bonus',
        value: 10000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000.0,
        bonusValueUnit: 'points',
        description:
          'Earn 50,000 bonus points after you spend $1,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'southwest_rapid_rewards_premier_credit_card.png',
  },
  [CreditCard.UNITEDU00SMS_EXPLORER_CARD]: {
    id: CreditCard.UNITEDU00SMS_EXPLORER_CARD,
    name: 'United\u2120 Explorer Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HBVG&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/united/united-explorer?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC57432.html',
    bank_name: 'Chase',
    rewardsType: 'united',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_explorer_card.png',
    rewardsSummary:
      'Earn 2x miles on United purchases, dining, and hotels, plus 1x mile on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.united',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
    ],
    creditScore: null,
    cardSummary:
      'The United Explorer Card earns 2x miles on United purchases, dining, and hotels, and 1x mile on all other purchases.  It also offers a free first checked bag, priority boarding, and two United Club passes per year.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free first checked bag',
        description:
          'The primary Cardmember and one companion can each check a first standard bag for free.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Priority boarding',
        description:
          'The primary Cardmember and companions on the same reservation will be invited to board United-operated flights prior to general boarding.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '2 United Club one-time passes per year',
        description:
          'Relax in comfort while waiting for your flight with complimentary beverages, snacks, high-speed Wi-Fi and more.',
        benefit_type: 'lounge_access',
        value: 2.0,
        value_unit: 'passes',
        spend_requirement: null,
      },
      {
        name: 'Up to $120 Global Entry, TSA PreCheck\u00ae, or NEXUS fee credit',
        description:
          'Receive a statement credit of up to $120 every 4 years as reimbursement for the application fee for Global Entry, TSA PreCheck\u00ae, or NEXUS when charged to your card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '25% back on United inflight and Club premium drink purchases',
        description:
          "You'll get 25% back as a statement credit on purchases of food, beverages and Wi-Fi on board United-operated flights and on Club premium drinks when you pay with your Explorer Card.",
        benefit_type: 'statement_credit',
        value: 0.25,
        value_unit: 'percent',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Earn 50,000 bonus miles after you spend $3,000 on purchases in the first 3 months your account is open. Plus, earn 5,000 bonus miles after you add an authorized user to your account in the first 3 months your account is open.',
      },
    ],
    cardType: 'personal',
    imageName: 'unitedu00sms_explorer_card.png',
  },
  [CreditCard.UNITED_QUESTU00SMS_CARD]: {
    id: CreditCard.UNITED_QUESTU00SMS_CARD,
    name: 'United Quest\u2120 Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HBJD&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/united/united-quest?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC57317.html',
    bank_name: 'Chase',
    rewardsType: 'united',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_quest_card.png',
    rewardsSummary:
      'Earn 3x miles on United purchases and 2x miles on all other travel.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.united',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: ['travel.airline.united'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'streaming',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
    ],
    creditScore: null,
    cardSummary:
      'The United Quest Card offers 60,000 bonus miles after $4,000 in purchases in the first 3 months, plus a $125 annual United purchase credit, free checked bags, and priority boarding.  Earn 3x miles on United purchases and 2x miles on all other travel.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: '$125 annual United purchase credit',
        description:
          'Receive up to $125 in statement credits each account anniversary year as reimbursement for United purchases charged to your United Quest Card.',
        benefit_type: 'travel_credit',
        value: 125.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Up to 10,000 miles in award flight credits each year',
        description:
          "Starting with your first anniversary, you'll get 5,000 miles back in your MileagePlus\u00ae account after you take a United\u00ae or United Express-operated award flight booked with your miles - up to 2 times every anniversary year.",
        benefit_type: 'anniversary_bonus',
        value: 10000.0,
        value_unit: 'miles',
        spend_requirement: null,
      },
      {
        name: 'Free first and second checked bags',
        description:
          'The primary Cardmember and one companion can each check a first and second standard bags for free - save up to $360 per roundtrip.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Priority boarding',
        description:
          'The primary Cardmember and companions traveling on the same reservation are eligible for priority boarding.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae or NEXUS Application Fee Statement Credit',
        description:
          'You will receive one statement credit every four years (up to $120) after the first program (either Global Entry or TSA PreCheck\u00ae or NEXUS) application fee is charged to your United Quest\u2120 Card, by you or an authorized user.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '25% back on United inflight and Club premium drink purchases',
        description:
          "You'll get 25% back as a statement credit on purchases of food, beverages and Wi-Fi on board United-operated flights and on Club premium drinks when you pay with your Quest Card.",
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Premier upgrades on award tickets',
        description:
          'The primary Cardmember who has MileagePlus\u00ae Premier\u00ae status and is traveling on an award ticket and one companion that is traveling on the same reservation are eligible for Complimentary Premier Upgrades on select United- and United Express-operated flights, subject to availability.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'Purchases made with your Quest Card outside the U.S. will not be subject to foreign transaction fees.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Renowned Hotels and Resorts for United\u00ae Cardmembers',
        description:
          'Experience an exclusive suite of benefits including a $100 property credit, daily breakfast for two, complimentary Wi-Fi, and a room upgrade and early check-in/late check-out, if available, when you book through Renowned Hotels and Resorts for United\u00ae Cardmembers.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'travel_insurance',
        value: 6000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature Concierge Service 24 hours a day.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'miles',
        description:
          'Earn 60,000 bonus miles after you spend $4,000 on purchases in the first 3 months your account is open. Plus, earn 5,000 bonus miles after you add an authorized user to your account in the first 3 months your account is open.',
      },
    ],
    cardType: 'personal',
    imageName: 'united_questu00sms_card.png',
  },
  [CreditCard.UNITED_GATEWAYU00SMS_CREDIT_CARD]: {
    id: CreditCard.UNITED_GATEWAYU00SMS_CREDIT_CARD,
    name: 'United Gateway\u2120 Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HBHR&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/united/united-gateway?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC57315.html',
    bank_name: 'Chase',
    rewardsType: 'united',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_gateway_card.png',
    rewardsSummary:
      'Earn 20,000 bonus miles after you spend $1,000 on purchases in the first 3 months from account opening, plus 2x miles on United purchases and 25% back on United inflight and Club premium drink purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.united',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 20,000 bonus miles after qualifying purchases.  Plus, earn 2x miles on United purchases, at gas stations and on local transit and commuting, and 25% back on United inflight and Club premium drink purchases; no foreign transaction fees.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: '25% back on United inflight and Club premium drink purchases',
        description:
          "You'll get 25% back as a statement credit on purchases of food, beverages and Wi-Fi on board United-operated flights and on Club premium drinks when you pay with your Gateway Card.",
        benefit_type: 'statement_credit',
        value: 0.25,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'Purchases made with your Gateway Card outside the U.S. will not be subject to foreign transaction fees.',
        benefit_type: 'no_foreign_transaction_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'United Card Events from Chase and United MileagePlus Exclusive Events',
        description:
          "Pursue more of your passions with United Card Events from Chase. As a Cardmember, you will be delighted with opportunities to purchase private, curated once-in-a-lifetime experiences. Sample select wines and satisfy your palate with culinary events at some of the world's best restaurants, meet a sporting legend or make memories with your family.  Through MileagePlus Exclusives, Cardmembers can use their miles to enjoy unique opportunities, such as exclusive multi-course dinners, sporting events, concerts, and behind-the-scenes experiences in United's operations facilities.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'trip_cancellation_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature\u00ae Concierge Service 24 hours a day. Find tickets to the top sports and entertainment events, make dinner reservations and even get help sending the perfect gift.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'miles',
        description:
          'Earn 20,000 bonus miles after you spend $1,000 on purchases in the first 3 months your account is open. Plus, earn 5,000 bonus miles after you add an authorized user to your account in the first 3 months your account is open.',
      },
    ],
    cardType: 'personal',
    imageName: 'united_gatewayu00sms_credit_card.png',
  },
  [CreditCard.UNITED_CLUBU00SMS_INFINITE_CARD]: {
    id: CreditCard.UNITED_CLUBU00SMS_INFINITE_CARD,
    name: 'United Club\u2120 Infinite Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HBV4&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/united/club-infinite?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC57430.html',
    bank_name: 'Chase',
    rewardsType: 'united',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_club_infinite_card.png',
    rewardsSummary:
      'Earn 80,000 bonus miles after you spend $5,000 on purchases in the first 3 months from account opening, plus earn 4x miles on United purchases and 2x miles on other travel and dining.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.united',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 80,000 bonus miles after you spend $5,000 on purchases in the first 3 months from account opening.  Enjoy United Club\u2120 membership and 2 free checked bags. Plus, earn rewards faster with 4x miles on United purchases, and 2x miles on dining and all other travel.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'United Club\u2120 Membership',
        description:
          'Enjoy access to United Club locations and participating Star Alliance\u2122 affiliated lounges worldwide.',
        benefit_type: 'lounge_access',
        value: 650.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Free Checked Bags',
        description:
          'The primary Cardmember and one companion can each check a first and second standard bags for free.',
        benefit_type: 'baggage_fee_credit',
        value: 360.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Global Entry, TSA PreCheck\u00ae, or NEXUS Application Fee Credit',
        description:
          'Receive a statement credit of up to $120 every 4 years as reimbursement for the application fee for Global Entry, TSA PreCheck\u00ae, or NEXUS when charged to your card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '25% Back on United Inflight and Club Premium Drink Purchases',
        description:
          "You'll get 25% back as a statement credit on purchases of food, beverages and Wi-Fi on board United-operated flights and on Club premium drinks when you pay with your United Club\u2120 Infinite Card.",
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $10,000 per covered traveler and $20,000 per trip for your pre-paid, non-refundable travel expenses.',
        benefit_type: 'travel_insurance',
        value: 20000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Visa Infinite\u00ae Concierge Services',
        description:
          'Enjoy 24/7 personalized assistance for travel planning, dinner reservations, sports, entertainment tickets and more.',
        benefit_type: 'concierge_service',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Return Protection',
        description:
          "You can be reimbursed for eligible items that the store won't accept within 90 days of purchase, up to $500 per item, $1,000 per 12-month period.",
        benefit_type: 'return_protection',
        value: 1000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 80000,
        bonusValueUnit: 'miles',
        description:
          'Earn 80,000 bonus miles after you spend $5,000 on purchases in the first 3 months from account opening. Plus, earn 5,000 bonus miles after you add an authorized user to your account in the first 3 months your account is open.',
      },
    ],
    cardType: 'personal',
    imageName: 'united_clubu00sms_infinite_card.png',
  },
  [CreditCard.MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD]: {
    id: CreditCard.MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD,
    name: 'Marriott Bonvoy Boundless\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HN4F&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/marriott-bonvoy/boundless?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60502.html',
    bank_name: 'Chase',
    rewardsType: 'marriott_bonvoy',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/marriott_bonvoy_boundless_card.png',
    rewardsSummary:
      'Earn Marriott Bonvoy points on every purchase, with bonus points on purchases at Marriott hotels and other select categories.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.marriott',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Marriott Bonvoy Boundless\u00ae Credit Card offers a $150 statement credit and 100,000 bonus points after meeting spending requirements.  Earn up to 17x total points on Marriott Bonvoy purchases and enjoy an annual free night award.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Free Night Award',
        description:
          'Enjoy a Free Night Award every year after your account anniversary, valid for a one night hotel stay at a property with a redemption level up to 35,000 points.',
        benefit_type: 'free_hotel_night',
        value: 35000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'Silver Elite Status',
        description:
          'Receive Silver Elite Status each calendar year as a cardmember.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 5 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'trip_cancellation_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature\u00ae Concierge Service 24 hours a day.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 100000,
        bonusValueUnit: 'points',
        description:
          'Earn a $150 statement credit after you make your first purchase in your first 12 months from account opening, plus earn 100,000 Bonus Points after you spend $3,000 on purchases in your first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'marriott_bonvoy_boundless_credit_card.png',
  },
  [CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD]: {
    id: CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD,
    name: 'Marriott Bonvoy Bountiful\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H8GS&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/marriott-bonvoy/bountiful?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56782.html',
    bank_name: 'Chase',
    rewardsType: 'marriott_bonvoy',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/marriott_bonvoy_bountiful_card.png',
    rewardsSummary:
      'Earn Marriott Bonvoy points on purchases, with bonus rates at Marriott Bonvoy hotels and on grocery stores and dining.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.marriott',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'grocery',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 15000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 15000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Marriott Bonvoy Bountiful\u00ae Credit Card offers 85,000 bonus points after spending $4,000 in the first 3 months.  Earn up to 18.5X total points per $1 spent at Marriott Bonvoy hotels and 4X points on grocery stores and dining.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: '15 Elite Night Credits',
        description: 'Receive 15 Elite Night Credits each calendar year.',
        benefit_type: 'hotel_status',
        value: 15.0,
        value_unit: 'night credits',
        spend_requirement: null,
      },
      {
        name: 'Automatic Gold Elite Status',
        description:
          'You will automatically receive Gold Elite Status each calendar year as a cardmember.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You will pay no foreign transaction fees when you use your card for purchases made outside the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 5 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'trip_cancellation_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature\u00ae Concierge Service 24 hours a day.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Night Award',
        description:
          "As a Marriott Bonvoy Bountiful\u00ae Cardmember, you'll enjoy a Free Night Award every calendar year, after $15,000 in spend, valid for a one night hotel stay at a property with a redemption level of up to 50,000 points.",
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: 15000.0,
      },
      {
        name: '1000 Bonus Points per Eligible Stay',
        description:
          'Earn 1,000 Bonus Points per eligible stay at hotels participating in Marriott Bonvoy\u00ae.',
        benefit_type: 'anniversary_bonus',
        value: 1000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 85000,
        bonusValueUnit: 'points',
        description:
          'Earn 85,000 bonus points after you spend $4,000 in purchases in your first 3 months from your account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'marriott_bonvoy_bountiful_credit_card.png',
  },
  [CreditCard.MARRIOTT_BONVOY_BOLD_CREDIT_CARD]: {
    id: CreditCard.MARRIOTT_BONVOY_BOLD_CREDIT_CARD,
    name: 'Marriott Bonvoy Bold\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HJ76&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/marriott-bonvoy/bold?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59202.html',
    bank_name: 'Chase',
    rewardsType: 'marriott_bonvoy',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/marriott-bonvoy-bold-card.png',
    rewardsSummary:
      'Earn Marriott Bonvoy points on every purchase and up to 14X total points per $1 spent at hotels participating in Marriott Bonvoy.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.marriott',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'travel.rideshare',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'takeoutDelivery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 60,000 bonus points + 1 Free Night Award after you spend $2,000 on purchases in the first 3 months from account opening.  Enjoy unlimited Marriott Bonvoy points and get free stays faster with up to 14X total points per $1 spent at hotels participating in Marriott Bonvoy.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 5 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'trip_cancellation_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature\u00ae Concierge Service 24 hours a day. Find tickets to the top sports and entertainment events, make dinner reservations and even get help sending the perfect gift.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Automatic Silver Elite Status',
        description:
          'Enjoy Automatic Silver Elite Status with Marriott Bonvoy\u00ae that renews each calendar year with benefits like Priority Late Checkout (where available) & 10% More Points on Stays at hotels participating in Marriott Bonvoy.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Marriott Bonvoy Credit Card from Chase Elite Night Credits',
        description:
          '5 Elite Night Credits (\u201cENC\u201d) will be deposited into your Marriott Bonvoy\u00ae Member Account within 60 days upon opening your Marriott Bonvoy Credit Card from Chase\u00ae. If you have already received the annual Elite Night Credits (\u201cAnnual ENC\u201d) benefit associated with a Marriott Bonvoy consumer card, regardless of bank issuer, you will only receive a deposit equal to the difference between the Annual ENC benefits to total the number of ENCs associated with the card that offers the highest number of ENCs, if applicable. On or before March 1 of each subsequent calendar year, the Annual ENC benefit will be deposited into your Marriott Bonvoy Member Account operated by Marriott International, Inc., in accordance with Marriott Bonvoy terms and conditions. To be eligible to receive the 5 ENCs associated with the Annual ENC benefit from your Marriott Bonvoy Credit Card from Chase you must be the Primary Cardmember, your Card Account must be open at the time of the deposit, and you must have an active Marriott Bonvoy Member Account linked to your Card account. This benefit is not exclusive to Cards offered by Chase. You can only receive the Annual ENC benefit associated with one eligible Marriott Bonvoy consumer card per year, regardless of the number of Marriott Bonvoy cards that are linked with a Marriott Bonvoy Member Account and regardless of bank issuer. If your Marriott Bonvoy Member Account is linked to more than one open Marriott Bonvoy consumer card that offers the Annual ENC benefit, you will only receive the Annual ENC benefit associated with the card that offers the highest number of ENCs. If you have both an open Marriott Bonvoy consumer card account and an open Marriott Bonvoy business card account that each offer the Annual ENC benefit, then you will receive an Annual ENC benefit for each, for a total of two Annual ENC benefits per Marriott Bonvoy Member Account per year. If you have more than one Marriott Bonvoy Member Account that has received the Annual ENC benefit and you merge accounts, you will retain only the ENCs associated with one eligible Marriott Bonvoy consumer card that offers the highest number of ENCs as a benefit; and, if applicable, the ENCs from one eligible Marriott Bonvoy business card that offers the highest number of ENCs as a benefit. Separate promotional offers of ENCs will not count toward the per-Account maximum but may have their own limits; see promotional terms at time of offer. Chase is not responsible for offer fulfillment or the provision of or failure to provide the stated benefits and services.',
        benefit_type: 'free_hotel_night',
        value: 5.0,
        value_unit: 'nights',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 2000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points + 1 Free Night Award after you spend $2,000 on purchases in the first 3 months from account opening. Free Night Award valued up to 50,000 points.',
      },
    ],
    cardType: 'personal',
    imageName: 'marriott_bonvoy_bold_credit_card.png',
  },
  [CreditCard.IHG_ONE_REWARDS_PREMIER_CREDIT_CARD]: {
    id: CreditCard.IHG_ONE_REWARDS_PREMIER_CREDIT_CARD,
    name: 'IHG One Rewards Premier Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HMSL&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/ihg-rewards-club/premier?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60417.html',
    bank_name: 'Chase',
    rewardsType: 'ihg',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ihg_premier_card.png',
    rewardsSummary:
      'Earn up to 26X total points per $1 spent when you stay at IHG\u00ae Hotels and Resorts, 5X points on gas and dining, and 3X points on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.ihg',
        earnRate: 26.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'dining',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'allPurchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 170,000 bonus points after you spend $4,000 on purchases in the first 3 months from account opening.  Enjoy up to 26X total points per $1 spent at IHG\u00ae Hotels and Resorts, plus 5X on travel, dining, and at gas stations.',
    cardNetwork: 'Mastercard',
    issuer: 'Chase',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic Platinum Elite Status',
        description:
          'Automatic Platinum Elite Status as long as you remain an IHG One Rewards Premier Cardmember.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary Free Night',
        description:
          'Earned each account anniversary year with a current point redemption cap of 40,000 points.',
        benefit_type: 'free_hotel_night',
        value: 40000,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: '$100 Statement Credit',
        description:
          'Earn a $100 statement credit and 10,000 bonus points after spending $20,000 each calendar year.',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: 20000.0,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $5,000 per covered traveler and $10,000 per trip for your pre-paid, non-refundable travel expenses, including passenger fares, tours, and hotels.',
        benefit_type: 'trip_cancellation_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Entry, TSA PreCheck\u00ae, or NEXUS Statement Credit',
        description:
          'Receive a statement credit of up to $120 every four years as reimbursement for the application fee for Global Entry, TSA PreCheck or NEXUS when charged to your card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 170000,
        bonusValueUnit: 'points',
        description:
          'Earn 170,000 bonus points after you spend $4,000 on purchases in the first 3 months from account opening. This product is not available to either (i) current cardmembers of any personal IHG One Rewards Credit card, or (ii) previous cardmembers of any personal IHG One Rewards Credit Card who received a new cardmember bonus for any personal IHG One Rewards Credit Card within the last 24 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'ihg_one_rewards_premier_credit_card.png',
  },
  [CreditCard.IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD]: {
    id: CreditCard.IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD,
    name: 'IHG One Rewards Traveler Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HMHW&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/ihg-rewards-club/traveler?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60354.html',
    bank_name: 'Chase',
    rewardsType: 'ihg',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/IHG_One_Traveler_card.png',
    rewardsSummary:
      'This card earns IHG One Rewards points on every purchase, with bonus points earned on dining, utilities, select streaming services, and at gas stations.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.ihg',
        earnRate: 17.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
    ],
    creditScore: null,
    cardSummary:
      'The IHG One Rewards Traveler Credit Card offers 100,000 bonus points after spending $2,000 in the first 3 months.  It earns up to 17X total points at IHG Hotels and Resorts and 3X points on gas and dining.  There is no annual fee.',
    cardNetwork: 'Mastercard',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic Silver Elite Status',
        description:
          'Automatic Silver Elite Status as long as you remain an IHG One Rewards Traveler Cardmember.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem 3 nights, get 4th night free',
        description:
          'When you redeem points for a consecutive four-night IHG\u00ae hotel stay, you can receive a fourth Reward Night free redeemable at that same hotel during that same stay.',
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $5,000 per covered traveler and $10,000 per trip for your pre-paid, non-refundable travel expenses,including passenger fares, tours, and hotels.',
        benefit_type: 'trip_cancellation_protection',
        value: 5000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'You will pay no foreign transaction fees when you use your card for purchases made outside the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Chase Pay Over Time',
        description:
          'Chase Pay Over Time lets eligible Chase customers break up credit card purchases into budget friendly payments.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Gold Elite Status',
        description:
          'Each calendar year you make purchases totaling $20,000 or more, you, as the primary cardmember, will qualify for Gold Elite Status through December 31st of the following year.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: 20000.0,
      },
      {
        name: 'Save 20% on Rewards Points Purchases',
        description:
          'Save 20% when you purchase points with your IHG One Rewards Traveler credit card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Early Access to IHG Reward Night Sales',
        description:
          'As an IHG One Rewards Cardmember, you are eligible for early access to Reward Night sales each year.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '10,000 bonus points each calendar year',
        description:
          "You'll receive 10,000 bonus points each calendar year during which you spend at least $10,000 in purchases.",
        benefit_type: 'anniversary_bonus',
        value: 10000.0,
        value_unit: 'points',
        spend_requirement: 10000.0,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 2000.0,
        spendRequirementMonths: 3,
        bonusValue: 100000.0,
        bonusValueUnit: 'points',
        description:
          'Earn 100,000 bonus points after you spend $2,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'ihg_one_rewards_traveler_credit_card.png',
  },
  [CreditCard.DISNEY_PREMIER_VISA_CARD]: {
    id: CreditCard.DISNEY_PREMIER_VISA_CARD,
    name: 'Disney\u00ae Premier Visa\u00ae Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HKB9&action=guest#/origination/cardDetails/index/index;cellCode=626980;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/rewards-credit-cards/disney/premier?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59614.html',
    bank_name: 'Chase',
    rewardsType: 'disney_rewards_dollars',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/disney.png',
    rewardsSummary:
      'Earn 5% in Disney Rewards Dollars on purchases at Disney+, Hulu, or ESPN+, 2% at gas stations, grocery stores, restaurants, and most Disney U.S. locations, and 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'disneyplus.com, hulu.com, espnplus.com',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'disney_rewards_dollars',
      },
      {
        category:
          'gas stations, grocery stores, restaurants, most Disney U.S. locations',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'disney_rewards_dollars',
      },
      {
        category: 'all other purchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'disney_rewards_dollars',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Disney Premier Visa Card offers a $300 statement credit after spending $1,000 in the first 3 months.  Earn 5% in Disney Rewards Dollars on select Disney purchases, 2% on other categories, and 1% on all other purchases. Redeem Rewards Dollars for Disney experiences.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: '$300 Statement Credit',
        description:
          'after you spend $1,000 on purchases in the first 3 months from account opening.',
        benefit_type: 'statement_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: '$1,000',
      },
      {
        name: 'Disney Card Designs',
        description:
          'Choose from more than a dozen designs celebrating Disney storytelling.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Special Disney Vacation Financing',
        description:
          'Enjoy 0% promotional APR for 6 months on select Disney vacation packages from the date of purchase, after that a variable APR of 18.24%-27.24%.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '10% savings everyday on shopping with the Disney Premier Visa Card',
        description:
          'Save 10% on select purchases at DisneyStore.com and at select locations at the Disneyland\u00ae Resort and Walt Disney World\u00ae Resort when you use your Disney Premier Visa Card.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$1,000',
        spendRequirementMonths: 3,
        bonusValue: 300.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $300 statement credit after you spend $1,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'disney_premier_visa_card.png',
  },
  [CreditCard.DISNEY_VISA_CARD]: {
    id: CreditCard.DISNEY_VISA_CARD,
    name: 'Disney\u00ae Visa\u00ae Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HK9Y&action=guest#/origination/cardDetails/index/index;cellCode=626980;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/rewards-credit-cards/disney/rewards?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59613.html',
    bank_name: 'Chase',
    rewardsType: 'disney_rewards_dollars',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/disney_visacard.png',
    rewardsSummary:
      'Earn 1% in Disney Rewards Dollars on all purchases, redeemable at most Disney U.S. locations.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'disney_rewards_dollars',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Disney Visa Card from Chase offers a $150 statement credit after spending $500 in the first 3 months.  Earn 1% back in Disney Rewards Dollars on all purchases and enjoy special vacation financing and shopping savings.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: '$150 Statement Credit',
        description:
          'after you spend $500 on purchases in the first 3 months from account opening.',
        benefit_type: 'statement_credit',
        value: 150.0,
        value_unit: 'dollars',
        spend_requirement: '$500',
      },
      {
        name: 'Special Disney Vacation Financing',
        description:
          'Enjoy 0% promotional APR for 6 months on select Disney vacation packages from the date of purchase, after that a variable APR of 18.24%\u201327.24%.',
        benefit_type: 'financing',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '10% savings everyday on shopping with the Disney Visa Card',
        description:
          'Save 10% on select purchases at DisneyStore.com and receive 10% off select merchandise purchases at select locations at the Disneyland\u00ae Resort and Walt Disney World\u00ae Resort when you use your Disney Visa Card.',
        benefit_type: 'discount',
        value: 10.0,
        value_unit: 'percent',
        spend_requirement: null,
      },
      {
        name: '1% in Disney Rewards Dollars',
        description:
          'Earn 1% in Disney Rewards Dollars on all your card purchases with no limits to the amount you can earn.',
        benefit_type: 'rewards',
        value: 1.0,
        value_unit: 'percent',
        spend_requirement: null,
      },
      {
        name: 'No annual fee',
        description: null,
        benefit_type: 'no_annual_fee',
        value: 0.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$500',
        spendRequirementMonths: 3,
        bonusValue: 150.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $150 statement credit after you spend $500 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'disney_visa_card.png',
  },
  [CreditCard.WORLD_OF_HYATT_CREDIT_CARD]: {
    id: CreditCard.WORLD_OF_HYATT_CREDIT_CARD,
    name: 'World of Hyatt Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HMPR&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/world-of-hyatt-credit-card?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60391.html',
    bank_name: 'Chase',
    rewardsType: 'hyatt',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/world_of_hyatt_card.png',
    rewardsSummary:
      'Earn up to 9X total points per $1 spent at Hyatt hotels & resorts, plus 2X points on dining and more.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.hyatt',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'travel.airline.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'fitness',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn up to 65,000 bonus points after qualifying purchases.  Enjoy up to 9X total points per $1 spent at Hyatt hotels & resorts, plus 2X on dining and more. Get a free night every year and 5 tier qualifying night credits.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free Night Award',
        description:
          'Receive one free night at any Category 1\u20134 Hyatt hotel or resort every year after your cardmember anniversary.',
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Night Award',
        description:
          'Get an extra free night at any Category 1\u20134 Hyatt hotel or resort if you spend $15,000 in a calendar year.',
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: '$15,000',
      },
      {
        name: 'Discoverist Status',
        description:
          'Receive Discoverist status in the World of Hyatt program for as long as your account is open.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'World of Hyatt Tier-Qualifying Night Credits',
        description:
          'You receive 5 qualifying night credits towards your next tier status every year.',
        benefit_type: 'hotel_status',
        value: 5,
        value_unit: 'nights',
        spend_requirement: null,
      },
      {
        name: 'World of Hyatt Tier-Qualifying Night Credits',
        description:
          'Earn 2 additional qualifying night credits every time you spend $5,000 on your card.',
        benefit_type: 'hotel_status',
        value: 2,
        value_unit: 'nights',
        spend_requirement: '$5,000',
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 5 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $5,000 per covered traveler and $10,000 per trip for your pre-paid, non-refundable travel expenses, including passenger fares, tours, and hotels.',
        benefit_type: 'trip_cancellation_protection',
        value: 5000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature Concierge Service 24 hours a day. Find tickets to the top sports and entertainment events, make dinner reservations and even get help sending the perfect gift.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$3,000',
        spendRequirementMonths: 3,
        bonusValue: 35000,
        bonusValueUnit: 'points',
        description:
          'Earn 35,000 Bonus Points after you spend $3,000 on purchases in your first 3 months from account opening. Plus, earn up to 30,000 more Bonus Points by earning 2 Bonus Points total per $1 spent in the first 6 months from account opening on purchases that normally earn 1 Bonus Point, on up to $15,000 spent.',
      },
    ],
    cardType: 'personal',
    imageName: 'world_of_hyatt_credit_card.png',
  },
  [CreditCard.AEROPLAN_CARD]: {
    id: CreditCard.AEROPLAN_CARD,
    name: 'Aeroplan\u00ae Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HN5X&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/aircanada/aeroplan?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60518.html',
    bank_name: 'Chase',
    rewardsType: 'avios',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/aeroplan_card.png',
    rewardsSummary:
      'Earn up to 70,000 bonus points, 3X points at grocery stores and on dining, and 1X point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [
          'gift cards',
          'car rentals',
          'hotel bookings',
          'third-party partner products and services purchased through aircanada.com',
          'onboard Wi-Fi',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn up to 70,000 bonus points after meeting spending requirements.  Enjoy 3X points on groceries and dining, plus free first checked bags on Air Canada flights.  No foreign transaction fees.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free First Checked Bags',
        description:
          'Cardmembers and travel companions (up to eight) traveling on the same reservation will all enjoy free first checked bags (up to 50lb) when travel originates on an Air Canada flight.',
        benefit_type: 'baggage_delay_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae or NEXUS Fee Credit',
        description:
          'Receive a statement credit of up to $120 every 4 years as a reimbursement for the application fee charged to your Aeroplan Card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Mastercard 24/7 Concierge',
        description:
          'Need to locate hard to find items or even reserve that perfect table? Our concierge is there to help. To contact the concierge, call the number on the back of your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '10% bonus on Ultimate Rewards\u00ae points transfers',
        description:
          'Chase Aeroplan credit cardmembers, get a 10% transfer bonus after transferring 50,000 or more Ultimate Rewards points in a single transaction from an eligible Chase credit card to their Aeroplan account. Maximum of 25,000 Aeroplan bonus points per calendar year.',
        benefit_type: 'anniversary_bonus',
        value: 25000.0,
        value_unit: 'points',
        spend_requirement: 50000.0,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'travel_insurance',
        value: 6000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          'Decline the rental company\u2019s collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'If you have a roadside emergency, call the service provider to dispatch the help you need. Roadside service fees will be billed to your card at time of dispatch.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 70000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points after you spend $3,000 on purchases in the first 3 months your account is open. Plus, earn an additional 10,000 bonus points after your annual fee renewal payment posts and is paid in full.',
      },
    ],
    cardType: 'personal',
    imageName: 'aeroplan_card.png',
  },
  [CreditCard.BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD]: {
    id: CreditCard.BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD,
    name: 'British Airways Visa Signature\u00ae Credit Card',
    apply_link:
      'https://creditcards.chase.com/travel-credit-cards/avios/british-airways?CELL=6269',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/avios/british-airways?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56313.html',
    bank_name: 'Chase',
    rewardsType: 'avios',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/british_sign_card.png',
    rewardsSummary:
      'Earn up to 3 Avios per $1 spent on purchases, with bonus Avios on British Airways, Aer Lingus, and Iberia flights and hotel stays.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.britishAirways',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
    ],
    creditScore: null,
    cardSummary:
      'The British Airways Visa Signature\u00ae Credit Card offers a generous welcome bonus, earning rates up to 3x Avios on British Airways and partner flights, and up to $600 in statement credits for reward flights.',
    cardNetwork: 'Visa',
    issuer: 'Chase',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You will pay no foreign transaction fees when you use your card for purchases made outside the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Payments',
        description:
          'For fast, easy and secure checkout simply tap to pay where you see the Contactless symbol.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Use Avios to Save',
        description:
          'You can use your Avios to pay for your taxes, fees, and carrier charges for your reward flight when you call the number on the back of your card to book your flight.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spend Instantly',
        description:
          'Receive instant access to your card by adding it to a digital wallet, like Apple Pay\u00ae, Google Pay\u2122 or Samsung Pay.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Chase Pay Over Time\u00ae',
        description:
          'Chase Pay Over Time lets eligible Chase customers break up credit card purchases into budget friendly payments.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'avios',
        description:
          'Earn 75,000 bonus Avios after you spend $5,000 on purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'british_airways_visa_signature_credit_card.png',
  },
  [CreditCard.AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD]: {
    id: CreditCard.AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD,
    name: 'Aer Lingus Visa Signature\u00ae Credit Card',
    apply_link:
      'https://creditcards.chase.com/travel-credit-cards/avios/aer-lingus?CELL=6269',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/avios/aer-lingus?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56713.html',
    bank_name: 'Chase',
    rewardsType: 'avios',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/aer_lingus_card.png',
    rewardsSummary:
      'Earn 3 Avios per $1 on Aer Lingus, British Airways, and Iberia flights, 2 Avios per $1 on hotel stays booked directly, and 1 Avios per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 75,000 bonus Avios after spending $5,000 in 3 months.  Earn 3x Avios on Aer Lingus, British Airways, and Iberia flights, 2x on hotels, and 1x on other purchases.  Annual fee is $95.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Economy Companion Ticket',
        description:
          "Every calendar year you make purchases of $30,000 on your Aer Lingus Visa Signature Card, you'll receive an economy companion ticket good for 12 months.",
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: 30000.0,
      },
      {
        name: 'Priority Boarding',
        description:
          'You and any authorized users on your account are eligible for Priority Boarding on Aer Lingus flights departing from and returning to the US from Ireland, subject to availability.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'avios',
        description:
          'Earn 75,000 bonus Avios after you spend $5,000 on purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'aer_lingus_visa_signature_credit_card.png',
  },
  [CreditCard.IBERIA_VISA_SIGNATURE_CREDIT_CARD]: {
    id: CreditCard.IBERIA_VISA_SIGNATURE_CREDIT_CARD,
    name: 'Iberia Visa Signature\u00ae Credit Card',
    apply_link:
      'https://creditcards.chase.com/travel-credit-cards/avios/iberia?CELL=6269',
    learn_more_link:
      'https://creditcards.chase.com/travel-credit-cards/avios/iberia?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56714.html',
    bank_name: 'Chase',
    rewardsType: 'avios',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/iberia_card.png',
    rewardsSummary:
      'Earn 3 Avios per $1 on Iberia, British Airways, and Aer Lingus flights, 2 Avios per $1 on hotel stays booked directly, and 1 Avios per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 75,000 bonus Avios after spending $5,000 in 3 months.  Earn 3x Avios on Iberia, British Airways, and Aer Lingus flights, 2x on hotels, and 1x on other purchases.  Plus, get a 10% discount on Iberia flights.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$1,000 Airfare Discount Voucher',
        description:
          'Earn a discount voucher of $1,000 to use toward two tickets on the same Iberia flight for each calendar year you make purchases of $30,000 on your card.',
        benefit_type: 'travel_credit',
        value: 1000.0,
        value_unit: 'dollars',
        spend_requirement: 30000.0,
      },
      {
        name: '10% discount on airfare',
        description:
          'Use your Iberia Visa Signature Card to book your flight on the website provided in your welcome materials.',
        benefit_type: 'travel_credit',
        value: 0.1,
        value_unit: 'percentage',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'avios',
        description:
          'Earn 75,000 bonus Avios after you spend $5,000 on purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'iberia_visa_signature_credit_card.png',
  },
  [CreditCard.PRIME_VISA]: {
    id: CreditCard.PRIME_VISA,
    name: 'Prime Visa',
    apply_link:
      'https://creditcards.chase.com/cash-back-credit-cards/amazon-prime-rewards?CELL=6269',
    learn_more_link:
      'https://creditcards.chase.com/cash-back-credit-cards/amazon-prime-rewards?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59329.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/prime_visa.png',
    rewardsSummary:
      'Earn unlimited 5% back at Amazon.com and on Chase Travel purchases with an eligible Prime membership, unlimited 2% back at gas stations, restaurants, and on local transit, and unlimited 1% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'amazon',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 5% back at Amazon.com, Amazon Fresh, Whole Foods Market, and on Chase Travel purchases with an eligible Prime membership, unlimited 2% back at gas stations, restaurants, and on local transit and commuting (including rideshare), and unlimited 1% back on all other purchases.  There is no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'When you pay for your air, bus, train or cruise transportation with your card, you are eligible to receive up to $500,000 in accidental death or dismemberment coverage',
        benefit_type: 'travel_insurance',
        value: 500000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Amazon Gift Card',
        description:
          "Prime members, get a $100 Amazon Gift Card instantly loaded into your Amazon account's Gift Card Balance upon approval of your credit card application.",
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 100.0,
        bonusValueUnit: 'dollars',
        description: 'Prime members get a $100 Amazon Gift Card upon approval.',
      },
    ],
    cardType: 'personal',
    imageName: 'prime_visa.png',
  },
  [CreditCard.AMAZON_VISA]: {
    id: CreditCard.AMAZON_VISA,
    name: 'Amazon Visa',
    apply_link:
      'https://creditcards.chase.com/cash-back-credit-cards/amazon-rewards?CELL=6269',
    learn_more_link:
      'https://creditcards.chase.com/cash-back-credit-cards/amazon-rewards?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59309.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/amazon_visa.png',
    rewardsSummary:
      'Earn unlimited 3% back at Amazon.com and on Chase Travel purchases, unlimited 2% back at gas stations, restaurants, and on local transit, and unlimited 1% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.travelPortal',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'amazon',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Amazon Visa offers unlimited 3% cash back at Amazon.com and on Chase Travel purchases, 2% back at gas stations and restaurants, and 1% back on all other purchases.  There is no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $500 per item.',
        benefit_type: 'purchase_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'When you pay for your air, bus, train or cruise transportation with your card, you are eligible to receive up to $500,000 in accidental death or dismemberment coverage',
        benefit_type: 'travel_insurance',
        value: 500000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage provides reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'statement_credit',
        description:
          "Get a $50 Amazon Gift Card instantly loaded into your Amazon account's Gift Card Balance upon approval of your credit card application.",
        benefit_type: 'statement_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 50.0,
        bonusValueUnit: 'dollars',
        description: 'Get a $50 Amazon Gift Card instantly upon approval.',
      },
    ],
    cardType: 'personal',
    imageName: 'amazon_visa.png',
  },
  [CreditCard.DOORDASH_REWARDS_MASTERCARD]: {
    id: CreditCard.DOORDASH_REWARDS_MASTERCARD,
    name: 'DoorDash Rewards Mastercard\u00ae',
    apply_link:
      'https://creditcards.chase.com/cash-back-credit-cards/doordash?CELL=6269',
    learn_more_link:
      'https://creditcards.chase.com/cash-back-credit-cards/doordash?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC55075.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/doordash_card.png',
    rewardsSummary:
      'Earn 4% cash back on DoorDash and Caviar, 3% on dining, 2% on groceries, and 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'takeoutDelivery.doordash',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The DoorDash Rewards Mastercard\u00ae offers a free year of DashPass, 4% cash back on DoorDash and Caviar orders, 3% on dining, 2% on groceries, and 1% on all other purchases.  There is no annual fee.',
    cardNetwork: 'Mastercard',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'DashPass',
        description: 'Free DashPass for a year',
        benefit_type: 'anniversary_bonus',
        value: 96.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'DashPass Anniversary Bonus',
        description:
          'Receive a complimentary DashPass membership ($96 value) every year with $10,000 in annual card spend.',
        benefit_type: 'anniversary_bonus',
        value: 96.0,
        value_unit: 'dollars',
        spend_requirement: 10000.0,
      },
      {
        name: '10% Off One Convenience, Grocery, Alcohol, Retail or DashMart Order Every Month',
        description:
          'Offer valid through 12/31/2024 on DoorDash only. Not valid on Caviar. Valid in the US only. Must use DoorDash Rewards Mastercard as payment method. Valid only on Convenience, Grocery, Alcohol, Retail or DashMart orders as designated in the DoorDash app or on doordash.com. Maximum value of discount is $15 each month.',
        benefit_type: 'statement_credit',
        value: 15.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Mastercard World Elite\u00ae Benefits',
        description:
          'Take advantage of additional benefits like 24/7 concierge services, cell phone protection, exclusive discounts and more -- compliments of Mastercard.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'doordash_rewards_mastercard.png',
  },
  [CreditCard.INK_BUSINESS_UNLIMITED_CREDIT_CARD]: {
    id: CreditCard.INK_BUSINESS_UNLIMITED_CREDIT_CARD,
    name: 'Ink Business Unlimited\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H3GX&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/ink/unlimited?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC55664.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_unlimited_card.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back rewards on every purchase made for your business.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 5.0,
        excludeMerchants: [
          'gift cards',
          'car rentals',
          'vehicle service centers',
          'miscellaneous fees',
          'other Lyft products and services',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Ink Business Unlimited\u00ae Credit Card offers unlimited 1.5% cash back on all purchases, plus a $750 bonus cash back after you spend $6,000 in the first 3 months.  It also features a 0% intro APR for 12 months and no annual fee.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'If you have a roadside emergency, call the service provider to dispatch the help you need. Roadside service fees will be billed to your card at time of dispatch.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 6000,
        spendRequirementMonths: 3,
        bonusValue: 750,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $750 bonus cash back after you spend $6,000 on purchases in the first 3 months after account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'ink_business_unlimited_credit_card.png',
  },
  [CreditCard.INK_BUSINESS_PREFERRED_CREDIT_CARD]: {
    id: CreditCard.INK_BUSINESS_PREFERRED_CREDIT_CARD,
    name: 'Ink Business Preferred\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HM3P&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/ink/business-preferred?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60250.html',
    bank_name: 'Chase',
    rewardsType: 'chase_ur',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_preferred_card.png',
    rewardsSummary:
      'Earn 3X points on select business categories and unlimited 1 Point Per $1 spent on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'shipping',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category:
          'Advertising purchases made with social media sites and search engines',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'Internet, cable and phone services',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 5.0,
        excludeMerchants: [
          'gift cards',
          'car rentals',
          'vehicle service centers',
          'miscellaneous fees',
          'other Lyft products and services',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'chase_ur',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Ink Business Preferred\u00ae Credit Card offers 90,000 bonus points after spending $8,000 in the first 3 months.  Earn 3X points on select business categories and 1 point per $1 on all other purchases.  Redeem points for cash back, gift cards, or travel.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather or other covered situations, you can be reimbursed up to $5,000 per covered traveler and $10,000 per trip for your pre-paid, nonrefundable travel expenses, including passenger fares, tours, and hotels.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'If you have a roadside emergency, call the service provider to dispatch the help you need. Roadside service fees will be billed to your card at time of dispatch.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          'Get up to $1,000 per claim in cell phone protection against covered theft or damage for cell phones listed on your monthly cell phone bill when you pay it with your eligible credit card. Maximum of 3 claims in a 12-month period with a $100 deductible per claim.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 8000.0,
        spendRequirementMonths: 3,
        bonusValue: 90000,
        bonusValueUnit: 'points',
        description:
          'Earn 90,000 bonus points after you spend $8,000 on purchases in the first 3 months after account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'ink_business_preferred_credit_card.png',
  },
  [CreditCard.INK_BUSINESS_CASH_CREDIT_CARD]: {
    id: CreditCard.INK_BUSINESS_CASH_CREDIT_CARD,
    name: 'Ink Business Cash\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HM3S&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/ink/cash?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60251.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_cash_card.png',
    rewardsSummary:
      'This card earns 5% cash back on the first $25,000 spent in combined purchases at office supply stores and on internet, cable and phone services each account anniversary year, 2% cash back on the first $25,000 spent in combined purchases at gas stations and restaurants each account anniversary year, and 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'officeSupplies',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 25000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'internetCablePhone',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 25000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 25000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 25000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Ink Business Cash Credit Card offers 5% cash back on the first $25,000 spent each year on combined purchases at office supply stores and on internet, cable, and phone services; 2% cash back on the first $25,000 spent each year on combined purchases at gas stations and restaurants; and 1% cash back on all other purchases.  There's no annual fee.",
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Auto Rental Collision Damage Waiver (Primary)',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'If you have a roadside emergency, call the service provider to dispatch the help you need. Roadside service fees will be billed to your card at time of dispatch.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 350.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn $350 cash back when you spend $3,000 on purchases in the first 3 months and an additional $400 cash back when you spend $6,000 on purchases in the first 6 months after account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'ink_business_cash_credit_card.png',
  },
  [CreditCard.INK_BUSINESS_PREMIER_CREDIT_CARD]: {
    id: CreditCard.INK_BUSINESS_PREMIER_CREDIT_CARD,
    name: 'Ink Business Premier\u00ae Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=GQ5X&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/ink/premier?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC53051.html',
    bank_name: 'Chase',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_business_premier_card.png',
    rewardsSummary:
      'Earn 2.5% cash back on purchases of $5,000 or more and 2% cash back on all other business purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 2.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 5000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Ink Business Premier\u00ae Credit Card offers unlimited rewards with 2.5% cash back on purchases of $5,000 or more and 2% cash back on all other business purchases.  It also includes a $1,000 bonus cash back after you spend $10,000 in the first 3 months.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services. (You will be responsible for the cost of any goods or services obtained.)',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'If you have a roadside emergency, call the service provider to dispatch the help you need.  Roadside service fees will be billed to your card at time of dispatch.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          'Get up to $1,000 per claim in cell phone protection against covered theft or damage for cell phones listed on your monthly cell phone bill when you pay it with your eligible credit card. Maximum of 3 claims in a 12-month period with a $100 deductible per claim.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 10000.0,
        spendRequirementMonths: 3,
        bonusValue: 100000,
        bonusValueUnit: 'points',
        description:
          'Earn a $1,000 bonus cash back after you spend $10,000 on purchases in your first 3 months from account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'ink_business_premier_credit_card.png',
  },
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD]: {
    id: CreditCard.SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD,
    name: 'Southwest Rapid Rewards\u00ae Performance Business Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H8LX&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/southwest/performance-business?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56827.html',
    bank_name: 'Chase',
    rewardsType: 'southwest',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_performance_biz_card.png',
    rewardsSummary:
      'Earn 4X points on Southwest\u00ae purchases and 2X points on select business purchases, plus an annual 9,000-point bonus.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.southwest',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.hotel',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Southwest Rapid Rewards Performance Business Credit Card earns 4X points on Southwest purchases and 2X points on select business categories.  It also offers an annual 9,000-point bonus and a generous welcome bonus.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Upgraded Boardings',
        description: 'Four upgraded boardings per year when available.',
        benefit_type: 'airline_priority_boarding',
        value: 4,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'InFlight WiFi credits',
        description: 'Up to 365 InFlight WiFi credits per year.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 365,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Tier Qualifying Points',
        description:
          'Earn 1,500 tier qualifying points toward A-List status for every $5,000 spent.',
        benefit_type: 'airline_status',
        value: 1500,
        value_unit: 'points',
        spend_requirement: '$5,000',
      },
      {
        name: 'Points Transfer Fee Credit',
        description:
          'Receive a $500 fee credit for points transfers to another Rapid Rewards Member.',
        benefit_type: 'statement_credit',
        value: 500,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Employee Cards',
        description:
          'Employee cards at no additional cost and earn points on employee spending.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Entry/TSA PreCheck\u00ae/NEXUS Fee Credit',
        description:
          'Receive a statement credit of up to $120 every four years for the application fee.',
        benefit_type: 'trusted_traveler_credit',
        value: 120,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus',
        description:
          'Receive 9,000 bonus points each year after your Cardmember anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 9000,
        value_unit: 'points',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$5,000',
        spendRequirementMonths: 3,
        bonusValue: 80000,
        bonusValueUnit: 'points',
        description:
          'Earn 80,000 bonus points after you spend $5,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'southwest_rapid_rewards_performance_business_credit_card.png',
  },
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD]: {
    id: CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD,
    name: 'Southwest Rapid Rewards\u00ae Premier Business Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=H8M9&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/southwest/premier-business?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC56829.html',
    bank_name: 'Chase',
    rewardsType: 'southwest',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_premier_biz_card.png',
    rewardsSummary:
      'Earn 3X points on Southwest\u00ae purchases, 2X points on local transit and commuting, and 1X points on all other purchases. Plus, 6,000 anniversary points each year.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.southwest',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.rideshare',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'southwest',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 60,000 bonus points after you spend $3,000 on purchases in the first 3 months from account opening. Earn 3X points on Southwest\u00ae purchases, 2X points on local transit and commuting, and 1X point on all other purchases.  Plus, 6,000 anniversary points each year.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'EarlyBird Check-In\u00ae',
        description:
          'Each anniversary year you will be reimbursed for the purchase of up to 2 EarlyBird Check-In services made with your Southwest Rapid Rewards Premier Business Credit Card.',
        benefit_type: 'statement_credit',
        value: 2.0,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% back on inflight purchases',
        description:
          'You will receive 25% back on Southwest Airlines inflight purchases made with your Southwest Rapid Rewards Premier Business Credit Card for drinks and WiFi in the form of a credit card account statement credit.',
        benefit_type: 'statement_credit',
        value: 0.25,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Southwest\u00ae $500 Fee Credit for Points Transfers',
        description:
          'A statement credit will automatically be applied to your account as reimbursement for fees associated with using your Southwest Rapid Rewards Premier Business Credit Card to transfer points to another Rapid Rewards Member or a pre-selected charity chosen by Southwest with an active Rapid Rewards account, up to an anniversary year maximum accumulation of $500 in reimbursed transfer fees.',
        benefit_type: 'statement_credit',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Unlimited tier qualifying points (TQPs)',
        description:
          'Earn 1,500 tier qualifying points toward A-List status for every $5,000 spent \u2013 with no limit on the amount of TQPs you can earn.',
        benefit_type: 'airline_status',
        value: 1500,
        value_unit: 'points',
        spend_requirement: 5000,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'You will pay no foreign transaction fees when you use your card for purchases made outside the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 100,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'anniversary_bonus',
        description:
          'Receive 6,000 bonus points each year after your Cardmember anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 6000,
        value_unit: 'points',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points after you spend $3,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'southwest_rapid_rewards_premier_business_credit_card.png',
  },
  [CreditCard.UNITEDU00SMS_BUSINESS_CARD]: {
    id: CreditCard.UNITEDU00SMS_BUSINESS_CARD,
    name: 'United\u2120 Business Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HGW5&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/united/united-business-card?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC58749.html',
    bank_name: 'Chase',
    rewardsType: 'united',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_biz_card.png',
    rewardsSummary:
      'Earn 2x miles on United purchases, dining, at gas stations, office supply stores and on local transit and commuting, plus enjoy a free first checked bag, priority boarding and other great United travel benefits.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.united',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.airline.united',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'officeSupplies',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 100,000 bonus miles after you spend $5,000 on purchases in the first 3 months from account opening. Earn 2x miles on United purchases, dining, at gas stations, office supply stores and on local transit and commuting. Plus, enjoy a free first checked bag, priority boarding and other great United travel benefits.',
    cardNetwork: 'Visa',
    issuer: 'Chase',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free first checked bag',
        description:
          'The primary Cardmember and one companion can each check a first standard bag for free \u2013 save up to $160 per roundtrip.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'United Club\u2120 Access',
        description:
          '2 United Club one-time passes per year. Relax in comfort while waiting for your flight with complimentary beverages, snacks, high-speed Wi-Fi and more.',
        benefit_type: 'lounge_access',
        value: 2.0,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$100 United travel credit',
        description:
          'after 7 United flight purchases of $100 or more each card anniversary year.',
        benefit_type: 'travel_credit',
        value: 100.0,
        value_unit: '$',
        spend_requirement: '7 United flight purchases of $100 or more',
      },
      {
        name: 'Priority boarding',
        description:
          'the primary Cardmember and companions on the same reservation will be invited to board United-operated flights prior to general boarding.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '5,000 better-together anniversary bonus miles',
        description:
          'when you have the United\u2120 Business Card and a personal United credit card',
        benefit_type: 'anniversary_bonus',
        value: 5000.0,
        value_unit: 'miles',
        spend_requirement: null,
      },
      {
        name: '25% back on United inflight and Club premium drink purchases',
        description:
          'You will receive 25% back, in the form of a credit card account statement credit, on purchases of food, beverages and Wi-Fi on board United and United Express-operated flights, and Wi-Fi subscription purchases, when you use your United\u2120 Business Card to make such purchases.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 0.25,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases like toiletries and clothing when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'trip_cancellation_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature\u00ae Concierge Service 24 hours a day. Find tickets to the top sports and entertainment events, make dinner reservations and even get help sending the perfect gift.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 100000,
        bonusValueUnit: 'miles',
        description:
          'Earn 100,000 bonus miles after you spend $5,000 on purchases in the first 3 months from account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'unitedu00sms_business_card.png',
  },
  [CreditCard.UNITED_CLUBU00SMS_BUSINESS__CARD]: {
    id: CreditCard.UNITED_CLUBU00SMS_BUSINESS__CARD,
    name: 'United Club\u2120 Business Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HGWH&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/united/united-club-business?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC58751.html',
    bank_name: 'Chase',
    rewardsType: 'united',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_club_biz_card.png',
    rewardsSummary:
      'Earn 2x miles on United purchases and 1.5x miles on all other purchases, plus enjoy United Club\u2120 membership and 2 free checked bags.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.united',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.airline.united',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
      {
        category: 'travel.hotel',
        earnRate: 3.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'united',
      },
    ],
    creditScore: null,
    cardSummary:
      'The United Club\u2120 Business Card offers 75,000 bonus miles + 1,000 Premier qualifying points after qualifying purchases.  Enjoy United Club\u2120 membership, 2 free checked bags, and earn 2x miles on United purchases and 1.5x miles on all other purchases.  Terms apply.',
    cardNetwork: 'Visa',
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'United Club\u2120 Membership',
        description:
          'Enjoy access to United Club locations and participating Star Alliance\u2122 affiliated lounges worldwide.',
        benefit_type: 'lounge_access',
        value: 650.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Free Checked Bags',
        description:
          'The primary Cardmember and one companion can each check a first and second standard bag for free.',
        benefit_type: 'baggage_fee_reimbursement',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Premier Access\u00ae Travel Services',
        description:
          'Receive preferential treatment to ease your way through the airport with priority check-in, security screening, boarding, and baggage handling privileges (where available).',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% Back on United In-flight and Club Premium Drink Purchases',
        description:
          'Receive 25% back as a statement credit on purchases of food, beverages, and Wi-Fi on board United-operated flights and on Club premium drinks.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Employee Cards at No Additional Cost',
        description:
          'Add employee cards at no additional cost and earn rewards faster.',
        benefit_type: 'employee_card',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather, or other covered situations, you can be reimbursed up to $10,000 per covered traveler and $20,000 per trip for your prepaid, nonrefundable travel expenses.',
        benefit_type: 'travel_insurance',
        value: 20000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Baggage Delay Insurance',
        description:
          'Reimburses you up to $100 a day for up to 3 days for essential purchases when baggage is delayed over 6 hours.',
        benefit_type: 'baggage_delay_insurance',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lost Luggage Reimbursement',
        description:
          'Provides reimbursement up to $3,000 per covered traveler for the cost to repair or replace checked or carry-on baggage that is lost, damaged, or stolen during a covered trip.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you are covered for unreimbursed expenses, such as meals and lodging, up to $500 per covered traveler.',
        benefit_type: 'travel_insurance',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Return Protection',
        description:
          "You can be reimbursed for eligible items that the store won't accept within 90 days of purchase, up to $500 per item, $1,000 per 12-month period.",
        benefit_type: 'return_protection',
        value: 500.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Concierge',
        description:
          'Get complimentary Visa Signature\u00ae Concierge Service 24 hours a day.',
        benefit_type: 'concierge',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'miles',
        description:
          'Earn 75,000 bonus miles + 1,000 Premier qualifying points (PQP) after you spend $5,000 on purchases in the first 3 months your account is open.',
      },
    ],
    cardType: 'business',
    imageName: 'united_clubu00sms_business__card.png',
  },
  [CreditCard.IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD]: {
    id: CreditCard.IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD,
    name: 'IHG One Rewards Premier Business Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HMHV&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/IHG/business-premier?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60353.html',
    bank_name: 'Chase',
    rewardsType: 'ihg',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/IHG_One_Premier_Biz_card_alt.png',
    rewardsSummary:
      'Earn IHG One Rewards points on every purchase, with bonus points for spending at IHG Hotels and Resorts, travel, dining, and select business purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.ihg',
        earnRate: 26.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'travel.general',
        earnRate: 5.0,
        excludeMerchants: ['hotels participating in IHG One Rewards'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'dining',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'officeSupplies',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
      {
        category: 'allPurchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'ihg',
      },
    ],
    creditScore: null,
    cardSummary:
      'The IHG One Rewards Premier Business Credit Card offers a generous welcome bonus, high earn rates on IHG stays and other purchases, and valuable travel benefits like Platinum Elite status and a free anniversary night.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Platinum Elite Status',
        description:
          'Automatic IHG One Rewards Platinum Elite status for as long as you remain a cardmember.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary Free Night',
        description:
          'Earned each account anniversary year with a current point redemption cap of 40,000 points.',
        benefit_type: 'free_hotel_night',
        value: 40000,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'Redeem 3 Nights, Get 4th Night Free',
        description:
          'Enjoy a reward night when you redeem points for a consecutive four-night IHG hotel stay.',
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$100 statement credit and 10,000 bonus points',
        description:
          'Earned each calendar year you spend $20,000 or more on purchases.',
        benefit_type: 'anniversary_bonus',
        value: 10000,
        value_unit: 'points',
        spend_requirement: 20000,
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae or NEXUS Application Fee Statement Credit',
        description:
          'Credit of up to $120 every 4 years as reimbursement for the application fee charged to your card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If your trip is canceled or cut short by sickness, severe weather and other covered situations, you can be reimbursed up to $1,500 per person and $6,000 per trip for your pre-paid, non-refundable travel expenses.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000,
        spendRequirementMonths: 3,
        bonusValue: 140000,
        bonusValueUnit: 'points',
        description:
          'Earn 140,000 bonus points after spending $4,000 in the first 3 months from account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'ihg_one_rewards_premier_business_credit_card.png',
  },
  [CreditCard.WORLD_OF_HYATT_BUSINESS_CREDIT_CARD]: {
    id: CreditCard.WORLD_OF_HYATT_BUSINESS_CREDIT_CARD,
    name: 'World of Hyatt Business Credit Card',
    apply_link:
      'https://secure.chase.com/web/oao/application/card?sourceCode=HMP8&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y',
    learn_more_link:
      'https://creditcards.chase.com/business-credit-cards/world-of-hyatt/hyatt-business-card?CELL=6269',
    terms_and_conditions_button_text: 'Pricing & Terms',
    terms_and_conditions_link:
      'https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60388.html',
    bank_name: 'Chase',
    rewardsType: 'hyatt',
    creditCardImageUrl:
      'https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/world_hyatt_biz_card.png',
    rewardsSummary:
      'Earn 2x points on your top three spending categories each quarter, plus bonus points on Hyatt purchases and fitness memberships.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.hyatt',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'fitness',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'shipping',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'travel.airline.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'socialMediaSearchEngineAdvertising',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'carRentalAgencies',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hyatt',
      },
    ],
    creditScore: null,
    cardSummary:
      'The World of Hyatt Business Credit Card offers 60,000 bonus points and a free night after meeting spending requirements.  It earns bonus points on Hyatt stays, fitness memberships, and your top three spending categories each quarter.',
    cardNetwork: null,
    issuer: 'JPMorgan Chase Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Discoverist Status',
        description:
          'Receive Discoverist status in the World of Hyatt program as long as your World of Hyatt Business Card account is open and not in default.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '5 Tier-Qualifying Night Credits',
        description:
          'Earn 5 World of Hyatt Tier-Qualifying Night credits for every $10,000 in purchases each calendar year.',
        benefit_type: 'hotel_status',
        value: 5,
        value_unit: 'nights',
        spend_requirement: '$10,000',
      },
      {
        name: 'Up to $100 Annual Hyatt Credit',
        description:
          'Earn a $50 statement credit per qualifying Hyatt purchase with your World of Hyatt Business Credit Card up to 2 times each anniversary year.',
        benefit_type: 'statement_credit',
        value: 100,
        value_unit: 'dollars',
        spend_requirement: '$50 per purchase',
      },
      {
        name: '10% Bonus Point Redemption Bonus',
        description:
          'Spend $50,000 in a calendar year and get 10% of your redeemed points back for the rest of the year, on up to 200,000 points redeemed.',
        benefit_type: 'anniversary_bonus',
        value: 0.1,
        value_unit: 'points',
        spend_requirement: '$50,000',
      },
      {
        name: 'Hyatt Leverage Membership',
        description:
          'Receive complimentary membership in the Hyatt Leverage Program.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary DashPass',
        description:
          'When the membership is activated for the first time with a World of Hyatt Business Credit Card by 01/31/2025 you and your authorized user(s) will receive 12 months of complimentary DashPass for use on both the DoorDash and Caviar applications during the same membership period based on the first activation date.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Earn $10 Off Quarterly on DoorDash Non-Restaurant Orders',
        description:
          'Once you have activated your World of Hyatt Business Credit Card DashPass membership, you will receive a $10 off discount each calendar quarter at checkout on one qualifying non-restaurant order on DoorDash as long as you remain enrolled in a DashPass membership.',
        benefit_type: 'statement_credit',
        value: 10,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Coverage',
        description:
          "Decline the rental company's collision insurance and charge the entire rental cost to your card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: 60000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description:
          'If you run into a problem while traveling away from home, this benefit provides legal and medical referrals and access to other travel and emergency assistance services.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'You can be reimbursed up to $1,500 per covered traveler and $6,000 per trip for your pre-paid, non-refundable passenger fares, if your trip is canceled or cut short by sickness, severe weather or other covered situations.',
        benefit_type: 'travel_insurance',
        value: 6000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Covers your eligible new purchases for 120 days from the date of purchase against damage or theft up to $10,000 per item.',
        benefit_type: 'purchase_protection',
        value: 10000,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty Protection',
        description:
          "Extends the time period of the manufacturer's U.S. warranty by an additional year, on eligible warranties of three years or less, up to four years from the date of purchase.",
        benefit_type: 'extended_warranty',
        value: 1,
        value_unit: 'year',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$5,000',
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points after you spend $5,000 on purchases within the first 3 months of account opening. Plus, earn 1 free night at any category 1-4 Hyatt hotel after you spend $15,000 within the first 6 months of account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'world_of_hyatt_business_credit_card.png',
  },
  [CreditCard.THE_PLATINUM_CARD]: {
    id: CreditCard.THE_PLATINUM_CARD,
    name: 'The Platinum Card\u00ae by American Express',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/platinum-card/91125-10-0?pmccode=137&intlink=US-Axp-Shop-Consumer-VAC-Platinum-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/platinum/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-Platinum-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/platinum-card/91125-10-0/?pznOfferCode=3R5Z-5Y9BDC-3H05-WXT&oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'The Platinum Card\u00ae from American Express earns Membership Rewards points on purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500000,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      }
    ],
    creditScore: null,
    cardSummary: null,
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.AMERICAN_EXPRESS_GOLD_CARD]: {
    id: CreditCard.AMERICAN_EXPRESS_GOLD_CARD,
    name: 'The American Express\u00ae Gold Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/gold-card/91190-10-0?pmccode=784&intlink=US-Axp-Shop-Consumer-VAC-GoldCard-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/gold-card/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-GoldCard-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/gold-card/91190-10-0/?pznOfferCode=3R5Z-5Y9BDC-3H05-WXT&oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'The American Express\u00ae Gold Card earns Membership Rewards\u00ae points on purchases.',
    rewardsEarnRates: [
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The American Express\u00ae Gold Card offers Membership Rewards\u00ae points on purchases, with bonus points for dining.  Additional benefits may apply.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.BLUE_CASH_PREFERRED_CARD]: {
    id: CreditCard.BLUE_CASH_PREFERRED_CARD,
    name: 'Amex Blue Cash Preferred\u00ae Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/blue-cash-preferred-credit-card/91124-10-0?pmccode=796&intlink=US-Axp-Shop-Consumer-VAC-BCP-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/blue-cash-preferred/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-BCP-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/blue-cash-preferred-credit-card/91124-10-0/?pznOfferCode=3R5Z-5Y9BDC-3H05-WXT&oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'cash_back',
    creditCardImageUrl: '',
    rewardsSummary:
      'The Amex Blue Cash Preferred Card earns 6% cash back on groceries, 6% on select streaming services, 3% on transit and at US gas stations, and 1% on other purchases.',
    rewardsEarnRates: [
      {
        category: 'grocery',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'streaming',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'transit',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Amex Blue Cash Preferred Card offers 6% cash back on groceries, select streaming services, and at US gas stations, 3% on transit, and 1% on other purchases.  It's a great choice for those who want to maximize their cash back on everyday spending.",
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.BLUE_CASH_EVERYDAY_CARD]: {
    id: CreditCard.BLUE_CASH_EVERYDAY_CARD,
    name: 'blue_cash_everyday_card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/blue-cash-everyday-credit-card/25330-10-0?pmccode=795&intlink=US-Axp-Shop-Consumer-VAC-BCE-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/blue-cash-everyday/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-BCE-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/blue-cash-everyday-credit-card/25330-10-0?oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
  },
  [CreditCard.DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD,
    name: 'Delta SkyMiles\u00ae Gold American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-gold-american-express-card/91175-10-0?pmccode=113&intlink=US-Axp-Shop-Consumer-VAC-DeltaGold-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-gold-american-express-card/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-DeltaGold-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-gold-american-express-card/91175-10-0/?pznOfferCode=3R5Z-5Y9BDC-3H05-WXT&oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn Delta SkyMiles\u00ae on purchases, and enjoy benefits like a free checked bag and priority boarding.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD,
    name: 'Delta SkyMiles\u00ae Platinum American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-platinum-american-express-card/91179-64-0?pmccode=142&intlink=US-Axp-Shop-Consumer-VAC-DeltaPlatinum-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-platinum-american-express-card/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-DeltaPlatinum-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-platinum-american-express-card/91179-10-0/?pznOfferCode=3R5Z-5Y9BDC-3H05-WXT&oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn Delta SkyMiles\u00ae on purchases, and enjoy benefits like priority boarding and free checked bags.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The Delta SkyMiles\u00ae Platinum American Express Card offers a variety of benefits for Delta flyers, including priority boarding, free checked bags, and bonus miles on Delta purchases.  It also earns Membership Rewards points on other purchases, which can be transferred to Delta SkyMiles.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD,
    name: 'Marriott Bonvoy Bevy\u2122 American Express\u00ae Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/marriott-bonvoy-bevy-card/25330-10-0?pmccode=1222&intlink=US-Axp-Shop-Consumer-VAC-MarriottBonvoyBevy-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/marriott-bonvoy-bevy/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-MarriottBonvoyBevy-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/marriott-bonvoy-bevy-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'marriott_bonvoy',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn Marriott Bonvoy points on purchases, and enjoy benefits like free night awards and more.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'travel.hotel.marriott',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Marriott Bonvoy Bevy\u2122 American Express\u00ae Card offers Marriott Bonvoy points on purchases, including a bonus rate on Marriott hotel stays.  Enjoy valuable benefits like free night awards and more.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD,
    name: 'Marriott Bonvoy Brilliant\u2122 American Express\u00ae Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/marriott-bonvoy-brilliant-card/25330-10-0?pmccode=1150&intlink=US-Axp-Shop-Consumer-VAC-MarriottBonvoyBrilliant-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/marriott-bonvoy-brilliant/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-MarriottBonvoyBrilliant-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/marriott-bonvoy-brilliant-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'marriott_bonvoy',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn Marriott Bonvoy points on purchases, and enjoy a free night award each year.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'travel.hotel.marriott',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Marriott Bonvoy Brilliant American Express Card offers a luxurious travel experience with benefits like a free night award each year, priority pass select membership, and high earning rates on Marriott purchases and travel.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free Night Award',
        description:
          'Receive a free night award each year after your card membership anniversary.',
        benefit_type: 'free_hotel_night',
        value: 1,
        value_unit: 'night',
        spend_requirement: null,
      },
      {
        name: 'Priority Pass Select Membership',
        description:
          'Enjoy complimentary access to over 1,300 airport lounges worldwide.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Marriott Bonvoy Gold Elite Status',
        description:
          'Automatically receive Marriott Bonvoy Gold Elite Status, offering benefits like late checkout and room upgrades.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_CARD,
    name: 'The Hilton Honors Credit Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/hilton-honors-credit-card/25330-10-0?pmccode=117&intlink=US-Axp-Shop-Consumer-VAC-HiltonHonors-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/hilton-honors/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-HiltonHonors-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/hilton-honors-credit-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'hilton',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn Hilton Honors Bonus Points on purchases, and enjoy complimentary Hilton Honors Silver status.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 7.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
      {
        category: 'travel.hotel.hilton',
        earnRate: 12.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Hilton Honors Card from American Express offers Hilton Honors Bonus Points on purchases and complimentary Silver status.  Enjoy benefits like free weekend night certificates and more.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Hilton Honors Silver Status',
        description: 'Complimentary Hilton Honors Silver status.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000,
        spendRequirementMonths: 3,
        bonusValue: 150000,
        bonusValueUnit: 'points',
        description:
          'Earn 150,000 Hilton Honors Bonus Points after you spend $3,000 in purchases on your new Card in the first 3 months.',
      },
    ],
    cardType: 'personal',
  },
  [CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD]: {
    id: CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD,
    name: 'The Hilton Surpass\u00ae Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/hilton-honors-surpass-credit-card/25330-10-0?pmccode=774&intlink=US-Axp-Shop-Consumer-VAC-HiltonSurpass-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/hilton-honors-surpass/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-HiltonSurpass-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/hilton-honors-surpass-credit-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'hilton',
    creditCardImageUrl: '',
    rewardsSummary: 'Earn Hilton Honors Bonus Points on purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
      {
        category: 'travel.hotel.hilton',
        earnRate: 12.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
    ],
    creditScore: null,
    cardSummary: null,
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD,
    name: 'Delta SkyMiles\u00ae Reserve American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-reserve-american-express-card/91180-10-0?pmccode=106&intlink=US-Axp-Shop-Consumer-VAC-DeltaReserve-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-reserve-american-express-card/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-DeltaReserve-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-reserve-american-express-card/91180-10-0/?pznOfferCode=3R5Z-5Y9BDC-3H05-WXT&oneXpVariant=elevatedOffer_varA#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'The Delta SkyMiles\u00ae Reserve American Express Card earns Membership Rewards points on purchases.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.AMERICAN_EXPRESS_GREEN_CARD]: {
    id: CreditCard.AMERICAN_EXPRESS_GREEN_CARD,
    name: 'American Express Green Card\u00ae',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/american-express-green-card/25330-10-0?pmccode=145&intlink=US-Axp-Shop-Consumer-VAC-Green-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/green/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-Green-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/american-express-green-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'The American Express Green Card\u00ae earns Membership Rewards\u00ae points on purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.transit',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      "The American Express Green Card offers Membership Rewards points on purchases, with bonus points on travel and transit.  It's a great option for everyday spending and travel rewards.",
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD]: {
    id: CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD,
    name: 'The Hilton Honors Aspire Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/hilton-honors-aspire-credit-card/25330-10-0?pmccode=1130&intlink=US-Axp-Shop-Consumer-VAC-HiltonAspire-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/hilton-honors-aspire/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-HiltonAspire-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/hilton-honors-aspire-credit-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'hilton',
    creditCardImageUrl: '',
    rewardsSummary:
      'The Hilton Honors Aspire Card earns Hilton Honors Points on purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.25,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
      {
        category: 'travel.hotel.hilton',
        earnRate: 14.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Hilton Honors Aspire Card offers Hilton Honors Points, a $250 annual resort credit, and complimentary Hilton Honors Diamond status.  It also provides access to airport lounges and other travel benefits.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Hilton Honors Diamond Status',
        description: 'Complimentary Hilton Honors Diamond status.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Annual Resort Credit',
        description: '$250 annual resort credit.',
        benefit_type: 'travel_credit',
        value: 250.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Airport Lounge Access',
        description: 'Access to airport lounges.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD,
    name: 'Delta SkyMiles\u00ae Blue Card - American Express',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-blue-american-express-card/25330-10-0?pmccode=105&intlink=US-Axp-Shop-Consumer-VAC-DeltaBlue-Prospect-ApplyNow-CardTile',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-blue-american-express-card/?eep=25330&intlink=US-Axp-Shop-Consumer-VAC-DeltaBlue-Prospect-Viewdetails-CardTile',
    terms_and_conditions_button_text: 'Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-blue-american-express-card/25330-10-0#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl: '',
    rewardsSummary:
      'The Delta SkyMiles\u00ae Blue Card from American Express earns Membership Rewards points on purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.airline.delta',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Delta SkyMiles\u00ae Blue American Express Card offers Membership Rewards points on purchases, with bonus points on Delta purchases.  It's a great option for Delta flyers looking to earn miles for travel.",
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.BUSINESS_PLATINUM_CARD]: {
    id: CreditCard.BUSINESS_PLATINUM_CARD,
    name: 'The Business Platinum Card\u00ae from American Express',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/business-platinum-charge-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-Platinum',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-platinum-credit-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Platinum',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/business-platinum-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-platinum-credit-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Platinum',
    rewardsSummary:
      'The Business Platinum Card earns 5x points on flights and prepaid hotels booked through AmexTravel.com, 1.5x points on eligible purchases in key business categories or purchases of $5,000 or more, and 1x point on other eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 5000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Business Platinum Card from American Express offers 5x points on flights and prepaid hotels booked through AmexTravel.com, plus valuable statement credits for Dell, Indeed, and Adobe purchases.  It also includes access to the Global Lounge Collection and premium hotel status.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Global Lounge Collection\u00ae',
        description:
          'Complimentary access to more than 1,400 airport lounges across 140 countries.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$200 Hilton Statement Credit',
        description:
          'Up to $200 in statement credits per calendar year for eligible purchases at Hilton properties. Hilton for Business program membership required.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Hilton Honors\u2122 Gold Status',
        description:
          'Complimentary Hilton Honors Gold status, offering benefits like room upgrades and bonus points.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Marriott Bonvoy\u00ae Gold Elite Status',
        description:
          'Complimentary Marriott Bonvoy Gold Elite status, providing benefits such as bonus points and late checkout.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fine Hotels + Resorts\u00ae Program',
        description:
          'Suite of benefits when booking through American Express Travel, including daily breakfast and late checkout.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$200 Dell Technologies Statement Credit',
        description:
          'Up to $200 back semi-annually on U.S. purchases with Dell Technologies.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$360 Indeed Statement Credit',
        description:
          'Up to $360 back (up to $90 quarterly) for purchases with Indeed.',
        benefit_type: 'statement_credit',
        value: 360.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$150 Adobe Creative Solutions Statement Credit',
        description:
          'Up to $150 back for select auto-renewing annual business subscription purchases with Adobe.',
        benefit_type: 'statement_credit',
        value: 150.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$120 Wireless Credit',
        description:
          'Up to $120 back per year for purchases with U.S. wireless telephone service providers.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$200 Airline Fee Credit',
        description:
          'Up to $200 in statement credits per calendar year for incidental fees (e.g., checked bags) with one qualifying airline.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$199 CLEAR\u00ae Plus Credit',
        description:
          'Up to $199 in statement credits per calendar year to cover the cost of a CLEAR Plus Membership.',
        benefit_type: 'statement_credit',
        value: 199.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName:
      'business_platinum_card.com/us/credit-cards/business/business-credit-cards/american-express-business-platinum-credit-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Platinum',
  },
  [CreditCard.BUSINESS_GOLD_CARD]: {
    id: CreditCard.BUSINESS_GOLD_CARD,
    name: 'American Express Business Gold Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/businessgold-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-Gold',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-gold-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Gold',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/businessgold-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/business-gold.png',
    rewardsSummary:
      'Earn 4x Membership Rewards points on your top 2 spending categories, 3x points on flights and prepaid hotels booked through AmexTravel.com, and 1x point on all other eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.hotel',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'officeSupplies',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'electronics',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.general',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'gas',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 150000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The American Express Business Gold Card offers 4x Membership Rewards points on your top 2 spending categories, 3x points on flights and prepaid hotels booked through AmexTravel.com, and 1x point on all other eligible purchases.  Unlock up to $395 in business value with statement credits for purchases at select merchants and Walmart+ membership.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: '$240 Flexible Business Credit',
        description:
          'Earn up to $20 in statement credits each month after you use the Business Gold Card for eligible U.S. purchases at FedEx, Grubhub, and Office Supply Stores.',
        benefit_type: 'statement_credit',
        value: 240.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$155 Walmart+ Credit',
        description:
          'Receive a statement credit for one monthly Walmart+ membership (subject to auto-renewal) after you pay for Walmart+ each month with your Business Gold Card.',
        benefit_type: 'statement_credit',
        value: 155.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'business_gold_card.png',
  },
  [CreditCard.BLUE_BUSINESS_CASHTM_CARD]: {
    id: CreditCard.BLUE_BUSINESS_CASHTM_CARD,
    name: 'Blue Business Cash Card from American Express',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/bluebusinesscash-credit-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-BlueBusinessCash',
    learn_more_link:
      'https://www.americanexpress.com/en-us/business/credit-cards/blue-business-cash/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-BlueBusinessCash',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/bluebusinesscash-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/blue-business-cash.png',
    rewardsSummary:
      'This card earns 2% cash back on the first $50,000 in purchases each year, then 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 50000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Blue Business Cash Card from American Express offers a $0 annual fee and earns 2% cash back on the first $50,000 in purchases each year, then 1% on all other purchases.  Cash back is automatically credited to your statement.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cash Flow Flexibility',
        description:
          'Option to spend above your credit limit with Expanded Buying Power\u2021\nAs business needs evolve, your spending power should too. Expanded Buying Power\u2021 gives you the freedom to spend above your credit limit and get business done. The amount you can spend above your credit limit is flexible, so it adapts with your use of the Card, your payment history, credit record, financial resources known to us, and other factors. Just remember, the amount you can spend with Expanded Buying Power is not unlimited.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'blue_business_cashtm_card.png',
  },
  [CreditCard.BLUE_BUSINESS_PLUS_CREDIT_CARD]: {
    id: CreditCard.BLUE_BUSINESS_PLUS_CREDIT_CARD,
    name: 'Blue Business Plus Credit Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/bluebusinessplus-credit-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-BlueForBusinessPlus',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-blue-business-plus-credit-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-BlueForBusinessPlus',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/bluebusinessplus-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/blue-business-plus.png',
    rewardsSummary:
      'The Blue Business Plus Card earns 2x Membership Rewards points on the first $50,000 in purchases each year, then 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 50000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Blue Business Plus Credit Card from American Express offers a $0 annual fee and earns 2x Membership Rewards points on the first $50,000 in purchases each year, then 1x point on all other purchases.  It also features Expanded Buying Power, allowing you to spend above your credit limit when needed.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Expanded Buying Power',
        description:
          'Enjoy flexible buying power, when your business needs it. Expanded Buying Power gives you the freedom to spend above your credit limit and get business done. The amount you can spend above your credit limit is flexible, so it adapts with your use of the Card, your payment history, credit record, financial resources known to us, and other factors. Just remember, the amount you can spend with Expanded Buying Power is not unlimited. Terms apply.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'blue_business_plus_credit_card.png',
  },
  [CreditCard.PLUM_CARD]: {
    id: CreditCard.PLUM_CARD,
    name: 'The Plum Card\u00ae',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/the-plum-card-business-charge-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-Plum',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-plum-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Plum',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/the-plum-card-business-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/plum.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on eligible charges when you pay within 10 days of your statement closing date.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Plum Card\u00ae offers unlimited 1.5% cash back on eligible purchases when paid within 10 days, and up to 60 days to pay without interest.  It features no preset spending limit, adapting to your spending habits.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Early Pay Discount',
        description:
          'Earn unlimited 1.5% cash back on eligible charges when you pay within 10 days of your statement closing date.',
        benefit_type: 'cash_back',
        value: 1.5,
        value_unit: '%',
        spend_requirement: null,
      },
      {
        name: 'Extra Days To Pay',
        description:
          'Up to 60 days to pay without interest. Just pay your minimum payment due by your payment due date.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Preset Spending Limit',
        description:
          'The Plum Card has No Preset Spending Limit, which gives you purchasing power that adjusts with your use of the Card and other factors.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose Your Billing Cycle',
        description:
          'Choose the time most convenient for your business to receive your bill each month.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'plum_card.png',
  },
  [CreditCard.BUSINESS_GREEN_REWARDS_CARD]: {
    id: CreditCard.BUSINESS_GREEN_REWARDS_CARD,
    name: 'Business Green Rewards Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/business-green-rewards-charge-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-Green',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-green-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Green',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/business-green-rewards-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/business-green-rewards.png',
    rewardsSummary:
      'The Business Green Rewards Card earns 2x points on flights and prepaid hotels booked through AmexTravel.com and 1x point on other eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.hotel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Business Green Rewards Card offers 2x Membership Rewards points on flights and prepaid hotels booked on AmexTravel.com and 1x point on other purchases.  It features a Pay Over Time option and no preset spending limit, providing cash flow flexibility for your business.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Pay Over Time Option',
        description:
          'Lets you carry a balance with interest on eligible charges.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Preset Spending Limit',
        description:
          'Your spending limit is flexible and adapts based on your purchase, payment, and credit history.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'business_green_rewards_card.png',
  },
  [CreditCard.DELTA_SKYMILES_RESERVE_BUSINESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_RESERVE_BUSINESS_CARD,
    name: 'Delta SkyMiles Reserve Business American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-reserve/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-DeltaReserve',
    learn_more_link:
      'https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-reserve/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaReserve',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-reserve/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/delta-reserve-business.png',
    rewardsSummary:
      'The Delta SkyMiles Reserve Business Card earns 3x miles on Delta purchases, 1.5x miles on transit and office supplies, and 1x mile on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.delta',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.transit',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'officeSupplies',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Delta SkyMiles Reserve Business Card offers a $650 annual fee, earning 3x miles on Delta purchases, 1.5x miles on transit and office supplies, and 1x mile on other purchases.  It also includes valuable benefits like a $240 Resy credit, $120 rideshare credit, and an annual companion certificate.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Resy Credit',
        description:
          'Earn up to $240 in statement credits annually after making an eligible Resy purchase on your enrolled Card.',
        benefit_type: 'statement_credit',
        value: 240.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Rideshare Credit',
        description:
          'Get rewarded to and from the airport. Earn up to $10 back each month on U.S. rideshare purchases with select providers after you pay with your Card.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Delta Stays Statement Credit',
        description:
          'Maximize your travel with your Card by earning an annual statement credit for eligible prepaid Delta Stays bookings on delta.com.',
        benefit_type: 'statement_credit',
        value: 250.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Annual Companion Certificate',
        description:
          'Receive a Companion Certificate on a First Class, Delta Comfort+\u00ae, or Main Cabin round-trip flight within the U.S. and to Mexico, the Caribbean, or Central America each year after renewal of your Card.',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Medallion Qualification Dollars (MQD) Boost',
        description:
          'Get closer to elevated Status next Medallion\u00ae Year by earning MQDs on purchases with your Card.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: "Hertz President's Circle Status",
        description:
          "Enjoy complimentary Hertz President's Circle Status with your Delta SkyMiles\u00ae Reserve Business Card.",
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Centurion Lounge Access',
        description:
          'When you purchase a Delta flight with your Delta SkyMiles\u00ae Reserve Business Card, you will receive complimentary access to The Centurion\u00ae Lounge and Escape Lounges.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Delta Sky Club Access',
        description:
          'Delta SkyMiles\u00ae Reserve Business Card Members receive 15 Visits per Medallion\u00ae Year to the Delta Sky Club\u00ae when flying Delta and can unlock an unlimited number of Visits after spending $75,000 in purchases on your Card in a calendar year.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Entry or TSA PreCheck Credit',
        description:
          'Keep long airport lines from slowing you down. Basic Card Members can receive a statement credit for a five-year membership every 4 years after applying for Global Entry ($120) or every 4.5 years after applying for TSA PreCheck\u00ae (up to $85 through a TSA PreCheck official enrollment provider) and pay the application fee with your Delta SkyMiles\u00ae Reserve Business American Express Card.',
        benefit_type: 'trusted_traveler_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Insurance',
        description:
          'If a round-trip is paid for entirely with your Eligible Card and a covered reason delays your trip more than 6 hours, Trip Delay Insurance can help reimburse certain additional expenses purchased on the same Eligible Card, up to $500 per trip, maximum 2 claims per Eligible Card per 12 consecutive month period.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Cancellation and Interruption Insurance',
        description:
          'If a round-trip is paid for entirely with your Eligible Card and a covered reason cancels or interrupts your trip, Trip Cancellation and Interruption Insurance can help reimburse the non-refundable travel expenses purchased with the same Eligible Card, up to $10,000 per trip and up to $20,000 per Eligible Card per 12 consecutive month period.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Insurance',
        description:
          'Travel more comfortably knowing you can be covered for lost, damaged, or stolen Baggage when you purchase the Entire Fare for a Common Carrier Vehicle ticket (e.g. plane, train, ship, or bus) on an Eligible Card.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Car Rental Loss and Damage Insurance',
        description:
          'Getting into your Rental Vehicle can be the start of a great vacation. When you use your Eligible Card to reserve and pay for the Entire Rental and decline the collision damage waiver (CDW) at the Rental Company counter, you can be covered for Damage to or Theft of a Rental Vehicle in a Covered Territory.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          "With Extended Warranty you can shop with less worry knowing the terms of the Original Manufacturer's Warranty can be extended up to one additional year.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'Sometimes your favorite new purchase gets stolen, accidentally damaged, or lost. But when you use your Eligible Card for Covered Purchases, your Membership can help protect them for up to 90 days from the Covered Purchase date.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          "You can be reimbursed, the lesser of, your costs to repair or replace your damaged or Stolen cell phone for a maximum of up to $800 per claim with a limit of 2 approved claims per 12-month period when your cell phone line is listed on a wireless bill and the prior month's wireless bill was paid by an Eligible Card Account.",
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'delta_skymiles_reserve_business_card.png',
  },
  [CreditCard.DELTA_SKYMILES_PLATINUM_BUSINESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_PLATINUM_BUSINESS_CARD,
    name: 'Delta SkyMiles Platinum Business American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-platinum/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-DeltaPlatinum',
    learn_more_link:
      'https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-platinum/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaPlatinum',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-platinum/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/platinum-delta-skymiles-business.png',
    rewardsSummary:
      'This card earns 3x miles on Delta and at hotels, 1.5x miles on transit and eligible U.S. shipping purchases, and 1x mile on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.delta',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.hotel',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.transit',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'shipping',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Delta SkyMiles Platinum Business American Express Card offers 3x miles on Delta and at hotels, plus valuable travel benefits like a Companion Certificate, Resy credit, and Delta Stays credit.  It also provides a Medallion Qualification Dollars (MQD) boost and various travel protections.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Resy Credit',
        description:
          'Earn up to $120 in statement credits annually after making eligible Resy purchases on your Card.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: 'Eligible Resy purchases',
      },
      {
        name: 'Delta Stays Statement Credit',
        description:
          'Earn an annual statement credit for eligible prepaid Delta Stay bookings on delta.com.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: 'Eligible prepaid Delta Stay bookings',
      },
      {
        name: 'Rideshare Credit',
        description:
          'Earn up to $10 back each month on U.S. rideshare purchases with select providers.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: 'U.S. rideshare purchases with select providers',
      },
      {
        name: 'Medallion Qualification Dollars (MQD) Boost',
        description:
          'Get $1 MQD for each $20 in purchases on your Card in a calendar year.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: '$20 in purchases',
      },
      {
        name: 'Companion Certificate',
        description:
          'Enjoy a Companion Certificate on a Main Cabin round-trip flight within the U.S. and to Mexico, the Caribbean, or Central America each year after renewal of your Card.',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: 'Card renewal',
      },
      {
        name: 'TakeOff 15',
        description: 'Take 15% off when booking Award Travel with miles.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 15.0,
        value_unit: 'percent',
        spend_requirement: null,
      },
      {
        name: 'Complimentary Upgrade List',
        description:
          'Delta SkyMiles\u00ae Platinum Business Card Members with an eligible ticket will be added to the Complimentary Upgrade list, after Delta SkyMiles Medallion Members and Reserve Card Members.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: 'Eligible ticket',
      },
      {
        name: 'Zone 5 Priority Boarding',
        description: 'Board early on your next Delta flight.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'First Checked Bag Free',
        description: 'Check your first bag free on Delta flights.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Delta Stays Credit',
        description:
          'Elevate your travel experience with an annual statement credit of up to $200 after using your Delta SkyMiles\u00ae Platinum Business Card to book prepaid hotels or vacation rentals through Delta Stays on delta.com.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement:
          'Prepaid hotels or vacation rentals through Delta Stays',
      },
      {
        name: 'Hertz Five Star\u00ae Status',
        description:
          'Transform your car rental experience with Hertz Five Star\u00ae Status.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: 'Enrollment in the Hertz Gold Plus Rewards program',
      },
      {
        name: 'Fee Credit for Global Entry or TSA Precheck\u00ae',
        description:
          'Receive either a statement credit every 4 years after you apply for Global Entry ($120) or a statement credit every 4.5 years after you apply for a five-year membership for TSA PreCheck\u00ae (up to $85).',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: 'Application fee payment',
      },
      {
        name: 'Trip Delay Insurance',
        description:
          'If a round-trip is paid for entirely with your Eligible Card and a covered reason delays your trip more than 12 hours, Trip Delay Insurance can help reimburse certain additional expenses purchased on the same Eligible Card, up to $300 per trip, maximum 2 claims per Eligible Card per 12 consecutive month period.',
        benefit_type: 'travel_insurance',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: 'Round-trip paid entirely with card',
      },
      {
        name: 'Baggage Insurance Plan',
        description:
          'Travel more comfortably knowing you can be covered for lost, damaged, or stolen Baggage when you purchase the Entire Fare for a Common Carrier Vehicle ticket (e.g. plane, train, ship, or bus) on an Eligible Card.',
        benefit_type: 'travel_insurance',
        value: 1250.0,
        value_unit: 'dollars',
        spend_requirement: 'Purchase of Entire Fare',
      },
      {
        name: 'Car Rental Loss and Damage Insurance',
        description:
          'When you use your Eligible Card to reserve and pay for the Entire Rental and decline the collision damage waiver (CDW) at the Rental Company counter, You can be covered for Damage to or Theft of a Rental Vehicle in a Covered Territory.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: 'Entire Rental payment and CDW decline',
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'delta_skymiles_platinum_business_card.png',
  },
  [CreditCard.DELTA_SKYMILES_GOLD_BUSINESS_CARD]: {
    id: CreditCard.DELTA_SKYMILES_GOLD_BUSINESS_CARD,
    name: 'Delta SkyMiles\u00ae Gold Business Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-gold/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-DeltaGold',
    learn_more_link:
      'https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-gold/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaGold',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-gold/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/gold-delta-skymiles-business.png',
    rewardsSummary:
      'This card earns 2x miles on Delta purchases and on US purchases at shipping providers and select media advertising providers, plus 1x mile on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.delta',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Delta SkyMiles\u00ae Gold Business Card offers 2x miles on Delta purchases and select US purchases, plus a $200 Delta Flight Credit after spending $10,000.  Additional benefits include 15% off Award Travel and Zone 5 Priority Boarding on Delta flights.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Delta Flight Credit',
        description:
          'Earn a $200 Delta Flight Credit to use toward future travel after you spend $10,000 in purchases on your Card in a calendar year.',
        benefit_type: 'travel_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: '$10,000',
      },
      {
        name: 'Up to $150 Delta Stays Statement Credit',
        description:
          'Maximize your travel with your Card by earning an annual statement credit for eligible prepaid Delta Stays bookings on delta.com.',
        benefit_type: 'statement_credit',
        value: 150.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'TakeOff 15: Save 15% on Award Travel',
        description:
          'Save 15% when booking Award Travel on Delta flights. Not applicable to partner-operated flights or to taxes and fees.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zone 5 Priority Boarding',
        description:
          'Board early, secure a spot for your carry-on, and enjoy plenty of time to settle in before takeoff on your next Delta flight with Zone 5 Priority Boarding.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'First Checked Bag Free',
        description:
          'As a benefit of Card Membership, you can check your first bag free on Delta flights, saving up to $70 on a round-trip Delta flight per person.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '20% Back on In-Flight Purchases',
        description:
          'On your next Delta flight, enjoy 20% savings in the form of a statement credit on select in-flight purchases when you use your Card.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'There are no foreign transaction fees with your Delta SkyMiles Gold Business Card.',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Insurance Plan',
        description:
          'Travel more comfortably knowing you can be covered for lost, damaged, or stolen Baggage when you purchase the Entire Fare for a Common Carrier Vehicle ticket (e.g. plane, train, ship, or bus) on an Eligible Card.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Car Rental Loss and Damage Insurance',
        description:
          'When you use your Eligible Card to reserve and pay for the Entire Rental and decline the collision damage waiver (CDW) at the Rental Company counter, You can be covered for Damage to or Theft of a Rental Vehicle in a Covered Territory.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'delta_skymiles_gold_business_card.png',
  },
  [CreditCard.MARRIOTT_BONVOY_BUSINESS_CARD]: {
    id: CreditCard.MARRIOTT_BONVOY_BUSINESS_CARD,
    name: 'Marriott Bonvoy Business\u00ae Credit Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/marriott-bonvoy-business-american-express-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-Marriott',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amex-marriott-bonvoy-business-credit-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Marriott',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/marriott-bonvoy-business-american-express-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'marriott_bonvoy',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/amex-marriott-bonvoy-business.png',
    rewardsSummary:
      'The Marriott Bonvoy Business\u00ae Credit Card earns Marriott Bonvoy points on purchases at Marriott hotels, restaurants, gas stations, and on wireless and shipping purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.marriott',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'gas',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'marriott_bonvoy',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Marriott Bonvoy Business\u00ae Credit Card offers 6x points on Marriott purchases, 4x points on dining and gas, and 2x points on other purchases.  It also includes Marriott Bonvoy Gold Elite status and a free night award.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Marriott Bonvoy\u00ae Room Rate Discount',
        description:
          'Receive a 7% discount on eligible bookings as a benefit of being both a Marriott Bonvoy\u00ae member & a Marriott Bonvoy Business\u00ae American Express\u00ae Card Member when you book directly with Marriott through an eligible channel for a participating property under the Amex Business Card Rate.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Marriott Bonvoy Gold Elite Status',
        description:
          'Enjoy complimentary Gold Elite status with your Marriott Bonvoy Business Card.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '4X Points on Global Dining',
        description:
          'Earn 4X points per dollar on purchases at restaurants worldwide.',
        benefit_type: 'rotating_quarterly_rewards',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Night Award',
        description:
          'Receive one Free Night Award every year, after your Card renewal month. And earn another Free Night Award after you spend $60,000 in purchases on your Card in a calendar year.',
        benefit_type: 'free_hotel_night',
        value: 1,
        value_unit: null,
        spend_requirement: '$60,000',
      },
      {
        name: 'Elite Night Credits',
        description:
          'Each calendar year you can receive 15 Elite Night Credits towards the next level of Marriott Bonvoy Elite status with your Marriott Bonvoy Business\u00ae American Express\u00ae Card.',
        benefit_type: 'hotel_status',
        value: 15,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Marriott Bonvoy Air+Car Transfer Program',
        description:
          'Air+Car allows members to redeem Marriott Bonvoy points for flights and car rentals across hundreds of travel partners around the world.',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Marriott Bonvoy Gold Elite Status',
        description:
          'Receive complimentary Gold Elite status with your Marriott Bonvoy Business\u00ae American Express\u00ae Card, which includes priority late checkout when available and 25% bonus points on stays. Must book with a Qualifying Rate.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Premium Internet Access',
        description:
          'Stay connected with complimentary in-room, premium Internet access while staying at hotels participating in the Marriott Bonvoy\u00ae program.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'Do business globally without any foreign transaction fees on purchases.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Baggage Insurance Plan',
        description:
          'Travel more comfortably knowing you can be covered for lost, damaged, or stolen Baggage when you purchase the Entire Fare for a Common Carrier Vehicle ticket (e.g. plane, train, ship, or bus) on an Eligible Card.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Assist\u00ae Hotline',
        description:
          'Whenever you travel more than 100 miles from home, you may be eligible for 24/7 emergency assistance and coordination services, including medical and legal referrals, passport information, emergency cash wires, and missing luggage assistance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Car Rental Loss and Damage Insurance',
        description:
          'As a Card Member, You can be covered for Damage to or Theft of a Rental Vehicle in a Covered Territory when you use your Eligible Card to reserve and pay for the Entire Rental and decline the collision damage waiver (CDW) at the Rental Company counter.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Employee Cards',
        description:
          'Think of Employee Marriott Bonvoy Business Cards as another tool you can use to stay on top of your expenses.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Connect to QuickBooks\u00ae',
        description:
          'Save time with auto-expense categorization in Intuit QuickBooks-Once enrolled, your Business Card transactions are automatically tagged with your QuickBooks categories.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account Manager',
        description:
          'When you designate an Account Manager, you can allow trusted individuals - like an assistant or business partner - to access and manage your Business Card account.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account Alerts',
        description:
          'American Express Business Card Members can set Account Alerts to help avoid late payments, spot irregular spending, and monitor Employee Card use.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Year-End Summary',
        description:
          'At the start of each year, we provide access to a Year-End Summary of charges so you can review your annual spending.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Online Statements',
        description:
          'View your purchase history, prepare reports, and budget your expenses.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'American Express\u00ae App',
        description:
          'Track spending and rewards, find offers, make a payment, and get important account alerts in real-time with the American Express\u00ae App.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Vendor Pay by Bill.com',
        description:
          'You can make the most out of paying your business bills. Enhance cash flow management and take advantage of Card benefits when you use your Card to pay bills with Vendor Pay by Bill.com.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          "With Extended Warranty you can shop with less worry knowing the terms of the Original Manufacturer's Warranty can be extended up to one additional year.",
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Protection',
        description:
          'When an American Express\u00ae Card Member charges a Covered Purchase with their Eligible Card, Purchase Protection can help protect their Covered Purchases for up to 90 days from the Covered Purchase date if it is stolen or accidentally damaged.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Dispute Resolution',
        description:
          'We will work with you to help resolve the issue if there is a fraudulent or incorrect charge on your statement.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'marriott_bonvoy_business_card.png',
  },
  [CreditCard.HILTON_HONORS_BUSINESS_CARD]: {
    id: CreditCard.HILTON_HONORS_BUSINESS_CARD,
    name: 'Hilton Honors American Express Business Credit Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/hilton-honors-american-express-business-credit-card/45094-9-0?intlink=US-Acq-GCP-BusinessCards-ViewAllCards-Apply-Hilton',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/hilton-honors/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Hilton',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/hilton-honors-american-express-business-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'hilton',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/hilton-honors.png',
    rewardsSummary:
      'This card earns Hilton Honors Bonus Points on purchases, with higher earning rates for Hilton hotel and resort purchases and other eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.hilton',
        earnRate: 12.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
      {
        category: 'allPurchases',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 100000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
      {
        category: 'allPurchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 100000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hilton',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Hilton Honors American Express Business Card offers 12x Hilton Honors Bonus Points on purchases made directly with Hilton hotels and resorts, and 5x points on the first $100,000 in other eligible purchases per calendar year (then 3x).  Enjoy complimentary Hilton Honors Gold status and other travel benefits.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Hilton Honors\u2122 Gold Status',
        description:
          'Enjoy complimentary Gold status with your Card. Gold status gives you an 80% Bonus on Base Points you earn on every stay, space-available room upgrades at select properties, and more.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Hilton Honors\u2122 Diamond Status',
        description:
          'Spend $40,000 on eligible purchases on your Card in a calendar year and you can earn an upgrade to Hilton Honors\u2122 Diamond status through the end of the next calendar year.',
        benefit_type: 'hotel_status',
        value: 40000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'National Car Rental\u00ae Emerald Club Executive\u00ae Status',
        description:
          'Hilton Honors Business Card Members can enjoy complimentary National Car Rental\u00ae Emerald Club Executive\u00ae status, including perks like Executive Area Access (for full-size reservations and above) in the USA and Canada. Card Members must enroll in the National Car Rental Emerald Club Executive status through their American Express online account using their Card. Terms apply.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'Use your Card on purchases when you travel abroad without the worry of foreign transaction fees.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'hilton_honors_business_card.png',
  },
  [CreditCard.AMAZON_BUSINESS_PRIME_CARD]: {
    id: CreditCard.AMAZON_BUSINESS_PRIME_CARD,
    name: 'Amazon Business Prime American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-prime-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusinessPrime',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-prime-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusinessPrime',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/partner/print/business-card/microsite/amz/amazon-prime-business-credit-card/ep-45094?print=false#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/amazon-business-prime-angled.png',
    rewardsSummary:
      'The Amazon Business Prime American Express Card earns 5% back or 90-day terms on purchases at Amazon.com with an eligible Prime membership, 2% back at restaurants, gas stations, and wireless providers, and 1% back on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 120000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.hotel.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 120000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 120000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Amazon Business Prime American Express Card offers a $0 annual fee and earns 5% back or 90-day terms on Amazon.com purchases (with eligible Prime membership), 2% back at restaurants, gas stations, and wireless providers, and 1% back on other purchases.  It also provides enhanced data views for Amazon Business purchases and allows you to redeem rewards at Amazon.com and Amazon Business.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Amazon Business Enhanced Data Views',
        description:
          'Gain deeper insights on purchases and simplify expense reconciliation. With enhanced data views, you can see Amazon Business purchases listed item by item in an easily downloadable file from your online statement.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Amazon Shop with Points',
        description:
          'Redeem rewards on millions of items during checkout at Amazon.com and Amazon Business (U.S.) or apply towards a purchase on your statement.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description: 'No Foreign Transaction Fees on international purchases.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'amazon_business_prime_card.png',
  },
  [CreditCard.AMAZON_BUSINESS_CARD]: {
    id: CreditCard.AMAZON_BUSINESS_CARD,
    name: 'Amazon Business American Express Card',
    apply_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusiness',
    learn_more_link:
      'https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusiness',
    terms_and_conditions_button_text:
      '\u2666\ufe0e\u2021\u2020Offer & Benefit Terms',
    terms_and_conditions_link:
      'https://www.americanexpress.com/us/credit-cards/card-application/apply/partner/print/business-card/microsite/amz/amazon-core-business-credit-card/ep-45094?print=false#offer-terms',
    bank_name: 'American Express',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/amazon-business-angled.png',
    rewardsSummary:
      'The Amazon Business American Express Card earns 3% back or 60-day terms on purchases at Amazon Business, AWS, Amazon.com, and Whole Foods Market (up to $120,000 per year), 2% back at restaurants, gas stations, and on wireless services, and 1% back on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 120000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.hotel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 120000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 120000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Amazon Business American Express Card offers rewards of 3% back or 60-day terms on Amazon Business, AWS, Amazon.com, and Whole Foods Market purchases (up to $120,000 per year), 2% back at restaurants and gas stations, and 1% back on other purchases.  It also includes enhanced data views for expense management and no foreign transaction fees.',
    cardNetwork: 'American Express',
    issuer: 'American Express',
    selectableCategories: [],
    benefits: [
      {
        name: 'Amazon Business Enhanced Data Views',
        description:
          'Gain deeper insights on purchases and simplify expense reconciliation. With enhanced data views, you can see Amazon Business purchases listed item by item in an easily downloadable file from your online statement.',
        benefit_type: 'expense_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Amazon Shop with Points',
        description:
          'Redeem rewards on millions of items during checkout at Amazon.com and Amazon Business (U.S.) or apply towards a purchase on your statement.',
        benefit_type: 'points_redemption',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          "Travel anywhere in the world and breathe easy with the knowledge you won't be charged a foreign transaction fee from American Express when you use your Card.",
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'amazon_business_card.png',
  },
  [CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS]: {
    id: CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS,
    name: 'Bank of America\u00ae Customized Cash Rewards Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071206&productoffercode=BK&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/cash-back-credit-card/?campaign=4071206~BK~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071206&productoffercode=BK&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8ckn_cshsigcm_v_250x158.png',
    rewardsSummary:
      'This card earns 3% cash back in a category of your choice, 2% cash back at grocery stores and wholesale clubs, and 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'choice',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Bank of America Customized Cash Rewards Credit Card offers a $200 online cash rewards bonus after spending $1,000 in the first 90 days.  It provides 3% cash back in a category of your choice, 2% at grocery stores and wholesale clubs, and 1% on all other purchases.  There is no annual fee.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [
      'gas',
      'onlineShopping',
      'dining',
      'travel',
      'drugstore',
      'homeImprovement',
    ],
    benefits: [
      {
        name: 'Online Cash Rewards Bonus',
        description:
          'Earn a $200 online cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening.',
        benefit_type: 'cash_bonus_amount',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: 1000.0,
      },
      {
        name: 'Bank of America Preferred Rewards',
        description:
          'Bank of America Preferred Rewards members earn 25%-75% more cash back on every purchase.',
        benefit_type: 'bank_of_america_preferred_rewards',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash rewards bonus after you make at least $1,000 in purchases within the first 3 months of opening your account.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_customized_cash_rewards.png',
  },
  [CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS]: {
    id: CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS,
    name: 'Bank of America\u00ae Unlimited Cash Rewards Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071240&productoffercode=C3&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-credit-card/?campaign=4071240~C3~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071240&productoffercode=C3&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cty_cshsigcm_v_250x157.png',
    rewardsSummary: 'Earn unlimited 1.5% cash back on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 1.5% cash back on all purchases.  No annual fee.  Online $200 cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 online cash rewards bonus after making at least $1,000 in purchases within the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_unlimited_cash_rewards.png',
  },
  [CreditCard.BANKAMERICARD]: {
    id: CreditCard.BANKAMERICARD,
    name: 'BankAmericard\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4069136&productoffercode=SS&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/bankamericard-credit-card/?campaign=4069136~SS~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4069136&productoffercode=SS&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cae_nrwcm_mc_250x158.png',
    rewardsSummary:
      'This card offers a 0% introductory APR for 18 billing cycles on purchases and balance transfers made within 60 days, followed by a variable APR, and no annual fee.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      "The BankAmericard offers a 0% introductory APR for 18 billing cycles on purchases and balance transfers (made within 60 days), then a variable APR applies.  There's no annual fee and it includes features like fraud protection and contactless payments.",
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bankamericard.png',
  },
  [CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS]: {
    id: CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS,
    name: 'Bank of America\u00ae Travel Rewards Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071157&productoffercode=9W&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/travel-rewards-credit-card/?campaign=4071157~9W~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071157&productoffercode=9W&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8blm_trvsigcm_v_250x158.png',
    rewardsSummary:
      'Earn unlimited 1.5 points for every $1 you spend on all purchases everywhere, every time.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 1.5 points for every $1 you spend on all purchases everywhere, every time and no expiration on points as long as your account remains open.  Enjoy no annual fee and no foreign transaction fees while earning points to use for a statement credit to pay for flights, hotel stays, vacation rentals, baggage fees, and also at restaurants \u2013 including takeout.  25,000 online bonus points if you make at least $1,000 in purchases in the first 90 days of your account opening \u2013 which can be redeemed for a $250 statement credit toward travel and dining purchases.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: '$1000',
        spendRequirementMonths: 3,
        bonusValue: 25000,
        bonusValueUnit: 'points',
        description:
          'Earn 25,000 online bonus points if you make at least $1,000 in purchases in the first 90 days of your account opening \u2013 which can be redeemed for a $250 statement credit toward travel and dining purchases.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_travel_rewards.png',
  },
  [CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS]: {
    id: CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS,
    name: 'Bank of America\u00ae Premium Rewards\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071193&productoffercode=VV&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/premium-rewards-credit-card/?campaign=4071193~VV~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071193&productoffercode=VV&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/bofa_prmsigcm_255x158.png',
    rewardsSummary:
      'Earn unlimited points: 2 points per $1 on travel and dining, 1.5 points per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited points with a low $95 annual fee and no foreign transaction fees.  Get 60,000 online bonus points (a $600 value) after spending $4,000 in the first 90 days. Redeem points for cash back, statement credits, or travel.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Airline Incidental Statement Credits',
        description:
          'Get up to $100 in Airline Incidental Statement Credits annually for qualifying purchases such as seat upgrades, baggage fees, in-flight services, and airline lounge fees - automatically applied to your card statement',
        benefit_type: 'travel_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Airport Security Statement Credits',
        description:
          'Get up to $100 in Airport Security Statement Credits for TSA PreCheck\u00ae or Global Entry application fees, every four years',
        benefit_type: 'travel_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Travel protections',
        description:
          'Travel Insurance protections to assist with trip delays, cancellations and interruptions, baggage delays, lost luggage and emergency evacuation and transportation.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase protections',
        description:
          "Shop with confidence, with excellent purchase protections like Warranty Manager Service, Return Protection and Purchase Security. These can help with repair, replacement or reimbursement on purchases, or extend the manufacturers' warranty.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Automotive protections',
        description:
          'Feel safer on the road with our 24/7 Roadside Dispatch Program, plus added protection with Auto Rental Collision Damage Waiver.',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Signature\u00ae Luxury Hotel Collection',
        description:
          'Enjoy a premium set of benefits when you use your Premium Rewards\u00ae card to book through the Visa Signature Luxury Hotel Collection.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Concierge Service',
        description:
          'The Visa Signature\u00ae concierge service gives you access to concierges who can help with travel planning, restaurant recommendations and event reservations.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 online bonus points \u2014 a $600 value \u2014 after you make at least $4,000 in purchases in the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_premium_rewards.png',
  },
  [CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE]: {
    id: CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE,
    name: 'Bank of America\u00ae Premium Rewards\u00ae Elite Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071149&productoffercode=RK&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/premium-rewards-elite-credit-card/?campaign=4071149~RK~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071149&productoffercode=RK&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/bofa_prmeltcm_v_metal_255x158.png',
    rewardsSummary:
      'Earn unlimited 2 points per dollar on travel and dining, and 1.5 points per dollar on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 75,000 online bonus points (a $750 value) after you spend $5,000 in the first 90 days.  Get up to $550 in statement credits for airline incidentals, TSA PreCheck\u00ae/Global Entry, and lifestyle conveniences.  No foreign transaction fees.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Airline Incidental Statement Credits',
        description:
          'Receive up to $300 annually in Airline Incidental Statement Credits for qualifying purchases such as seat upgrades, baggage fees, airline lounge fees and in-flight services',
        benefit_type: 'statement_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: 'qualifying purchases',
      },
      {
        name: 'Lifestyle Statement Credits',
        description:
          'Receive up to $150 annually for lifestyle conveniences including video streaming services, food delivery, fitness subscriptions and rideshare services',
        benefit_type: 'statement_credit',
        value: 150.0,
        value_unit: 'dollars',
        spend_requirement: 'qualifying purchases',
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae Statement Credit',
        description:
          'Receive up to $100 in statement credits for either Global Entry or TSA PreCheck\u00ae application fees, every four years',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: 'every four years',
      },
      {
        name: 'Airfare Savings',
        description:
          'Save 20% on domestic or international airfare for any class when you pay with points',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Airport Lounge Access',
        description:
          'Enjoy free unlimited access to airport lounges and experiences worldwide with your complimentary Priority Pass\u2122 Select Memberships.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Infinite Luxury Hotel Collection',
        description:
          'Enjoy benefits at premium hotels, including late checkouts, free breakfast daily for two, automatic upgrades and more. (some benefits based on availability)',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Infinite Car Rental Benefits',
        description:
          'Get VIP amenities, complimentary status upgrades and discounts with Avis\u00ae, Hertz\u00ae, and National\u00ae.',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Protections',
        description:
          'Travel Insurance protections to assist with trip delays, cancellations and interruptions, baggage delay, lost luggage reimbursement, roadside assistance, and emergency evacuation and transportation.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Full Service Concierge',
        description:
          'Open the door to unique experiences, find tickets to top sports and entertainment events, book travel, make dinner reservations and more with complimentary 24/7 Premium Rewards\u00aeElite Visa Infinite\u00aeConcierge service.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'points',
        description:
          'Earn 75,000 bonus points after you make at least $5,000 in purchases in the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_premium_rewards_elite.png',
  },
  [CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS]: {
    id: CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS,
    name: 'Bank of America\u00ae Customized Cash Rewards Credit Card for Students',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071226&productoffercode=KE&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/student-cash-back-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071226&productoffercode=KE&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8ckn_cshsigcm_v_250x158.png',
    rewardsSummary:
      'Earn unlimited cash rewards with 3% cash back in a category of your choice, 2% cash back at grocery stores and wholesale clubs, and 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'choice',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'This Bank of America Customized Cash Rewards credit card for students offers a $200 online cash rewards bonus after spending $1,000 in the first 90 days.  It features a 0% introductory APR for 15 billing cycles on purchases and balance transfers, and no annual fee.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [
      'gas',
      'onlineShopping',
      'dining',
      'travel',
      'drugstore',
      'homeImprovement',
    ],
    benefits: [
      {
        name: '$200 online cash rewards bonus offer',
        description:
          'Online $200 cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: '1000 dollars in 90 days',
      },
    ],
    signupBonus: [
      {
        spendRequirement: '1000',
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash rewards bonus after you make at least $1,000 in purchases within the first 90 days of opening your account.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_customized_cash_rewards_for_students.png',
  },
  [CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS]: {
    id: CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS,
    name: 'Bank of America\u00ae Unlimited Cash Rewards Credit Card for Students',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071258&productoffercode=2H&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-student-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071258&productoffercode=2H&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cty_cshsigcm_v_250x157.png',
    rewardsSummary: 'Earn unlimited 1.5% cash back on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Start building a successful financial future today while earning unlimited 1.5% cash back on all purchases.  Enjoy no annual fee while earning unlimited cash back on all purchases.  This online only offer may not be available if you leave this page, if you visit a Bank of America financial center or call the bank.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'cash_back',
        description:
          'Online $200 cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_unlimited_cash_rewards_for_students.png',
  },
  [CreditCard.BANKAMERICARD_FOR_STUDENTS]: {
    id: CreditCard.BANKAMERICARD_FOR_STUDENTS,
    name: 'BankAmericard\u00ae Credit Card for Students',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4069143&productoffercode=XY&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/low-interest-student-credit-card/?campaign=4069143~XY~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4069143&productoffercode=XY&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cae_nrwcm_mc_250x158.png',
    rewardsSummary:
      'This card offers no annual fee and helps you build credit.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      "Get on the path to building your credit and save on interest, a great choice when you're just starting out.  No annual fee. Review rates and fees.",
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bankamericard_for_students.png',
  },
  [CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS]: {
    id: CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS,
    name: 'Bank of America\u00ae Travel Rewards Credit Card for Students',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071166&productoffercode=T7&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/student-rewards-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071166&productoffercode=T7&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'travel',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8blm_trvsigcm_v_250x158.png',
    rewardsSummary:
      'Earn unlimited 1.5 points for every $1 you spend on all purchases everywhere, every time, and no expiration on points as long as your account remains open.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'travel',
      },
    ],
    creditScore: null,
    cardSummary:
      'Start building a successful financial future today while earning unlimited 1.5 points for every $1 you spend on all purchases.  Enjoy no annual fee and no foreign transaction fees on purchases while earning points to use for statement credit to pay for flights, hotels, vacation packages, cruises, rental cars or baggage fees, and also at restaurants\u2014including takeout.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: '$1,000',
        spendRequirementMonths: 3,
        bonusValue: 25000,
        bonusValueUnit: 'points',
        description:
          '25,000 online bonus points if you make at least $1,000 in purchases in the first 90 days of your account opening \u2013 which can be redeemed for a $250 statement credit toward travel and dining purchases.',
      },
    ],
    cardType: 'personal',
    imageName: 'bank_of_america_travel_rewards_for_students.png',
  },
  [CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED]: {
    id: CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED,
    name: 'Bank of America\u00ae Customized Cash Rewards Secured Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071217&productoffercode=HF&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/cash-back-secured-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071217&productoffercode=HF&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8ckn_cshcm_v_250x158.png',
    rewardsSummary:
      'Earn unlimited cash back rewards at a rate of 3%, 2%, or 1% depending on the category.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'online shopping',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'drug stores and pharmacies',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'home improvement and furnishings',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery stores',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'wholesale clubs',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'all other purchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Help strengthen or build your credit and earn cash back.  Looks and works like any other credit card.  No annual fee.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [
      'gas',
      'online shopping',
      'dining',
      'travel',
      'drug stores and pharmacies',
      'home improvement and furnishings',
    ],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bank_of_america_customized_cash_rewards_secured.png',
  },
  [CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED]: {
    id: CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED,
    name: 'Bank of America\u00ae Unlimited Cash Rewards Secured Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071252&productoffercode=B5&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-secured-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071252&productoffercode=B5&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cty_cshcm_v_250x157.png',
    rewardsSummary: 'Earn unlimited 1.5% cash back on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Help establish, strengthen, or even rebuild your credit and earn unlimited cash back on all purchases, without a second thought.  Earn unlimited 1.5% cash back on all purchases; no limit to the amount of cash back you can earn and cash rewards do not expire as long as your account remains open.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bank_of_america_unlimited_cash_rewards_secured.png',
  },
  [CreditCard.BANKAMERICARD_SECURED]: {
    id: CreditCard.BANKAMERICARD_SECURED,
    name: 'BankAmericard\u00ae Secured Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4069138&productoffercode=SF&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/secured-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4069138&productoffercode=SF&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cae_nrwcm_mc_250x158.png',
    rewardsSummary: 'This card does not offer a traditional rewards program.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The BankAmericard Secured Credit Card helps you build credit with no annual fee.  It requires a security deposit, and your credit limit will be based on that deposit, your income, and your ability to repay.  You can access your FICO\u00ae Score for free monthly.',
    cardNetwork: null,
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bankamericard_secured.png',
  },
  [CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED]: {
    id: CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED,
    name: 'Bank of America\u00ae Travel Rewards Secured Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071173&productoffercode=7Y&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/travel-rewards-secured-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071173&productoffercode=7Y&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8blm_trvcm_v_250x158.png',
    rewardsSummary:
      'Earn unlimited 1.5 points for every $1 you spend on all purchases everywhere, every time and no expiration on points as long as your account remains open.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Help establish, strengthen, or even rebuild your credit and earn unlimited points with no expiration on points as long as your account remains open.  No annual fee and no foreign transaction fees.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bank_of_america_travel_rewards_secured.png',
  },
  [CreditCard.ALASKA_AIRLINES_VISA_SIGNATURE]: {
    id: CreditCard.ALASKA_AIRLINES_VISA_SIGNATURE,
    name: 'Alaska Airlines Visa Signature\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4072745&productoffercode=RJ&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/alaska-airlines-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4072745&productoffercode=RJ&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'alaska',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/1bbt_sigcm_v_mileageplan_250x158.png',
    rewardsSummary:
      'Earn unlimited miles on purchases with bonus miles for Alaska Airlines, gas, EV charging stations, cable, streaming services, and local transit purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.alaska',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'streaming',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
    ],
    creditScore: null,
    cardSummary:
      "Earn 70,000 bonus miles plus Alaska's Famous Companion Fare\u2122 with $3,000 in purchases within 90 days.  Enjoy free checked bags, priority boarding, and a $99 Companion Fare each anniversary year after spending $6,000.",
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free checked bag',
        description:
          'Free checked bag for any cardholder who purchases airfare with their card, and up to 6 additional guests traveling on the same reservation.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: 'Purchase airfare with card',
      },
      {
        name: 'Priority boarding',
        description:
          'Enjoy priority boarding when you pay for your flight with your card, so you can get to your seat quicker.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: 'Pay for flight with card',
      },
      {
        name: "Alaska's Famous Companion Fare\u2122",
        description:
          'Get a $99 Companion Fare (plus taxes and fees from $23) each account anniversary after you spend $6,000 or more in purchases within the prior anniversary year.',
        benefit_type: 'bogo_flight_coupon',
        value: 99.0,
        value_unit: 'dollars',
        spend_requirement: '$6,000 in purchases within prior anniversary year',
      },
      {
        name: '20% back on Alaska Airlines inflight purchases',
        description:
          'Enjoy 20% back on Alaska Airlines inflight purchases when you pay with your new card.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 20.0,
        value_unit: 'percent',
        spend_requirement: 'Pay with card',
      },
      {
        name: '$100 off an annual Alaska Lounge+ Membership',
        description:
          'Get $100 off an annual Alaska Lounge+ Membership purchased with your Alaska card.',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: 'Purchase with Alaska card',
      },
      {
        name: '10% rewards bonus',
        description:
          'You can also earn a 10% rewards bonus on all miles earned from card purchases if you have an eligible Bank of America\u00ae account.',
        benefit_type: 'anniversary_bonus',
        value: 10.0,
        value_unit: 'percent',
        spend_requirement: 'Have an eligible Bank of America account',
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 70000,
        bonusValueUnit: 'miles',
        description:
          "Earn 70,000 bonus miles plus Alaska's Famous Companion Fare\u2122 ($99 fare plus taxes and fees from $23) with this offer. To qualify, make $3,000 or more in purchases within the first 90 days of opening your account.",
      },
    ],
    cardType: 'personal',
    imageName: 'alaska_airlines_visa_signature.png',
  },
  [CreditCard.SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS]: {
    id: CreditCard.SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS,
    name: 'Susan G. Komen\u00ae Customized Cash Rewards Visa\u00ae credit card from Bank of America',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4070517&productoffercode=DR&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/susan-komen-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4070517&productoffercode=DR&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/qvys_sigcm_v_250.png',
    rewardsSummary:
      'This card earns 3% cash back in a category of your choice, 2% cash back at grocery stores and wholesale clubs, and 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'online shopping',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'drug stores and pharmacies',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'home improvement and furnishings',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery stores',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'wholesale clubs',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 2500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Susan G. Komen\u00ae Customized Cash Rewards Visa\u00ae credit card offers a $200 online cash rewards bonus after spending $1,000 in the first 90 days.  It earns 3% cash back in a choice category, 2% at grocery stores and wholesale clubs, and 1% on all other purchases. There is no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [
      'gas',
      'online shopping',
      'dining',
      'travel',
      'drug stores and pharmacies',
      'home improvement and furnishings',
    ],
    benefits: [
      {
        name: 'Online Cash Rewards Bonus',
        description:
          'Earn a $200 online cash rewards bonus after making at least $1,000 in purchases in the first 90 days of your account opening.',
        benefit_type: 'cash_bonus_amount',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: 1000.0,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash rewards bonus after you spend $1,000 in purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'susan_g_komen_customized_cash_rewards.png',
  },
  [CreditCard.FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD,
    name: 'Free Spirit\u00ae Travel More World Elite Mastercard\u00ae',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4070592&productoffercode=Y9&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/spirit-airlines-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4070592&productoffercode=Y9&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'frontier',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/ragb_eltcm_mc_blk_250.png',
    rewardsSummary:
      'Earn 3 points per $1 spent on eligible Spirit purchases, 2 points per $1 on dining and grocery, and 1 point per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.frontier',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Free Spirit\u00ae Travel More World Elite Mastercard\u00ae earns 3 points per $1 on Spirit Airlines purchases, 2 points on dining and groceries, and 1 point on all other purchases.  There's no limit to points earned, and points don't expire as long as your account is open.  Enjoy an introductory annual fee of $0 for the first year; a $79 fee will apply thereafter.",
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Group 2 Priority Boarding',
        description: 'Group 2 Priority Boarding on all flights',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% rebate on inflight food and beverage purchases',
        description:
          '25% rebate on all inflight food and beverage purchases when you pay with your card',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Companion Flight Voucher',
        description:
          'Receive a $100 Companion Flight Voucher each anniversary after making at least $5,000 in purchases within the prior anniversary year',
        benefit_type: 'bogo_flight_coupon',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: '5000.0',
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'points',
        description:
          'Online Offer: Earn 50,000 bonus points plus a $100 Companion Flight Voucher after making at least $1,000 in purchases within the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'free_spirit_travel_more_world_elite_mastercard.png',
  },
  [CreditCard.ALLWAYS_REWARDS_VISA]: {
    id: CreditCard.ALLWAYS_REWARDS_VISA,
    name: 'Allways Rewards Visa\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071700&productoffercode=NH&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/allegiant-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071700&productoffercode=NH&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/ragp_sigcm_v_250.png',
    rewardsSummary:
      'Earn 3 points per $1 spent on Allegiant purchases, 2 points per $1 on dining, and 1 point per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Allways Rewards Visa\u00ae Credit Card offers easy-to-earn and easy-to-redeem points with no blackout dates or minimum redemption requirements.  Earn 3 points per $1 on Allegiant purchases, 2 points on dining, and 1 point on all other purchases.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Priority Boarding',
        description:
          'Complimentary priority boarding and one free beverage every time you fly Allegiant when you present your Allways Rewards Visa\u00ae credit card',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Buy One, Get One Free',
        description:
          'Buy one, get one free airfare offer anytime you use your card to purchase a vacation package from Allegiant with 4 or more hotel nights or 7 or more rental car days on the same itinerary when you call Allegiant Member Services for booking.',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 25000,
        bonusValueUnit: 'points',
        description:
          'Online Offer: Earn 25,000 bonus points, equal to $250 off a future Allegiant trip, after you make $1,000 or more in purchases within the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'allways_rewards_visa.png',
  },
  [CreditCard.AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD,
    name: 'Air France KLM World Elite Mastercard\u00ae',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4073826&productoffercode=GS&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/air-france-credit-card/?campaign=4073826~GS~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4073826&productoffercode=GS&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'miles',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/1bdx_eltwldcm_mc_250x158.png',
    rewardsSummary:
      'Earn 3 miles per $1 spent on Air France, KLM, and SkyTeam airlines, and 1.5 miles per $1 on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'miles',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'miles',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Air France KLM World Elite Mastercard\u00ae offers 50,000 bonus miles after spending $2,000 in 90 days, plus 5,000 anniversary miles.  Earn 3x miles on Air France, KLM, and SkyTeam airlines and 1.5x miles on all other purchases.  No foreign transaction fees apply.',
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Anniversary Miles',
        description:
          '5,000 Miles every year on your account anniversary after you spend $50 or more on purchases within the anniversary year',
        benefit_type: 'anniversary_bonus',
        value: 5000,
        value_unit: 'miles',
        spend_requirement: '$50',
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'No foreign transaction fees when making purchases outside of the United States',
        benefit_type: 'no_foreign_transaction_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$2000',
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Online Offer: Get 50,000 Bonus Miles after you make $2,000 or more in purchases within the first 90 days of your account opening',
      },
    ],
    cardType: 'personal',
    imageName: 'air_france_klm_world_elite_mastercard.png',
  },
  [CreditCard.ROYAL_CARIBBEAN_VISA_SIGNATURE]: {
    id: CreditCard.ROYAL_CARIBBEAN_VISA_SIGNATURE,
    name: 'Royal Caribbean\u00ae Visa Signature\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4072729&productoffercode=6W&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/royal-caribbean-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4072729&productoffercode=6W&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'mycruise_points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/raem_sigcm_v_250x158.png',
    rewardsSummary:
      'Earn 2 MyCruise points per $1 spent on Royal Caribbean and partner brands, and 1 point per $1 on other purchases.',
    rewardsEarnRates: [
      {
        category: 'Royal Caribbean and partners',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'mycruise_points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'mycruise_points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Royal Caribbean Visa Signature card offers no annual fee, no foreign transaction fees, and earns MyCruise rewards redeemable for onboard credits, cruise discounts, upgrades, and vacations.  Earn 2x points on Royal Caribbean purchases and 1x point on all other purchases.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Online Offer: 30,000 MyCruise\u00ae bonus points',
        description:
          '30,000 bonus points after making at least $1,000 in purchases in the first 90 days of your account opening. Valued at $300 onboard credit.',
        benefit_type: 'anniversary_bonus',
        value: 30000,
        value_unit: 'points',
        spend_requirement: '$1,000',
      },
      {
        name: 'Airfare discount',
        description:
          "$50 Discount on Royal Caribbean's Air2Sea program after making at least $3,500 in card purchases within the first 90 days of account opening",
        benefit_type: 'travel_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: '$3,500',
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$1,000',
        spendRequirementMonths: 3,
        bonusValue: 30000,
        bonusValueUnit: 'points',
        description:
          'Earn 30,000 bonus points after you make at least $1,000 in purchases in the first 3 months of account opening.  This is worth $300 in onboard credit.',
      },
    ],
    cardType: 'personal',
    imageName: 'royal_caribbean_visa_signature.png',
  },
  [CreditCard.NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD]: {
    id: CreditCard.NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD,
    name: 'Norwegian Cruise Lineu00ae World Mastercardu00ae',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4070523&productoffercode=7Q&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/norwegian-cruise-lines-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4070523&productoffercode=7Q&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'norwegian_cruise_points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/radz_wldcm_mc_250x158.png',
    rewardsSummary:
      'Earn 3 WorldPointsu00ae points for every $1 spent on Norwegian purchases, 2 WorldPointsu00ae points per $1 spent on eligible air and hotel purchases and 1 WorldPointsu00ae point per $1 spent on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'Norwegian purchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'norwegian_cruise_points',
      },
      {
        category: 'eligible air and hotel purchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'norwegian_cruise_points',
      },
      {
        category: 'all other purchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'norwegian_cruise_points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn triple points on Norwegian purchases, double points on eligible air and hotel purchases, and 1 point per $1 on all other purchases.  Redeem points for stateroom upgrades, travel discounts, onboard credits, and more.  No annual fee and no foreign transaction fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'points',
        description:
          'Get 20,000 bonus points after you make $1,000 or more in purchases in the first 90 days of account openingu2013which can be redeemed for a $200 off your next Norwegian cruise.',
      },
    ],
    cardType: 'personal',
    imageName: 'norwegian_cruise_line_world_mastercard.png',
  },
  [CreditCard.CELEBRITY_CRUISES_VISA_SIGNATURE]: {
    id: CreditCard.CELEBRITY_CRUISES_VISA_SIGNATURE,
    name: 'Celebrity Cruises Visa Signature\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4072738&productoffercode=QT&locale=en_US',
    learn_more_link:
      'https://www.bankofamerica.com/credit-cards/products/celebrity-cruises-credit-card/',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4072738&productoffercode=QT&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'mycruise_points',
    creditCardImageUrl:
      'https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/ragf_sigcm_v_250.png',
    rewardsSummary:
      'Earn 2 MyCruise points per $1 spent on Celebrity Cruises and sister brands, and 1 point per $1 on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'mycruise_points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'mycruise_points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn MyCruise\u00ae points on purchases, with bonus points after meeting a minimum spend. Redeem points for onboard credit, upgrades, and cruises.',
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: '$1000',
        spendRequirementMonths: 3,
        bonusValue: 30000,
        bonusValueUnit: 'points',
        description:
          'Earn 30,000 bonus points after you make at least $1,000 in purchases in the first 90 days of account opening.  This is worth $300 in onboard credit.',
      },
    ],
    cardType: 'personal',
    imageName: 'celebrity_cruises_visa_signature.png',
  },
  [CreditCard.BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD]: {
    id: CreditCard.BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD,
    name: 'Business Advantage Customized Cash Rewards credit card',
    apply_link:
      'https://secure.bankofamerica.com/applynow/initialize-workflow.go?requesttype=BCC&campaignid=4065310&productoffercode=DS&locale=en_US&mktg_track=undefined',
    learn_more_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/products/cash-rewards-business-credit-card/?campaign=4065310~DS~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/terms-and-conditions/?campaignid=4065310&productoffercode=DS&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_cshbuscm_mc-CSXc0949a8f.png',
    rewardsSummary:
      'Earn 3% cash back in the category of your choice, 2% cash back on dining purchases and 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'officeSupplies',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'internetCablePhone',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'computerServices',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'businessConsultingServices',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 50000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "Get a $300 online statement credit after you make at least $3,000 in purchases in the first 90 days of your account opening. Earn 3% cash back in the category of your choice, 2% cash back on dining purchases and 1% cash back on all other purchases.  You'll earn 3% and 2% cash back on the first $50,000 in combined choice category/dining purchases each calendar year, 1% thereafter.",
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America, N.A.',
    selectableCategories: [
      'gas',
      'officeSupplies',
      'travel',
      'internetCablePhone',
      'computerServices',
      'businessConsultingServices',
    ],
    benefits: [
      {
        name: '$300 online statement credit bonus offer',
        description:
          'Get a $300 online statement credit after you make at least $3,000 in purchases in the first 90 days of your account opening.',
        benefit_type: 'statement_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: 3000.0,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'business_advantage_customized_cash_rewards_credit_card.png',
  },
  [CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD]: {
    id: CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD,
    name: 'Business Advantage Unlimited Cash Rewards Mastercard\u00ae Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/applynow/initialize-workflow.go?requesttype=BCC&campaignid=4065284&productoffercode=NV&locale=en_US&mktg_track=undefined',
    learn_more_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-business-credit-card/?campaign=4065284~NV~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/terms-and-conditions/?campaignid=4065284&productoffercode=NV&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_cshbuscm_mc_sky-CSX944967d2.png',
    rewardsSummary: 'Earn unlimited 1.5% cash back on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 1.5% cash back on every purchase, every time.  No annual fee.  Redeem rewards as a statement credit, deposit, or check.',
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: 'Statement Credit',
        description:
          'Get a $300 online statement credit after you make at least $3,000 in purchases in the first 90 days of your account opening.',
        benefit_type: 'statement_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: '$3,000',
      },
      {
        name: 'Purchase Protection',
        description:
          'Additional protections cover certain purchases against loss, damage, theft, or fire and provide extended warranty coverage.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Services',
        description:
          'Travel benefits your business needs including $100,000 in travel accident insurance. Additional services include auto rental insurance, emergency ticket replacement, lost-luggage assistance and legal and medical referrals when you\u2019re away from home.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Balance Connect\u00ae for overdraft protection',
        description:
          'An optional service to help prevent declined purchases, returned checks or other overdrafts when you link your credit card to a Bank of America business checking account for overdraft protection through Balance Connect\u00ae.',
        benefit_type: 'overdraft_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud Monitoring',
        description:
          'We block potential fraud if abnormal patterns are detected and let you know if we suspect fraudulent activity.',
        benefit_type: 'fraud_monitoring',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Paperless Statement Option',
        description:
          'Opt for paperless credit card statements and increase account security while reducing paper consumption.',
        benefit_type: 'paperless_statement',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cash Flow Management Tools',
        description:
          'Manage your business with a suite of online services including automatic payments, transfers and downloading transactions into QuickBooks.',
        benefit_type: 'cash_flow_management',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Online & Mobile Access',
        description:
          'Manage your account online 24/7 with secure Online and Mobile Banking. Check your balance and keep tabs on account activity for you and your employees easily anytime, anywhere.',
        benefit_type: 'online_banking',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free access to business credit scores',
        description:
          'View your Dun & Bradstreet business credit scores for free within Business Advantage 360, our Small Business Online Banking.',
        benefit_type: 'credit_score',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$3,000',
        spendRequirementMonths: 3,
        bonusValue: 300.0,
        bonusValueUnit: 'dollars',
        description:
          'Get a $300 online statement credit after you make at least $3,000 in purchases in the first 90 days of your account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'business_advantage_unlimited_cash_rewards_credit_card.png',
  },
  [CreditCard.BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD]: {
    id: CreditCard.BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD,
    name: 'Business Advantage Travel Rewards World Mastercard\u00ae credit card',
    apply_link:
      'https://secure.bankofamerica.com/applynow/initialize-workflow.go?requesttype=BCC&campaignid=4069740&productoffercode=GU&locale=en_US&mktg_track=undefined',
    learn_more_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/products/travel-rewards-business-credit-card/?campaign=4069740~GU~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/terms-and-conditions/?campaignid=4069740&productoffercode=GU&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'travel',
    creditCardImageUrl:
      'https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_trvbuswldcm_mc-CSX44dee15a.png',
    rewardsSummary:
      'Earn unlimited 1.5 points per $1 spent on all purchases, everywhere, every time.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'travel',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 1.5 points per $1 spent on all purchases; redeem points for statement credit towards travel and dining purchases, or for travel with no blackout dates at the Bank of America\u00ae Travel Center; no annual fee and no international transaction fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Travel and Emergency Services',
        description:
          'Travel services your business needs including $1 million in travel accident insurance, lost luggage reimbursement, trip cancellation coverage, and trip delay reimbursement.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free access to business credit scores',
        description:
          'View your Dun & Bradstreet business credit scores for free within Business Advantage 360, our Small Business Online Banking.',
        benefit_type: 'credit_score',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Balance Connect\u00ae for overdraft protection',
        description:
          'An optional service to help prevent declined purchases, returned checks or other overdrafts when you link your credit card to a Bank of America business checking account for overdraft protection through Balance Connect\u00ae.',
        benefit_type: 'overdraft_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero liability protection for unauthorized transactions',
        description:
          'Zero liability protection for unauthorized transactions. Additional protections cover certain purchases against loss, damage, theft, or fire and provide extended warranty coverage.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Paperless Statement Option',
        description:
          'Opt for paperless credit card statements and increase account security while reducing paper consumption.',
        benefit_type: 'paperless_statement',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000,
        spendRequirementMonths: 3,
        bonusValue: 30000,
        bonusValueUnit: 'points',
        description:
          'Earn 30,000 online bonus points after you made at least $3,000 in purchases in the first 90 days of your account opening, which can be redeemed for a $300 statement credit towards travel or dining purchases.',
      },
    ],
    cardType: 'business',
    imageName: 'business_advantage_travel_rewards_credit_card.png',
  },
  [CreditCard.ALASKA_AIRLINES_BUSINESS_CREDIT_CARD]: {
    id: CreditCard.ALASKA_AIRLINES_BUSINESS_CREDIT_CARD,
    name: 'Alaska Airlines Visa\u00ae Business Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/applynow/initialize-workflow.go?requesttype=BCC&campaignid=4073360&productoffercode=UP&locale=en_US&mktg_track=undefined',
    learn_more_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/products/alaska-airlines-business-credit-card/?campaign=4073360~UP~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/terms-and-conditions/?campaignid=4073360&productoffercode=UP&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'alaska',
    creditCardImageUrl:
      'https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_alaska-CSX98c324d2.png',
    rewardsSummary:
      'Earn 3 miles per dollar on Alaska Airlines purchases, 2 miles per dollar on gas, EV charging, shipping, and transit, and 1 mile per dollar on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.alaska',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'travel.transit',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'shipping',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'alaska',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Alaska Airlines Visa\u00ae Business Credit Card offers 70,000 bonus miles and Alaska's Famous Companion Fare\u2122 after spending $4,000 in the first 90 days.  It earns 3x miles on Alaska Airlines purchases, 2x on gas and transit, and 1x on other purchases.  Cardholders also receive a free checked bag and priority boarding on Alaska Airlines flights.",
    cardNetwork: 'Visa',
    issuer: 'Bank of America',
    selectableCategories: [],
    benefits: [
      {
        name: "Alaska's Famous Companion Fare\u2122",
        description:
          "Get Alaska's Famous Companion Fare ($99 fare plus taxes and fees from $23) each account anniversary after spending $6,000 or more on purchases within the prior anniversary year.",
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: '$6,000',
      },
      {
        name: 'Free Checked Bag',
        description:
          'Free checked bag for any cardholder and up to 6 guests on the same reservation when you pay for your flight with your card.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Priority Boarding',
        description:
          'Priority Boarding for any cardholder when paying for the flight with an Alaska Airlines Business card.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Alaska Airlines Inflight Purchase Discount',
        description:
          'Enjoy 20% back on Alaska Airlines inflight purchases when you pay with your new card.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 0.2,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Alaska Lounge+ Membership Discount',
        description:
          'Get $100 off an annual Alaska Lounge+ Membership purchased with your Alaska Airlines Business card.',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$4,000',
        spendRequirementMonths: 3,
        bonusValue: 70000,
        bonusValueUnit: 'miles',
        description:
          "Get 70,000 bonus miles and Alaska's Famous Companion Fare\u2122 after you make $4,000 or more in purchases within the first 90 days of opening your account.",
      },
    ],
    cardType: 'business',
    imageName: 'alaska_airlines_business_credit_card.png',
  },
  [CreditCard.PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD]: {
    id: CreditCard.PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD,
    name: 'Platinum Plus\u00ae Mastercard\u00ae Business Credit Card',
    apply_link:
      'https://secure.bankofamerica.com/applynow/initialize-workflow.go?requesttype=BCC&campaignid=4065316&productoffercode=8T&locale=en_US&mktg_track=undefined',
    learn_more_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/products/platinum-plus-business-credit-card/?campaign=4065316~8T~en_US',
    terms_and_conditions_button_text: 'Terms & Conditions',
    terms_and_conditions_link:
      'https://www.bankofamerica.com/smallbusiness/credit-cards/terms-and-conditions/?campaignid=4065316&productoffercode=8T&locale=en_US',
    bank_name: 'Bank of America',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_pltbuscm_mc-CSX9775b891.png',
    rewardsSummary:
      'Get a $300 online statement credit after you make at least $3,000 in purchases in the first 90 days of your account opening.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'Get a competitive APR with no annual fee\u2020 with a Platinum Plus\u00ae Mastercard\u00ae Business card.  Get a $300 online statement credit after you make at least $3,000 in purchases in the first 90 days of your account opening.  Manage your business with a suite of online services including automatic payments, transfers and downloading transactions into QuickBooks.',
    cardNetwork: 'Mastercard',
    issuer: 'Bank of America, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Statement Credit',
        description: 'Get a $300 online statement credit',
        benefit_type: 'statement_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: '$3,000 in purchases in the first 90 days',
      },
      {
        name: 'Employee Cards',
        description:
          'Get employee cards at no additional cost to you and with credit limits you set.',
        benefit_type: 'employee_cards',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard Easy Saving\u00ae Program',
        description:
          'Mastercard Easy Saving\u00ae Program \u2014 No coupons. No codes. Just automatic rebates when you pay with your card at tens of thousands of locations across the U.S.',
        benefit_type: 'cash_back',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Services',
        description:
          "Travel benefits your business needs including $100,000 in travel accident insurance. Additional services include auto rental insurance, emergency ticket replacement, lost-luggage assistance and legal and medical referrals when you're away from home.",
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free access to business credit scores',
        description:
          'View your Dun & Bradstreet business credit scores for free within Business Advantage 360, our Small Business Online Banking.',
        benefit_type: 'credit_score',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero liability protection',
        description:
          'Zero liability protection for unauthorized transactions. Additional protections cover certain purchases against loss, damage, theft, or fire and provide extended warranty coverage.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Balance Connect\u00ae for overdraft protection',
        description:
          'An optional service to help prevent declined purchases, returned checks or other overdrafts when you link your credit card to a Bank of America business checking account for overdraft protection through Balance Connect\u00ae.',
        benefit_type: 'overdraft_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud Monitoring',
        description:
          'We block potential fraud if abnormal patterns are detected and let you know if we suspect fraudulent activity.',
        benefit_type: 'fraud_monitoring',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'platinum_plus_mastercard_business_card.png',
  },
  [CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD]:
    {
      id: CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD,
      name: 'Business Advantage Unlimited Cash Rewards Secured Business Credit Card',
      apply_link:
        'https://secure.bankofamerica.com/applynow/initialize-workflow.go?requesttype=BCC&campaignid=4065324&productoffercode=9G&locale=en_US&mktg_track=undefined',
      learn_more_link:
        'https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-secured-business-credit-card/?campaign=4065324~9G~en_US',
      terms_and_conditions_button_text: 'Terms & Conditions',
      terms_and_conditions_link:
        'https://www.bankofamerica.com/smallbusiness/credit-cards/terms-and-conditions/?campaignid=4065324&productoffercode=9G&locale=en_US',
      bank_name: 'Bank of America',
      rewardsType: 'cash_back',
      creditCardImageUrl:
        'https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_cshbuscm_mc_sky-CSX944967d2.png',
      rewardsSummary:
        "Earn 1.5% cash back on every purchase, every time, with no annual cap and rewards that don't expire as long as your account remains open.",
      rewardsEarnRates: [
        {
          category: 'allPurchases',
          earnRate: 1.5,
          excludeMerchants: [],
          spendCap: null,
          spendMinimum: null,
          minimumTransactionCount: null,
          minimumTransactionAmount: null,
          rewardsType: 'cash_back',
        },
      ],
      creditScore: null,
      cardSummary:
        'The Business Advantage Unlimited Cash Rewards Secured Business Credit Card offers unlimited 1.5% cash back on all purchases and a $1,000 minimum security deposit.  With consistent, on-time payments, you could improve your business credit over time and potentially transition to an unsecured card.',
      cardNetwork: 'Mastercard',
      issuer: 'Bank of America',
      selectableCategories: [],
      benefits: [
        {
          name: 'Travel and Emergency Services',
          description:
            'Travel benefits your business needs including $100,000 in travel accident insurance. Additional services include auto rental insurance, emergency ticket replacement, lost-luggage assistance and legal and medical referrals when you\u2019re away from home.',
          benefit_type: 'travel_insurance',
          value: null,
          value_unit: null,
          spend_requirement: null,
        },
        {
          name: 'Free access to business credit scores',
          description:
            'View your Dun & Bradstreet business credit scores for free within Business Advantage 360, our Small Business Online Banking.',
          benefit_type: 'credit_limit_increase',
          value: null,
          value_unit: null,
          spend_requirement: null,
        },
        {
          name: 'Zero liability protection',
          description:
            'Zero liability protection for unauthorized transactions. Additional protections cover certain purchases against loss, damage, theft, or fire and provide extended warranty coverage.',
          benefit_type: 'purchase_protection',
          value: null,
          value_unit: null,
          spend_requirement: null,
        },
        {
          name: 'Balance Connect\u00ae for overdraft protection',
          description:
            'An optional service to help prevent declined purchases, returned checks or other overdrafts when you link your credit card to a Bank of America business checking account for overdraft protection through Balance Connect\u00ae.',
          benefit_type: 'purchase_protection',
          value: null,
          value_unit: null,
          spend_requirement: null,
        },
      ],
      signupBonus: [],
      cardType: 'business',
      imageName:
        'business_advantage_unlimited_cash_rewards_mastercard_secured_credit_card.png',
    },
  [CreditCard.PLATINUM_MASTERCARD]: {
    id: CreditCard.PLATINUM_MASTERCARD,
    name: 'Platinum Mastercard\u00ae from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32179',
    learn_more_link: 'https://www.capitalone.com/credit-cards/platinum/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/plat_cardart_prim_323x203.png',
    rewardsSummary:
      'This card offers automatic credit line reviews and CreditWise access, along with $0 fraud liability.',
    rewardsEarnRates: [],
    creditScore: 'FAIR',
    cardSummary:
      'The Capital One Platinum Mastercard\u00ae has no annual fee and offers automatic credit line reviews after 6 months.  It also includes CreditWise access for free credit score monitoring and $0 fraud liability.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic Credit Line Reviews',
        description:
          'Be automatically considered for a higher credit line in as little as 6 months.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'CreditWise',
        description:
          'Enjoy unlimited access to your credit score and tools to help you monitor your credit profile with CreditWise from Capital One.  It\u2019s free and available to anyone, whether or not you have a Capital One product.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability',
        description:
          "You're covered by $0 Fraud Liability if your card is ever lost or stolen. That means you will not be responsible for fraudulent purchases.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Tap to Pay',
        description:
          'Check out faster and securely with your contactless card. Simply hold or tap your card on a contactless-enabled card reader and you are good to go.',
        benefit_type: 'contactlesswave',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'platinum_mastercard.png',
  },
  [CreditCard.VENTURE_X_REWARDS]: {
    id: CreditCard.VENTURE_X_REWARDS,
    name: 'Venture X Rewards Credit Card',
    apply_link: 'https://applynow.capitalone.com/?productId=31830',
    learn_more_link: 'https://www.capitalone.com/credit-cards/venture-x/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/venturex-cg-static-card-1000x630-2.png',
    rewardsSummary:
      'The Venture X card earns unlimited 2X miles on all purchases, 5X miles on flights and vacation rentals booked through Capital One Travel, and 10X miles on hotels and rental cars booked through Capital One Travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.rentalCar',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'The Capital One Venture X Rewards Credit Card offers a variety of travel benefits, including a $300 annual travel credit, complimentary airport lounge access, and a high welcome bonus.  It earns unlimited miles on purchases, with bonus miles on travel and other select categories.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Travel Credit',
        description:
          'Receive a $300 annual credit for bookings through Capital One Travel.',
        benefit_type: 'travel_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae Credit',
        description:
          'Receive up to a $120 credit for Global Entry or TSA PreCheck\u00ae.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Airport Lounge Access',
        description:
          'Enjoy complimentary access to Capital One Lounges and 1,300+ partner lounges worldwide.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making purchases outside of the United States.',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          'Protect your cell phone every time you pay your bill with your Venture X card. If it\u2019s stolen or damaged, you\u2019ll get reimbursed up to $800. Certain terms, conditions and exclusions apply.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: "Miles Don't Expire",
        description:
          'Your miles won\u2019t expire for the life of the account.',
        benefit_type: 'miles_dont_expire',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary PRIOR Subscription',
        description:
          'Access extraordinary travel experiences, destination guides and more with a complimentary PRIOR Subscription (a $149 value).',
        benefit_type: 'subscription',
        value: 149.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Complimentary The Cultivist Membership',
        description:
          'Access extraordinary travel experiences, destination guides and more with a complimentary The Cultivist Membership.',
        benefit_type: 'subscription',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'miles',
        description:
          'Earn 75,000 bonus miles once you spend $4,000 on purchases within the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'venture_x_rewards.png',
  },
  [CreditCard.VENTURE_REWARDS]: {
    id: CreditCard.VENTURE_REWARDS,
    name: 'Capital One Venture Rewards',
    apply_link: 'https://applynow.capitalone.com/?productId=31858',
    learn_more_link: 'https://www.capitalone.com/credit-cards/venture/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/venture_cardart_prim_323x203-1.png',
    rewardsSummary:
      'Earn unlimited 2X miles on every purchase, every day, plus a one-time bonus of 75,000 miles after spending $4,000 in the first 3 months.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.rentalCar',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'The Capital One Venture Rewards Credit Card offers unlimited 2X miles on every purchase and 5X miles on hotels and rental cars booked through Capital One Travel.  It also comes with a 75,000 mile bonus after spending $4,000 in the first 3 months.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Hertz Five Star Status',
        description:
          'Skip the rental counter and choose from a wider selection of cars.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lifestyle Collection Experience Credit',
        description:
          'Receive a $50 experience credit on every Lifestyle Collection stay.',
        benefit_type: 'statement_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Global Entry or TSA PreCheck\u00ae Credit',
        description:
          'Receive up to a $120 credit for Global Entry or TSA PreCheck\u00ae.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          "You won't pay a transaction fee when making purchases outside of the United States.",
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Collision Damage Waiver',
        description:
          'Rent an eligible vehicle with your credit card and you can be covered for damage due to collision or theft.',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'miles',
        description:
          'Earn a one-time bonus of 75,000 miles after you spend $4,000 on purchases within the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'venture_rewards.png',
  },
  [CreditCard.VENTUREONE_REWARDS]: {
    id: CreditCard.VENTUREONE_REWARDS,
    name: 'VentureOne Rewards from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=31866',
    learn_more_link: 'https://www.capitalone.com/credit-cards/ventureone/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/ventureone_cardart_prim_323x203.png',
    rewardsSummary:
      'Earn unlimited 1.25 miles per dollar on every purchase, plus 5x miles on hotels and rental cars booked through Capital One Travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.25,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.rideshare',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'EXCELLENT',
    cardSummary:
      'The VentureOne card offers unlimited 1.25 miles per dollar on all purchases and 5x miles on hotels and rental cars booked through Capital One Travel, with no annual fee.  Earn a 20,000-mile bonus after spending $500 in the first 3 months.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          "You won't pay a transaction fee when making purchases outside of the United States.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Emergency Card Replacement',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transfer Your Miles',
        description:
          'With our Venture X, Venture and VentureOne miles rewards cards, transfer your miles to your choice of 15+ travel loyalty programs for more flexibility.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Shop With Your Rewards',
        description:
          'Now you can pay for Amazon.com purchases using your Capital One rewards.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'miles',
        description:
          'Earn 20,000 bonus miles once you spend $500 on purchases within the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'ventureone_rewards.png',
  },
  [CreditCard.VENTUREONE_REWARDS_FOR_GOOD_CREDIT]: {
    id: CreditCard.VENTUREONE_REWARDS_FOR_GOOD_CREDIT,
    name: 'VentureOne Rewards for Good Credit from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32201',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/ventureone-good-credit/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/ventureone_cardart_prim_323x203.png',
    rewardsSummary:
      'Earn unlimited 1.25 miles per dollar on every purchase, plus 5 miles per dollar on hotels and rental cars booked through Capital One Travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.25,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.rideshare',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD',
    cardSummary:
      'The VentureOne Rewards Credit Card offers unlimited 1.25 miles per dollar on all purchases and 5X miles on hotels and rental cars booked through Capital One Travel.  It has a $0 annual fee and no foreign transaction fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making a purchase outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Emergency Card Replacement',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transfer Your Miles*',
        description:
          'With our Venture and VentureOne miles rewards cards, transfer your miles to your choice of 15+ travel loyalty programs for more flexibility.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping**',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Shop With Your Rewards',
        description:
          'Now you can pay for Amazon.com purchases using your Capital One rewards.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'ventureone_rewards_for_good_credit.png',
  },
  [CreditCard.QUICKSILVER_REWARDS]: {
    id: CreditCard.QUICKSILVER_REWARDS,
    name: 'Quicksilver from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=31840',
    learn_more_link: 'https://www.capitalone.com/credit-cards/quicksilver/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/qs_cardart_prim_323x203.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on every purchase, every day.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'EXCELLENT',
    cardSummary:
      "Earn unlimited 1.5% cash back on every purchase, every day.  Plus, a $200 Cash Bonus. Rewards don't expire for the life of the account.",
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          "You won't pay a transaction fee when making purchases outside of the United States.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Concierge Service',
        description:
          'Enjoy comprehensive, personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'You\u2019ll get additional warranty protection at no charge on eligible items that are purchased with your credit card.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24-hour Travel Assistance Services',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash bonus once you spend $500 within 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'quicksilver_rewards.png',
  },
  [CreditCard.QUICKSILVER_REWARDS_FOR_GOOD_CREDIT]: {
    id: CreditCard.QUICKSILVER_REWARDS_FOR_GOOD_CREDIT,
    name: 'Quicksilver Rewards for Good Credit from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32202',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/quicksilver-good-credit/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/qs_gen_master_rgb_323x203.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on every purchase, every day.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'GOOD',
    cardSummary:
      'The Quicksilver Rewards Credit Card for Good Credit earns unlimited 1.5% cash back on every purchase, every day, with no annual fee.  It also offers access to Capital One Travel with additional rewards.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making a purchase outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Concierge Service',
        description:
          'Enjoy comprehensive, personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'You\u2019ll get additional warranty protection at no charge on eligible items that are purchased with your credit card.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24-hour Travel Assistance Services',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Instant Purchase Notifications',
        description:
          'Stay on top of your spending by receiving a push notification each time a new purchase is approved on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Shop With Your Rewards',
        description:
          'Now you can pay for Amazon.com purchases using your Capital One rewards.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'quicksilver_rewards_for_good_credit.png',
  },
  [CreditCard.SAVOR_REWARDS]: {
    id: CreditCard.SAVOR_REWARDS,
    name: 'Savor Rewards from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32194',
    learn_more_link: 'https://www.capitalone.com/credit-cards/savor/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/new-savor-card-art.png',
    rewardsSummary:
      'Earn unlimited 3% cash back on dining, entertainment, and popular streaming services, 5% cash back on hotels and rental cars booked through Capital One Travel, and 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: ['Walmart', 'Target'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'streaming',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rentalCar',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'EXCELLENT',
    cardSummary:
      'The Capital One Savor Rewards card offers unlimited 3% cash back on dining, entertainment, and popular streaming services; 5% cash back on hotels and rental cars booked through Capital One Travel; and 1% cash back on all other purchases.  It also features a $0 annual fee and no foreign transaction fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making purchases outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Concierge Service',
        description:
          'Enjoy comprehensive, personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'You\u2019ll get additional warranty protection at no charge on eligible items that are purchased with your credit card.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24-hour Travel Assistance Services',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Instant Purchase Notifications',
        description:
          'Stay on top of your spending by receiving a push notification each time a new purchase is approved on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Shop With Your Rewards',
        description:
          'Now you can pay for Amazon.com purchases using your Capital One rewards.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash bonus after you spend $500 on purchases within 3 months from account opening. Existing or previous cardmembers are not eligible for this product if they have received a new cardmember bonus for this product in the past 48 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'savor_rewards.png',
  },
  [CreditCard.SAVOR_REWARDS_FOR_GOOD_CREDIT]: {
    id: CreditCard.SAVOR_REWARDS_FOR_GOOD_CREDIT,
    name: 'Savor Rewards for Good Credit from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32203',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/savor-good-credit/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/new-savor-card-art.png',
    rewardsSummary:
      'Earn unlimited 3% cash back at grocery stores, on dining, entertainment and popular streaming services, plus 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: ['superstores like Walmart\u00ae and Target\u00ae'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'entertainment',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'streaming',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'GOOD',
    cardSummary:
      'The Capital One Savor Rewards for Good Credit card offers unlimited 3% cash back on dining, entertainment, popular streaming services, and grocery store purchases, plus 1% on all other purchases.  It has no annual fee and offers various benefits like no foreign transaction fees and access to Capital One Travel.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making a purchase outside of the United States.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Concierge Service',
        description:
          'Enjoy comprehensive, personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'You\u2019ll get additional warranty protection at no charge on eligible items that are purchased with your credit card.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24-hour Travel Assistance Services',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: 'statement_credit',
        value: 50.0,
        value_unit: '%',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'savor_rewards_for_good_credit.png',
  },
  [CreditCard.QUICKSILVERONE_REWARDS]: {
    id: CreditCard.QUICKSILVERONE_REWARDS,
    name: 'QuicksilverOne from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32171',
    learn_more_link: 'https://www.capitalone.com/credit-cards/quicksilverone/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/qs1_cardart_prim_323x203.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on every purchase, every day.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'FAIR',
    cardSummary:
      'The QuicksilverOne Credit Card from Capital One offers unlimited 1.5% cash back on every purchase, every day, with no annual fee.  It also includes valuable benefits like automatic credit line reviews and fraud coverage.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic Credit Line Reviews',
        description:
          'Be automatically considered for a higher credit line in as little as 6 months.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'CreditWise',
        description:
          'Enjoy unlimited access to your credit score and tools to help you monitor your credit profile with CreditWise from Capital One. It\u2019s free and available to anyone, whether or not you have a Capital One product.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud Coverage',
        description:
          "You're covered by $0 Fraud Liability if your card is ever lost or stolen. That means you will not be responsible for fraudulent purchases.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Tap to Pay',
        description:
          'Check out faster and securely with your contactless card. Simply hold or tap your card on a contactless-enabled card reader and you are good to go.',
        benefit_type: 'contactless',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem for Cash',
        description:
          'We\u2019ll send you a check or you can apply rewards as a statement credit.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cover Your Purchases',
        description:
          'Apply your cash back to directly cover a recent purchase.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Get Gift Cards',
        description: 'Spend your rewards on gift cards.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making a purchase outside of the United States.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Emergency Card Replacement',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'ATM Location Services',
        description: 'Receive help finding the nearest ATM when traveling.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Tap to Pay',
        description:
          "Just like in your mobile wallet, you can now tap to pay with your contactless card. It's a fast and secure way to pay. Simply hold or tap your card on a contactless-enabled card reader and you are good to go.",
        benefit_type: 'contactless',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'quicksilverone_rewards.png',
  },
  [CreditCard.SAVOR_REWARDS_FOR_STUDENTS]: {
    id: CreditCard.SAVOR_REWARDS_FOR_STUDENTS,
    name: 'Savor Rewards for Students',
    apply_link: 'https://applynow.capitalone.com/?productId=32229',
    learn_more_link: 'https://www.capitalone.com/credit-cards/savor-student/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/new-savor-card-art.png',
    rewardsSummary:
      'Earn unlimited 3% cash back at grocery stores, on dining, entertainment and popular streaming services, plus 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: ['Walmart', 'Target'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'entertainment',
        earnRate: 3.0,
        excludeMerchants: [
          'golf courses',
          'country clubs',
          'collegiate sporting events',
          'charitable organizations that provide live entertainment',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'streaming',
        earnRate: 3.0,
        excludeMerchants: [
          'Verizon FIOS On Demand',
          'audiobook subscriptions',
          'fitness programming',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Capital One Savor Rewards for Students card offers unlimited 3% cash back on dining, entertainment, popular streaming services, and groceries, plus 1% on all other purchases.  It also features a $0 annual fee and a $50 cash bonus after spending $100 in the first 3 months.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making a purchase outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Concierge Service',
        description:
          'Enjoy comprehensive, personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'You\u2019ll get additional warranty protection at no charge on eligible items that are purchased with your credit card.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24-hour Travel Assistance Services',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Instant Purchase Notifications',
        description:
          'Stay on top of your spending by receiving a push notification each time a new purchase is approved on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Shop With Your Rewards',
        description:
          'Now you can pay for Amazon.com purchases using your Capital One rewards.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 100.0,
        spendRequirementMonths: 3,
        bonusValue: 50.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a one-time $50 cash bonus once you spend $100 on purchases within 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'savor_rewards_for_students.png',
  },
  [CreditCard.QUICKSILVER_REWARDS_FOR_STUDENTS]: {
    id: CreditCard.QUICKSILVER_REWARDS_FOR_STUDENTS,
    name: 'Quicksilver Rewards for Students',
    apply_link: 'https://applynow.capitalone.com/?productId=32223',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/quicksilver-student/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/qs_cardart_prim_323x203.png',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on every purchase, every day.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 1.5% cash back on every purchase, every day.  $0 annual fee. Plus, earn a $50 cash bonus.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description:
          'You won\u2019t pay a transaction fee when making a purchase outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary Concierge Service',
        description:
          'Enjoy comprehensive, personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'You\u2019ll get additional warranty protection at no charge on eligible items that are purchased with your credit card.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24-hour Travel Assistance Services',
        description:
          'If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description:
          'Get automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Instant Purchase Notifications',
        description:
          'Stay on top of your spending by receiving a push notification each time a new purchase is approved on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Shopping',
        description:
          'Capital One Shopping is an online shopping tool that automatically applies available coupon codes to your order.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Shop With Your Rewards',
        description:
          'Now you can pay for Amazon.com purchases using your Capital One rewards.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Your Rewards with PayPal',
        description:
          'Use your Capital One rewards on eligible purchases at millions of online stores.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% off Handcrafted Beverages',
        description:
          'Capital One cardholders enjoy 50% off all handcrafted beverages everyday at any Capital One Caf\u00e9 nationwide.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 100,
        spendRequirementMonths: 3,
        bonusValue: 50,
        bonusValueUnit: 'dollars',
        description:
          'Earn a one-time $50 cash bonus once you spend $100 on purchases within 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'quicksilver_rewards_for_students.png',
  },
  [CreditCard.QUICKSILVER_SECURED_REWARDS]: {
    id: CreditCard.QUICKSILVER_SECURED_REWARDS,
    name: 'Quicksilver Secured from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32155',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/quicksilver-secured/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/qs_cardart_prim_323x203.png',
    rewardsSummary:
      'Earn 1.5% cash back on every purchase with a refundable $200 minimum deposit.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'FAIR',
    cardSummary:
      'Earn unlimited 1.5% cash back on every purchase, every day.  There is a $200 refundable minimum deposit required.  With responsible card use, you could earn your deposit back and upgrade to an unsecured Quicksilver card.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Refundable Security Deposit',
        description:
          'With responsible card use, you could earn your deposit back and upgrade to an unsecured Quicksilver card.',
        benefit_type: 'statement_credit',
        value: 200,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'quicksilver_secured_rewards.png',
  },
  [CreditCard.PLATINUM_SECURED]: {
    id: CreditCard.PLATINUM_SECURED,
    name: 'Platinum Secured Credit Card from Capital One',
    apply_link: 'https://applynow.capitalone.com/?productId=32162',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/platinum-secured/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/plat_cardart_prim_323x203.png',
    rewardsSummary:
      'This card helps you build credit and offers a refundable security deposit.',
    rewardsEarnRates: [],
    creditScore: 'REBUILDING',
    cardSummary:
      'The Capital One Platinum Secured Credit Card is designed to help you build or rebuild your credit.  It requires a refundable security deposit, and responsible use can lead to a credit line increase and eventual upgrade to an unsecured card.  There are no annual fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Refundable Deposits & Upgrades',
        description:
          'With responsible card use, you could earn back your deposit and upgrade to a standard, unsecured Platinum card.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Hidden Fees',
        description:
          'No foreign transaction fees. No replacement card fees. No authorized user fees. Just the card you need with no unwanted surprises.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Automatic Credit Line Reviews',
        description:
          'Be automatically considered for a higher credit line in as little as 6 months.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Pay Zero Interest',
        description:
          "If you pay your statement balance in full each month, you won't pay interest.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'platinum_secured.png',
  },
  [CreditCard.KOHLS_REWARDS_VISA]: {
    id: CreditCard.KOHLS_REWARDS_VISA,
    name: "Kohl's Rewards\u00ae Visa",
    apply_link: 'https://www.capitalone.com/apply/partner/kohls/uns/',
    learn_more_link: 'https://www.capitalone.com/credit-cards/kohls/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/kohls_visa_sig_master_rgb_300x189.png',
    rewardsSummary:
      "Earn 7.5% in rewards at Kohl's every day, plus 3% on gas, 2% at grocery stores, and 1% on all other purchases.",
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.general',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: "Kohl's",
        earnRate: 7.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      "Save 40% today and earn 7.5% in rewards at Kohl's every day with no annual fee.  The Kohl's Rewards Visa also earns 3% on gas, 2% at grocery stores, and 1% on all other purchases.",
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'anniversary_bonus',
        description: 'Special anniversary offer every year.',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          "Save 40% on Kohl's-only brands and other great brands for one transaction with your new Kohl's Card within 30 days of credit approval.",
      },
    ],
    cardType: 'personal',
    imageName: 'kohls_rewards_visa.png',
  },
  [CreditCard.REI_COOP_MASTERCARD]: {
    id: CreditCard.REI_COOP_MASTERCARD,
    name: 'REI Co-op\u00ae Mastercard\u00ae',
    apply_link:
      'https://applynow.capitalone.com/application-capture/membervalidation/index.html?brandCode=REICB&marketingChannelCode=UNS',
    learn_more_link: 'https://www.capitalone.com/credit-cards/rei/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/pages/rei/rei-co-op-mastercard.png',
    rewardsSummary:
      'The REI Co-op Mastercard earns 5% back in rewards on REI purchases and 1.5% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      'The REI Co-op Mastercard offers 5% back in rewards on REI purchases and 1.5% back on all other purchases, plus a $100 REI gift card after your first purchase outside of REI within 60 days of account opening.  There is no annual fee and no foreign transaction fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: '$100 REI gift card',
        description:
          'after first purchase outside of REI within 60 days from account opening',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: '$50 account credit',
        description:
          'Toward REI Co-op Experiences, including classes, day trips or multiday outings led by outdoor experts.',
        benefit_type: 'statement_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'rei_coop_mastercard.png',
  },
  [CreditCard.POTTERY_BARN_KEY_REWARDS_VISA]: {
    id: CreditCard.POTTERY_BARN_KEY_REWARDS_VISA,
    name: 'Pottery Barn Key Rewards Visa',
    apply_link:
      'https://applynow.capitalone.com/?brandCode=POTTERYBARNCB&marketingChannelCode=UNS',
    learn_more_link: 'https://www.capitalone.com/credit-cards/potterybarn',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/pb_ca_cb_rgb.png',
    rewardsSummary:
      'Earn 10% back in rewards for your first 30 days, then 5% back at Pottery Barn, Williams Sonoma, West Elm, and Rejuvenation, 4% back at grocery stores and restaurants (excluding fast food), and 1% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'grocery',
        earnRate: 0.04,
        excludeMerchants: ['fast food'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.general',
        earnRate: 0.05,
        excludeMerchants: ['GreenRow'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      'The Pottery Barn Key Rewards Visa offers a welcome bonus of 10% back in rewards for the first 30 days, then 5% back at Pottery Barn and other participating stores, plus 4% back at grocery stores and restaurants and 1% back on all other purchases.  Enjoy benefits like a $25 birthday reward and no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'birthday reward',
        description: '$25 birthday reward sent annually to your email.',
        benefit_type: 'statement_credit',
        value: 25.0,
        value_unit: 'dollars',
        spend_requirement:
          'Make a purchase in the previous 12 months starting 1 month prior to your birthday.',
      },
      {
        name: 'no annual fee',
        description: "That's $0.",
        benefit_type: 'no_annual_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'free standard shipping',
        description: 'at Williams Sonoma.',
        benefit_type: 'return_shipping',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'New cardmembers earn 10% back in rewards for Net Eligible purchases made at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham (excludes GreenRow) during the first 30 days from account opening,  5% thereafter.',
      },
    ],
    cardType: 'personal',
    imageName: 'pottery_barn_key_rewards_visa.png',
  },
  [CreditCard.WILLIAMS_SONOMA_KEY_REWARDS_VISA]: {
    id: CreditCard.WILLIAMS_SONOMA_KEY_REWARDS_VISA,
    name: 'Williams Sonoma Key Rewards Visa',
    apply_link:
      'https://applynow.capitalone.com/?brandCode=WILLIAMSSONOMACB&marketingChannelCode=UNS',
    learn_more_link: 'https://www.capitalone.com/credit-cards/williams-sonoma/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/ws_ca_cb_rgb_card_art.png',
    rewardsSummary:
      'Earn 10% back in rewards for your first 30 days, then 5% back at Pottery Barn, Williams Sonoma, West Elm, Rejuvenation, and more; 4% back at grocery stores and restaurants (excludes fast food); and 1% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'grocery',
        earnRate: 4.0,
        excludeMerchants: ['fast food'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      'The Williams Sonoma Key Rewards Visa offers 10% back on purchases at participating stores for the first 30 days, then 5% back; 4% back at grocery stores and restaurants (excluding fast food); and 1% back on all other purchases.  Enjoy no annual fee and other benefits.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'birthday reward',
        description: '$25 birthday reward sent annually to your email.',
        benefit_type: 'statement_credit',
        value: 25.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'free standard shipping',
        description: 'Free standard shipping at Williams Sonoma.',
        benefit_type: 'return_shipping',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'New cardmembers earn 10% back in rewards for Net Eligible purchases made at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham (excludes GreenRow) during the first 30 days from account opening,  5% thereafter.',
      },
    ],
    cardType: 'personal',
    imageName: 'williams_sonoma_key_rewards_visa.png',
  },
  [CreditCard.WEST_ELM_KEY_REWARDS_VISA]: {
    id: CreditCard.WEST_ELM_KEY_REWARDS_VISA,
    name: 'West Elm Key Rewards Visa',
    apply_link:
      'https://applynow.capitalone.com/?brandCode=WESTELMCB&marketingChannelCode=UNS',
    learn_more_link: 'https://www.capitalone.com/credit-cards/westelm/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/we_ca_cb_rgb.png',
    rewardsSummary:
      'Earn 10% back in rewards for your first 30 days, then 5% back at Pottery Barn, Williams Sonoma, West Elm, and more, 4% back at grocery stores and restaurants, and 1% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.general',
        earnRate: 0.05,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'grocery',
        earnRate: 0.04,
        excludeMerchants: ['fast food'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'allPurchases',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      'The West Elm Key Rewards Visa offers a welcome bonus of 10% back in rewards for your first 30 days, then 5% back at Pottery Barn, Williams Sonoma, West Elm, and more, 4% back at grocery stores and restaurants, and 1% back on all other purchases.  There is no annual fee.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'birthday reward',
        description: '$25 birthday reward sent annually to your email.',
        benefit_type: 'statement_credit',
        value: 25.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'free standard shipping',
        description: 'Free standard shipping at Williams Sonoma.',
        benefit_type: 'return_shipping',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'Earn 10% back in rewards for your first 30 days on purchases at Pottery Barn, Williams Sonoma, West Elm, and more.',
      },
    ],
    cardType: 'personal',
    imageName: 'west_elm_key_rewards_visa.png',
  },
  [CreditCard.THE_KEY_REWARDS_VISA]: {
    id: CreditCard.THE_KEY_REWARDS_VISA,
    name: 'The Key Rewards Visa',
    apply_link:
      'https://applynow.capitalone.com/?brandCode=KEYREWARDSWSICB&marketingChannelCode=UNS',
    learn_more_link: 'https://www.capitalone.com/credit-cards/thekeyrewards/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/kr_ca_cb_rgb.png',
    rewardsSummary:
      'Earn 10% back in rewards for your first 30 days, then 5% back at Pottery Barn, Williams Sonoma, West Elm, and more, 4% back at grocery stores and restaurants (excluding fast food), and 1% back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'grocery',
        earnRate: 0.04,
        excludeMerchants: ['fast food'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.general',
        earnRate: 0.05,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      'The Key Rewards Visa offers a welcome bonus of 10% back in rewards for your first 30 days, then 5% back at select retailers, 4% back at grocery stores and restaurants, and 1% back on all other purchases.  Enjoy no annual fee and additional perks like a $25 birthday reward.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'birthday reward',
        description: '$25 birthday reward sent annually to your email.',
        benefit_type: 'statement_credit',
        value: 25.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'free standard shipping',
        description: 'Free standard shipping at Williams Sonoma.',
        benefit_type: 'return_shipping',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'New cardmembers earn 10% back in rewards for Net Eligible purchases made at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham (excludes GreenRow) during the first 30 days from account opening,  5% thereafter.',
      },
    ],
    cardType: 'personal',
    imageName: 'the_key_rewards_visa.png',
  },
  [CreditCard.SPARK_2_CASH_PLUS]: {
    id: CreditCard.SPARK_2_CASH_PLUS,
    name: 'Spark Cash Plus',
    apply_link: 'https://applynow.capitalone.com/?productId=31796',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/spark-cash-plus/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/sem_0004_scp-refresh-primary.png',
    rewardsSummary:
      'Earn unlimited 2% cash back on every purchase, everywhere, with no limits or category restrictions.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rentalCar',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'The Spark Cash Plus card offers unlimited 2% cash back on all purchases, a $2,000 welcome bonus after spending $30,000 in the first 3 months, and additional $2,000 bonuses for every $500,000 spent in the first year.  It also provides 5% cash back on hotels and rental cars booked through Capital One Travel.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Fee Refund',
        description:
          'Get your $150 annual fee refunded every year you spend at least $150,000.',
        benefit_type: 'statement_credit',
        value: 150.0,
        value_unit: 'dollars',
        spend_requirement: '150000.0 dollars',
      },
      {
        name: 'Automatic Payments',
        description:
          'Set up AutoPay so you don\u2019t have to worry about signing into your account every month.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability',
        description:
          'If your card is lost or stolen, you can get an emergency replacement and a cash advance.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Year-End Summaries',
        description:
          'Get an itemized report of your spending to simplify budgeting and tax time.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account Managers',
        description:
          'Assign an account manager to make purchases and payments, review transactions and resolve any problems.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Records',
        description:
          'Quickly and securely download your purchase records into multiple formats including Quicken\u00ae, QuickBooks\u00ae and Excel\u00ae.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Virtual Card Numbers',
        description:
          'Make safer payments online without exposing your actual card number with merchants.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose Your Due Date',
        description:
          'Pick your own monthly due date. Your business has the control to pay when you want.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transaction Details',
        description:
          'Stay on top of your purchases. You can find merchant information like an address, logo, phone number and map, when available.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Recurring Transactions',
        description:
          'View a list of merchants that charge your business card monthly like subscriptions and bills.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Employee Cards',
        description:
          'Track employee spending while earning all the rewards from their purchases.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spend Limits',
        description:
          'Set customized spending limits for employee cards and see transactions as soon as they post.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'Pay zero foreign transaction fees on purchases made outside of the United States.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'Our business cards offer services to help you during auto-related emergencies, such as jump-starting, tire changing and towing.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options \u2014 even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account Access',
        description:
          'Manage your account online or use the mobile app to get account activity alerts, see payment options, download past account statements and more.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Security Alerts',
        description:
          'Get notified via text, email and phone if Capital One notices potential suspicious transactions on your account.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud & Security Alerts',
        description:
          'Receive an email or text message alert if we detect a potential mistake or suspicious charge on your account.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Card Lock',
        description:
          'Lock your card or an employee\u2019s if it has been misplaced, lost or stolen.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty',
        description:
          'Get free additional warranty and protection on eligible items that you purchase with your card.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customer Support',
        description:
          'Our Capital One Business representatives are specially trained to work with business owners and are available to answer any questions you may have.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '30000.0 dollars',
        spendRequirementMonths: 3,
        bonusValue: 2000.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $2,000 cash bonus when you spend $30,000 in the first 3 months.  You can also earn an additional $2,000 bonus for every $500,000 spent in the first year.',
      },
    ],
    cardType: 'business',
    imageName: 'spark_2_cash_plus.png',
  },
  [CreditCard.SPARK_2_CASH]: {
    id: CreditCard.SPARK_2_CASH,
    name: 'Spark Cash',
    apply_link: 'https://applynow.capitalone.com/?productId=31799',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/spark-cash/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn unlimited 2% cash back on every purchase, everywhere.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'Earn unlimited 2% cash back on every purchase, everywhere. Plus, earn a $750 cash bonus when you spend $7,500 in the first 3 months.  Enjoy a $0 annual fee for the first year, and then $95 after that.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic payments',
        description:
          'Set up AutoPay so you don\u2019t have to worry about signing into your account every month.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 fraud liability',
        description:
          'If your card is lost or stolen, you can get an emergency replacement and a cash advance.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Year-end summaries',
        description:
          'Get an itemized report of your spending to simplify budgeting and tax time.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account managers',
        description:
          'Assign an account manager to make purchases and payments, review transactions and resolve any problems.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase records',
        description:
          'Quickly and securely download your purchase records into multiple formats including Quicken\u00ae, QuickBooks\u00ae and Excel\u00ae.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Virtual card numbers',
        description:
          'Make safer payments online without exposing your actual card number with merchants.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose your due date',
        description:
          'Pick your own monthly due date. Your business has the control to pay when you want.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transaction details',
        description:
          'Stay on top of your purchases. You can find merchant information like an address, logo, phone number and map, when available.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Recurring transactions',
        description:
          'View a list of merchants that charge your business card monthly like subscriptions and bills.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free employee cards',
        description:
          'Track employee spending while earning all the rewards from their purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spend limits',
        description:
          'Set customized spending limits for employee cards and see transactions as soon as they post.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'Pay zero foreign transaction fees on purchases made outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside assistance',
        description:
          'Our business cards offer services to help you during auto-related emergencies, such as jump-starting, tire changing and towing.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One travel',
        description:
          'Get our best prices on thousands of trip options \u2014 even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account access',
        description:
          'Manage your account online or use the mobile app to get account activity alerts, see payment options, download past account statements and more.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Security alerts',
        description:
          'Get notified via text, email and phone if Capital One notices potential suspicious transactions on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud & security alerts',
        description:
          'Receive an email or text message alert if we detect a potential mistake or suspicious charge on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Card lock',
        description:
          'Lock your card or an employee\u2019s if it has been misplaced, lost or stolen.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended warranty',
        description:
          'Get free additional warranty and protection on eligible items that you purchase with your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customer support',
        description:
          'Our Capital One Business representatives are specially trained to work with business owners and are available to answer any questions you may have.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 7500.0,
        spendRequirementMonths: 3,
        bonusValue: 750.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a one-time $750 cash bonus once you spend $7,500 on purchases within the first 3 months from account opening',
      },
    ],
    cardType: 'business',
  },
  [CreditCard.SPARK_15_CASH_SELECT]: {
    id: CreditCard.SPARK_15_CASH_SELECT,
    name: 'Spark 1.5% Cash Select',
    apply_link: 'https://applynow.capitalone.com/?productId=31803',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/spark-cash-select',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/background-images/sbc-cash-pdp/pdp_bannersspark-1.5-excellent-optimized.jpg',
    rewardsSummary:
      'Earn unlimited 1.5% cash back on every purchase, everywhere, with no limits or category restrictions.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'Earn unlimited 1.5% cash back on every purchase. Plus, earn a $500 cash bonus when you spend $4,500 in the first 3 months.  Enjoy a $0 annual fee.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic payments',
        description:
          'Set up AutoPay so you don\u2019t have to worry about signing into your account every month.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 fraud liability',
        description:
          'If your card is lost or stolen, you can get an emergency replacement and a cash advance.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Year-end summaries',
        description:
          'Get an itemized report of your spending to simplify budgeting and tax time.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account managers',
        description:
          'Assign an account manager to make purchases and payments, review transactions and resolve any problems.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase records',
        description:
          'Quickly and securely download your purchase records into multiple formats including Quicken\u00ae, QuickBooks\u00ae and Excel\u00ae.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Virtual card numbers',
        description:
          'Make safer payments online without exposing your actual card number with merchants.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose your due date',
        description:
          'Pick your own monthly due date. Your business has the control to pay when you want.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transaction details',
        description:
          'Stay on top of your purchases. You can find merchant information like an address, logo, phone number and map, when available.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Recurring transactions',
        description:
          'View a list of merchants that charge your business card monthly like subscriptions and bills.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free employee cards',
        description:
          'Track employee spending while earning all the rewards from their purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spend limits',
        description:
          'Set customized spending limits for employee cards and see transactions as soon as they post.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'Pay zero foreign transaction fees on purchases made outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside assistance',
        description:
          'Our business cards offer services to help you during auto-related emergencies, such as jump-starting, tire changing and towing.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One travel',
        description:
          'Get our best prices on thousands of trip options \u2014 even after you book. Plus, pay flexibly with your rewards, a card or both. Explore Capital One Travel.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account access',
        description:
          'Manage your account online or use the mobile app to get account activity alerts, see payment options, download past account statements and more.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Security alerts',
        description:
          'Get notified via text, email and phone if Capital One notices potential suspicious transactions on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud & security alerts',
        description:
          'Receive an email or text message alert if we detect a potential mistake or suspicious charge on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Card lock',
        description:
          'Lock your card or an employee\u2019s if it has been misplaced, lost or stolen.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended warranty',
        description:
          'Get free additional warranty and protection on eligible items that you purchase with your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customer support',
        description:
          'Our Capital One Business representatives are specially trained to work with business owners and are available to answer any questions you may have.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4500,
        spendRequirementMonths: 3,
        bonusValue: 500,
        bonusValueUnit: 'dollars',
        description:
          'Earn a one-time $500 cash bonus once you spend $4,500 on purchases within the first 3 months from account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'spark_15_cash_select.jpg',
  },
  [CreditCard.SPARK_CLASSIC]: {
    id: CreditCard.SPARK_CLASSIC,
    name: 'Spark 1% Classic',
    apply_link: 'https://applynow.capitalone.com/?productId=31808',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/spark-classic/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn unlimited 1% cash back on every purchase, everywhere, with no limits or category restrictions.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rentalCar',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Fair',
    cardSummary:
      'Build a strong foundation for your business while earning unlimited 1% cash back and no annual fee.  Get access to business-grade features and benefits, including digital tools that help you manage your expenses and employee spending with ease.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic payments',
        description:
          'Set up AutoPay so you don\u2019t have to worry about signing into your account every month.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 fraud liability',
        description:
          'If your card is lost or stolen, you can get an emergency replacement and a cash advance.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Year-end summaries',
        description:
          'Get an itemized report of your spending to simplify budgeting and tax time.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account managers',
        description:
          'Assign an account manager to make purchases and payments, review transactions and resolve any problems.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase records',
        description:
          'Quickly and securely download your purchase records into multiple formats including Quicken\u00ae, QuickBooks\u00ae and Excel\u00ae.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Virtual card numbers',
        description:
          'Make safer payments online without exposing your actual card number with merchants.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose your due date',
        description:
          'Pick your own monthly due date. Your business has the control to pay when you want.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transaction details',
        description:
          'Stay on top of your purchases. You can find merchant information like an address, logo, phone number and map, when available.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Recurring transactions',
        description:
          'View a list of merchants that charge your business card monthly like subscriptions and bills.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free employee cards',
        description:
          'Track employee spending while earning all the rewards from their purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spend limits',
        description:
          'Set customized spending limits for employee cards and see transactions as soon as they post.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'Pay zero foreign transaction fees on purchases made outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside assistance',
        description:
          'Our business cards offer services to help you during auto-related emergencies, such as jump-starting, tire changing and towing.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One travel',
        description:
          'Get our best prices on thousands of trip options \u2014 even after you book. Plus, pay flexibly with your rewards, a card or both.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account access',
        description:
          'Manage your account online or use the mobile app to get account activity alerts, see payment options, download past account statements and more.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Security alerts',
        description:
          'Get notified via text, email and phone if Capital One notices potential suspicious transactions on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud & security alerts',
        description:
          'Receive an email or text message alert if we detect a potential mistake or suspicious charge on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Card lock',
        description:
          'Lock your card or an employee\u2019s if it has been misplaced, lost or stolen.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended warranty',
        description:
          'Get free additional warranty and protection on eligible items that you purchase with your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customer support',
        description:
          'Our Capital One Business representatives are specially trained to work with business owners and are available to answer any questions you may have.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
  },
  [CreditCard.VENTURE_X_BUSINESS]: {
    id: CreditCard.VENTURE_X_BUSINESS,
    name: 'Venture X Business',
    apply_link: 'https://applynow.capitalone.com/?productId=32213',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/venture-x-business/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/vxb-card-alt-at-2x.png',
    rewardsSummary:
      'Earn unlimited 2X miles on every purchase, with bonus earning rates on flights and hotels booked through Capital One Travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.rentalCars',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'The Capital One Venture X Business card offers unlimited 2X miles on every purchase, plus bonus miles on travel booked through Capital One Travel.  It also includes a $300 annual travel credit and access to 1,300+ airport lounges worldwide.',
    cardNetwork: null,
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Annual Travel Credit',
        description:
          'Receive an annual $300 credit for bookings through Capital One Travel.',
        benefit_type: 'travel_credit',
        value: 300.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Annual Bonus Miles',
        description:
          'Get 10,000 bonus miles every year, starting on your first anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 10000.0,
        value_unit: 'miles',
        spend_requirement: null,
      },
      {
        name: 'Partner Lounge Network',
        description:
          'Enjoy complimentary access to 1,300+ airport lounges worldwide.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'TSA PreCheck\u00ae or Global Entry Credit',
        description:
          'Receive up to a $120 statement credit on Global Entry or TSA PreCheck\u00ae.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Free Employee Cards',
        description:
          'Empower your team to make purchases while earning rewards on their transactions.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Virtual Card Numbers',
        description:
          'Make safer payments online without exposing your actual card number with merchants.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 30000.0,
        spendRequirementMonths: 3,
        bonusValue: 150000.0,
        bonusValueUnit: 'miles',
        description:
          'Earn a one-time bonus of 150,000 miles when you spend $30,000 in the first 3 months.',
      },
    ],
    cardType: 'business',
    imageName: 'venture_x_business.png',
  },
  [CreditCard.SPARK_2X_MILES]: {
    id: CreditCard.SPARK_2X_MILES,
    name: 'Spark 2X Miles',
    apply_link: 'https://applynow.capitalone.com/?productId=31815',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/spark-miles/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/background-images/sbc-miles-pdps/pdp_bannersspark-1.5x-miles-optimized.jpg',
    rewardsSummary:
      'Earn unlimited 2X miles on every purchase, plus 5X miles on hotels and rental cars booked through Capital One Travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.rentalCars',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'Earn unlimited 2X miles on every purchase for your business, plus 5X on hotels and rental cars booked through Capital One Travel.  Get a one-time bonus of 50,000 miles once you spend $4,500 on purchases within the first 3 months of account opening.  Enjoy a $0 intro annual fee for the first year, then $95 after.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Global Entry or TSA PreCheck\u00ae Credit',
        description:
          'Receive up to $120 credit for Global Entry or TSA PreCheck\u00ae when you use your Spark Miles 2X card.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4500.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Earn a one-time bonus of 50,000 miles once you spend $4,500 on purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'spark_2x_miles.jpg',
  },
  [CreditCard.SPARK_15X_MILES_SELECT]: {
    id: CreditCard.SPARK_15X_MILES_SELECT,
    name: 'Spark 1.5X Miles Select',
    apply_link: 'https://applynow.capitalone.com/?productId=31819',
    learn_more_link:
      'https://www.capitalone.com/small-business/credit-cards/spark-miles-select/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn unlimited 1.5X miles on every purchase, plus a 50,000-mile bonus after spending $4,500 in the first 3 months.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'Excellent',
    cardSummary:
      'The Spark 1.5X Miles Select card offers unlimited 1.5X miles on all purchases and 5X miles on hotels and rental cars booked through Capital One Travel.  It also includes a 50,000-mile bonus after spending $4,500 in the first 3 months and has a $0 annual fee.',
    cardNetwork: 'Visa',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic payments',
        description:
          'Set up AutoPay so you don\u2019t have to worry about signing into your account every month.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 fraud liability',
        description:
          'If your card is lost or stolen, you can get an emergency replacement and a cash advance.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Year-end summaries',
        description:
          'Get an itemized report of your spending to simplify budgeting and tax time.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account managers',
        description:
          'Assign an account manager to make purchases and payments, review transactions and resolve any problems.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase records',
        description:
          'Quickly and securely download your purchase records into multiple formats including Quicken\u00ae, QuickBooks\u00ae and Excel\u00ae.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Virtual card numbers',
        description:
          'Make safer payments online without exposing your actual card number with merchants.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose your due date',
        description:
          'Pick your own monthly due date. Your business has the control to pay when you want.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Transaction details',
        description:
          'Stay on top of your purchases. You can find merchant information like an address, logo, phone number and map, when available.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Recurring transactions',
        description:
          'View a list of merchants that charge your business card monthly like subscriptions and bills.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free employee cards',
        description:
          'Track employee spending while earning all the rewards from their purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spend limits',
        description:
          'Set customized spending limits for employee cards and see transactions as soon as they post.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Capital One Travel',
        description:
          'Get our best prices on thousands of trip options\u2014even after you book. Plus, pay flexibly with your rewards, a card or both. Explore Capital One Travel.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Miles Transfer',
        description:
          'With your Spark Miles card, you may be able to transfer miles to one of our 15+ participating partners.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem Miles for Travel',
        description:
          'Redeem your miles through Capital One Travel or get reimbursed for travel expenses made with your card within 90 days of purchase.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description:
          'Pay zero foreign transaction fees on purchases made outside of the United States.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Rental Collision Coverage',
        description:
          'With your Spark card, you\u2019re covered for any damage or theft that may happen when you rent an eligible car.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance',
        description:
          'Our business cards offer services to help you during auto-related emergencies, such as jump-starting, tire changing and towing.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account access',
        description:
          'Manage your account online or use the mobile app to get account activity alerts, see payment options, download past account statements and more.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Security alerts',
        description:
          'Get notified via text, email and phone if Capital One notices potential suspicious transactions on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud & security alerts',
        description:
          'Receive an email or text message alert if we detect a potential mistake or suspicious charge on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Card lock',
        description:
          'Lock your card or an employee\u2019s if it has been misplaced, lost or stolen.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended warranty',
        description:
          'Get free additional warranty and protection on eligible items that you purchase with your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customer support',
        description:
          'Our Capital One Business representatives are specially trained to work with business owners and are available to answer any questions you may have.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4500.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Earn a one-time bonus of 50,000 miles once you spend $4,500 on purchases within the first 3 months from account opening.',
      },
    ],
    cardType: 'business',
  },
  [CreditCard.CABELAS_CLUB_CARD]: {
    id: CreditCard.CABELAS_CLUB_CARD,
    name: 'Cabela\u2019s CLUB Card',
    apply_link:
      'https://applynow.capitalone.com/?brandCode=CABELAS&marketingChannelCode=UNS&storeId=711',
    learn_more_link: 'https://www.capitalone.com/credit-cards/cabelas/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/cabelas_card_art_2023.png',
    rewardsSummary:
      'Earn up to 5% points back on all Bass Pro Shops and Cabela\u2019s purchases and 1% points back on purchases everywhere else Mastercard is accepted.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: "Bass Pro Shops and Cabela's",
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      'The Cabela\u2019s CLUB Card earns up to 5% points back on Bass Pro Shops and Cabela\u2019s purchases and 1% points back on other purchases.  It has a $0 annual fee and offers exclusive CLUB perks.',
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'CLUB Points',
        description:
          "Earn up to 5% points back on Bass Pro Shops and Cabela's purchases and 1% points back on other purchases.",
        benefit_type: 'points',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 50.0,
        bonusValueUnit: 'dollars',
        description:
          "Earn up to $50 in CLUB Points: $20 upon approval, $10 after 2 Bass Pro Shops or Cabela's purchases within 30 days, and $20 after 5 other purchases within 30 days.",
      },
    ],
    cardType: 'personal',
    imageName: 'cabelas_club_card.png',
  },
  [CreditCard.BASS_PRO_SHOPS_CLUB_CARD]: {
    id: CreditCard.BASS_PRO_SHOPS_CLUB_CARD,
    name: 'Bass Pro Shops CLUB Card',
    apply_link:
      'https://applynow.capitalone.com/?brandCode=BASSPRO&marketingChannelCode=UNS&storeId=701',
    learn_more_link: 'https://www.capitalone.com/credit-cards/bass-pro-shops/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/bass_pro_card_art_2023.png',
    rewardsSummary:
      "Earn up to 5% back in CLUB Points on Bass Pro Shops & Cabela's purchases and 1% back on all other purchases.",
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: "Bass Pro Shops & Cabela's",
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'GOOD-EXCELLENT',
    cardSummary:
      "The Bass Pro Shops CLUB Card earns up to 5% back in CLUB Points on Bass Pro Shops & Cabela's purchases and 1% back on all other purchases.  There is no annual fee, and CLUB Points never expire for open accounts.",
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'CLUB Points',
        description:
          "Earn up to 5% back in CLUB Points on Bass Pro Shops & Cabela's purchases and 1% back on all other purchases.",
        benefit_type: 'points',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 50.0,
        bonusValueUnit: 'dollars',
        description:
          "Earn up to $50 in CLUB Points: $20 upon approval, $10 after 2 Bass Pro Shops or Cabela's purchases within 30 days, and $20 after 5 other purchases within 30 days.",
      },
    ],
    cardType: 'personal',
    imageName: 'bass_pro_shops_club_card.png',
  },
  [CreditCard.BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD]: {
    id: CreditCard.BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD,
    name: "Bass Pro Shops and Cabela's CLUB Business Mastercard",
    apply_link:
      'https://applynow.capitalone.com/?brandCode=CLUBBUSINESS&marketingChannelCode=UNS',
    learn_more_link: 'https://www.capitalone.com/credit-cards/club-business/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'capital_one',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/smallbusinesscard_club_120120.jpg',
    rewardsSummary:
      "Earn 1.5% back on all purchases, 2.5% back at Cenex, and 5% back at Bass Pro Shops and Cabela's.",
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: 'Cenex',
        earnRate: 2.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
      {
        category: "Bass Pro Shops and Cabela's",
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'capital_one',
      },
    ],
    creditScore: 'EXCELLENT',
    cardSummary:
      "The Bass Pro Shops and Cabela's CLUB Business Mastercard offers no annual fee and unlimited CLUB Points that never expire.  Earn 1.5% back on purchases everywhere Mastercard is accepted, 2.5% back at Cenex, and 5% back at Bass Pro Shops and Cabela's.",
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [
      {
        name: 'Bonus Points',
        description:
          "Earn $100 in CLUB Points when you spend $1,000 on your Bass Pro Shops & Cabela's CLUB Business card within 60 days of account approval.",
        benefit_type: 'anniversary_bonus',
        value: 100.0,
        value_unit: 'points',
        spend_requirement: '$1,000',
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$1,000',
        spendRequirementMonths: 2,
        bonusValue: 100.0,
        bonusValueUnit: 'points',
        description:
          'Earn a one-time bonus of $100 in CLUB Points after making $1,000 in purchases on your card within 60 days of account approval. Once you qualify for this bonus, it will be awarded within 60 days.',
      },
    ],
    cardType: 'business',
    imageName: 'bass_pro_shops_and_cabelas_club_business_mastercard.jpg',
  },
  [CreditCard.BJS_ONE_MASTERCARD]: {
    id: CreditCard.BJS_ONE_MASTERCARD,
    name: 'BJ\u2019s One\u00ae Mastercard\u00ae',
    apply_link:
      'https://applynow.capitalone.com/application-capture/membervalidation/index.html?brandCode=BJSONE&marketingChannelCode=UNS',
    learn_more_link:
      'https://www.capitalone.com/credit-cards/bjs-wholesale-club/',
    terms_and_conditions_button_text: 'View important rates and disclosures',
    terms_and_conditions_link: null,
    bank_name: 'Capital One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://ecm.capitalone.com/WCM/card/products/www-bj-one-mc-240x151.png',
    rewardsSummary:
      'Earn 3% back in rewards on most purchases at BJ\u2019s and 1.5% back everywhere else Mastercard is accepted.',
    rewardsEarnRates: [
      {
        category: 'wholesaleClub',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [
          'BJ\u2019s clubs',
          'BJ\u2019s Gas\u00ae',
          'BJs.com',
          'BJ\u2019s app',
          'B2B and BJ\u2019s Global Sales transactions',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Good-Excellent Credit',
    cardSummary:
      "The BJ's One\u00ae Mastercard\u00ae offers rewards of 3% back at BJ's and 1.5% back everywhere else Mastercard is accepted, with no annual fee.  Manage your card with the Capital One Mobile app.",
    cardNetwork: 'Mastercard',
    issuer: 'Capital One',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bjs_one_mastercard.png',
  },
  [CreditCard.DISCOVER_IT_CASH_BACK_CREDIT_CARD]: {
    id: CreditCard.DISCOVER_IT_CASH_BACK_CREDIT_CARD,
    name: 'discover_it_cash_back_credit_card',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=GJVP&ICMPGN=ALL_CC_CB_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/cash-back/it-card.html?ICMPGN=ALL_CC_CB_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn unlimited cash back on every purchase, with rotating 5% cash back categories each quarter.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'rotating_quarterly_rewards',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Discover it\u00ae Cash Back Credit Card offers unlimited 1% cash back on all purchases and rotating 5% cash back categories each quarter.  There's no annual fee, and Discover will match all the cash back you earn at the end of your first year!",
    cardNetwork: 'Discover',
    issuer: 'Discover',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cashback Match',
        description:
          'Discover will automatically match all the cash back you earn at the end of your first year.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'discover_it_cash_back_credit_card.png',
    fees: {
      annualFeeAmountDollars: 0,
      annualFeeFirstYear: 0,
      aprDescription: null,
      aprLow: null,
      aprHigh: null,
      balanceTransferApr: null,
      balanceTransferFee: null,
      zeroAprPeriodMonths: null,
      hasForeignTransactionFee: true,
      foreignTransactionFeePercent: null,
    },
  },
  [CreditCard.DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD]: {
    id: CreditCard.DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD,
    name: 'Discover it\u00ae Student Cash Back Credit Card',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=RJQX&ICMPGN=ALL_CC_STUDENT_CB_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/student-credit-card/it-card.html?ICMPGN=ALL_CC_STUDENT_IT_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-student-it-choose-new-your-card-614-432.png',
    rewardsSummary:
      'Earn 5% cash back on everyday purchases at rotating categories each quarter, plus 1% on all other purchases, and get an unlimited dollar-for-dollar match of all the cash back you earn at the end of your first year.',
    rewardsEarnRates: [
      {
        category: 'rotating_quarterly_rewards',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Discover it\u00ae Student Cash Back card offers 5% cash back on everyday purchases in rotating categories each quarter, plus 1% on all other purchases.  It also features an unlimited cash back match for the first year and a $0 fraud liability.',
    cardNetwork: 'Discover',
    issuer: 'Discover',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cashback Match',
        description:
          'Get an unlimited dollar-for-dollar match of all the cash back you earn at the end of your first year, automatically.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'discover_it_student_cash_back_credit_card.png',
  },
  [CreditCard.DISCOVER_IT_SECURED_CREDIT_CARD]: {
    id: CreditCard.DISCOVER_IT_SECURED_CREDIT_CARD,
    name: 'Discover it\u00ae Secured Credit Card',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=KXPA&ICMPGN=ALL_CC_SECURED_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/secured-credit-card/?ICMPGN=ALL_CC_SECURED_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-secured-fr-rgb-620-382.png',
    rewardsSummary:
      'Earn unlimited 1% cash back on all other purchases, plus a 2% cashback bonus at gas stations and restaurants on up to $1,000 in combined purchases each quarter.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [
          'Gas Stations affiliated with supermarkets, supercenters, and wholesale clubs',
        ],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Discover it\u00ae Secured Credit Card helps you build your credit history with responsible use.  It offers unlimited 1% cash back on all purchases and a 2% cashback bonus at gas stations and restaurants on up to $1,000 in combined purchases each quarter.  After 7 months, Discover reviews your account to see if you qualify to upgrade to an unsecured card and get your deposit back.',
    cardNetwork: 'Discover',
    issuer: 'Discover Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'discover_it_secured_credit_card.png',
  },
  [CreditCard.DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD]: {
    id: CreditCard.DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD,
    name: 'Discover it\u00ae Student Chrome',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=RJRM&ICMPGN=ALL_CC_STUDENT_CHROME_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/student-credit-card/chrome-card.html?ICMPGN=ALL_CC_STUDENT_CHROME_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-cash-chrome-platinum-620-382.png',
    rewardsSummary:
      'Earn 2% cash back at gas stations and restaurants on up to $1,000 in combined purchases each quarter, plus 1% unlimited cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Discover it\u00ae Student Chrome card offers unlimited cash back rewards, including 2% cash back at gas stations and restaurants (up to $1,000 combined quarterly) and 1% on all other purchases.  It also features a cashback match at the end of your first year and no annual fee.',
    cardNetwork: 'Discover',
    issuer: 'Discover',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cashback Match',
        description:
          'Get an unlimited dollar-for-dollar match of all the cash back you earn at the end of your first year.',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'discover_it_student_chrome_credit_card.png',
  },
  [CreditCard.DISCOVER_IT_MILES_CREDIT_CARD]: {
    id: CreditCard.DISCOVER_IT_MILES_CREDIT_CARD,
    name: 'Discover it\u00ae Miles',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=GJX4&ICMPGN=ALL_CC_TRAVEL_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/travel/?ICMPGN=ALL_CC_TRAVEL_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'miles',
    creditCardImageUrl:
      'https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-travel-beachcard-620-382.png',
    rewardsSummary:
      "Earn 1.5x miles on every purchase, and we'll match all the miles you earn at the end of your first year.",
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'miles',
      },
      {
        category: 'travel.general',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'miles',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Discover it\u00ae Miles card offers unlimited 1.5x miles on every purchase, a first-year miles match, and flexible redemption options for travel or cash.  There's no annual fee.",
    cardNetwork: 'Discover',
    issuer: 'Discover',
    selectableCategories: [],
    benefits: [
      {
        name: 'Online Privacy Protection',
        description:
          'Discover will help you regularly remove your personal info from select people-search websites that could sell your data.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Annual Fee',
        description:
          'There is no annual fee with the Discover travel rewards credit card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Miles Never Expire',
        description:
          'Every Mile you earn can be used whenever you want, so you can save up for your next big trip.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'discover_it_miles_credit_card.png',
  },
  [CreditCard.NHL_DISCOVER_IT_CREDIT_CARD]: {
    id: CreditCard.NHL_DISCOVER_IT_CREDIT_CARD,
    name: 'NHL\u00ae Discover it\u00ae Credit Card',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=GJVV&ICMPGN=ALL_CC_NHL_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/cash-back/nhl-card.html?ICMPGN=ALL_CC_NHL_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-NHL-Shield-620-374.png',
    rewardsSummary:
      'Earn 5% cash back on everyday purchases at different places you shop each quarter like grocery stores, restaurants, gas stations, and more, up to the quarterly maximum when you activate. Plus, earn 1% cash back on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'rotating_quarterly_rewards',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The NHL\u00ae Discover it\u00ae card offers unlimited cash back rewards with no annual fee.  Earn 5% cash back on everyday purchases in rotating categories each quarter, plus 1% on all other purchases.  Get a dollar-for-dollar match of all the cash back you earn at the end of your first year!',
    cardNetwork: 'Discover',
    issuer: 'Discover',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cashback Match',
        description:
          'Get an unlimited dollar-for-dollar match of all the cash back you earn at the end of your first year, automatically.',
        benefit_type: 'anniversary_bonus',
        value: 1.0,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'nhl_discover_it_credit_card.png',
  },
  [CreditCard.DISCOVER_IT_CHROME_GAS__RESTAURANT_CREDIT_CARD]: {
    id: CreditCard.DISCOVER_IT_CHROME_GAS__RESTAURANT_CREDIT_CARD,
    name: 'Discover it\u00ae Chrome Gas & Restaurant Credit Card',
    apply_link:
      'https://www.discovercard.com/application/website/apply?srcCde=GJVR&ICMPGN=ALL_CC_GAS_AND_RESTAURANT_APPLY_NOW_BTN&adobe_mc=TS%3D1737840454%7CMCMID%3D83997978955373127690761792206773066804%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg&sv_session=5551aa09e63037817311a0fcd0e6100d',
    learn_more_link:
      'https://www.discover.com/credit-cards/cash-back/chrome.html?ICMPGN=ALL_CC_GAS_AND_RESTAURANT_LEARN_MORE',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Discover',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-cash-chrome-platinum-620-382.png',
    rewardsSummary:
      'Earn 2% cash back at gas stations and restaurants, plus 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Discover it\u00ae Chrome card offers unlimited 1% cash back on all purchases and a 2% cash back bonus at gas stations and restaurants on up to $1,000 in combined purchases each quarter.  It also features a cashback match at the end of your first year and no annual fee.',
    cardNetwork: 'Discover',
    issuer: 'Discover',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'discover_it_chrome_gas__restaurant_credit_card.png',
  },
  [CreditCard.ACTIVE_CASH_CARD]: {
    id: CreditCard.ACTIVE_CASH_CARD,
    name: 'Wells Fargo Active Cash\u00ae Credit Card',
    apply_link:
      'https://apply.wellsfargo.com/getting_started?FPID=0126D7I6F40000&applicationtype=consumercreditcard&product_code=CC&subproduct_code=AC&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    learn_more_link:
      'https://creditcards.wellsfargo.com/active-cash-credit-card/?FPID=0126D7I6F40000&product_code=CC&subproduct_code=AC&cx_nm=CXNAME_CSMPD_MC&sub_channel=SEO&vendor_code=G',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/active-cash/terms/?FPID=0126D7I6F40000&product_code=CC&subproduct_code=AC&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/ActiveCash/WF_ActiveCash_VS_Collateral_Front_RGB.png',
    rewardsSummary:
      'Earn unlimited 2% cash rewards on purchases with no annual fee.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wells Fargo Active Cash\u00ae Card offers unlimited 2% cash rewards on all purchases, a $0 annual fee, and a $200 cash rewards bonus after spending $500 in the first 3 months.  Additional benefits include cell phone protection, auto rental collision damage waiver, and travel and emergency assistance services.',
    cardNetwork: 'Visa',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cellular Telephone Protection',
        description:
          'Up to $600 of cell phone protection against damage or theft. Subject to a $25 deductible.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Collision Damage Waiver',
        description:
          'Pay for rental cars using an eligible card and get reimbursed for covered damage or theft.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance Services',
        description:
          'Available for covered Wells Fargo cardholders. Count on emergency assistance while traveling anywhere in the world. To learn more, call 1-800-992-6029. If you are outside the U.S., you can call collect: 1-804-673-1675.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Dispatch\u00ae',
        description:
          "Available whenever you're in need of a tow - for eligible Wells Fargo cardholders 24/7 with no membership required. To learn more call 1-800-847-2869.",
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Emergency Cash Disbursement and Card Replacement',
        description:
          'Visa credit cardholders can get an emergency cash advance disbursed or a card replaced within one to three business days after issuer approval. Any cash advance fees and interest charges that are associated with your credit card account would apply.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'My Wells Fargo Deals',
        description:
          'Through My Wells Fargo Deals, you can get access to personalized deals from a variety of merchants. It\u2019s an easy way to earn cash back as an account credit when you shop, dine, or enjoy an experience simply by using an eligible Wells Fargo credit card.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability Protection',
        description:
          "Built-in protection features ensure that you won't be held responsible for unauthorized transactions, as long as they're reported promptly.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Credit Close-Up\u00ae',
        description:
          'With Credit Close-Up\u00ae you own the skills to help understand and track your FICO\u00ae Score, raise it, or maintain it. Enroll to receive monthly FICO\u00ae Score updates and personalized credit insights. It\u2019s complimentary to Wells Fargo Online\u00ae customers and using it won\u2019t negatively affect your score.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Signature\u00ae Concierge service',
        description:
          'Find tickets to top sports and entertainment events, book travel, make dinner reservations and more with your complimentary 24/7 Visa Signature\u00ae Concierge.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Signature\u00ae Luxury Hotel Collection',
        description:
          'Enjoy a premium collection of benefits at a selection of the world\u2019s most intriguing and prestigious properties.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash rewards bonus when you spend $500 in purchases in the first 3 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'active_cash_card.png',
  },
  [CreditCard.AUTOGRAPH_JOURNEY_CARD]: {
    id: CreditCard.AUTOGRAPH_JOURNEY_CARD,
    name: 'Wells Fargo Autograph Journey\u00ae Card',
    apply_link:
      'https://apply.wellsfargo.com/getting_started?FPID=0127E1I0P10000&product_code=CC&subproduct_code=MT&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&applicationtype=consumercreditcard',
    learn_more_link:
      'https://creditcards.wellsfargo.com/autograph-journey-visa-credit-card/?FPID=0127E1I0P10000&product_code=CC&subproduct_code=MT&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC',
    terms_and_conditions_button_text: '$95.',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/autograph-journey-visa/terms/?FPID=0127E1I0P10000&product_code=CC&subproduct_code=MT&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'wells_fargo',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/AutographJourney/WF_Autograph_Journey_Card_d.png',
    rewardsSummary:
      'Earn unlimited points on purchases, with bonus points on hotels, airlines, restaurants, and other travel.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'travel.airline.general',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wells Fargo Autograph Journey\u00ae Card offers unlimited rewards points with bonus earning rates on travel and dining.  It also includes a $50 annual airline statement credit and various travel protections.',
    cardNetwork: 'Visa',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Worldwide Automatic Common Carrier Travel Accident Insurance',
        description:
          'Get Travel Accident Insurance protection of up to $1,000,000 when you purchase your airline or other common carrier ticket with your eligible credit card.',
        benefit_type: 'travel_insurance',
        value: 1000000.0,
        value_unit: 'dollars',
        spend_requirement:
          'Purchase airline or common carrier ticket with card',
      },
      {
        name: 'Lost Baggage Reimbursement',
        description:
          'Receive up to $3,000 in luggage reimbursement per trip if your bags are lost due to theft or misdirection by a common carrier while traveling.',
        benefit_type: 'lost_luggage_reimbursement',
        value: 3000.0,
        value_unit: 'dollars',
        spend_requirement: 'Purchase common carrier ticket with card',
      },
      {
        name: 'Trip Cancellation and Interruption Protection',
        description:
          'Use an eligible card to pay for your trip and get reimbursed up to $15,000 for lodging, flights, and activities if the trip is canceled for a covered reason.',
        benefit_type: 'trip_cancellation_protection',
        value: 15000.0,
        value_unit: 'dollars',
        spend_requirement: 'Pay for trip with card',
      },
      {
        name: 'Auto Rental Collision Damage Waiver',
        description:
          'Pay for rental cars using an eligible card and get reimbursed for covered damage or theft.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: 'Pay for rental car with card',
      },
      {
        name: 'Travel and Emergency Assistance Services',
        description:
          'Available for covered Wells Fargo cardholders. Count on emergency assistance while traveling anywhere in the world. To learn more, call 1-800-992-6029. If you are outside the U.S., you can call collect: 1-804-673-1675.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fee',
        description:
          'Using your card abroad is like using it at home. We won\u2019t charge a fee for converting your purchases to U.S dollars.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cellular Telephone Protection',
        description:
          'Get up to $1,000 of cell phone protection against damage, theft, or unintended separation. Subject to a $25 deduction.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: 'Pay cell phone bill with card',
      },
      {
        name: 'Roadside Dispatch\u00ae',
        description:
          "Available whenever you're in need of a tow - for eligible Wells Fargo cardholders 24/7 with no membership required. To learn more call 1-800-847-2869.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Emergency Cash Disbursement and Card Replacement',
        description:
          'Visa credit cardholders can get an emergency cash advance disbursed or a card replaced within one to three business days after issuer approval.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability Protection',
        description:
          "Built-in protection features ensure that you won't be held responsible for unauthorized transactions, as long as they're reported promptly.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'My Wells Fargo Deals',
        description:
          'Through My Wells Fargo Deals, you can get access to personalized deals from a variety of merchants. It\u2019s an easy way to earn cash back as an account credit when you shop, dine, or enjoy an experience simply by using an eligible Wells Fargo credit card.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Autograph Card Exclusives',
        description:
          'Get access to tickets to live events featuring fan-favorite artists that put you closer to the artists than you\u2019ve ever been with your Wells Fargo Autograph Journey\u2120 Credit Card.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless cards',
        description:
          'Tap your card where you see the Contactless Symbol and speed through checkout!',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Credit Close-Up\u00ae',
        description:
          'With Credit Close-Up\u00ae you own the skills to help understand and track your FICO\u00ae Score, raise it, or maintain it. Enroll to receive monthly FICO\u00ae Score updates and personalized credit insights. It\u2019s complimentary to Wells Fargo Online\u00ae customers and using it won\u2019t negatively affect your score.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Signature\u00ae Concierge service',
        description:
          'Find tickets to top sports and entertainment events, book travel, make dinner reservations and more with your complimentary 24/7 Visa Signature\u00ae Concierge.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Signature\u00ae Luxury Hotel Collection',
        description:
          'Enjoy a premium collection of benefits at a selection of the world\u2019s most intriguing and prestigious properties.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$50 annual statement credit',
        description:
          'Each year, you will receive a one-time $50 statement credit applied to your account when your card is used for your first airline purchase of at least $50.',
        benefit_type: 'statement_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: '$50 minimum airline purchase',
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points when you spend $4,000 in purchases in the first 3 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'autograph_journey_card.png',
  },
  [CreditCard.AUTOGRAPH_CARD]: {
    id: CreditCard.AUTOGRAPH_CARD,
    name: 'Wells Fargo Autograph\u2120 Card',
    apply_link:
      'https://apply.wellsfargo.com/getting_started?FPID=012988I6P10000&applicationtype=consumercreditcard&product_code=CC&subproduct_code=AU&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    learn_more_link:
      'https://creditcards.wellsfargo.com/autograph-visa-credit-card/?FPID=012988I6P10000&product_code=CC&subproduct_code=AU&cx_nm=CXNAME_CSMPD_MC&sub_channel=SEO&vendor_code=G',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/autograph-visa/terms/?FPID=012988I6P10000&product_code=CC&subproduct_code=AU&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'wells_fargo',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/Autograph/Autograph-No-Fee-Card-RGB_d.png',
    rewardsSummary:
      'Earn unlimited 3X points on dining, travel, gas, transit, streaming services, and phone plans, plus 1X points on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'transit',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'streaming',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'phonePlans',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wells_fargo',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wells Fargo Autograph\u2120 Card offers a $0 annual fee, 20,000 bonus points after spending $1,000 in the first 3 months, and unlimited 3X points on dining, travel, gas, transit, streaming, and phone plans.',
    cardNetwork: 'Visa',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cellular Telephone Protection',
        description:
          'Up to $600 of cell phone protection against damage or theft. Subject to a $25 deductible.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto rental collision damage waiver',
        description:
          'Covers theft, damage, valid loss-of-use charges imposed and substantiated by the rental company, administrative fees and reasonable and customary towing charges to the nearest qualified repair facility.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance Services',
        description:
          'Offers emergency assistance and referral services designed to help you in case of an emergency while traveling. For assistance, call 1-800-992-6029.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Dispatch\u00ae',
        description:
          'A 24/7 on-demand referral dispatch network that provides emergency roadside assistance, towing, or locksmith service when you need them. For assistance, call 1-800-847-2869.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Emergency cash disbursement and card replacement',
        description:
          'Visa credit cardholders can get an emergency cash advance disbursed or a card replaced within one to three business days after issuer approval. Any cash advance fees and interest charges that are associated with your credit card account would apply.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'My Wells Fargo Deals',
        description:
          'Through My Wells Fargo Deals, you can get access to personalized deals from a variety of merchants. It\u2019s an easy way to earn cash back as an account credit when you shop, dine, or enjoy an experience simply by using an eligible Wells Fargo credit card.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability protection',
        description:
          "Built-in protection features ensure that you won't be held responsible for unauthorized transactions, as long as they're reported promptly.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Credit Close-Up\u00ae',
        description:
          'With Credit Close-Up\u00ae you own the skills to help understand and track your FICO\u00ae Score, raise it, or maintain it. Enroll to receive monthly FICO\u00ae Score updates and personalized credit insights. It\u2019s complimentary to Wells Fargo Online\u00ae customers and using it won\u2019t negatively affect your score.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Autograph Card Exclusives',
        description:
          'Get access to tickets to live events featuring fan-favorite artists that put you closer to the artists than you\u2019ve ever been with your Wells Fargo Autograph-branded Credit Card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fee',
        description:
          'Using your card abroad is like using it at home. We won\u2019t charge a fee for converting your purchases to U.S dollars.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'points',
        description:
          "Earn 20,000 bonus points when you spend $1,000 in purchases in the first 3 months. That's a $200 cash redemption value.",
      },
    ],
    cardType: 'personal',
    imageName: 'autograph_card.png',
  },
  [CreditCard.REFLECT_CARD]: {
    id: CreditCard.REFLECT_CARD,
    name: 'Wells Fargo Reflect\u00ae Card',
    apply_link:
      'https://apply.wellsfargo.com/getting_started?FPID=013000IGF80000&applicationtype=consumercreditcard&product_code=CC&subproduct_code=VV&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    learn_more_link:
      'https://creditcards.wellsfargo.com/reflect-visa-credit-card/?FPID=013000IGF80000&product_code=CC&subproduct_code=VV&cx_nm=CXNAME_CSMPD_MC&sub_channel=SEO&vendor_code=G',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/reflect-visa/terms/?FPID=013000IGF80000&product_code=CC&subproduct_code=VV&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/Reflect/Reflect_homepage_m.png',
    rewardsSummary:
      'The Wells Fargo Reflect Card offers a 0% intro APR for 21 months on purchases and qualifying balance transfers, and has no annual fee.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The Wells Fargo Reflect Card offers a 0% intro APR for 21 months on purchases and qualifying balance transfers, and has no annual fee.  It also includes benefits such as cellular telephone protection and roadside dispatch.',
    cardNetwork: 'Visa',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cellular Telephone Protection',
        description:
          'Up to $600 of cell phone protection against damage or theft. Subject to a $25 deductible.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Dispatch\u00ae',
        description:
          'A 24/7 on-demand referral dispatch network that provides emergency roadside assistance, towing, or locksmith service when you need them. For assistance, call 1-800-847-2869.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'My Wells Fargo Deals',
        description:
          'Through My Wells Fargo Deals, you can get access to personalized deals from a variety of merchants. It\u2019s an easy way to earn cash back as an account credit when you shop, dine, or enjoy an experience simply by using an eligible Wells Fargo credit card.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability protection',
        description:
          "Built-in protection features ensure that you won't be held responsible for unauthorized transactions, as long as they're reported promptly.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Credit Close-Up\u2120',
        description:
          'With Credit Close-Up\u2120you own the skills to help understand and track your FICO\u00ae Score, raise it, or maintain it. Enroll to receive monthly FICO\u00ae Score updates and personalized credit insights. It\u2019s complimentary to Wells Fargo Online\u00ae customers and using it won\u2019t negatively affect your score.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'reflect_card.png',
  },
  [CreditCard.ATTUNE_CARD]: {
    id: CreditCard.ATTUNE_CARD,
    name: 'Wells Fargo Attune\u2120 Card',
    apply_link:
      'https://apply.wellsfargo.com/getting_started?FPID=012286I6P10000&product_code=CC&subproduct_code=EM&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&applicationtype=consumercreditcard',
    learn_more_link:
      'https://creditcards.wellsfargo.com/attune-credit-card/?FPID=012286I6P10000&product_code=CC&subproduct_code=EM&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/attune/terms/?FPID=012286I6P10000&product_code=CC&subproduct_code=EM&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC',
    bank_name: 'Wells Fargo',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/Attune/attune_card_banner_d.png',
    rewardsSummary:
      'Earn unlimited 4% cash rewards on select categories, 1% on other purchases.',
    rewardsEarnRates: [
      {
        category: 'Self-care',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Select Sports, Recreation, and Entertainment',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Planet-Friendly purchases',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wells Fargo Attune\u2120 Card offers unlimited 4% cash rewards on select categories like self-care, sports & entertainment, and planet-friendly purchases, plus 1% on all other purchases.  It also features a $0 annual fee and a $100 cash rewards bonus after spending $500 in the first 3 months.',
    cardNetwork: 'Mastercard',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Cellular Telephone Protection',
        description:
          'Get up to $600 of cell phone protection per claim against damage, theft, and unintended separation when you pay your monthly phone bill with your Attune Card. Subject to a $25 deduction.',
        benefit_type: 'cell_phone_protection',
        value: 600.0,
        value_unit: 'dollars',
        spend_requirement: 'Pay your monthly phone bill with your Attune Card',
      },
      {
        name: 'Mastercard Global Service',
        description:
          'Wherever you are, you can always count on Mastercard Global Services for any card-related need.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard ID Theft Protection',
        description:
          'Identity theft hurts, but Mastercard can help \u2013 for no extra cost. From scouring the internet to see if your personal info is being sold to helping you clear your name with credit rating agencies, we are there for you 24/7.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability Protection',
        description:
          "Built-in protection features ensure that you won't be held responsible for unauthorized transactions, as long as they're reported promptly.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Collision Damage Waiver',
        description:
          'Pay for rental cars using an eligible card and get reimbursed for covered damage or theft.',
        benefit_type: 'auto_rental_collision_damage_waiver_secondary',
        value: null,
        value_unit: null,
        spend_requirement: 'Pay for rental cars using an eligible card',
      },
      {
        name: 'Concierge Service',
        description: 'A personal assistant ready to help 24/7, worldwide.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard Travel and Lifestyle Services',
        description:
          'Enjoy added peace of mind and a worry-free stay. If you experience problems with your 3-star or higher rated hotel, contact a Lifestyle Manager, 24/7, who will work directly with your hotel to help resolve the issue.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 100.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $100 cash rewards bonus when you spend $500 in purchases in the first 3 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'attune_card.png',
  },
  [CreditCard.BILT_MASTERCARD]: {
    id: CreditCard.BILT_MASTERCARD,
    name: 'Bilt Mastercard\u00ae',
    apply_link:
      'https://go.bilt.page/e/LKkqAnRAWnb/?utm_source=WF&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=EC&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en&sub_channel=SEO&vendor_code=G',
    learn_more_link:
      'https://creditcards.wellsfargo.com/bilt-rewards-credit-card/?product_code=CC&subproduct_code=EC&cx_nm=CXNAME_CSMPD_MC&sub_channel=SEO&vendor_code=G',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/bilt/terms/?product_code=CC&subproduct_code=EC&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'bilt_rewards',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/Bilt/Bilt_card_D.png',
    rewardsSummary:
      'The Bilt Mastercard\u00ae earns 1 point per $1 spent on rent, 2 points per $1 on travel, 3 points per $1 on dining, and 1 point per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'rent',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: 100000.0,
        spendMinimum: null,
        minimumTransactionCount: 5,
        minimumTransactionAmount: null,
        rewardsType: 'bilt_rewards',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: 5,
        minimumTransactionAmount: null,
        rewardsType: 'bilt_rewards',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: 5,
        minimumTransactionAmount: null,
        rewardsType: 'bilt_rewards',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: 5,
        minimumTransactionAmount: null,
        rewardsType: 'bilt_rewards',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Bilt World Elite Mastercard\u00ae offers a $0 annual fee and earns points on rent payments (up to 100,000 points per year), 2X points on travel, and 3X points on dining.  It also includes various travel benefits and purchase protections.',
    cardNetwork: 'Mastercard',
    issuer: 'Wells Fargo Bank, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Trip Cancellation and Interruption Protection',
        description:
          'Receive reimbursement for the nonrefundable cost of your common carrier fare if your trip is canceled or interrupted for a covered reason.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Trip Delay Reimbursement',
        description:
          'Get reimbursed for eligible expenses incurred if a trip is delayed over six hours --benefit amount up to $200 per day, per traveler; maximum of $1,800 for all covered travelers.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Auto Rental Collision Damage Waiver',
        description:
          'Pay for rental transactions with an eligible card and receive reimbursement of up to $50,000 if covered damage to or theft of your eligible rental vehicle occurs.',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fee',
        description:
          'When you use your card for travel, you won\u2019t pay a foreign transaction fee for purchases converted to U.S. dollars.',
        benefit_type: 'no_foreign_transaction_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lyft credits',
        description:
          'Take 3 eligible rides with your Bilt World Elite Mastercard\u00ae in a month and earn $5 in Lyft credit.',
        benefit_type: 'statement_credit',
        value: 5.0,
        value_unit: 'dollars',
        spend_requirement: '3 rides',
      },
      {
        name: 'Concierge Service',
        description:
          'Whether you need hard-to-find dinner reservations, the perfect last-minute gift or insider hotel recommendations, the World Elite Mastercard Concierge will work behind the scenes on your behalf \u2014 anywhere in the world.',
        benefit_type: 'concierge_service',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cellular Telephone Protection',
        description:
          'Get up to $800 of cell phone protection per claim against damage, theft, and unintended separation when you pay your monthly phone bill with an eligible card. Subject to a $25 deductible.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Security',
        description:
          'Get reimbursed for the cost to repair or replace an item purchased with your Bilt Mastercard in the event of covered damages or theft within 90 days of purchase.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'bilt_mastercard.png',
  },
  [CreditCard.ONE_KEY_CARD]: {
    id: CreditCard.ONE_KEY_CARD,
    name: 'one_key_card',
    apply_link:
      'https://www.expedia.com/one-key-cards/apply?FPID=21231EIO050000&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=OW&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en&langid=1033',
    learn_more_link:
      'https://creditcards.wellsfargo.com/one-key-credit-card/?FPID=21231EIO050000&product_code=CC&subproduct_code=OW&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/terms/onekey/?FPID=21231EIO050000&product_code=CC&subproduct_code=OW&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
  },
  [CreditCard.CHOICE_PRIVILEGES_MASTERCARD]: {
    id: CreditCard.CHOICE_PRIVILEGES_MASTERCARD,
    name: 'Choice Privileges\u00ae Mastercard\u00ae',
    apply_link:
      'https://www.choicehotels.com/choice-privileges/earn-points/mastercard-credit-card?FPID=0124CAIXP10000&utm_source=WF&app_source=WELLS_FARGO_COM&locale=en_US&product_code=CC&subproduct_code=CP&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en',
    learn_more_link:
      'https://creditcards.wellsfargo.com/choice-hotel-privileges-mastercard/?FPID=0124CAIXP10000&product_code=CC&subproduct_code=CP&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/choice/terms/?FPID=0124CAIXP10000&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=CP&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'choice',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/ChoicePrivileges/WF_Choice_NoFee_Collateral_Front_RGB_no_flag.png',
    rewardsSummary:
      'Earn 5X points on Choice Hotels stays and Choice Privileges point purchases, 3X points on gas, groceries, home improvement, and phone plans, and 1X point on other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.choiceHotels',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'homeImprovement',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'internetCablePhone',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Choice Privileges\u00ae Mastercard\u00ae offers a $0 annual fee and earns bonus points on Choice Hotels stays, gas, groceries, home improvement stores, and phone plans.  It also comes with automatic Gold Elite status in the Choice Privileges program and other benefits like cell phone protection.',
    cardNetwork: 'Mastercard',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic Gold Elite membership',
        description:
          'Enjoy the perks of Gold Elite status and earn 10% bonus points every time you book a qualifying stay at Choice\u00ae hotels. That\u2019s halfway to Platinum Elite status. Receive 10 Elite night credits qualifying for at least Gold level status each calendar year.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cellular Telephone Protection',
        description:
          'Up to $800 of cell phone protection against damage or theft. Subject to a $25 deductible.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fee',
        description:
          'When you use your card for travel, you won\u2019t pay a foreign currency conversion fee for purchases converted to U.S. dollars.',
        benefit_type: 'no_foreign_transaction_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard\u00ae World Elite benefits',
        description:
          'Get access to additional security benefits, exclusive offers, concierge, travel & lifestyles services, and more.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 40000,
        bonusValueUnit: 'points',
        description:
          'Earn 40,000 bonus points when you spend $1,000 in purchases in the first 3 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'choice_privileges_mastercard.png',
  },
  [CreditCard.CHOICE_PRIVILEGES_SELECT_MASTERCARD]: {
    id: CreditCard.CHOICE_PRIVILEGES_SELECT_MASTERCARD,
    name: 'Choice Privileges\u00ae Select Mastercard\u00ae',
    apply_link:
      'https://www.choicehotels.com/choice-privileges/earn-points/mastercard-credit-card?FPID=0123CBIXP10000&utm_source=WF&app_source=WELLS_FARGO_COM&locale=en_US&product_code=CC&subproduct_code=CE&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en',
    learn_more_link:
      'https://creditcards.wellsfargo.com/choice-hotels-privileges-select-mastercard/?FPID=0123CBIXP10000&product_code=CC&subproduct_code=CE&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC',
    terms_and_conditions_button_text: '$95',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/credit-cards/choice-select/terms/?FPID=0123CBIXP10000&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=CE&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'choice',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/ChoicePrivilegesSelect/WF_Choice_Fee_Collateral_Front__RGB_no_flag.png',
    rewardsSummary:
      'This card earns 10x points on Choice Hotels stays and Choice Privileges point purchases, 5x points on gas, groceries, home improvement stores, and phone plans, and 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.choiceHotels',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'grocery',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'homeImprovement',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'internetCablePhone',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'choice',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Choice Privileges\u00ae Select Mastercard\u00ae offers a 60,000-point bonus after spending $3,000 in the first 3 months, plus 10x points on Choice Hotels stays and Choice Privileges point purchases, 5x points on gas, groceries, home improvement, and phone plans, and 1x point on all other purchases.  It also includes an annual fee of $95.',
    cardNetwork: 'Mastercard',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Global Entry\u00ae or TSA PreCheck\u00ae Credit',
        description:
          'Enroll in Global Entry or TSA PreCheck and receive a statement credit of up to $120 every four years as reimbursement for the application fee.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fee',
        description:
          'When you use your card for travel, you won\u2019t pay a foreign currency conversion fee for purchases converted to U.S. dollars.',
        benefit_type: 'noForeignTransactionFee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cellular Telephone Protection',
        description:
          'Up to $800 of cell phone protection against damage or theft. Subject to a $25 deductible.',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard\u00ae World Elite benefits',
        description:
          'Get access to additional security benefits, exclusive offers, concierge, travel & lifestyles services, and more.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus',
        description: 'Earn 30,000 bonus points every account anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 30000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'Automatic Platinum Elite Membership',
        description:
          'Enjoy the perks of Platinum Elite status and earn 25% bonus points every time you book and stay at a qualifying Choice\u00ae hotel.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000.0,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 bonus points when you spend $3,000 in purchases in the first 3 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'choice_privileges_select_mastercard.png',
  },
  [CreditCard.SIGNIFY_BUSINESS_CARD]: {
    id: CreditCard.SIGNIFY_BUSINESS_CARD,
    name: 'Signify Business Cash\u2120 Card by Wells Fargo',
    apply_link:
      'https://apply.wellsfargo.com/getting_started?FPID=7086BAI6000000&product_code=BD&subproduct_code=BCMC&applicationtype=businesscreditcard&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    learn_more_link:
      'https://creditcards.wellsfargo.com/business-credit-cards/signify-business-cash-credit-card/?FPID=7086BAI6000000&product_code=BD&subproduct_code=BCMC&cx_nm=CXNAME_CSMPD_MC&sub_channel=SEO&vendor_code=G',
    terms_and_conditions_button_text: '$0',
    terms_and_conditions_link:
      'https://www.wellsfargo.com/biz/business-credit/credit-cards/signify-business-cash-credit-card-terms-conditions?FPID=7086BAI6000000&product_code=BD&subproduct_code=BCMC&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G',
    bank_name: 'Wells Fargo',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://creditcards.wellsfargo.com/W-Card-MarketPlace/v2-5-25/images/Products/SignifyBusiness/WF_Signify_Cash_Card_d.png',
    rewardsSummary:
      'Earn unlimited 2% cash rewards on all business purchases with no annual fee.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Signify Business Cash\u2120 Card by Wells Fargo offers unlimited 2% cash rewards on all business purchases, a $0 annual fee, and a $500 cash rewards bonus after spending $5,000 in the first 3 months.',
    cardNetwork: 'Mastercard',
    issuer: 'Wells Fargo',
    selectableCategories: [],
    benefits: [
      {
        name: 'Employee cards',
        description:
          'Earn more rewards with employee cards at no additional cost.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '0% intro APR for 12 months',
        description:
          '0% intro APR for 12 months from account opening on purchases. After that your variable APR will be 17.49% \u2013 25.49%.',
        benefit_type: null,
        value: 12,
        value_unit: 'Months',
        spend_requirement: null,
      },
      {
        name: 'Autopay',
        description:
          'Make sure your credit card is paid on time by scheduling automatic payments.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Account Alerts',
        description:
          'Stay informed of important activity on your account and on employee cards with customizable alerts.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Digital Wallets',
        description:
          'Choose the digital wallets you would like to use to make payments quickly and securely. Get started in the Wells Fargo Mobile\u00ae app.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Online Banking',
        description:
          'With Wells Fargo Business Online\u00ae, you have secure online access to your accounts through your desktop and mobile devices.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem to account',
        description: 'Rewards can be used to credit eligible accounts.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem for travel',
        description:
          'Redeem your rewards on flights, car rentals, and hotel stays for your next business trip.',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem for gift cards',
        description:
          'Find the perfect gift card for that right occasion. Gift cards are redeemable in many amounts.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Priority Pass\u2122',
        description:
          'Complimentary membership access to more than 1,300 participating airport lounges worldwide with \u201cpay as you go\u201d lounge visit fees.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Worldwide Automatic Common Carrier Travel Accident Insurance',
        description:
          'Purchase your airline or other common carrier ticket with your eligible Wells Fargo card and you can be protected with Travel Accident Insurance of up to $250,000.',
        benefit_type: 'travel_insurance',
        value: 250000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'MasterRental Insurance Coverage',
        description:
          'Reimbursement for covered physical damage and/or theft of a rental vehicle with primary protection.',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability Protection',
        description:
          "Built-in protection features ensure that you won't be held responsible for unauthorized transactions, as long as they're reported promptly.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard ID Theft Protection\u2122',
        description:
          'Detection and protection against identity theft, including monitoring, alerts and expert resolution 24/7/365. Enrollment is required.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 5000.0,
        spendRequirementMonths: 3,
        bonusValue: 500.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $500 cash rewards bonus when you spend $5,000 in purchases for your business in the first 3 months.',
      },
    ],
    cardType: 'business',
    imageName: 'signify_business_card.png',
  },
  [CreditCard.CITI_DOUBLE_CASH_CARD]: {
    id: CreditCard.CITI_DOUBLE_CASH_CARD,
    name: 'Citi Double Cash\u00ae Credit Card',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=96df08cbea1f382c2c2b7420888b25d8f4b4a2b0f057360f098d56d138de22ef&ID=3000&ProspectID=PSV1gnPFBOrZI6yVtjXt6Gwc8PWljvHW&intc=citihpmenu~creditcards~vac&pid=142&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-double-cash-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=96df08cbea1f382c2c2b7420888b25d8f4b4a2b0f057360f098d56d138de22ef',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'data:image/png;base64,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',
    rewardsSummary:
      'Earn unlimited 2% cash back: 1% when you buy, and another 1% as you pay.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Citi Double Cash Card offers unlimited 2% cash back on every purchase\u20141% when you buy and another 1% as you pay.  There are no annual fees and a $200 cash back bonus after spending $1,500 in the first 6 months.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '24/7 Customer Service',
        description:
          'Our customer service representatives are available to assist you 24 hours a day, 7 days a week.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Pay',
        description:
          'Shop safely with a contactless-chip enabled card. Just tap your card on the payment reader and go in seconds.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Digital Wallets',
        description:
          'Digital Wallets let you shop with confidence in millions of places online, within apps and in stores. With digital wallets you can speed through checkout and continue to enjoy all the great benefits that come with your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24 Hour Fraud Protection',
        description:
          'Citi will alert you if we see unusual activity on your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'ID Theft Protection',
        description:
          'The ID Theft Protection program offered by Mastercard helps eliminate the worry of identity theft by monitoring the information you choose to protect and alerting you if suspicious activity is found.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Liability on Unauthorized Charges',
        description:
          "You're completely protected against unauthorized charges on your account. At Citi, you will not be responsible for a charge that you did not authorize, online or otherwise.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Citi Entertainment\u00ae',
        description:
          "Citi Entertainment takes the once out of once in a lifetime. Get special access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for the year's most anticipated concerts, sporting events, dining experiences and more.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1500.0,
        spendRequirementMonths: 6,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash back bonus after you spend $1,500 on purchases in the first 6 months of your Citi Double Cash\u00ae card account opening.',
      },
    ],
    cardType: 'personal',
    imageName:
      'citi_double_cash_card.data:image/png;base64,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',
  },
  [CreditCard.CITI_SIMPLICITY_CREDIT_CARD]: {
    id: CreditCard.CITI_SIMPLICITY_CREDIT_CARD,
    name: 'CITI SIMPLICITYu00aeCARD',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=44d62b77f58f046b30104e9ec898aeb46d98e2fc19ed3316a7a307509fa5dd32&ID=3000&ProspectID=P33wTEff8d2W4KpnuKlWOvYDeI3gdFPD&intc=citihpmenu~creditcards~vac&pid=202&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-simplicity-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=44d62b77f58f046b30104e9ec898aeb46d98e2fc19ed3316a7a307509fa5dd32',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'data:image/png;base64,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\n\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',
    rewardsSummary:
      'This card does not earn rewards; it offers no late fees, no penalty rate, and no annual fee.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
    imageName:
      'citi_simplicity_credit_card.data:image/png;base64,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\n\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',
  },
  [CreditCard.CITI_DIAMOND_PREFERRED_CREDIT_CARD]: {
    id: CreditCard.CITI_DIAMOND_PREFERRED_CREDIT_CARD,
    name: 'Citi\u00ae Diamond Preferred\u00ae Card',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=7cedf909ab56cc91468bda88bd3bffc5a2af44d1a1e242332519b42c5044f9da&ID=3000&ProspectID=PGDUzr5F2t69jO2DGJQucp1CQXIpdkep&intc=citihpmenu~creditcards~vac&pid=257&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-diamond-preferred-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=7cedf909ab56cc91468bda88bd3bffc5a2af44d1a1e242332519b42c5044f9da',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-diamond/citi-diamond_171x108.png',
    rewardsSummary: 'This card does not earn rewards.',
    rewardsEarnRates: [],
    creditScore: 'good to excellent',
    cardSummary:
      'The Citi\u00ae Diamond Preferred\u00ae Card offers a low introductory APR on both purchases and balance transfers, along with no annual fee and $0 liability on unauthorized charges.  It also provides free access to your FICO\u00ae Score and Mastercard\u00ae ID Theft Protection.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '0% Intro APR on Purchases',
        description:
          '0% Intro APR for 12 months on purchases from date of account opening; after that, the variable APR will be 17.24% - 27.99%, based on your creditworthiness.',
        benefit_type: 'introductory_apr',
        value: 0,
        value_unit: '%',
        spend_requirement: null,
      },
      {
        name: '0% Intro APR on Balance Transfers',
        description:
          '0% Intro APR for 21 months on balance transfers from date of first transfer; after that, the variable APR will be 17.24% - 27.99%, based on your creditworthiness.',
        benefit_type: 'introductory_apr',
        value: 0,
        value_unit: '%',
        spend_requirement: null,
      },
      {
        name: 'No Annual Fee',
        description:
          'There is no annual fee with the Citi\u00ae Diamond Preferred\u00ae card.',
        benefit_type: 'no_annual_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Liability on Unauthorized Charges',
        description:
          "You're completely protected against unauthorized charges on your account.",
        benefit_type: 'zero_liability',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Access to Your FICO\u00ae Score',
        description: 'Free Access to Your Fico<sup>\u00ae</sup>Score',
        benefit_type: 'fico_score',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard\u00ae ID Theft Protection',
        description:
          'Mastercard<sup>\u00ae</sup>ID Theft Protection\u2122available for no additional charge',
        benefit_type: 'id_theft_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'citi_diamond_preferred_credit_card.png',
  },
  [CreditCard.CITI_CUSTOM_CASH_CARD]: {
    id: CreditCard.CITI_CUSTOM_CASH_CARD,
    name: 'CITI CUSTOM CASH\u00ae CARD',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=ff93c595b1fb40dede81a226fd2bc6c997aa6b569fecc1d7d1be7a15a20c277f&ID=3000&ProspectID=P2tXUijmmGT06HPZ5Iw73WTX1CPxzKSm&intc=citihpmenu~creditcards~vac&pid=416&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-custom-cash-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=ff93c595b1fb40dede81a226fd2bc6c997aa6b569fecc1d7d1be7a15a20c277f',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'data:image/png;base64,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',
    rewardsSummary:
      'Earn 5% cash back on your top eligible spend category each billing cycle up to $500 spent, and 1% cash back thereafter on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'Restaurants',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Gas Stations',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Grocery Stores',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Select Travel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Select Transit',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Select Streaming Services',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Drugstores',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Home Improvement Stores',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Fitness Clubs',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Live Entertainment',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Citi Custom Cash\u00ae Card offers unlimited 1% cash back on all purchases and 5% cash back on your top eligible spending category each billing cycle, up to $500.  There's also a special travel offer for additional cash back.",
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'New Cardmember Bonus',
        description:
          'Earn $200 cash back after you spend $1,500 on purchases in the first 6 months of account opening.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: '$1,500',
      },
      {
        name: 'Special Travel Offer',
        description:
          'Earn an additional 4% cash back on hotels, car rentals, and attractions booked on Citi Travel\u2120 portal through 6/30/2026.',
        benefit_type: 'cash_back',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$1,500',
        spendRequirementMonths: 6,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 cash back bonus after you spend $1,500 on purchases within the first 6 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName:
      'citi_custom_cash_card.data:image/png;base64,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',
  },
  [CreditCard.AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD]:
    {
      id: CreditCard.AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD,
      name: 'CITIu00ae/ AADVANTAGEu00aePLATINUM SELECTu00aeWORLD ELITE MASTERCARDu00ae',
      apply_link:
        'https://online.citi.com/US/ag/cards/application?app=UNSOL&prodType=CitiCardAA&HKOP=aa8d793079ddff663801560378dd868ae3755249b3b1543c6c8de91c71a6c15c&ID=3000&ProspectID=Pqr0gaDQp2OXooXqfxxvqi8ylXtt20mJ&intc=citihpmenu~creditcards~vac&pid=056&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
      learn_more_link:
        'https://www.citi.com/credit-cards/citi-aadvantage-platinum-elite-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
      terms_and_conditions_button_text: 'Important Pricing & Information+',
      terms_and_conditions_link:
        'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=aa8d793079ddff663801560378dd868ae3755249b3b1543c6c8de91c71a6c15c',
      bank_name: 'Citi',
      rewardsType: 'american',
      creditCardImageUrl:
        'data:image/png;base64,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, "cardSummary": "Earn 50,000 bonus miles after you spend $2,500 in purchases within the first 3 months of account opening.  Enjoy 2x miles on American Airlines purchases, restaurants, and gas stations, plus a first checked bag free on American Airlines domestic itineraries.',
      rewardsSummary:
        'Earn 2 AAdvantageu00ae miles for every $1 spent at restaurants, gas stations, and eligible American Airlines purchases and 1 AAdvantageu00ae mile for every $1 spent on all other purchases.',
      rewardsEarnRates: [
        {
          category: 'travel.airline.american',
          earnRate: 2.0,
          excludeMerchants: [],
          spendCap: null,
          spendMinimum: null,
          minimumTransactionCount: null,
          minimumTransactionAmount: null,
          rewardsType: 'american',
        },
        {
          category: 'gas',
          earnRate: 2.0,
          excludeMerchants: [],
          spendCap: null,
          spendMinimum: null,
          minimumTransactionCount: null,
          minimumTransactionAmount: null,
          rewardsType: 'american',
        },
        {
          category: 'dining',
          earnRate: 2.0,
          excludeMerchants: [],
          spendCap: null,
          spendMinimum: null,
          minimumTransactionCount: null,
          minimumTransactionAmount: null,
          rewardsType: 'american',
        },
        {
          category: 'allPurchases',
          earnRate: 1.0,
          excludeMerchants: [],
          spendCap: null,
          spendMinimum: null,
          minimumTransactionCount: null,
          minimumTransactionAmount: null,
          rewardsType: 'american',
        },
      ],
      creditScore: null,
      cardSummary: null,
      cardNetwork: 'Mastercard',
      issuer: 'Citi',
      selectableCategories: [],
      benefits: [
        {
          name: 'First Checked Bag Free',
          description:
            'First checked bag free on domestic American Airlines itineraries for you and up to 4 companions traveling with you on the same reservation.',
          benefit_type: 'airline_priority_boarding',
          value: null,
          value_unit: null,
          spend_requirement: null,
        },
        {
          name: 'Preferred Boarding',
          description:
            'Enjoy preferred boarding on American Airlines flights so you can save time and be more productive.',
          benefit_type: 'airline_priority_boarding',
          value: null,
          value_unit: null,
          spend_requirement: null,
        },
        {
          name: '25% Savings on Inflight Food and Beverage',
          description:
            'Receive 25% savings on food and beverage purchases when you use your card on American Airlines flights.',
          benefit_type: 'airline_inflight_purchase_discount',
          value: 25.0,
          value_unit: '%',
          spend_requirement: null,
        },
      ],
      signupBonus: [
        {
          spendRequirement: 2500.0,
          spendRequirementMonths: 3,
          bonusValue: 50000,
          bonusValueUnit: 'miles',
          description:
            'Earn 50,000 bonus miles after you spend $2,500 in purchases within the first 3 months of account opening.',
        },
      ],
      cardType: 'personal',
      imageName:
        'american_airlines_aadvantage_platinum_select_world_elite_mastercard.',
    },
  [CreditCard.CITI_STRATA_PREMIER_CARD]: {
    id: CreditCard.CITI_STRATA_PREMIER_CARD,
    name: 'Citi Strata Premier\u2120 Card',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=8a3c96a8f92b22d7ea9dcc1a1abb1a04d43659f2035a8d201d227a33d1302fbc&ID=3000&ProspectID=PiR4NBq16xevYFChACsHbN5kaMwO68Gg&intc=citihpmenu~creditcards~vac&pid=089&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-strata-premier-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=8a3c96a8f92b22d7ea9dcc1a1abb1a04d43659f2035a8d201d227a33d1302fbc',
    bank_name: 'Citi',
    rewardsType: 'citi_typ',
    creditCardImageUrl:
      'data:image/png;base64,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      "cardSummary": "The Citi Strata Premier\u2120 Card offers a $100 annual hotel credit, no foreign transaction fees, and earns ThankYou\u00ae Points on purchases, with bonus rates on travel and everyday spending.',
    rewardsSummary:
      'The Citi Strata Premier\u2120 Card earns ThankYou\u00ae Points on purchases, with bonus rates on air travel, hotels, restaurants, supermarkets, gas, and EV charging stations.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'travel.carRental',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'travel.attraction',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'allOtherPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
    ],
    creditScore: null,
    cardSummary: null,
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '$100 Annual Hotel Benefit',
        description:
          'Once per calendar year, enjoy $100 off a single hotel stay of $500 or more (excluding taxes and fees) when booked through CitiTravel.com. Benefit applied instantly at the time of booking.',
        benefit_type: 'travel_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: '$500 or more',
      },
      {
        name: 'Travel Protection Benefits',
        description:
          'Help stay protected with travel insurances, including Trip Delay Protection, Common Carrier Trip Cancellation and Interruption Protection, Lost or Damaged Luggage, and MasterRental Coverage (car rental insurance).',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 75000,
        bonusValueUnit: 'points',
        description:
          'Earn 75,000 bonus points after spending $4,000 in the first 3 months of account opening, redeemable for $750 in gift cards or travel rewards on thankyou.com.',
      },
    ],
    cardType: 'personal',
    imageName: 'citi_strata_premier_card.',
  },
  [CreditCard.CITI_REWARDS_STUDENT_CREDIT_CARD]: {
    id: CreditCard.CITI_REWARDS_STUDENT_CREDIT_CARD,
    name: 'Citi Rewards+\u00ae Student Credit Card    |    NO ANNUAL FEE',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=COLLEGE&HKOP=56e6eef64aae0280068f87cf3329f05da77cb369fa981ef2590abf16700a2f4b&ID=3000&ProspectID=P4z5Ggnj8VBvYAKNEBi2vWBablUnnBPI&intc=citihpmenu~creditcards~vac&pid=408&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-rewards-plus-student-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=COLLEGE&HKOP=56e6eef64aae0280068f87cf3329f05da77cb369fa981ef2590abf16700a2f4b',
    bank_name: 'Citi',
    rewardsType: 'citi_typ',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-rewards-plus-student/citi-rewards-plus-student_171x108.png',
    rewardsSummary:
      'Earn ThankYou\u00ae points on purchases, with bonus points for meeting spending requirements.',
    rewardsEarnRates: [
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Citi Rewards+\u00ae Student Card offers ThankYou\u00ae Points on purchases, with bonus points for spending $500 in the first 3 months.  Earn 5X points on travel, 2X at supermarkets and gas stations, and 1X on all other purchases.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Digital Wallets',
        description:
          'Digital Wallets let you shop with confidence in millions of places online, within apps and in stores.',
        benefit_type: 'convenience',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Pay',
        description:
          'Shop safely with a contactless-chip enabled card. Just tap your card on the payment reader and go in seconds.',
        benefit_type: 'convenience',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Citi Mobile App',
        description:
          'The Citi Mobile App gives you access to your account virtually anywhere, anytime.',
        benefit_type: 'convenience',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose Your Payment Due Date',
        description:
          'Choose to pay your bill on any available due date in the beginning, middle or end of the month.',
        benefit_type: 'convenience',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24/7 Customer Service',
        description:
          'Our customer service representatives are available to assist you 24 hours a day, 7 days a week.',
        benefit_type: 'support',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard ID Theft Protection',
        description:
          'Offered by Mastercard, this program helps eliminate the worry of identity theft by monitoring and alerting cardholders if suspicious activity is found.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Citi Entertainment',
        description:
          "Citi Entertainment takes the once out of once in a lifetime. Get special access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for the year's most anticipated concerts, sporting events, dining experiences and more.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Round Up to the nearest 10 points on every purchase',
        description:
          'Earn points fast with the only credit card that automatically rounds up to the nearest 10 points on every purchase.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Points Back',
        description:
          'Get 10% Points Back when you redeem, up to the first 100,000 points redeemed per year.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 5000,
        bonusValueUnit: 'points',
        description:
          'Earn 5,000 bonus ThankYou\u00ae points after spending $500 within the first 3 months of account opening, redeemable for $50 in gift cards or travel rewards at thankyou.com.',
      },
    ],
    cardType: 'personal',
    imageName: 'citi_rewards_student_credit_card.png',
  },
  [CreditCard.CITI_REWARDS_CREDIT_CARD]: {
    id: CreditCard.CITI_REWARDS_CREDIT_CARD,
    name: 'Citi Rewards+\u00ae Card',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=2444caf3d314becef62109c891379aeb5f596a7c074a964823559f1584149500&ID=3000&ProspectID=PzkDVV5AoeYafXeGs2WUDarrsUfbQFht&intc=citihpmenu~creditcards~vac&pid=408&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-rewards-plus-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=2444caf3d314becef62109c891379aeb5f596a7c074a964823559f1584149500',
    bank_name: 'Citi',
    rewardsType: 'citi_typ',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-rewards-plus/citi-rewards-plus_171x108.png',
    rewardsSummary:
      'The Citi Rewards+\u00ae Card earns ThankYou\u00ae Points on purchases, with bonus rates on hotels, car rentals, supermarkets, and gas stations.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'travel.rideshare',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: 6000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'citi_typ',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Citi Rewards+\u00ae Card offers a 0% intro APR for 15 months on purchases and balance transfers, no annual fee, and earns ThankYou\u00ae Points on purchases with bonus categories.  Redeem points for travel, gift cards, or cash back.',
    cardNetwork: null,
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Points Back',
        description:
          'Get 10% Points Back when you redeem, up to the first 100,000 points redeemed per year.',
        benefit_type: 'statement_credit',
        value: 10.0,
        value_unit: '%',
        spend_requirement: '100,000 points redeemed per year',
      },
      {
        name: 'Citi Entertainment\u00ae',
        description:
          "Get special access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for the year's most anticipated concerts, sporting events, dining experiences and more.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1500.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'points',
        description:
          'Earn 20,000 bonus points after spending $1,500 within the first 3 months of account opening, redeemable for $200 in gift cards or travel rewards at thankyou.com.',
      },
    ],
    cardType: 'personal',
    imageName: 'citi_rewards_credit_card.png',
  },
  [CreditCard.COSTCO_ANYWHERE_VISA_CARD_BY_CITI]: {
    id: CreditCard.COSTCO_ANYWHERE_VISA_CARD_BY_CITI,
    name: 'COSTCO ANYWHERE VISA\u00ae CARD BY CITI',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&prodType=CitiCardCostco&HKOP=c90edc5b2c56ecc2ec650223ade179c04d936eba35899fd28e7bbefe2c31a12c&ID=3000&ProspectID=PxJrtj3uTqGfParaTUIgmdbHcgoh09jY&intc=citihpmenu~creditcards~vac&pid=520&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-costco-anywhere-visa-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=c90edc5b2c56ecc2ec650223ade179c04d936eba35899fd28e7bbefe2c31a12c',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/pdp/costco_cobrand.svg',
    rewardsSummary:
      'Earn unlimited cash back rewards on purchases at Costco and other locations.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 7000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 7000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [
          'bakeries',
          'department store restaurants',
          'grocery or warehouse clubs',
          'timeshares',
          'campgrounds',
          'bed & breakfasts',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: ['train and commuter travel'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Costco Anywhere Visa\u00ae Card by Citi offers no annual fee with your active Costco membership.  Earn 5% cash back on gas at Costco and 4% on other eligible gas and EV charging, plus 3% on restaurants and travel, 2% on other Costco purchases, and 1% on all other purchases.',
    cardNetwork: 'Visa',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Damage & theft purchase protection',
        description:
          'Shop with more confidence \u2014 Damage & Theft Purchase Protection may cover you for repairs or a refund if purchases made with your Citi card are damaged or stolen within 120 days of purchase (90 days for New York residents).',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'No foreign transaction fees on purchases',
        benefit_type: 'noForeignTransactionFees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and emergency assistance',
        description: 'Travel and emergency assistance',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Worldwide car rental insurance',
        description: 'Worldwide car rental insurance',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel accident insurance',
        description: 'Travel accident insurance',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside assistance dispatch service',
        description: 'Roadside assistance dispatch service',
        benefit_type: 'roadsideAssistance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'costco_anywhere_visa_card_by_citi.svg',
  },
  [CreditCard.CITI__AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.CITI__AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD,
    name: 'Citi\u00ae / AAdvantage\u00ae Executive World Elite Mastercard\u00ae',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&prodType=CitiCardAA&HKOP=41fbaac39177403717c320e0684486de73c421f637068eaed18b36665afe9078&ID=3000&ProspectID=Pwzgen59dZvyYmKTVBu4gv4uetkaMUx2&intc=citihpmenu~creditcards~vac&pid=093&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-aadvantage-executive-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=41fbaac39177403717c320e0684486de73c421f637068eaed18b36665afe9078',
    bank_name: 'Citi',
    rewardsType: 'american',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/aa-exec/aa-exec_171x108.png',
    rewardsSummary:
      'Earn 4 American Airlines AAdvantage\u00ae miles for every $1 spent on eligible American Airlines purchases, 10 miles per $1 on eligible hotels and car rentals, and 1 mile per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.american',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'travel.hotel.general',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'travel.airline.general',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Citi\u00ae / AAdvantage\u00ae Executive World Elite Mastercard\u00ae is a premium travel rewards card that earns 4x miles on American Airlines purchases, 10x miles on eligible hotels and car rentals, and 1x miles on all other purchases. It also offers Admirals Club\u00ae membership, a free first checked bag on domestic American Airlines flights, and a Global Entry or TSA PreCheck\u00ae application fee credit every 4 years.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Admirals Club\u00ae Membership',
        description:
          'Includes access to nearly 100 Admirals Club\u00ae and partner lounges worldwide. Immediate family (spouse, domestic partner and/or children under 18) or up to 2 guests may join you. Up to $850 value.',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'First Checked Bag Free',
        description:
          'First checked bag free on domestic American Airline itineraries for you and up to 8 companions traveling with you on the same reservation.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'TSA PreCheck\u00ae or Global Entry Application Fee Credit',
        description:
          'Global Entry or TSA PreCheck\u00ae application fee credit every 4 years.',
        benefit_type: 'trusted_traveler_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% Savings on Inflight Food and Beverage',
        description:
          'Receive 25% savings on food and beverage purchases when you use your card on American Airlines flights.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Dedicated Concierge',
        description:
          'With Dedicated Concierge, you\u2019ll have access to a staff of experts for help with your foreign and domestic travel, shopping, dining, household, and entertainment needs.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Tap Your Card with Contactless Pay',
        description:
          'Shop securely with a contactless-chip enabled card. Just tap your card on the payment reader and go in seconds.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Digital Wallets',
        description:
          'Digital Wallets let you shop with confidence in millions of places online, within apps and in stores. With digital wallets you can speed through checkout and continue to enjoy all the great benefits that come with your card. Learn how to get started and how digital wallets can help protect your card information at citi.com/digitalservices.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Liability on Unauthorized Charges',
        description:
          "As a Citi cardmember, you're protected with $0 liability on unauthorized charges \u2013 which means you're not responsible for charges you didn't authorize. For additional information on this, please visit cardbenefits.citi.com for details.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Up to $120 in Lyft Credits',
        description:
          'After taking 3 eligible rides in a calendar month, you will earn a $10 Lyft credit, for a total of up to $120 Lyft credits annually.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Up to $120 Back on Eligible Grubhub purchases',
        description:
          'Earn a statement credit of up to $10 per monthly billing statement on eligible Grubhub purchases, for a total of up to $120 every 12 billing statements.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Up to $120 Back on Eligible Prepaid Avis\u00ae and Budget Car Rentals',
        description:
          'Earn up to $120 in statement credits every calendar year when eligible prepaid car rentals are booked directly on avis.com or budget.com.',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Citi Entertainment\u00ae',
        description:
          "Citi Entertainment takes the once out of once in a lifetime. Get special access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for the year's most anticipated concerts, sporting events, dining experiences and more. In addition, receive access to select exclusive event offers with your Citi\u00ae / AAdvantage\u00ae Executive Card.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 7000.0,
        spendRequirementMonths: 3,
        bonusValue: 70000,
        bonusValueUnit: 'miles',
        description:
          'Earn 70,000 bonus miles after making $7,000 in purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'citi__aadvantage_executive_world_elite_mastercard.png',
  },
  [CreditCard.CITI__AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.CITI__AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD,
    name: 'CITIu00ae/ AADVANTAGE BUSINESSu2122WORLD ELITE MASTERCARDu00ae',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&prodType=CitiCardAA&HKOP=80ab4ab9103f0d68df6c8dd8c590f26339b3682d7577ee01e0b3cdba0e326581&ID=3000&ProspectID=PooaRwhysRsm3F8FtiJ1DIgFznBSMuVT&intc=citihpmenu~creditcards~vac&pid=051&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citibusiness-aadvantage-platinum-select-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=80ab4ab9103f0d68df6c8dd8c590f26339b3682d7577ee01e0b3cdba0e326581',
    bank_name: 'Citi',
    rewardsType: 'american',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/pdp/citi-business-plat/citi-business-plat_171x108.png',
    rewardsSummary:
      'Earn 2 AAdvantageu00ae miles per $1 spent at telecommunications merchants, cable and satellite providers, car rental merchants, gas stations, and on eligible American Airlines purchases; earn 1 mile per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.american',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'telecommunications',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'cable and satellite',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'car rental',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'gas stations',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 65,000 bonus miles after spending $4,000 in purchases within the first 4 months.  Earn 2x miles on select business categories and 1x mile on all other purchases.  Enjoy benefits like a first checked bag free on American Airlines domestic itineraries and no foreign transaction fees.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '$0 intro annual fee, $99 after the first year',
        description: 'The annual fee is waived for the first 12 months.',
        benefit_type: 'statement_credit',
        value: 99.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'First checked bag free on American Airlines domestic itineraries',
        description:
          'First checked bag is free on domestic American Airlines itineraries for you and up to four companions traveling with you on the same reservation.',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'No foreign transaction fees on purchases.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Preferred boarding on American Airlines flights',
        description:
          'Save time and be more productive with early access to overheads bins.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% savings on American Airlines inflight food, beverage and Wi-Fi purchases',
        description:
          'Receive 25% savings on food and beverage purchases when you use your card on American Airlines flights.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 4,
        bonusValue: 65000,
        bonusValueUnit: 'miles',
        description:
          'Earn 65,000 American Airlines AAdvantageu00ae bonus miles after you spend $4,000 in purchases within the first 4 months of account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'citi__aadvantage_business_world_elite_mastercard.png',
  },
  [CreditCard.AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD]: {
    id: CreditCard.AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD,
    name: 'AMERICAN AIRLINES AADVANTAGE\u00ae MILEUP\u00ae CARD',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&prodType=CitiCardAA&HKOP=adadcad1dc2d998760dc63b12ae61ab2694d876bffefed62a2637b5ad064e8f0&ID=3000&ProspectID=PXMlpFZ1Gl9ky08AApBX5e4h3T1fFnhd&intc=citihpmenu~creditcards~vac&pid=410&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/aadvantage-mile-up-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=adadcad1dc2d998760dc63b12ae61ab2694d876bffefed62a2637b5ad064e8f0',
    bank_name: 'Citi',
    rewardsType: 'american',
    creditCardImageUrl:
      'https://www.citi.com/content/dam/citigroup/citi/us/credit-cards/aa-mileup-card/aa-mileup-card-front.jpg',
    rewardsSummary:
      'This card earns 2 miles per dollar spent on eligible American Airlines purchases and at grocery stores, and 1 mile per dollar on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.american',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
    ],
    creditScore: 'Good to Excellent',
    cardSummary:
      'The American Airlines AAdvantage\u00ae MileUp\u00ae Card is a great option for frequent American Airlines flyers. It earns 2 miles per dollar on eligible American Airlines purchases and at grocery stores, and 1 mile per dollar on all other purchases. It also comes with a $100 annual travel credit when you spend $250 or more on eligible travel purchases, priority boarding on American Airlines flights, and one free checked bag on American Airlines flights.',
    cardNetwork: 'Visa',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
    imageName: 'american_airlines_aadvantage_mileup_card.jpg',
  },
  [CreditCard.ATT_POINTS_PLUS_CARD_FROM_CITI]: {
    id: CreditCard.ATT_POINTS_PLUS_CARD_FROM_CITI,
    name: 'COSTCO ANYWHERE VISA\u00ae BUSINESS CARD BY CITI',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=561ff953124bfeecdbd5f8f65896ad16dfd9d2f21bf7df37e8ca04aa2c43d1bb&ID=3000&ProspectID=PEgAEkLfNaEwkOqSvnLnx6jWWgHhyCBr&intc=citihpmenu~creditcards~vac&pid=458&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-att-pointsplus-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=561ff953124bfeecdbd5f8f65896ad16dfd9d2f21bf7df37e8ca04aa2c43d1bb',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'data:image/png;base64,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"cardSummary": "The Costco Anywhere Visa\u00ae Business Card offers cash back rewards on gas, restaurants, and travel, with no annual fee for Costco members.  Additional benefits include purchase protection and no foreign transaction fees.',
    rewardsSummary:
      'Earn unlimited cash back rewards on purchases at Costco and other locations.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 7000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 7000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [
          'bakeries',
          'department store restaurants',
          'grocery or warehouse clubs',
          'timeshares',
          'campgrounds',
          'bed & breakfasts',
          'train and commuter travel',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [
          'bakeries',
          'department store restaurants',
          'grocery or warehouse clubs',
          'timeshares',
          'campgrounds',
          'bed & breakfasts',
          'train and commuter travel',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary: null,
    cardNetwork: 'Visa',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Damage & Theft Purchase Protection',
        description:
          'Shop with more confidence \u2014 Damage & Theft Purchase Protection may cover you for repairs or a refund if purchases made with your Citi card are damaged or stolen within 120 days of purchase (90 days for New York residents).',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Citi Quick Lock',
        description:
          'Instantly lock a misplaced or lost card with Citi Quick Lock in the app or online to block new charges and transactions right away.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Fraud Early Warning',
        description:
          'Our Fraud Early Warning feature monitors your account to help detect potentially fraudulent transactions. If we notice anything suspicious happening on your account, we\u2019ll contact you via text, email or phone call',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description: 'No foreign transaction fees',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lost Baggage Protection',
        description: 'Lost baggage protection',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Emergency Assistance',
        description: 'Travel and emergency assistance',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Worldwide Car Rental Insurance',
        description: 'Worldwide car rental insurance',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Accident Insurance',
        description: 'Travel accident insurance',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Roadside Assistance Dispatch Service',
        description: 'Roadside assistance dispatch service',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'business',
    imageName: 'att_points_plus_card_from_citi.',
  },
  [CreditCard.COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI]: {
    id: CreditCard.COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI,
    name: 'CITI\u00ae SECURED MASTERCARD\u00ae',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&prodType=CitiCardCostco&HKOP=8b524affd1f54ed9f3cb4fc1692efd958d66308e2d624c6acb332147554bb324&ID=3000&ProspectID=P2RsWiMJExKulL6p7RN0KoUkHyUScsI6&intc=citihpmenu~creditcards~vac&pid=522&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-costco-anywhere-visa-business-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=8b524affd1f54ed9f3cb4fc1692efd958d66308e2d624c6acb332147554bb324',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-secured-card/citi-secured-card_171x108.png',
    rewardsSummary:
      'This card offers no annual fee and helps you build credit history by making everyday purchases and paying your bill on time.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The Citi\u00ae Secured Mastercard\u00ae is a great option for building credit.  It has no annual fee and offers a credit limit equal to your security deposit (between $200-$2,500).  Enjoy benefits like $0 liability on unauthorized charges and free access to your FICO score.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '$0 Liability on unauthorized charges',
        description:
          "You're completely protected against unauthorized charges on your account. At Citi, you will not be responsible for a charge that you did not authorize, online or otherwise.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mastercard\u00ae ID Theft Protection\u2122',
        description: 'available for no additional charge',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free access to your FICO score online',
        description:
          'Tracking your score is a great first step to managing your credit history and taking control of your financial future.',
        benefit_type: 'credit_limit_increase',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'costco_anywhere_visa_business_card_by_citi.png',
  },
  [CreditCard.CITI_SECURED_MASTERCARD]: {
    id: CreditCard.CITI_SECURED_MASTERCARD,
    name: 'Shop Your Way Mastercard\u00ae',
    apply_link:
      'https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=70a4bf8bc81f2ca131be3703bfd497a70270198bb23eff1027d979a0036974ee&ID=3000&ProspectID=Pkh99GOa2HsB2VxPb1TOEj1AWEoJcg9D&intc=citihpmenu~creditcards~vac&pid=009&adobe_mc=MCMID%3D65566536188452835653763711564249531119%2CMCAID%3DNONE&category=view-all-credit-cards&afc=161',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-secured-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=70a4bf8bc81f2ca131be3703bfd497a70270198bb23eff1027d979a0036974ee',
    bank_name: 'Citi',
    rewardsType: 'citi_typ',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/shop-your-way/shop-your-way_171x108.png',
    rewardsSummary:
      'Earn points on everyday purchases and redeem them for gift cards or merchandise from Shop Your Way Merchants.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 10000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 10000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 10000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'Shop Your Way Merchants',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Shop Your Way Mastercard\u00ae earns points on everyday purchases, with bonus rates at gas stations, grocery stores, and restaurants.  Redeem points for gift cards or merchandise from Shop Your Way Merchants.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'statement_credit',
        description:
          'Earn a $75 statement credit for every $500 spent, up to $225, on eligible purchases in the first 90 days after you are approved for a new Shop Your Way Mastercard\u00ae.',
        benefit_type: 'statement_credit',
        value: 225.0,
        value_unit: 'dollars',
        spend_requirement: '500',
      },
      {
        name: 'price_protection',
        description: 'Price protection',
        benefit_type: 'price_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'extended_warranty',
        description: 'Extended warranty',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'identity_theft_protection',
        description: 'Identity theft protection',
        benefit_type: 'identity_theft_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1500.0,
        spendRequirementMonths: 3,
        bonusValue: 225.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn up to $225 in statement credits when you spend $1500 in the first 3 months after account opening. Valid for new accounts opened 10/1/24 \u2013 3/31/25.',
      },
    ],
    cardType: 'personal',
    imageName: 'citi_secured_mastercard.png',
  },
  [CreditCard.SHOP_YOUR_WAY_MASTERCARD]: {
    id: CreditCard.SHOP_YOUR_WAY_MASTERCARD,
    name: 'My Best Buy\u00ae Credit Cards',
    apply_link:
      'https://citiretailservices.citibankonline.com/apply/shop-your-way-credit-card?app=UNSOL&siteId=PLCN_SYW&sc=51007&bns_str=SYWMC&bns_prg=SYWMCW&off_cd=w&langId=EN&cmp=W~P~Z~B~8~D~ZZZ1~ZZ~SR~ZZ',
    learn_more_link:
      'https://www.citi.com/credit-cards/shop-your-way-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/shop-your-way-credit-card?app=UNSOL&siteId=PLCN_SYW&sc=51007#tnc',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-best-buy-dual/citi-best-buy-dual_171x108.png',
    rewardsSummary:
      'The My Best Buy\u00ae Credit Card earns 5% back in rewards on Best Buy purchases and up to 3% back on other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Best Buy',
        earnRate: 0.05,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 0.03,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 0.02,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 0.02,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The My Best Buy\u00ae Credit Card offers rewards or flexible financing options.  Earn 5% back on Best Buy purchases and up to 3% back on other purchases.  Enjoy free shipping on qualifying purchases.',
    cardNetwork: 'Visa',
    issuer: 'Citibank',
    selectableCategories: [],
    benefits: [
      {
        name: '10% back in rewards on first day of purchases',
        description:
          'Get 10% back in rewards on your first day of purchases at Best Buy\u00ae or choose flexible financing when you are approved for the Card.',
        benefit_type: 'statement_credit',
        value: 0.1,
        value_unit: 'rewards',
        spend_requirement:
          'First day of purchases within 14 days of account opening',
      },
      {
        name: '5% back in rewards on Best Buy purchases',
        description:
          'Choose rewards and get a $5 reward certificate for every $100 spent at Best Buy\u00ae with your Card or Choose financing and enjoy the flexibility of low monthly payments.',
        benefit_type: 'statement_credit',
        value: 0.05,
        value_unit: 'rewards',
        spend_requirement: '$100 spent at Best Buy\u00ae',
      },
      {
        name: '3% back in rewards on gas purchases',
        description: 'Earn 3% back in rewards on gas purchases.',
        benefit_type: 'statement_credit',
        value: 0.03,
        value_unit: 'rewards',
        spend_requirement: null,
      },
      {
        name: '2% back in rewards on grocery, dining and takeout purchases',
        description:
          'Earn 2% back in rewards on grocery, dining and takeout purchases.',
        benefit_type: 'statement_credit',
        value: 0.02,
        value_unit: 'rewards',
        spend_requirement: null,
      },
      {
        name: '1% back in rewards on other purchases',
        description: 'Earn 1% back in rewards on other purchases.',
        benefit_type: 'statement_credit',
        value: 0.01,
        value_unit: 'rewards',
        spend_requirement: null,
      },
      {
        name: 'Free shipping on qualifying purchases',
        description:
          'Enjoy free shipping on qualifying purchases at Best Buy\u00ae.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: 'Qualifying purchases at Best Buy\u00ae',
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'shop_your_way_mastercard.png',
  },
  [CreditCard.MY_BEST_BUY_CREDIT_CARDS]: {
    id: CreditCard.MY_BEST_BUY_CREDIT_CARDS,
    name: 'THE HOME DEPOT\u00ae CONSUMER CREDIT CARD',
    apply_link:
      'https://www.bestbuy.com/profile/bbycard-application/route-apply?&ref=186&loc=citi_app&cmp=A~E~Z~Z~Z~Z~ZZZ0~ZZ~BB~EB',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-best-buy-credit-cards?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/best-buy-credit-card?langId=EN&siteId=PLCN_BESTBUY&app=UNSOL&sc=BBYPL#tnc',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-home-depot-consumer/citi-home-depot-consumer_222x140.png',
    rewardsSummary:
      'The Home Depot\u00ae Consumer Credit Card offers cash back rewards on purchases made at Home Depot stores and online.',
    rewardsEarnRates: [
      {
        category: 'homeImprovement',
        earnRate: null,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Home Depot\u00ae Consumer Credit Card offers special financing for purchases of $299 or more. You may also get up to 24 months financing during special promotions. The Home Depot\u00ae Consumer Credit Card also gives you a full year for returns, four times longer than the standard return window, subject to The Home Depot\u00ae Returns Policy.',
    cardNetwork: null,
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Extended Return Window',
        description:
          'Cardmembers get 1 year to make returns, not just 3 months.',
        benefit_type: 'return_protection',
        value: 1,
        value_unit: 'year',
        spend_requirement: null,
      },
      {
        name: 'Flexible Payment Due Date',
        description:
          'Choose to pay your bill on any available due date in the beginning, middle or end of the month.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24/7 Customer Service',
        description:
          'Questions about your Citi\u00ae card account? Just call the number on the back of your credit card.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'my_best_buy_credit_cards.png',
  },
  [CreditCard.THE_HOME_DEPOT_CONSUMER_CREDIT_CARD]: {
    id: CreditCard.THE_HOME_DEPOT_CONSUMER_CREDIT_CARD,
    name: 'L.L.Bean\u00ae Mastercard\u00ae',
    apply_link:
      'https://citiretailservices.citibankonline.com/apply/home-depot-credit-card?app=UNSOL&siteId=PLCN_HOMEDEPOT&sc=30005&cmp=W~P~Z~B~7~D~ZZZ0~AI~HD~ZZ_1D3',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-home-depot-consumer-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/home-depot-credit-card?app=UNSOL&siteId=PLCN_HOMEDEPOT&sc=30005#tnc',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-llbean/citi-llbean_171x108.png',
    rewardsSummary:
      'Earn Bean Bucks\u00ae everywhere you shop: 4% at L.L.Bean, 2% at restaurants and gas stations, 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.transit',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.uber',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.rideshare.lyft',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.general',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.general',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.alaska',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.american',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.delta',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.frontier',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.hawaiian',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.jetblue',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.southwest',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.united',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.general',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.bestWestern',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.choiceHotels',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.hilton',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.hyatt',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.ihg',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.marriott',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.wyndham',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'L.L.Bean',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The L.L.Bean\u00ae Mastercard\u00ae offers a no annual fee and lets you earn Bean Bucks\u00ae on purchases at L.L.Bean and everywhere Mastercard is accepted.  Enjoy exclusive cardmember benefits like free shipping and free returns at L.L.Bean.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '20% off at L.L.Bean',
        description:
          'Get 20% off your first purchase at L.L.Bean upon approval.',
        benefit_type: 'statement_credit',
        value: 20.0,
        value_unit: '%',
        spend_requirement: null,
      },
      {
        name: 'Free Shipping at L.L.Bean',
        description: 'Enjoy free shipping on all purchases made at L.L.Bean.',
        benefit_type: 'return_shipping',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Return Shipping at L.L.Bean',
        description:
          'Enjoy free return shipping on all purchases made at L.L.Bean.',
        benefit_type: 'return_shipping',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Monogramming at L.L.Bean',
        description:
          'Get free monogramming on select items purchased at L.L.Bean.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'the_home_depot_consumer_credit_card.png',
  },
  [CreditCard.TSC_CREDIT_CARDS]: {
    id: CreditCard.TSC_CREDIT_CARDS,
    name: 'SHELL | FUEL REWARDS\u00ae Mastercard\u00ae',
    apply_link:
      'https://www.tractorsupply.com/webapp/wcs/stores/servlet/LogonForm?catalogId=10051&catalogId=10051&storeId=10151&langId=-1&krypto=KyplhJA%2BTQhvssixVEylVJ4YRQtO%2BXPYKkPio3PVhUjTD1EXB3pNU3oU4OQOaWikOo5yRjydCCBQNvRsHtddwF3FpnJqwPGEt8w%2Bhl9X%2FG62M9la7wuiz4',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-tractor-supply-credit-cards?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/tractor-supply-credit-card?app=UNSOL&siteId=PLCN_TRACTORSUPPLY&sc=03201#tnc',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/shell-fuel-rewards-master/shell-fuel-rewards-master_171x108.png',
    rewardsSummary:
      'Earn 10\u00a2/gal on fuel purchases at Shell, 10% back on Shell non-fuel purchases up to $1,200, 2% back on dining and groceries up to $10,000, and 1% back on other purchases, all per year.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 0.1,
        excludeMerchants: [],
        spendCap: 35.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 0.02,
        excludeMerchants: [],
        spendCap: 10000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 0.02,
        excludeMerchants: [],
        spendCap: 10000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Shell non-fuel purchases',
        earnRate: 0.1,
        excludeMerchants: [],
        spendCap: 1200.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Shell | Fuel Rewards\u00ae Mastercard\u00ae offers fuel savings of 10\u00a2/gal at Shell, plus rewards on dining, groceries, and other purchases.  Enjoy 10% back on Shell non-fuel purchases up to $1,200, 2% back on dining and groceries up to $10,000, and 1% back on other purchases, all annually.',
    cardNetwork: 'Mastercard',
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: 'Fuel Rewards\u00ae Gold Status',
        description:
          'Offers Fuel Rewards\u00ae savings of 5 cents per gallon, up to 35 gallons, on fuel purchases made at participating Shell locations within the United States.',
        benefit_type: 'statement_credit',
        value: 0.05,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'Save 50\u00a2/gal (up to 35 gallons) on your first 5 Shell fuel purchases made by 6/30/25. New accounts only. Apply by 4/30/25.',
      },
    ],
    cardType: 'personal',
    imageName: 'tsc_credit_cards.png',
  },
  [CreditCard.LL_BEAN_MASTERCARD]: {
    id: CreditCard.LL_BEAN_MASTERCARD,
    name: 'EXXON MOBIL SMART CARD+\u2122 CREDIT CARD',
    apply_link:
      'https://www.llbean.com/llb/shop/514535?nav=gn-514535&cmp=W~P~Z~B~3~E~ZZZ0~CL~LL~ZZ',
    learn_more_link:
      'https://www.citi.com/credit-cards/citi-llbean-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/ll-bean-credit-card?app=UNSOL&siteId=PLCN_LLBEAN&sc=07603#tnc',
    bank_name: 'Citi',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.citi.com/CRD/images/citi-exxon-mobil/citi-exxon-mobil_171x108.png',
    rewardsSummary:
      'Earn 40\u00a2/gal or more for one month after account opening, save 10\u00a2/gal on regular fuel and 12\u00a2/gal on premium, and get 5% back on convenience store purchases and car washes (up to $1,200 annually).',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 0.4,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 0.1,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 0.12,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 0.05,
        excludeMerchants: [],
        spendCap: 1200.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Exxon Mobil Smart Card+\u2122 credit card offers everyday instant savings at the pump and at the convenience store.  Save up to 12\u00a2/gal on fuel and get 5% back on convenience store purchases and car washes (up to $1,200 annually). There is no annual fee.',
    cardNetwork: null,
    issuer: 'Citi',
    selectableCategories: [],
    benefits: [
      {
        name: '$0 Fraud Liability',
        description: '$0 liability on unauthorized charges',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'll_bean_mastercard.png',
  },
  [CreditCard.SHELL__FUEL_REWARDS_CREDIT_CARDS]: {
    id: CreditCard.SHELL__FUEL_REWARDS_CREDIT_CARDS,
    name: 'Shell | Fuel Rewardsu00ae Credit Cards',
    apply_link:
      'https://citiretailservices.citibankonline.com/apply/shell-credit-card?app=UNSOL&siteId=PLOC_SHELL&plsrc=FR07&cmp=W~P~Z~B~7~D~ZZZ0~AI~SH~ZZ&sc=06276',
    learn_more_link:
      'https://www.citi.com/credit-cards/shell-fuel-rewards-credit-cards?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/shell-credit-card?app=UNSOL&siteId=PLOC_SHELL&plsrc=FS03&sc=06276#tnc',
    bank_name: 'Citi',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.EXXON_MOBIL_SMART_CARD_CREDIT_CARD]: {
    id: CreditCard.EXXON_MOBIL_SMART_CARD_CREDIT_CARD,
    name: 'Exxon Mobil Smart Card+u2122 Credit Card',
    apply_link:
      'https://citiretailservices.citibankonline.com/apply/exxon-mobil-credit-card?app=UNSOL&langId=EN&siteId=PLOC_EXXONMOBIL&sc=06001&plsrc=EM04&cmp=W~8~M~I~Z~E~RZZZ~AI~EX~ZZ',
    learn_more_link:
      'https://www.citi.com/credit-cards/exxon-mobil-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161',
    terms_and_conditions_button_text: 'Important Pricing & Information+',
    terms_and_conditions_link:
      'https://citiretailservices.citibankonline.com/apply/exxon-mobil-credit-card?app=UNSOL&siteId=PLOC_EXXONMOBIL&sc=06001#tnc',
    bank_name: 'Citi',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.US_BANK_SMARTLY_VISA_SIGNATURE_CARD]: {
    id: CreditCard.US_BANK_SMARTLY_VISA_SIGNATURE_CARD,
    name: 'U.S. Bank Smartly\u2122 Visa Signature\u00ae Card',
    apply_link:
      'https://onboarding.usbank.com/consumer/cards/RGW2234MP4/8069/87193/start',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/bank-smartly-visa-signature-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=RGW2234MP4&sourceCode=87193',
    bank_name: 'US Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-bank-smartly-card-art.png',
    rewardsSummary:
      'Earn unlimited 2% cash back on every purchase, plus an additional bonus based on your U.S. Bank Smartly Savings account balance.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 2.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 5000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 50000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: 100000.0,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The U.S. Bank Smartly Visa Signature Card offers unlimited 2% cash back on all purchases, with the potential to earn up to 4% cash back when paired with a U.S. Bank Smartly Savings account.  There is a $0 annual fee and a 0% intro APR on purchases and balance transfers for the first 12 billing cycles.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'us_bank_smartly_visa_signature_card.png',
  },
  [CreditCard.US_BANK_CASH_VISA_SIGNATURE_CARD]: {
    id: CreditCard.US_BANK_CASH_VISA_SIGNATURE_CARD,
    name: 'U.S. Bank Cash+\u00ae Visa Signature\u00ae Card',
    apply_link:
      'https://onboarding.usbank.com/consumer/cards/WRH8D23H2R/8069/86937/start',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/cash-plus-visa-signature-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=WRH8D23H2R&sourceCode=86937',
    bank_name: 'US Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-cash-plus-signature-lg.png',
    rewardsSummary:
      'Earn up to 5% cash back on two categories you choose each quarter, 2% on one everyday category, and 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'prepaid travel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'online shopping',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'two categories you choose',
        earnRate: 5.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: 2000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'one everyday category you choose',
        earnRate: 2.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The U.S. Bank Cash+ Visa Signature Card offers up to 5% cash back on two selectable categories, 2% on one everyday category, and 1% on all other purchases, plus a $200 bonus after spending $1,000 in the first 90 days.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank',
    selectableCategories: [
      'gas',
      'dining',
      'drugstore',
      'grocery',
      'fitness',
      'streaming',
      'wholesaleClub',
      'internetCablePhone',
      'homeImprovement',
      'officeSupplies',
      'electronics',
      'charity',
      'takeoutDelivery',
      'travel',
    ],
    benefits: [
      {
        name: '$200 bonus',
        description:
          'Earn a $200 bonus after you spend $1,000 in eligible purchases within the first 90 days of account opening.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: '$1,000',
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$1,000',
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $200 bonus after you spend $1,000 in eligible purchases within the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'us_bank_cash_visa_signature_card.png',
  },
  [CreditCard.US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD]: {
    id: CreditCard.US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD,
    name: 'U.S. Bank Altitudeu00ae Go Visa Signatureu00ae Card',
    apply_link:
      'https://onboarding.usbank.com/consumer/cards/HQWRM3D57Q/18569/33720/start',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/altitude-go-visa-signature-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=18569&offerId=HQWRM3D57Q&sourceCode=33720',
    bank_name: 'US Bank',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-altitude-go-signature-credit-card.png',
    rewardsSummary:
      'The Altitude Go card earns 4X points on dining, 2X points on groceries, gas, and streaming, and 1X point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 2000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [
          'wholesale clubs',
          'discount stores/supercenters',
          'grocery stores/supermarkets',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'streaming',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: 'good to excellent',
    cardSummary:
      'The U.S. Bank Altitude Go Visa Signature Card offers a $0 annual fee, 20,000 bonus points after spending $1,000 in the first 90 days, and bonus points on dining, groceries, gas, and streaming services.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank National Association',
    selectableCategories: [],
    benefits: [
      {
        name: 'No annual fee',
        description:
          'Enjoy no annual fee and get 0% intro APR on purchases and balance transfers for the first 15 billing cycles.',
        benefit_type: 'statement_credit',
        value: 0.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Redemption choices',
        description:
          'Redeem points toward a deposit to an eligible U.S. Bank account, merchandise, gift cards, travel and more. Plus, redeem for charity and get 100% match.',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'ExtendPay Plan',
        description:
          'Receive a new cardmember $0 fee offer on ExtendPay Plans opened in the first 60 days after account opening.',
        benefit_type: 'statement_credit',
        value: 0.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Streaming bonus',
        description:
          'Get a $15 credit for annual streaming service purchases like Netflix, Apple TV+, Spotifyu00ae and more.',
        benefit_type: 'statement_credit',
        value: 15.0,
        value_unit: 'dollars',
        spend_requirement:
          '11 consecutive calendar months of eligible streaming service purchases',
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'points',
        description:
          'Earn 20,000 bonus points if you are approved for a new U.S. Bank Altitude Go Visa Signature Card and make $1,000 or more in total eligible Net Purchases to your Account within 90 days of Account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'us_bank_altitude_go_visa_signature_card.png',
  },
  [CreditCard.US_BANK_VISA_PLATINUM_CARD]: {
    id: CreditCard.US_BANK_VISA_PLATINUM_CARD,
    name: 'U.S. Bank Visa\u00ae Platinum Credit Card',
    apply_link:
      'https://onboarding.usbank.com/consumer/cards/2QB2G9RX69/8069/86784/start',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/visa-platinum-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=2QB2G9RX69&sourceCode=86784',
    bank_name: 'US Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-visa-platinum-credit-card.png',
    rewardsSummary:
      'This card offers a 0% intro APR for 21 billing cycles on purchases and balance transfers, and no annual fee.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The U.S. Bank Visa Platinum Credit Card offers a 0% intro APR for 21 billing cycles on purchases and balance transfers, no annual fee, and benefits like auto pay, cell phone protection, and free credit score access.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank National Association',
    selectableCategories: [],
    benefits: [
      {
        name: 'Auto pay & due date choice',
        description:
          'Avoid interest and late fees with automatic payments that put you in control. Pick a payment due date that works for your schedule.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell phone protection',
        description:
          'Get up to $600 reimbursement if your cell phone is stolen or damaged when you pay your monthly cell phone with your card.',
        benefit_type: 'cell_phone_protection',
        value: 600,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'us_bank_visa_platinum_card.png',
  },
  [CreditCard.US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD]: {
    id: CreditCard.US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD,
    name: 'U.S. Bank Altitudeu00ae Connect Visa Signatureu00ae Card',
    apply_link:
      'https://onboarding.usbank.com/consumer/cards/8BB5BD89H1/18569/87106/start',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/altitude-connect-visa-signature-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=18569&offerId=8BB5BD89H1&sourceCode=87106',
    bank_name: 'US Bank',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-altitude-connect-consumer.png',
    rewardsSummary:
      'Earn 5X points on prepaid hotels and car rentals, 4X points on travel and gas, 2X points on dining and groceries, and 1X point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'travel.carRental',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'travel.general',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'gas',
        earnRate: 4.0,
        excludeMerchants: [
          'discount stores/supercenters',
          'wholesale clubs',
          'grocery stores/supermarkets',
        ],
        spendCap: 1000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'streaming',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: ['wholesale clubs', 'discount stores/supercenters'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: 'good to excellent',
    cardSummary:
      'The U.S. Bank Altitude Connect Visa Signature Card offers no annual fee, earns bonus points on various spending categories, and includes travel benefits like airport lounge access and TSA PreChecku00ae or Global Entryu00ae credits.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank',
    selectableCategories: [],
    benefits: [
      {
        name: '0% intro APR',
        description:
          'Get 0% intro APR on purchases and balance transfers for the first 15 billing cycles. After that, a variable APR applies.',
        benefit_type: 'apr',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description:
          'Enjoy no foreign transaction fees when making purchases outside the United States.',
        benefit_type: 'noForeignTransactionFees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Airport lounge access',
        description:
          'Complimentary Priority Passu2122 Select Membership gives you 4 free visits to over 1,600 airport VIP lounges and experiences worldwide.',
        benefit_type: 'lounge_access',
        value: 4,
        value_unit: 'visits',
        spend_requirement: null,
      },
      {
        name: 'TSA PreChecku00ae or Global Entryu00ae',
        description:
          'Enjoy up to $100 in statement credits toward your application fee once every four years.',
        benefit_type: 'trusted_traveler_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'U.S. Bank ExtendPayu00ae Plan',
        description:
          'Receive a new cardmember $0 fee offer on ExtendPay Plans opened in the first 60 days after account opening.',
        benefit_type: 'paymentPlan',
        value: 0.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Global Connectivity',
        description:
          'Stay connected in over 125 countries with complimentary GigSky global mobile data plans.',
        benefit_type: 'globalMobileData',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel protections',
        description:
          'Protection and assistance when traveling with Trip Cancelation/Interruption, Trip Delay Reimbursement and SmartDelay.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa Signature benefits',
        description: 'Special access to unforgettable experiences.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 20000,
        bonusValueUnit: 'points',
        description:
          'Earn 20,000 bonus points if you are approved for a new U.S. Bank Altitude Connect Visa Signature Card and make $1,000 or more in total eligible Net Purchases to your Account within 90 days of Account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'us_bank_altitude_connect_visa_signature_card.png',
  },
  [CreditCard.US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD]: {
    id: CreditCard.US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD,
    name: 'U.S. Bank Shopper Cash Rewards\u00ae Visa Signature\u00ae Card',
    apply_link:
      'https://onboarding.usbank.com/consumer/cards/32VH7G6DBG/8069/43683/start',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/shopper-cash-rewards-visa-signature-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=32VH7G6DBG&sourceCode=43683',
    bank_name: 'US Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-shopper-cash-rewards--no-glow-2x3.png',
    rewardsSummary:
      'Earn up to 6% cash back at select retailers, 3% on one chosen category, and 1.5% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel',
        earnRate: 5.5,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'wholesaleClub',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'bills and utilities',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Ace Hardware',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Apple',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Amazon.com',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Anthropologie',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Bed, Bath, & Beyond',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Best Buy',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Chewy.com',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Crate and Barrel',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Disney',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Home Depot',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Ikea',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: "Kohl's",
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: "Lowe's",
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Lululemon',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: "Macy's",
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Menards',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Nordstrom',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Pottery Barn',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'QVC',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Restoration Hardware',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Target',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Walmart',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Wayfair.com',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Williams Sonoma',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: 1500.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'good to excellent',
    cardSummary:
      'The U.S. Bank Shopper Cash Rewards Visa Signature Card offers a $250 bonus after spending $2,000 in 120 days, plus customizable cash back rates of up to 6% at select retailers, 3% on one everyday category, and 1.5% on all other purchases.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank National Association',
    selectableCategories: ['gas', 'wholesaleClub', 'bills and utilities'],
    benefits: [
      {
        name: 'Bonus Cash Rewards',
        description:
          'Earn a $250 bonus after you spend $2,000 in eligible purchases within the first 120 days of account opening.',
        benefit_type: 'statement_credit',
        value: 250.0,
        value_unit: 'dollars',
        spend_requirement: '$2,000',
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$2,000',
        spendRequirementMonths: 3,
        bonusValue: 250.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $250 bonus after you spend $2,000 in eligible purchases within the first 3 months of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'us_bank_shopper_cash_rewards_visa_signature_card.png',
  },
  [CreditCard.US_BANK_ALTITUDE_GO_SECURED_VISA_CARD]: {
    id: CreditCard.US_BANK_ALTITUDE_GO_SECURED_VISA_CARD,
    name: 'U.S. Bank Altitude Go\u00ae Secured Visa\u00ae Signature Card',
    apply_link:
      'https://applications.usbank.com/pdap/begin?locationCode=18569&offerId=P3934BH7MQ&sourceCode=42955',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/altitude-go-secured-visa-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/pdap/terms?locationCode=18569&offerId=P3934BH7MQ&sourceCode=42955',
    bank_name: 'US Bank',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-cc-go-secured-2x3.png',
    rewardsSummary:
      'Earn up to 4X points on dining, takeout and delivery, 2X points at gas stations and EV charging stations, and 2X points on streaming services and at grocery stores.',
    rewardsEarnRates: [
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: 2000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [
          'wholesale clubs',
          'discount stores/supercenters',
          'grocery stores/supermarkets',
        ],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'streaming',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Open the door to better credit and get rewarded for your everyday spending. Start with a security deposit of $300 to $5,000 and enjoy a $0 annual fee. Earn up to 4X points on dining, takeout and restaurant delivery, 2X points at gas stations and EV charging stations, and 2X points on streaming services and at grocery stores.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'streaming service credit',
        description:
          'An automatic statement credit of $15 per 12-month period will be applied to your U.S. Bank Altitude\u00ae Go Secured Visa\u00ae Card Account within 2 statement billing cycles following 11 consecutive calendar months of eligible streaming service purchases, such as Netflix, Hulu, Apple Music, if the Account is in good standing (not past due or overlimit).',
        benefit_type: 'statement_credit',
        value: 15.0,
        value_unit: 'dollars',
        spend_requirement:
          '11 consecutive calendar months of eligible streaming service purchases',
      },
      {
        name: 'Choose your payment due date',
        description:
          'Everyone\u2019s schedule is different. So it\u2019s handy to be able to pick when your payment is due.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero fraud liability',
        description:
          'You are not responsible for unauthorized transactions if your card is ever lost or stolen.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless payments',
        description:
          'Pay with a tap. Your contactless card makes payments with a simple, single tap. Just look for the Contactless Symbol when checking out.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mobile Wallet',
        description:
          'Add the Altitude Go Secured Visa card to your Mobile Wallet. Convenient and secure, you can pay with just a tap.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Autopay',
        description:
          'Pay on time and avoid late fees by selecting an automatic payment option that best suits your budget.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'us_bank_altitude_go_secured_visa_card.png',
  },
  [CreditCard.US_BANK_CASH_SECURED_VISA_CARD]: {
    id: CreditCard.US_BANK_CASH_SECURED_VISA_CARD,
    name: 'U.S. Bank Cash+\u00ae Secured Visa\u00ae Card',
    apply_link:
      'https://onboarding.usbank.com/usl/consumer/secured-card/application?offerId=27PPH4GHG8&locationCode=8069&sourceCode=42962',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/cash-plus-secured-visa-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/pdap/terms?locationCode=8069&offerId=27PPH4GHG8&sourceCode=42962',
    bank_name: 'US Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.usbank.com/dam/en/images/photos/credit-cards/photo-cash-plus-secured-lg.png',
    rewardsSummary:
      'Earn unlimited cash back on purchases with a $0 annual fee and a security deposit of $300 to $5,000.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: ['discount stores/supercenters', 'wholesale clubs'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.travelPortal',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 2000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'rotating_quarterly_rewards',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 2000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Build credit and earn unlimited cash back.  Choose two 5% cash back categories each quarter, plus 2% on one everyday category and 1% on all other purchases.  Enjoy benefits like zero fraud liability and contactless payments.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank',
    selectableCategories: [
      'gas',
      'grocery',
      'dining',
      'travel.travelPortal',
      'fast food',
      'home utilities',
      'TV, internet and streaming',
      'department stores',
      'cell phone providers',
      'electronic stores',
      'sporting goods stores',
      'movie theaters',
      'gyms/fitness centers',
      'furniture stores',
      'ground transportation',
      'select clothing stores',
    ],
    benefits: [
      {
        name: 'Zero Fraud Liability',
        description:
          'You are not responsible for unauthorized transactions if your card is ever lost or stolen.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Payments',
        description:
          'Pay with a tap. Your contactless card makes payments with a simple, single tap. Just look for the Contactless Symbol when checking out.',
        benefit_type: 'contactless',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Autopay',
        description:
          'Pay on time and avoid late fees by selecting an automatic payment option that best suits your budget.',
        benefit_type: 'autopay',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose Your Payment Due Date',
        description:
          'Everyone\u2019s schedule is different. So it\u2019s handy to be able to pick when your payment is due.',
        benefit_type: 'payment_due_date',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mobile Wallet',
        description:
          'Add the Cash+ Secured Visa card to your Mobile Wallet. Convenient and secure, you can pay with just a tap.',
        benefit_type: 'mobile_wallet',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'us_bank_cash_secured_visa_card.png',
  },
  [CreditCard.US_BANK_SECURED_VISA_CARD]: {
    id: CreditCard.US_BANK_SECURED_VISA_CARD,
    name: 'U.S. Bank Secured Visa\u00ae Card',
    apply_link:
      'https://applications.usbank.com/oad/begin?locationCode=8069&sourceCode=37913&offerId=7961492XPV',
    learn_more_link:
      'https://www.usbank.com/content/usbank/us/en/credit-cards/secured-visa-credit-card',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link:
      'https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=7961492XPV&sourceCode=37913',
    bank_name: 'US Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.usbank.com/dam/images/rps/large/ClassicSecured_Visa_vertical_209x333.png',
    rewardsSummary: 'This card offers no annual fee and helps build credit.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The U.S. Bank Secured Visa Card is a credit-building card with no annual fee.  It helps build credit history by reporting purchases to credit bureaus. Start with a security deposit of $300 to $5,000.',
    cardNetwork: 'Visa',
    issuer: 'U.S. Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Your credit score',
        description:
          'View your credit score anytime, anywhere in the mobile app or online banking.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose your payment due date',
        description:
          "Everyone's schedule is different. So it's handy to be able to pick when your payment is due.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero fraud liability',
        description:
          'You are not responsible for unauthorized transactions if your card is ever lost or stolen',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless payments',
        description:
          'Pay with a tap. Your contactless card makes payments with a simple, single tap. Just look for the Contactless Symbol when checking out.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mobile Wallet',
        description:
          'Add the Secured Visa card to your Mobile Wallet. Convenient and secure, you can pay with just a tap.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Autopay',
        description:
          'Pay on time and avoid late fees by selecting an automatic payment option that best suits your budget.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'us_bank_secured_visa_card.png',
  },
  [CreditCard.EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD,
    name: 'Emirates Skywards Premium World Elite Mastercard',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/emirates-skywards-premium-world-elite-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/emirates-skywards-premium-world-elite-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'avios',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/EKE_card_rRGB_Premium_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 3 Skywards Miles on eligible Emirates purchases, 2 miles on eligible travel, and 1 mile on all other purchases, plus a 10,000-mile anniversary bonus.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Emirates Skywards Premium World Elite Mastercard offers Emirates Skywards Gold tier membership for the first year, 70,000 bonus Skywards Miles after spending $3,000 in the first 90 days, and earns 3x miles on Emirates purchases, 2x on travel, and 1x on all other purchases.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Emirates Skywards Gold tier membership',
        description:
          'Enjoy Emirates Skywards Gold tier membership during your first year, and retain your tier status by spending $40,000 each cardmembership year.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: '$40,000',
      },
      {
        name: 'Global Entry or TSA PreCheck application fee credit',
        description:
          'Receive an automatic statement credit for the cost of one Global Entry or TSA PreCheck application fee every five years \u2013 up to $120.',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'No foreign transaction fees on international purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% savings when you Buy or Gift Miles',
        description:
          'Receive a 25% savings when you Buy Skywards Miles for yourself or Gift Miles.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Priority Pass Select lounge access',
        description:
          'Provides unlimited access to over 1,200 lounges worldwide for the primary cardmember and their guest(s).',
        benefit_type: 'lounge_access',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          "You're not responsible for charges you did not authorize.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary online access to your FICO\u00ae Credit Score',
        description:
          'Lets you keep an eye on your credit score and get alerts when we learn that your score has changed.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$3,000',
        spendRequirementMonths: 3,
        bonusValue: 70000,
        bonusValueUnit: 'miles',
        description:
          'Earn 70,000 bonus Skywards Miles after spending $3,000 on purchases in the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'emirates_skywards_premium_world_elite_mastercard.png',
  },
  [CreditCard.BREEZE_EASYVISA_CREDIT_CARD]: {
    id: CreditCard.BREEZE_EASYVISA_CREDIT_CARD,
    name: 'Breeze Easy\u2122 Visa\u00ae Credit Card',
    apply_link: 'https://cards.barclaycardus.com/banking/cards/breeze-airways/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/breeze-airways/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'breezepoints',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BRZ_CD_card_Windows_VS_Angle_359x246_L.png',
    rewardsSummary:
      'Earn up to 10X BreezePoints on Nicer Bundles, Nicest Bundles and Trip Add-Ons, up to 4X on Nice Bundles, and 2X on No Flex Fares, plus additional earning on eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'Nicer Bundles, Nicest Bundles, and Trip Add-Ons',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'breezepoints',
      },
      {
        category: 'Nice Bundles',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'breezepoints',
      },
      {
        category: 'No Flex Fares',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'breezepoints',
      },
      {
        category:
          'eligible grocery store & restaurants including Breeze Airways inflight food and beverages',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'breezepoints',
      },
      {
        category: 'all other purchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'breezepoints',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Breeze Easy\u2122 Visa\u00ae Credit Card offers a welcome bonus of 40,000 BreezePoints after spending $1,000 in the first 90 days, plus earn rates up to 10X on Breeze Airways purchases and 2X on eligible grocery and restaurant purchases.  It also includes benefits like priority boarding and complimentary WiFi on Breeze Airways flights.',
    cardNetwork: 'Visa',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Priority Boarding',
        description:
          'Primary cardmembers and their companions receive Group 1 priority boarding when traveling on flights operated by Breeze Airways.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Unlimited Points Earning',
        description:
          'There\u2019s no limit to the total BreezePoints you can earn using your Breeze Easy Visa.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redemption',
        description:
          'Redeeming BreezePoints is easy. You can redeem BreezePoints for fares, taxes, fees, and trip add-ons such as seats, bags, and adding pets on Breeze flights. You can even book for someone else.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary WiFi',
        description:
          'With Complimentary Inflight WiFi, you can surf, stream and stay connected while you enjoy your flight on Breeze Airways.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'BreezePoints Never Expire',
        description:
          "As a cardmemeber, your BreezePoints never expire. They're yours to earn and yours to burn for as long as you want.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Full Points Flexibility',
        description: 'Use BreezePoints how you want, whenever you want.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus',
        description:
          'Earn 7,500 Anniversary Bonus BreezePoints after every account anniversary with eligible purchases.',
        benefit_type: 'anniversary_bonus',
        value: 7500,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'One-Way Bundle Upgrade',
        description: 'One-Way Bundle Upgrade with every $15,000 in purchases.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: 15000,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000,
        spendRequirementMonths: 3,
        bonusValue: 40000,
        bonusValueUnit: 'points',
        description:
          "Earn 40,000 Bonus BreezePoints, that's a $400 value, after spending $1,000 on purchases within the first 90 days.",
      },
    ],
    cardType: 'personal',
    imageName: 'breeze_easyvisa_credit_card.png',
  },
  [CreditCard.XBOX_MASTERCARD]: {
    id: CreditCard.XBOX_MASTERCARD,
    name: 'Xbox Mastercard',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/xbox-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/xbox-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/XBO_card_Xbox_MC_Angle_359x246.png',
    rewardsSummary:
      'Earn 5X points on eligible Microsoft Store purchases, 3X on eligible streaming and dining delivery services, and 1X on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'Microsoft Store',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'Streaming services',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'Dining delivery services',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Xbox Mastercard offers 5X points on eligible Microsoft Store purchases, 3X points on eligible streaming and dining delivery services, and 1X point on all other purchases.  It also includes a welcome bonus of 5,000 bonus points after your first purchase and no annual fee.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Personalized Card Design',
        description:
          'Choose from one of five iconic card designs and personalize with your gamertag.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Game Pass Ultimate',
        description:
          'Earn 3 months of Game Pass Ultimate for new Game Pass members after making your first purchase.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Game Pass Ultimate (Additional)',
        description:
          'Earn two 3-month Game Pass Ultimate codes when you spend $7,000 or more within your first 12 months of opening your account.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: 7000.0,
      },
      {
        name: 'Redeem Points',
        description:
          'Redeem your card points on eligible purchases at xbox.com, Microsoft.com, on console, and in-game (applied as a credit on your billing statement).',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Spotify Premium',
        description:
          'Get 3 months of Spotify Premium Individual after your first purchase with your Xbox Mastercard.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Annual Fee',
        description: 'Enjoy all of the card benefits for $0 annual fee.',
        benefit_type: null,
        value: 0.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Digital Wallet Access',
        description:
          'Enjoy the flexibility of digital wallets such as Apple Pay and Google Pay.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'FICO Score Access',
        description:
          'Online access to your FICO Credit Score lets you keep an eye on your credit score and get alerts when we learn that your score has changed.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability',
        description:
          "You're not responsible for the charges you did not authorize.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: 180,
        bonusValue: 5000,
        bonusValueUnit: 'points',
        description:
          "Earn 5,000 bonus card points after making your first purchase within the first 180 days of account opening. That's a $50 value.",
      },
    ],
    cardType: 'personal',
    imageName: 'xbox_mastercard.png',
  },
  [CreditCard.JETBLUE_PLUS_CARD]: {
    id: CreditCard.JETBLUE_PLUS_CARD,
    name: 'JetBlue Plus Card',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/jetblue-plus-card/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/jetblue-plus-card/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'jetblue',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/JBE_card_Plus_WE_Angle_359x246_L.png',
    rewardsSummary:
      'The JetBlue Plus Card earns 6x points on JetBlue purchases, 2x points at restaurants and eligible grocery stores, and 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.jetblue',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
    ],
    creditScore: null,
    cardSummary:
      'The JetBlue Plus Card offers a welcome bonus of 50,000 bonus points after spending $1,000 in the first 90 days and paying the annual fee.  It earns bonus points on JetBlue purchases, dining, and groceries, plus a free first checked bag and other travel benefits.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free first checked bag',
        description:
          'Free first checked bag for you and up to 3 eligible travel companions on JetBlue-operated flights',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% savings on inflight purchases',
        description:
          '50% savings on eligible inflight purchases on JetBlue-operated flights',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '10% points back on award flights',
        description:
          'Get 10% of your points back after you redeem for and travel on a JetBlue-operated Award Flight',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$100 statement credit',
        description:
          'Receive a $100 statement credit after you purchase a JetBlue Vacations package of $100 or more with your JetBlue Plus Card. Limit one statement credit per year',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: '$',
        spend_requirement: 'JetBlue Vacations package of $100 or more',
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          'Means you\u2019re not responsible for unauthorized charges',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Points Payback',
        description:
          'Points Payback allows you to redeem points for a statement credit, up to $1,000 annually',
        benefit_type: 'statement_credit',
        value: 1000.0,
        value_unit: '$',
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '5,000 points bonus',
        description:
          'each year after your JetBlue Plus Card account anniversary',
        benefit_type: 'anniversary_bonus',
        value: 5000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000.0,
        bonusValueUnit: 'points',
        description:
          'Earn 50,000 bonus points after spending $1,000 on purchases and paying the annual fee in full, both within the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'jetblue_plus_card.png',
  },
  [CreditCard.ATHLETA_REWARDS_MASTERCARD]: {
    id: CreditCard.ATHLETA_REWARDS_MASTERCARD,
    name: 'Athleta Rewards Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/athleta-rewards-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/athleta-rewards-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/AT_card_NEW_Enth_MC_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 5 points for every $1 spent at Gap, Banana Republic, Old Navy, and Athleta, and 1 point for every $1 spent on other Mastercard purchases; 100 points = $1 reward.',
    rewardsEarnRates: [
      {
        category: 'Gap Inc. family of brands',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Gap', 'Banana Republic', 'Old Navy', 'Athleta'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Athleta Rewards Mastercard offers a $0 annual fee and lets you earn 5 points per dollar spent at Gap Inc. brands and 1 point per dollar elsewhere.  Redeem 100 points for a $1 reward and enjoy free fast shipping on online orders of $50 or more.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: '20% off first purchase',
        description:
          'Receive 20% off your first purchase with your new credit card at the Gap Inc. family of brands',
        benefit_type: 'statement_credit',
        value: 0.2,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free fast shipping',
        description: 'Free fast shipping on all online orders $50 or more',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: 50.0,
      },
      {
        name: 'Early access to select sales',
        description: 'Early access to select sales',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Members only exclusive offers',
        description: 'Members only exclusive offers',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability Protection',
        description:
          '$0 Fraud Liability Protection on purchases you did not authorize',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Donate your rewards to a good cause',
        description: 'Donate your rewards to a good cause',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'Receive 20% off your first purchase with your new credit card at the Gap Inc. family of brands',
      },
    ],
    cardType: 'personal',
    imageName: 'athleta_rewards_mastercard.png',
  },
  [CreditCard.NAVYIST_REWARDS_MASTERCARD]: {
    id: CreditCard.NAVYIST_REWARDS_MASTERCARD,
    name: 'Navyist Rewards Mastercard',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/navyist-rewards-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/navyist-rewards-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/ON_card_NEW_Enth_MC_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 5 points per $1 spent at Gap Inc. brands and 1 point per $1 on other Mastercard purchases; 100 points = $1 reward.',
    rewardsEarnRates: [
      {
        category: 'Gap Inc. Brands',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Gap Inc. Brands'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Navyist Rewards Mastercard offers a $0 annual fee and earns 5 points per $1 spent at Gap, Banana Republic, Old Navy, and Athleta, and 1 point per $1 on all other purchases.  Redeem 100 points for a $1 reward.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: '30% Off First Purchase at Old Navy',
        description:
          'Receive 30% off your first purchase with your new credit card at Old Navy.',
        benefit_type: 'statement_credit',
        value: 0.3,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Fast Shipping',
        description: 'Free fast shipping on all online orders $50 or more',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: 50.0,
      },
      {
        name: 'Early Access to Sales',
        description: 'Early access to select sales',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Members-Only Exclusive Offers',
        description: 'Members-only exclusive offers',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability Protection',
        description:
          '$0 Fraud Liability Protection on purchases you did not authorize',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Donate Rewards to Charity',
        description: 'Donate your rewards to a good cause',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'Receive 30% off your first purchase with your new credit card at Old Navy.',
      },
    ],
    cardType: 'personal',
    imageName: 'navyist_rewards_mastercard.png',
  },
  [CreditCard.WYNDHAM_REWARDS_EARNER_BUSINESS_CARD]: {
    id: CreditCard.WYNDHAM_REWARDS_EARNER_BUSINESS_CARD,
    name: 'Wyndham Rewards Earner\u00ae Business Card',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-business-card/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-business-card/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'wyndham',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BWY_card_rRGB_EarnerBusiness_VS_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 8 points per $1 spent on eligible Wyndham Hotels and gas, 5 points on marketing/advertising/utilities, and 1 point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.wyndham',
        earnRate: 8.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'gas',
        earnRate: 8.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'marketing, advertising, and utilities',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Wyndham Timeshare resort down payments'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wyndham Rewards Earner Business Card offers a $95 annual fee and earns 8x points on Wyndham Hotels & gas, 5x on marketing/advertising/utilities, and 1x on other purchases.  It includes a 45,000-point welcome bonus after $3,000 spend and 15,000 bonus points annually.',
    cardNetwork: 'Visa',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Complimentary Employee Cards',
        description:
          'offer you more control over business expenses and improved tracking by adding employees to your account at no additional cost.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa SavingsEdge',
        description:
          'turns qualifying business purchases into savings. Visit visasavingsedge.com for details.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Extended Warranty protection',
        description:
          'provides valuable features that help you manage, use, and extend the warranties for eligible item purchases.',
        benefit_type: 'extended_warranty',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          'You\u2019re not responsible for charges you did not authorize.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Technology',
        description:
          'Use Tap to Pay for faster, easier, contactless purchasing.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Automatic DIAMOND Level Benefits',
        description:
          'Automatically receive a Wyndham Rewards DIAMOND member level and enjoy perks like suite upgrades, welcome amenity at check-in, and more.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Enjoy a Cardmember Booking Discount',
        description:
          'Wyndham Rewards Earner Business Cardmembers can save even more on our Best Available Rate at participating Hotels by Wyndham.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Annual Bonus',
        description:
          'Receive 15,000 bonus points each anniversary year\u2014that\u2019s enough for up to two free nights at participating properties.',
        benefit_type: 'anniversary_bonus',
        value: 15000,
        value_unit: 'points',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000,
        spendRequirementMonths: 3,
        bonusValue: 45000,
        bonusValueUnit: 'points',
        description:
          'Earn 45,000 bonus points after you spend $3,000 on purchases in the first 90 days.  Free nights can require up to 30,000 points per bedroom at participating properties and are subject to availability. Resort fees may apply and cannot be paid with points.',
      },
    ],
    cardType: 'business',
    imageName: 'wyndham_rewards_earner_business_card.png',
  },
  [CreditCard.GAP_GOOD_REWARDS_MASTERCARD]: {
    id: CreditCard.GAP_GOOD_REWARDS_MASTERCARD,
    name: 'Gap Good Rewards Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/gap-good-rewards/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/gap-good-rewards/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/GP_card_NEW_Enth_MC_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 5 points per $1 spent at Gap Inc. brands and 1 point per $1 on other Mastercard purchases; 100 points = $1 reward.',
    rewardsEarnRates: [
      {
        category: 'Gap, Banana Republic, Old Navy, and Athleta',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Gap', 'Banana Republic', 'Old Navy', 'Athleta'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Gap Good Rewards Mastercard\u00ae offers a $0 annual fee and lets you earn 5 points per $1 spent at Gap Inc. brands and 1 point per $1 on other purchases.  Redeem 100 points for a $1 reward at Gap Inc. stores.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: '20% off first purchase at Gap',
        description:
          'Receive 20% off your first purchase with your new credit card at Gap',
        benefit_type: 'statement_credit',
        value: 0.2,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free fast shipping on online orders $50+',
        description: 'Free fast shipping on all online orders $50 or more',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: 50.0,
      },
      {
        name: 'Early access to select sales',
        description: 'Early access to select sales',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Members-only exclusive offers',
        description: 'Members only exclusive offers',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Donate rewards to charity',
        description: 'Donate your rewards to a good cause',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability Protection',
        description:
          '$0 Fraud Liability Protection on purchases you did not authorize',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'gap_good_rewards_mastercard.png',
  },
  [CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD]: {
    id: CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD,
    name: 'Hawaiian Airlines\u00ae World Elite Business Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-business-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-business-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'hawaiian',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BHA_card_rRGB_BC_Angle_359x246_Angle_L_2021-09-22T04_42_44.png',
    rewardsSummary:
      'This card earns 3x HawaiianMiles on Hawaiian Airlines purchases, 2x on gas, dining, and office supplies, and 1x on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.hawaiian',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'officeSupplies',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Hawaiian Airlines World Elite Business Mastercard offers a welcome bonus of 50,000 HawaiianMiles after spending $4,000 in the first 90 days and paying the $99 annual fee.  It earns bonus miles on Hawaiian Airlines purchases and other categories, plus provides a one-time 50% companion discount on Hawaiian Airlines flights.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays',
    selectableCategories: [],
    benefits: [
      {
        name: 'One-time 50%-off companion discount',
        description:
          'for roundtrip coach travel between Hawaii and North America on Hawaiian Airlines',
        benefit_type: 'bogo_flight_coupon',
        value: 0.5,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary employee cards',
        description:
          'help you earn rewards faster and control business spending',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Share Miles',
        description:
          'allows you to send and receive miles from family and friends through HawaiianAirlines.com, without a fee',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easier expense tracking',
        description: 'with a consolidated statement showing all expenses',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary bonus HawaiianMiles',
        description:
          'Earn 20,000 bonus HawaiianMiles if you spend $50,000-$99,999 in annual purchases -OR- 40,000 bonus HawaiianMiles if you spend $100,000 or more in annual purchases',
        benefit_type: 'anniversary_bonus',
        value: 40000,
        value_unit: 'miles',
        spend_requirement: '100000',
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Earn 50,000 bonus HawaiianMiles after spending $4,000 on purchases and paying the annual fee in full, both within the first 90 days.',
      },
    ],
    cardType: 'business',
    imageName: 'hawaiian_airlines_world_elite_business_mastercard.png',
  },
  [CreditCard.JETBLUE_BUSINESS_CARD]: {
    id: CreditCard.JETBLUE_BUSINESS_CARD,
    name: 'JetBlue Business Card',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/jetblue-business-card/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/jetblue-business-card/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'jetblue',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BJT_card_BC_WE_Angle_359x246_L.png',
    rewardsSummary:
      'The JetBlue Business Card earns 6x points on JetBlue purchases, 2x points at restaurants and office supply stores, and 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.jetblue',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'officeSupplies',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
    ],
    creditScore: null,
    cardSummary:
      'The JetBlue Business Card offers a welcome bonus of up to 60,000 bonus points and earns valuable TrueBlue points on every purchase.  Enjoy perks like free checked bags, Group A boarding, and other exclusive benefits.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free first checked bag',
        description:
          'Free first checked bag for you and up to 3 companions on the same reservation when you use your card to book JetBlue-operated flights.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Group A boarding',
        description:
          'Get on board earlier with Group A boarding on JetBlue-operated flights.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Mosaic status faster',
        description: 'Earn toward Mosaic with every purchase',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No blackout dates',
        description:
          'Redeem points for any seat, any time, on JetBlue-operated flights.',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Points never expire',
        description: 'Your points will be ready when you are.',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Points Pooling',
        description: 'Earn & share points with family & friends.',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$100 statement credit',
        description:
          'Receive a $100 statement credit after you purchase a JetBlue Vacations package of $100 or more with your JetBlue Business Card. Limit one statement credit per calendar year.',
        benefit_type: 'statement_credit',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: 'JetBlue Vacations package of $100 or more',
      },
      {
        name: '5,000 bonus points',
        description:
          '5,000 bonus points each year after your JetBlue Business Card account anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 5000.0,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: '50% savings',
        description:
          '50% savings on eligible inflight purchases on JetBlue-operated flights.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Get 10% of your points back',
        description:
          'Get 10% of your points back after you redeem for and travel on a JetBlue-operated Award Flight.',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cash + Points redemptions',
        description: 'Cash + Points redemptions for award flights.',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          'Means you\u2019re not responsible for unauthorized charges.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000.0,
        bonusValueUnit: 'points',
        description:
          "Earn up to 60,000 bonus points: that's 50,000 bonus points after spending $4,000 on purchases in the first 90 days, plus 10,000 bonus points when a purchase is made on an employee card in the first 90 days.",
      },
    ],
    cardType: 'business',
    imageName: 'jetblue_business_card.png',
  },
  [CreditCard.UPROMISEWORLD_MASTERCARD]: {
    id: CreditCard.UPROMISEWORLD_MASTERCARD,
    name: 'Upromise\u00ae World Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/upromise-world-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/upromise-world-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/UPR_card_rRGB_Upromise_WM_angled_359x246_L.png',
    rewardsSummary:
      'Earn 1.529% cash back rewards on purchases when your Upromise Program account is linked to an eligible College Savings Plan; up to $250 cash back per year on eligible gift card purchases at MyGiftCardsPlus.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 0.0125,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 0.01529,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'giftCards',
        earnRate: null,
        excludeMerchants: [],
        spendCap: 250.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Upromise\u00ae World Mastercard\u00ae offers a $100 bonus cash back reward after spending $500 in the first 90 days, 1.529% cash back on purchases when linked to an eligible College Savings Plan, and up to $250 cash back per year on eligible gift cards at MyGiftCardsPlus.  It also features no foreign transaction fees and a $0 annual fee.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'No Foreign Transaction Fees',
        description: 'No foreign transaction fees on international purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability Protection',
        description: "You're not responsible for unauthorized charges.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free FICO\u00ae Score Access',
        description:
          'Keep an eye on your credit score and get email alerts when it changes.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 100.0,
        bonusValueUnit: 'cash_back',
        description:
          'Earn a $100 cash back bonus after spending $500 on purchases within the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'upromiseworld_mastercard.png',
  },
  [CreditCard.FRONTIER_AIRLINES_WORLD_MASTERCARD]: {
    id: CreditCard.FRONTIER_AIRLINES_WORLD_MASTERCARD,
    name: 'FRONTIER Airlines World Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/frontier-airlines-world-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/frontier-airlines-world-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'frontier',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/FTA_CD_Flat_Card_Art_370x246.png',
    rewardsSummary:
      'Earn 5x miles on eligible purchases at flyfrontier.com, 3x miles on eligible restaurant purchases, and 1x mile on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.frontier',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'frontier',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Frontier Airlines World Mastercard\u00ae offers 50,000 bonus miles after spending $500 and paying the annual fee within 90 days.  It earns 5x miles on Frontier purchases, 3x on dining, and 1x on all other purchases.  Cardholders receive two free checked bags on Frontier flights and other benefits.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Two Free Checked Bags',
        description: 'on Frontier flights.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Unlock Instant Elite Gold Status',
        description:
          'after first purchase with your card, in the first 90 days after account opening.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Earn a $100 Flight Voucher',
        description:
          'every account anniversary after spending $2,500 or more on purchases with your card during your cardmembership year.',
        benefit_type: 'anniversary_bonus',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: 2500.0,
      },
      {
        name: 'Miles Never Expire',
        description: 'as long as your account is open and in good standing.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Blackout Dates',
        description: 'Redeem miles any day with no blackouts on award travel.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Award redemption fee waiver',
        description:
          'when you book an award ticket and use your Frontier Airlines World Mastercard to pay the related taxes and fees, starting from $5.60 for a one-way ticket.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Priority boarding',
        description: 'allows cardmembers to enjoy Zone 2 boarding.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary online access to your FICO\u00ae Credit Score',
        description:
          'lets you keep an eye on your credit score and get alerts when we learn that your score has changed.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 500.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Earn 50,000 Travel Miles after spending $500 on purchases and paying the annual fee in full, both within the first 90 days of account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'frontier_airlines_world_mastercard.png',
  },
  [CreditCard.WYNDHAM_REWARDS_EARNER_PLUS_CARD]: {
    id: CreditCard.WYNDHAM_REWARDS_EARNER_PLUS_CARD,
    name: 'Wyndham Rewards Earner\u00ae Plus Card',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-plus-card/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-plus-card/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'wyndham',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/WYF_card_rRGB_EarnerPlus_VS_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 6 points per $1 spent on eligible purchases at Wyndham Hotels and on gas, 4 points on dining and groceries, and 1 point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.wyndham',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'gas',
        earnRate: 6.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'grocery',
        earnRate: 4.0,
        excludeMerchants: ['Target', 'Walmart'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Wyndham Timeshare resort down payments'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wyndham Rewards Earner Plus Card offers a welcome bonus of 45,000 bonus points, enough for up to 6 free nights.  Earn 6x points on Wyndham Hotels and gas, 4x on dining and groceries, and 1x on all other purchases.  Enjoy automatic Wyndham Rewards Platinum status and other benefits.',
    cardNetwork: 'Visa',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Wyndham Rewards Platinum Status',
        description:
          'Automatically receive a Wyndham Rewards PLATINUM member level and enjoy perks like early check-in, car rental upgrades, and more.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cardmember Booking Discount',
        description:
          'Wyndham Rewards Earner Plus Cardmembers can save even more on our Best Available Rate at participating Hotels by Wyndham.',
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus',
        description:
          'Receive 7,500 bonus points each anniversary year\u2014that\u2019s enough for up to one free night at participating properties.',
        benefit_type: 'anniversary_bonus',
        value: 7500,
        value_unit: 'points',
        spend_requirement: null,
      },
      {
        name: 'Contactless Technology',
        description:
          'Use Tap to Pay for faster, easier, contactless purchasing.',
        benefit_type: 'contactless',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          'You\u2019re not responsible for charges you did not authorize.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Chip Technology',
        description:
          'So paying for your purchases is more secure at chip-card terminals in the US and abroad.',
        benefit_type: 'contactless',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description: 'No foreign transaction fees on international purchases.',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000,
        spendRequirementMonths: 3,
        bonusValue: 45000,
        bonusValueUnit: 'points',
        description:
          'Earn 45,000 bonus points after you spend $1,000 on purchases in the first 90 days.  Free nights can require up to 30,000 points per bedroom at participating properties and are subject to availability. Resort fees may apply and cannot be paid with points.',
      },
    ],
    cardType: 'personal',
    imageName: 'wyndham_rewards_earner_plus_card.png',
  },
  [CreditCard.AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD,
    name: 'AAdvantage\u00ae Aviator\u00ae Red World Elite Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/aadvantage-aviator-red-world-elite-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/aadvantage-aviator-red-world-elite-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'american',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-front/AA_card_Red_WE_Flat_359x246.png',
    rewardsSummary:
      'Earn 2X AAdvantage\u00ae miles on American Airlines purchases and 1X mile on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.american',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'american',
      },
    ],
    creditScore: null,
    cardSummary:
      'The AAdvantage\u00ae Aviator\u00ae Red World Elite Mastercard\u00ae earns 2X AAdvantage\u00ae miles on American Airlines purchases and 1X mile on all other purchases.  It also offers a welcome bonus of 60,000 bonus miles after your first purchase and paying the annual fee within 90 days.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'First checked bag free',
        description:
          'on domestic American Airlines itineraries for the primary cardmember and up to 4 companions traveling with you on the same reservation.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Preferred boarding',
        description:
          'for the primary cardmember and up to 4 companions on their reservation for all American Airlines operated flights.',
        benefit_type: 'airline_priority_boarding',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Inflight savings',
        description:
          'Receive 25% inflight savings as statement credits on food and beverages when you use your card on American Airlines operated flights.',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 25.0,
        value_unit: '%',
        spend_requirement: null,
      },
      {
        name: 'Anniversary Companion Certificate',
        description:
          'Each anniversary year: earn a Companion Certificate good for 1 guest at $99 (plus taxes and fees) if you spend $20,000 on purchases and your account remains open for 45 days after your anniversary date.',
        benefit_type: 'bogo_flight_coupon',
        value: 99.0,
        value_unit: '$',
        spend_requirement: 20000.0,
      },
      {
        name: 'Up to $25 back as statement credits on inflight Wi-Fi purchases',
        description:
          'every anniversary year on American Airlines operated flights.',
        benefit_type: 'statement_credit',
        value: 25.0,
        value_unit: '$',
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases.',
        benefit_type: 'no_foreign_transaction_fee',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Coverage',
        description:
          'Eligible for Travel Accident Insurance, Trip Cancellation and Interruption coverage, Baggage Delay Insurance, and Auto Rental Collision Damage Waiver.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel and Lifestyle Services',
        description:
          'Access a suite of benefits, amenities and upgrades, preferential treatment and premium travel offers from best-in-class travel companies.',
        benefit_type: 'travel_credit',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: 90,
        bonusValue: 60000,
        bonusValueUnit: 'miles',
        description:
          'Earn 60,000 AAdvantage\u00ae bonus miles after making your first purchase and paying the $99 annual fee in full, both within the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'aadvantageaviatorred_world_elite_mastercard.png',
  },
  [CreditCard.MILES__MOREWORLD_ELITE_MASTERCARD]: {
    id: CreditCard.MILES__MOREWORLD_ELITE_MASTERCARD,
    name: 'Miles & More\u00ae World Elite Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/lufthansa-miles-more-world-elite-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/lufthansa-miles-more-world-elite-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'miles',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/LFT_card_rCMY_Lufthansa_359x246_angled_L.png',
    rewardsSummary:
      'Earn 2 miles per $1 spent on ticket purchases directly from Miles & More integrated airline partners and 1 mile per $1 spent on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'miles',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'miles',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Miles & More\u00ae World Elite Mastercard\u00ae earns 2 miles per $1 spent on Miles & More ticket purchases and 1 mile per $1 on other purchases.  It offers benefits like complimentary Lufthansa Business Lounge Vouchers and a Companion Ticket annually.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Lufthansa Business Lounge Vouchers',
        description:
          'Receive two complimentary Lufthansa Business Lounge Vouchers after each account anniversary.',
        benefit_type: 'lounge_access',
        value: 2,
        value_unit: 'vouchers',
        spend_requirement: null,
      },
      {
        name: 'Companion Ticket',
        description:
          'Receive a Companion Ticket after each account anniversary (taxes and fees apply).',
        benefit_type: 'bogo_flight_coupon',
        value: 1,
        value_unit: 'ticket',
        spend_requirement: null,
      },
      {
        name: 'Miles & More Status Boost',
        description:
          'Once each calendar year, you can convert 5,000 to 25,000 miles earned on purchases into Points and Qualifying Points.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fees',
        description: 'No foreign transaction fees on international purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'miles',
        description:
          'Earn 60,000 miles after you spend $3,000 in purchases and pay the annual fee, both within the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'miles__moreworld_elite_mastercard.png',
  },
  [CreditCard.WYNDHAM_REWARDS_EARNERCARD]: {
    id: CreditCard.WYNDHAM_REWARDS_EARNERCARD,
    name: 'Wyndham Rewards Earner\u00ae Card',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-card/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-card/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'wyndham',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/WYZ_card_rRGB_NoFeeEarner_VS_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 5 points per $1 spent at Wyndham Hotels and on gas, 2 points per $1 on dining and groceries, and 1 point per $1 on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel.wyndham',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: ['Target', 'Walmart'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: ['Target', 'Walmart'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Wyndham Timeshare resort down payments'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'wyndham',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Wyndham Rewards Earner Card offers a $0 annual fee and earns 5x points on Wyndham Hotels & gas, 2x on dining & groceries, and 1x on all other purchases.  Enjoy a 30,000-point welcome bonus after spending $1,000 in the first 90 days.',
    cardNetwork: 'Visa',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Automatic GOLD Level Benefits',
        description:
          'Automatically receive a Wyndham Rewards GOLD member level and enjoy perks like free WiFi, preferred room selection, late checkout, and more.',
        benefit_type: 'hotel_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cardmember Booking Discount',
        description:
          'Wyndham Rewards Earner Cardmembers can save even more on our Best Available Rate at participating Hotels by Wyndham.',
        benefit_type: 'free_hotel_night',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Anniversary Bonus',
        description:
          'Earn 7,500 bonus points each anniversary year if you spend $15,000 on eligible purchases\u2014that\u2019s enough for up to one free night at participating properties.',
        benefit_type: 'anniversary_bonus',
        value: 7500,
        value_unit: 'points',
        spend_requirement: 15000,
      },
      {
        name: 'Contactless Technology',
        description:
          'Use Tap to Pay for faster, easier, contactless purchasing.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Chip Technology',
        description:
          'So paying for your purchases is more secure at chip-card terminals in the US and abroad.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          'You\u2019re not responsible for charges you did not authorize.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000,
        spendRequirementMonths: 3,
        bonusValue: 30000,
        bonusValueUnit: 'points',
        description:
          'Earn 30,000 bonus points after you spend $1,000 on purchases in the first 90 days.  Free nights can require up to 30,000 points per bedroom at participating properties and are subject to availability. Resort fees may apply and cannot be paid with points.',
      },
    ],
    cardType: 'personal',
    imageName: 'wyndham_rewards_earnercard.png',
  },
  [CreditCard.EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD,
    name: 'Emirates Skywards Rewards World Elite Mastercard',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/emirates-skywards-rewards-world-elite-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/emirates-skywards-rewards-world-elite-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'avios',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/EKS_card_rRGB_Rewards_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 3 Skywards Miles on eligible Emirates purchases, 2 miles on eligible travel, and 1 mile on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'avios',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Emirates Skywards Rewards World Elite Mastercard offers a welcome bonus of 50,000 bonus Skywards Miles after spending $3,000 in the first 90 days.  Enjoy Emirates Skywards Silver tier membership during your first year, and earn 3x miles on Emirates purchases, 2x on travel, and 1x on all other purchases.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Emirates Skywards Silver tier membership',
        description:
          'Enjoy Emirates Skywards Silver tier membership during your first year, and retain your tier status by spending $20,000 each cardmembership year.',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: '$20,000',
      },
      {
        name: 'No foreign transaction fees',
        description: 'No foreign transaction fees on international purchases.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Complimentary online access to your FICO\u00ae Credit Score',
        description:
          'lets you keep an eye on your credit score and get alerts when we learn that your score has changed.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '25% savings when you Buy or Gift Miles',
        description:
          'Receive a 25% savings when you Buy Skywards Miles for yourself or Gift Miles.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          "means you're not responsible for charges you did not authorize.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: '$3,000',
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'miles',
        description:
          'Earn 50,000 bonus Skywards Miles after spending $3,000 on purchases in the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'emirates_skywards_rewards_world_elite_mastercard.png',
  },
  [CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD]: {
    id: CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD,
    name: 'Hawaiian Airlines\u00ae World Elite Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'hawaiian',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/HCL_card_PremWhite_WE_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 3x miles on Hawaiian Airlines purchases, 2x miles on gas, dining, and grocery store purchases, and 1x mile on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.hawaiian',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'hawaiian',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Hawaiian Airlines World Elite Mastercard offers 70,000 bonus HawaiianMiles after spending $2,000 in the first 90 days, two free checked bags on eligible Hawaiian Airlines flights when booking directly with the airline, and a one-time 50% companion discount on roundtrip coach travel between Hawaii and North America.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Two free checked bags on eligible flights',
        description:
          'Two free checked bags on eligible flights for the primary cardmember when you use your card to purchase tickets directly from Hawaiian Airlines.',
        benefit_type: 'baggage',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'One-time 50%-off companion discount',
        description:
          'Receive a one-time 50%-off companion discount for roundtrip coach travel between Hawaii and North America on Hawaiian Airlines.',
        benefit_type: 'bogo_flight_coupon',
        value: 0.5,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$100 companion discount annually',
        description:
          '$100 companion discount for roundtrip travel between Hawaii and North America on Hawaiian Airlines after each account anniversary.',
        benefit_type: 'anniversary_bonus',
        value: 100.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Discounted award flights',
        description: 'Discounted award flights on Hawaiian Airlines.',
        benefit_type: 'discount',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Payment',
        description:
          'lets you pay just by tapping your card to the card reader. It\u2019s quick, easy and secure.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No HawaiianMiles Expiration',
        description:
          'HawaiianMiles never expire, so you can redeem them anytime.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 2000.0,
        spendRequirementMonths: 3,
        bonusValue: 70000,
        bonusValueUnit: 'miles',
        description:
          'Earn 70,000 bonus HawaiianMiles after spending $2,000 on purchases within the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'hawaiian_airlines_world_elite_mastercard.png',
  },
  [CreditCard.BANANA_REPUBLIC_REWARDS_MASTERCARD]: {
    id: CreditCard.BANANA_REPUBLIC_REWARDS_MASTERCARD,
    name: 'Banana Republic Rewards Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/banana-republic-rewards-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/banana-republic-rewards-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BR_card_NEW_Enth_MC_Angle_359x246_L.png',
    rewardsSummary:
      'Earn 5 points per $1 spent at Gap Inc. brands and 1 point per $1 on other Mastercard purchases; 100 points = $1 reward.',
    rewardsEarnRates: [
      {
        category: 'Gap Inc. Brands',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Gap Inc. Brands'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Banana Republic Rewards Mastercard offers a $0 annual fee and lets you earn 5 points per $1 spent at Gap Inc. brands (Gap, Banana Republic, Old Navy, and Athleta) and 1 point per $1 on all other purchases.  Redeem 100 points for a $1 reward.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: '20% off first purchase',
        description:
          'Receive 20% off your first purchase with your new credit card at Banana Republic.',
        benefit_type: 'statement_credit',
        value: 0.2,
        value_unit: 'purchase_discount',
        spend_requirement: null,
      },
      {
        name: 'Free fast shipping',
        description: 'Free fast shipping on all online orders $50 or more',
        benefit_type: 'statement_credit',
        value: null,
        value_unit: null,
        spend_requirement: 50.0,
      },
      {
        name: 'Early access to select sales',
        description: 'Early access to select sales',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Members only exclusive offers',
        description: 'Members only exclusive offers',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability Protection',
        description:
          '$0 Fraud Liability Protection on purchases you did not authorize',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Donate your rewards to a good cause',
        description: 'Donate your rewards to a good cause',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: null,
        bonusValueUnit: null,
        description:
          'Receive 20% off your first purchase with your new credit card at Banana Republic.',
      },
    ],
    cardType: 'personal',
    imageName: 'banana_republic_rewards_mastercard.png',
  },
  [CreditCard.CAPITAL_VACATIONSWORLD_MASTERCARD]: {
    id: CreditCard.CAPITAL_VACATIONSWORLD_MASTERCARD,
    name: 'Capital Vacations\u00ae World Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/capital-vacations/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/capital-vacations/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/CAP_card_CapitalVaca_PM_WM_Flat_359x246.png',
    rewardsSummary:
      'Earn 5X Rewards on Capital Vacations purchases, 2X on RCI and travel, and 1X on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'Capital Vacations',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'RCI and travel',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Capital Vacations\u00ae World Mastercard\u00ae offers a $0 annual fee and earns 5X rewards on Capital Vacations purchases, 2X on RCI and travel, and 1X on other purchases.  It also includes a 5,000 bonus rewards after your first purchase and a 3-night Capital Vacations Resort Stay Certificate after spending $10,000 in net purchases each calendar year.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: '0% Intro APR on Balance Transfers',
        description:
          '0% introductory APR for 15 months for each balance transfer made within 45 days of account opening. After that, a variable APR will apply, 19.99% to 29.99%, based on your creditworthiness and other factors. There is a fee for balance transfers.',
        benefit_type: 'balance_transfer_apr',
        value: 0.0,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'On international purchases',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '3-night Capital Vacations Resort Stay Certificate',
        description:
          'After spending $10,000 in net purchases each calendar year',
        benefit_type: 'free_hotel_night',
        value: 3.0,
        value_unit: 'nights',
        spend_requirement: '$10,000',
      },
      {
        name: '$0 Fraud Liability Protection',
        description:
          'Means you\u2019re not responsible for unauthorized charges you report to us',
        benefit_type: 'fraud_liability_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 5000,
        bonusValueUnit: 'points',
        description:
          'Earn 5,000 Bonus Rewards after making your first purchase.',
      },
    ],
    cardType: 'personal',
    imageName: 'capital_vacationsworld_mastercard.png',
  },
  [CreditCard.RCIELITE_REWARDSWORLD_MASTERCARD]: {
    id: CreditCard.RCIELITE_REWARDSWORLD_MASTERCARD,
    name: 'RCI\u00ae Elite Rewards\u00ae World Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/rci-elite-rewards-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/rci-elite-rewards-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/RCI_CD_card_RCI_PM_WM_Angle_L_359x246.png',
    rewardsSummary:
      'Earn 5X Rewards on RCI purchases, 2X on travel, and 1X on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'rci',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The RCI Elite Rewards World Mastercard offers a $0 annual fee, 5X rewards on RCI purchases, 2X on travel, and 1X on other purchases, plus a 5,000-point bonus after your first purchase.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: '0% intro APR on balance transfers',
        description:
          '0% introductory APR for the first fifteen billing cycles following each balance transfer that posts to your account within 45 days of account opening. After that, (and for balance transfers that do not post to your account within 45 days of account opening) your APR will be 19.99% to 29.99%, based on your creditworthiness and other factors. This APR will vary with the market based on the Prime Rate.',
        benefit_type: 'apr',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No annual fee',
        description: 'No annual fee',
        benefit_type: 'no_annual_fee',
        value: 0.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'No foreign transaction fees on international purchases.',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$250 USD Vacation Credit',
        description:
          'after spending $10,000 in net purchases each calendar year.',
        benefit_type: 'travel_credit',
        value: 250.0,
        value_unit: 'dollars',
        spend_requirement: 10000.0,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          "$0 Fraud Liability protection means you're not responsible for unauthorized charges you report to us",
        benefit_type: 'fraud_liability_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 5000,
        bonusValueUnit: 'points',
        description:
          "Earn 5,000 Bonus Rewards after making your first purchase - that's worth $50 in RCI Member RewardsSM.",
      },
    ],
    cardType: 'personal',
    imageName: 'rcielite_rewardsworld_mastercard.png',
  },
  [CreditCard.JETBLUE_CARD]: {
    id: CreditCard.JETBLUE_CARD,
    name: 'JetBlue Card',
    apply_link: 'https://cards.barclaycardus.com/banking/cards/jetblue-card/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/jetblue-card/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'jetblue',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/JBM_card_NoFee_WM_Angle_359x246_L.png',
    rewardsSummary:
      'The JetBlue Card earns 3x points on JetBlue purchases, 2x points at restaurants and eligible grocery stores, and 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.airline.jetblue',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'jetblue',
      },
    ],
    creditScore: null,
    cardSummary:
      'The JetBlue Card offers a $0 annual fee and earns 3x points on JetBlue purchases, 2x points at restaurants and eligible grocery stores, and 1x point on all other purchases.  It also includes a welcome bonus of 10,000 bonus points after spending $1,000 in the first 90 days.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Mosaic status faster',
        description: 'Earn toward Mosaic with every purchase',
        benefit_type: 'airline_status',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No blackout dates',
        description:
          'That\u2019s any seat, any time, on JetBlue-operated flights',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Redeem for any seat, any time on JetBlue-operated flights',
        description:
          'Points required for an Award flight will vary based on the published base fare at the time of booking',
        benefit_type: 'bogo_flight_coupon',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Points never expire',
        description: 'Your points will be ready whenever you are',
        benefit_type: 'anniversary_bonus',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Points pooling',
        description: 'Earn & share points with family and friends',
        benefit_type: 'points_pooling',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cash + Points',
        description:
          'Short on points (or cash) for that trip? Pay for your flight with almost any combination of dollars and TrueBlue points \u2013 starting with as few as 500 points',
        benefit_type: 'cash_back',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '50% savings',
        description:
          'on eligible inflight purchases on JetBlue-operated flights',
        benefit_type: 'airline_inflight_purchase_discount',
        value: 50.0,
        value_unit: '%',
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          'Means you\u2019re not responsible for unauthorized charges',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No foreign transaction fees',
        description: 'on international purchases',
        benefit_type: 'no_foreign_transaction_fees',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Chip technology',
        description:
          'so paying for your purchases is more secure at chip-card terminals in the U.S. and abroad',
        benefit_type: 'chip_technology',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 10000,
        bonusValueUnit: 'points',
        description:
          'Earn 10,000 bonus points after spending $1,000 on purchases in the first 90 days.',
      },
    ],
    cardType: 'personal',
    imageName: 'jetblue_card.png',
  },
  [CreditCard.BARNES__NOBLE_MASTERCARD]: {
    id: CreditCard.BARNES__NOBLE_MASTERCARD,
    name: 'Barnes & Noble Mastercard\u00ae',
    apply_link:
      'https://cards.barclaycardus.com/banking/cards/barnes-noble-mastercard/',
    learn_more_link:
      'https://cards.barclaycardus.com/banking/cards/barnes-noble-mastercard/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'Barclays',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BN1_card_rRGB_BarnesAndNoble_PM_359x246_Angle_L.png',
    rewardsSummary:
      'Earn 5% back at Barnes & Noble and Paper Source, 2x points at restaurants (excluding Barnes & Noble Caf\u00e9), and 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'Barnes & Noble and Paper Source',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: ['Barnes & Noble Caf\u00e9'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: ['Barnes & Noble'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Barnes & Noble Mastercard\u00ae offers a $25 Barnes & Noble Gift Card after your first purchase or balance transfer.  Earn 5% back at Barnes & Noble and Paper Source, 2x points at restaurants (excluding Barnes & Noble Caf\u00e9), and 1x point on all other purchases.  There is a $0 annual fee.',
    cardNetwork: 'Mastercard',
    issuer: 'Barclays Bank Delaware',
    selectableCategories: [],
    benefits: [
      {
        name: 'Free online FICO\u00ae Credit Score access',
        description:
          'lets you keep an eye on your credit score and get alerts when we learn that your score has changed',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 Fraud Liability protection',
        description:
          "means you're not responsible for unauthorized charges you report to us",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 25.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn a $25 Barnes & Noble Gift Card after your first purchase or balance transfer.',
      },
    ],
    cardType: 'personal',
    imageName: 'barnes__noble_mastercard.png',
  },
  [CreditCard.BARCLAYS_EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARDU00AE]: {
    id: CreditCard.BARCLAYS_EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARDU00AE,
    fees: {
      annualFeeAmountDollars: 499.0,
      annualFeeFirstYear: 0.0,
      aprDescription:
        'Purchases \u2013 20.24% to 29.99%, based on your creditworthiness and other factors. This APR will vary with the market based on the Prime Rate.Balance Transfers \u2013 0% introductory APR for the first 12 billing cycles following each balance transfer that posts to your account within 45 days of account opening. After that, (and for balance transfers that do not post to your account within 45 days of account opening) your APR will be 20.24% to 29.99%, based on your creditworthiness and other factors. This APR will vary with the market based on the Prime Rate.',
      aprLow: 0.2024,
      aprHigh: 0.2999,
      balanceTransferApr: 0.0,
      balanceTransferFee:
        'Either $5 or 5% of the amount of each transfer, whichever is greater.',
      zeroAprPeriodMonths: 12.0,
      hasForeignTransactionFee: false,
      foreignTransactionFeePercent: null,
    },
    bank_name: 'Barclays',
    name: 'barclays_emirates_skywards_premium_world_elite_mastercardu00ae',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.TD_DOUBLE_UP_CREDIT_CARD]: {
    id: CreditCard.TD_DOUBLE_UP_CREDIT_CARD,
    name: 'TD Double Up\u2120 Credit Card',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tddoubleup&src=8020860003',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/double-up',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/tddoubleup-personal-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/content/dam/tdb/images/personal-banking/td-doubleup-548x344-40-en.png',
    rewardsSummary: 'Earn unlimited 2% cash back on all eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 2% cash back on all eligible purchases \u2013 no rotating Spend Categories, no caps or limits. Plus, get 2 special introductory offers: Bonus Cash Back: Earn $200 Cash Back in the form of a statement credit when you spend $1,500 within the first 90 days after account opening; balance transfers: 0% introductory APR* balance transfers for first 15 billing cycles after account opening.',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Visa benefits',
        description:
          'Visa benefits like cell phone protection when you pay your monthly mobile bill with your card',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Bonus Cash Back',
        description:
          'Earn $200 Cash Back in the form of a statement credit when you spend $1,500 within the first 90 days after account opening',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: 1500.0,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1500.0,
        spendRequirementMonths: 3.0,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn $200 Cash Back in the form of a statement credit when you spend $1,500 within the first 90 days after account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'td_double_up_credit_card.png',
  },
  [CreditCard.TD_CASH_CREDIT_CARD]: {
    id: CreditCard.TD_CASH_CREDIT_CARD,
    name: 'TD Cash Credit Card',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdcash&src=8020550002',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/cash-card',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/tdcash-personal-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/content/dam/tdb/images/personal-banking/td-cash-548x344-23-en.png',
    rewardsSummary:
      'Earn unlimited 1% cash back on all purchases, plus choose two categories to earn 3% and 2% cash back.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Grocery Stores',
        earnRate: 2.0,
        excludeMerchants: ['superstores', 'warehouse clubs'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The TD Cash Credit Card offers unlimited 1% cash back on all purchases, plus the option to select two categories for 3% and 2% cash back.  There's no annual fee and a special offer to earn $200 cash back.",
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [
      'Dining',
      'Entertainment',
      'Gas',
      'Grocery Stores',
      'Travel',
    ],
    benefits: [
      {
        name: 'Visa benefits',
        description:
          'Visa benefits like cell phone protection when you pay your monthly mobile bill with your card',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: 'Pay your monthly mobile bill with your card',
      },
      {
        name: 'Balance Transfer Offer',
        description:
          '0% introductory APR* balance transfers for first 15 billing cycles after account opening. After that, 19.24%, 24.24%, or 29.24% variable APR based on your credit worthiness',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 200.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn $200 Cash Back when you spend $1,000 within the first 90 days after account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'td_cash_credit_card.png',
  },
  [CreditCard.TD_FLEXPAY_CREDIT_CARD]: {
    id: CreditCard.TD_FLEXPAY_CREDIT_CARD,
    name: 'TD FlexPay Credit Card',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdflexpay&src=8020960001',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/flex-pay',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/tdflex-personal-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/content/dam/tdb/images/personal-banking/flex-320x178-61e-en.png',
    rewardsSummary:
      'The TD FlexPay Credit Card offers 0% introductory APR on balance transfers for the first 18 billing cycles and no annual fee.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: null,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'balanceTransfer',
        earnRate: 0.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Get our best balance transfer offer with 0% introductory APR* on balance transfers for the first 18 billing cycles after account opening.  No annual fee* and Visa benefits like cell phone protection when you pay your monthly mobile bill with your card.<sup>1</sup>',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Late fee forgiveness',
        description:
          "We'll automatically refund your first late fee each year. Please note, past due payments may impact your credit score.",
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Visa benefits',
        description:
          'Get Visa benefits like cell phone protection when you pay your monthly mobile bill with your card<sup>1</sup>',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'td_flexpay_credit_card.png',
  },
  [CreditCard.TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_1000_CREDIT_LIMIT]: {
    id: CreditCard.TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_1000_CREDIT_LIMIT,
    name: 'TD Clear Visa Platinum Credit Cards',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdclear1&src=8020000101',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/clear',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/tdclear1-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/us/en/personal-banking/credit-cards/clear/_jcr_content/root/container/responsivegrid/container_1596974475/textimagectagrid_con/0/compare_card_6_1_c_e.coreimg.82.320.png/1711460720139/clear-320x178-61e-en.png',
    rewardsSummary:
      'The TD Clear Visa Platinum Credit Card earns no rewards points or miles, but instead offers a simple monthly fee structure with no interest charges.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The TD Clear Visa Platinum Credit Card offers no interest charges, just a simple monthly fee.  It also includes no late payment or foreign transaction fees, and comes with Visa benefits like cell phone protection and emergency card replacement.',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Visa benefits',
        description:
          'Enjoy Visa benefits like cell phone protection, emergency card replacement and Visa Zero Liability',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName:
      'td_clear_visa_platinum_credit_card_with_a_1000_credit_limit.png',
  },
  [CreditCard.TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_2000_CREDIT_LIMIT]: {
    id: CreditCard.TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_2000_CREDIT_LIMIT,
    name: 'TD Clear Visa Platinum Credit Cards',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdclear2&src=8020000201',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/clear',
    terms_and_conditions_button_text: '\u2020Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/tdclear2-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/us/en/personal-banking/credit-cards/clear/_jcr_content/root/container/responsivegrid/container_1596974475/textimagectagrid_con/0/compare_card_6_1_c_e.coreimg.82.320.png/1711460720139/clear-320x178-61e-en.png',
    rewardsSummary:
      'The TD Clear Visa Platinum Credit Card earns no rewards points or miles, but instead offers a simple monthly fee with no interest charges.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The TD Clear Visa Platinum Credit Card offers no interest charges, only a simple monthly fee.  It also includes no late payment or foreign transaction fees, and comes with Visa benefits like cell phone protection and emergency card replacement.',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Visa Benefits',
        description:
          'Enjoy Visa benefits like cell phone protection, emergency card replacement and Visa Zero Liability',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName:
      'td_clear_visa_platinum_credit_card_with_a_2000_credit_limit.png',
  },
  [CreditCard.TD_FIRST_CLASS_VISA_SIGNATURE_CREDIT_CARD]: {
    id: CreditCard.TD_FIRST_CLASS_VISA_SIGNATURE_CREDIT_CARD,
    name: 'TD First Class\u2120 Visa Signature\u00ae Credit Card',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdfirstclass&src=8020000074',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/first-class-card',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/firstclass-personal-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'airline',
    creditCardImageUrl:
      'https://www.td.com/content/dam/tdb/images/personal-banking/td-firstclass-sign-contactless-en.jpeg',
    rewardsSummary:
      'Earn 3X First Class miles on travel and dining purchases and 1X mile on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'airline',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'airline',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'airline',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 25,000 bonus miles when you spend $3,000 in the first 6 billing cycles.  Earn 3X miles on travel and dining, and 1X mile on all other purchases. Miles never expire as long as your account is open and in good standing.',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [
      {
        spendRequirement: 3000.0,
        spendRequirementMonths: 6,
        bonusValue: 25000,
        bonusValueUnit: 'miles',
        description:
          'Earn 25,000 bonus miles when you spend $3,000 within the first 6 billing cycles.',
      },
    ],
    cardType: 'personal',
    imageName: 'td_first_class_visa_signature_credit_card.jpeg',
  },
  [CreditCard.TD_CASH_SECURED_CREDIT_CARD]: {
    id: CreditCard.TD_CASH_SECURED_CREDIT_CARD,
    name: 'TD Cash Secured Credit Card',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdcashsecured&src=8020000052',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/secured-credit-card',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/secured-personal-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/content/dam/tdb/images/personal-banking/td-cash-320x178-63-en.png',
    rewardsSummary:
      'Earn 3% and 2% Cash Back on your choice of Spend Categories. Plus, you can switch your categories quarterly. Earn 1% Cash Back on other purchases.',
    rewardsEarnRates: [
      {
        category: 'Dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'Grocery Stores',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Build your credit and earn rewards. Make purchases like with any credit card, build your credit by making on-time payments, and your linked savings account works as a security deposit.',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: ['Dining', 'Grocery Stores'],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'td_cash_secured_credit_card.png',
  },
  [CreditCard.TD_BUSINESS_SOLUTIONS_CREDIT_CARD]: {
    id: CreditCard.TD_BUSINESS_SOLUTIONS_CREDIT_CARD,
    name: 'TD Business Solutions Credit Card',
    apply_link:
      'https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tdbusinesssolutions&src=8021000003',
    learn_more_link:
      'https://www.td.com/us/en/personal-banking/credit-cards/business-solutions-credit-card',
    terms_and_conditions_button_text: '*Terms and conditions',
    terms_and_conditions_link:
      'https://www.td.com/content/dam/tdb/document/pdf/personal-banking/business-solutions-terms-en.pdf',
    bank_name: 'TD Bank',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.td.com/content/dam/tdb/images/personal-banking/credit-card-business-27-1-en.jpeg',
    rewardsSummary: 'Earn unlimited 2% cash back on all eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn unlimited 2% cash back on all eligible purchases.  Limited-time offer: 0% Intro APR on Purchases for the first 12 billing cycles after account opening. After that, 18.24%-28.24% variable APR based on your creditworthiness.',
    cardNetwork: 'Visa',
    issuer: 'TD Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Statement Credit',
        description:
          'Earn $250 cash back in the form of a statement credit when you spend $1,500 within the first 90 days after account opening',
        benefit_type: 'statement_credit',
        value: 250.0,
        value_unit: 'dollars',
        spend_requirement: '1500 dollars in 90 days',
      },
      {
        name: 'Visa Benefits',
        description:
          'Visa benefits like cell phone protection when you pay your monthly mobile bill with your card',
        benefit_type: 'cell_phone_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1500.0,
        spendRequirementMonths: 3,
        bonusValue: 250.0,
        bonusValueUnit: 'dollars',
        description:
          'Earn $250 cash back in the form of a statement credit when you spend $1,500 within the first 90 days after account opening.',
      },
    ],
    cardType: 'business',
    imageName: 'td_business_solutions_credit_card.jpeg',
  },
  [CreditCard.HSBC_PREMIER_CREDIT_CARD]: {
    id: CreditCard.HSBC_PREMIER_CREDIT_CARD,
    name: 'hsbc_premier_credit_card',
    apply_link: 'https://www.us.hsbc.com/credit-cards/products/premier/#apply',
    learn_more_link: 'https://www.us.hsbc.com/credit-cards/products/premier/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'HSBC',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn Points for every dollar spent on purchases, with bonus earning rates on gas, groceries, and travel.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'grocery',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'travel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The HSBC Premier World Mastercard offers a 50,000-point welcome bonus, 3x points on gas and groceries, 2x points on travel, and 1x point on all other purchases.  It also includes travel and everyday benefits like statement credits, discounts, and purchase protection.',
    cardNetwork: 'Mastercard',
    issuer: 'HSBC Bank USA, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Statement Credit (Streaming)',
        description:
          'Receive up to $60 in statement credits annually when you pay for your TV streaming subscription.',
        benefit_type: 'statement_credit',
        value: 60.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Statement Credit (Instacart+)',
        description:
          'Get up to $140 annually with Instacart+. When you sign up as a new member, receive 2 free months of Instacart+ and $10 off your second order each month.',
        benefit_type: 'statement_credit',
        value: 140.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lyft Credit',
        description:
          'Take 3 rides, and get a $5 Lyft App credit every month with your Premier credit card.',
        benefit_type: 'statement_credit',
        value: 5.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'ShopRunner Membership',
        description: 'Complimentary ShopRunner membership worth $79 annually.',
        benefit_type: 'statement_credit',
        value: 79.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Trusted Traveler Credit',
        description:
          'Speed up airport screening with up to $85 towards Global Entry, TSA Precheck, TSA Precheck by Clear, or NEXUS application fees, once every 4.5 years.',
        benefit_type: 'trusted_traveler_credit',
        value: 85.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Booking.com Discount',
        description: 'Get up to 7% off prepaid accommodation with Booking.com',
        benefit_type: 'travel_credit',
        value: 7.0,
        value_unit: 'percent',
        spend_requirement: null,
      },
      {
        name: 'Rewards for Miles',
        description:
          'Transfer your points into any of our 11 airline and 2 hotel partners\u2019 loyalty programs.',
        benefit_type: 'points',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          'Cellular Wireless Telephone Protection provides reimbursements up to $600 per claim if your cellphone is stolen or damaged',
        benefit_type: 'cell_phone_protection',
        value: 600.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Mastercard ID Theft Protection\u2122',
        description:
          'Mastercard ID Theft Protection\u2122 and Identity Fraud Expense Reimbursement provide support and expense reimbursement if your identity is compromised through identity fraud.',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Purchase Assurance',
        description:
          'Purchase Assurance covers most purchases from damage or theft within 90 days of purchase up to $1,000',
        benefit_type: 'purchase_protection',
        value: 1000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 50000,
        bonusValueUnit: 'points',
        description:
          'Earn 50,000 bonus points after you spend $4,000 in the first 3 months from account opening.',
      },
    ],
    cardType: 'personal',
    imageName: 'hsbc_premier_credit_card.jpg',
    fees: {
      annualFeeAmountDollars: 95.0,
      annualFeeFirstYear: 0.0,
      aprDescription:
        'Competitive variable APR on purchases and balance transfers',
      aprLow: 0.2024,
      aprHigh: 0.2424,
      balanceTransferApr: null,
      balanceTransferFee: 10.0,
      zeroAprPeriodMonths: null,
      hasForeignTransactionFee: false,
      foreignTransactionFeePercent: null,
    },
  },
  [CreditCard.HSBC_ELITE_CREDIT_CARD]: {
    id: CreditCard.HSBC_ELITE_CREDIT_CARD,
    name: 'HSBC Elite credit card',
    apply_link: 'https://www.us.hsbc.com/credit-cards/products/elite/#apply',
    learn_more_link: 'https://www.us.hsbc.com/credit-cards/products/elite/',
    terms_and_conditions_button_text: null,
    terms_and_conditions_link: null,
    bank_name: 'HSBC',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.us.hsbc.com/content/dam/hsbc/us/images/tile-16-9/14388-hsbc-elite-mastercard-left-cropped-hex-1600x900.jpg',
    rewardsSummary:
      'The HSBC Elite card earns 5x points on travel, 2x points on dining, and 1x point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'dining',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'The HSBC Elite World Elite Mastercard offers exceptional rewards on travel, dining, and entertainment, with benefits worth over $2,900 in the first year and $2,000 annually thereafter.  It features a 60,000-point welcome bonus, 5x points on travel, 2x points on dining, and 1x point on all other purchases.',
    cardNetwork: 'Mastercard',
    issuer: 'HSBC Bank USA, N.A.',
    selectableCategories: [],
    benefits: [
      {
        name: 'Travel Credit',
        description:
          'Earn up to $400 of travel credits per year for all airfares, hotels and car rentals booked through HSBC Travel',
        benefit_type: 'travel_credit',
        value: 400.0,
        value_unit: 'dollars',
        spend_requirement: '$2,000 spent in cumulative travel purchases',
      },
      {
        name: 'Trusted Traveler Credit',
        description:
          'Speed up airport screening with up to $120 towards Global Entry, TSA Precheck, TSA Precheck by Clear, or NEXUS once every 4.5 years',
        benefit_type: 'trusted_traveler_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Lounge Access',
        description:
          'Elevate your airport experience with complimentary and unlimited lounge access for the cardholder and up to 2 guests worth more than $469 annually with Priority Pass',
        benefit_type: 'lounge_access',
        value: 469.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Rewards for Miles',
        description:
          'Rewards for Miles program that allows you to transfer your points into any of our 11 airline and 2 hotel partners\u2019 loyalty programs.',
        benefit_type: 'points',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'MasterRental Coverage',
        description: 'MasterRental Coverage\u2122',
        benefit_type: 'auto_rental_collision_damage_waiver_primary',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Travel Insurance',
        description: 'complimentary travel insurance',
        benefit_type: 'travel_insurance',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Airport Concierge Services',
        description: 'airport concierge services',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Exclusive Discounts and Upgrades',
        description:
          'exclusive discounts and upgrades from fine restaurants and designer brands',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Rideshare Credit',
        description:
          'Earn up to $120 in statement credits annually on taxis, cabs and rideshare. Use your Elite credit card to pay for your rideshare and automatically receive $10 each month',
        benefit_type: 'statement_credit',
        value: 120.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Instacart+ Credit',
        description:
          'Get up to $140 annually with Instacart+. When you sign up as a new member, receive 2 free months of Instacart+ and $10 off your second order each month',
        benefit_type: 'statement_credit',
        value: 140.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'ShopRunner Membership',
        description:
          'Enjoy complimentary ShopRunner membership, worth $79 annually',
        benefit_type: 'other',
        value: 79.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Concierge Service',
        description:
          'Unlimited concierge service - 24 hours a day, 365 days a year. A dedicated personal service ready to assist you with travel, dining, shopping, entertainment, securing coveted reservations, and special perks and privileges',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Lyft Credit',
        description:
          'Take 3 rides, and get a $5 Lyft App credit every month with your Elite credit card',
        benefit_type: 'statement_credit',
        value: 60.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Purchase Assurance',
        description:
          'Purchase Assurance covers most purchases from damage or theft within 90 days of purchase up to $1,000',
        benefit_type: 'purchase_protection',
        value: 1000.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Cell Phone Protection',
        description:
          'Claim up to $800 if your cellphone is stolen or damaged using Cellular Wireless Telephone Protection',
        benefit_type: 'cell_phone_protection',
        value: 800.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'Mastercard ID Theft Protection',
        description:
          'Mastercard ID Theft Protection\u2122 and Identity Fraud Expense Reimbursement provide support and expense reimbursement if your identity is compromised through identity fraud.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 4000.0,
        spendRequirementMonths: 3,
        bonusValue: 60000,
        bonusValueUnit: 'points',
        description:
          'Earn 60,000 Welcome Bonus Points, worth up to $900 in travel, when booked through HSBC Travel, after spending $4,000 in the first 3 months of opening the card.',
      },
    ],
    cardType: 'personal',
    imageName: 'hsbc_elite_credit_card.jpg',
  },
  [CreditCard.SAMS_CLUB_CREDIT_CARD]: {
    id: CreditCard.SAMS_CLUB_CREDIT_CARD,
    name: 'sams_club_credit_card',
    apply_link:
      "https://www.samsclub.com/account/credit-app-login?refsite=MPAN&intcmp=NoOff_Sam's Club credit card_credit cards_body-catalog-cards_ext",
    learn_more_link:
      "https://www.samsclub.com/account/credit-app-login?refsite=MPAN&intcmp=NoOff_Sam's Club credit card_credit cards_body-catalog-cards_ext",
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl:
      'https://scene7.samsclub.com/is/image/samsclub/CC_Landingpage_Web?fmt=png-alpha&op_sharpen=1&wid=170',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
    imageName:
      'sams_club_credit_card.com/is/image/samsclub/CC_Landingpage_Web?fmt=png-alpha&op_sharpen=1&wid=170',
  },
  [CreditCard.ASHLEY_ADVANTAGE_CREDIT_CARD]: {
    id: CreditCard.ASHLEY_ADVANTAGE_CREDIT_CARD,
    name: 'Ashley Advantage\u00ae Credit Card',
    apply_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=565510A04C0A508AC067D9B072C9D4F57DB34A98269D02B5&client=Ashley%20Furniture%20HomeStore&icid=Financing-Synchrony-Apply&_gl=1*ygysck*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMjUwLjAuMC4w&intcmp=NoOff_Ashley Advantage\u00ae Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=565510A04C0A508AC067D9B072C9D4F57DB34A98269D02B5&client=Ashley%20Furniture%20HomeStore&icid=Financing-Synchrony-Apply&_gl=1*ygysck*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMjUwLjAuMC4w&intcmp=NoOff_Ashley Advantage\u00ae Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl:
      'https://etail.mysynchrony.com/cs/groups/public/documents/et_imagetype/etimg076570.png',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'Purchase APR 34.99%. Penalty APR 39.99%. Min Interest Charge $2. A promo fee will be charged equal to 2% of the amount financed on an equal payment no interest promotion of 18 months or more. Subject to credit approval. See ashleyfurniture.com/financing for details.',
    cardNetwork: null,
    issuer: 'Synchrony',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'ashley_advantage_credit_card.png',
  },
  [CreditCard.GOOGLE_STORE_FINANCING]: {
    id: CreditCard.GOOGLE_STORE_FINANCING,
    name: 'google_store_financing',
    apply_link:
      'https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fstore.google.com%2Fus%2Fmagazine%2Ffinancing%3Fhl%3Den-US%26initApply%3Dtrue&hl=en-US&ifkv=AXo7B7U7AkpmW6C8q0JjnoiEFK1ZC_25kyM9KGtV21aNDStfyZZJIEnHi110OuYxFI1jigEWW9t6Tw&flowName=GlifWebSignIn&flowEntry=ServiceLogin&dsh=S-653781164%3A1692736540693212&intcmp=NoOff_Google Store Financing_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fstore.google.com%2Fus%2Fmagazine%2Ffinancing%3Fhl%3Den-US%26initApply%3Dtrue&hl=en-US&ifkv=AXo7B7U7AkpmW6C8q0JjnoiEFK1ZC_25kyM9KGtV21aNDStfyZZJIEnHi110OuYxFI1jigEWW9t6Tw&flowName=GlifWebSignIn&flowEntry=ServiceLogin&dsh=S-653781164%3A1692736540693212&intcmp=NoOff_Google Store Financing_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
  },
  [CreditCard.REAL_REWARDS_CREDIT_CARD]: {
    id: CreditCard.REAL_REWARDS_CREDIT_CARD,
    name: 'Real Rewards\u00ae credit card',
    apply_link:
      'https://apply.syf.com/eapply/eapply.action?clientCode=AE&intcmp=NoOff_Real Rewards Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://apply.syf.com/eapply/eapply.action?clientCode=AE&intcmp=NoOff_Real Rewards Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://apply.syf.com/cs/groups/public/documents/et_imagetype/etimg046516.png',
    rewardsSummary: 'Earn cash back rewards on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: null,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Real Rewards credit card offers an extra 20% off your first purchase when you open and use your card.  There is no annual fee, and you'll earn cash back rewards on all purchases.  See terms and conditions for details.",
    cardNetwork: 'Visa',
    issuer: 'Synchrony',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'real_rewards_credit_card.png',
  },
  [CreditCard.MYLOWES_REWARDS_CREDIT_CARD]: {
    id: CreditCard.MYLOWES_REWARDS_CREDIT_CARD,
    name: 'mylowes_rewards_credit_card',
    apply_link:
      "https://www.lowes.com/u/register/creditapp?cardType=LAC&diy=true&clientCode=LOWES&sitecode=lwMS24lan&intcmp=NoOff_MyLowe's Rewards Credit Card_credit cards_body-catalog-cards_ext",
    learn_more_link:
      "https://www.lowes.com/u/register/creditapp?cardType=LAC&diy=true&clientCode=LOWES&sitecode=lwMS24lan&intcmp=NoOff_MyLowe's Rewards Credit Card_credit cards_body-catalog-cards_ext",
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
  },
  [CreditCard.ROOMS_TO_GO_CREDIT_CARD]: {
    id: CreditCard.ROOMS_TO_GO_CREDIT_CARD,
    name: 'Rooms To Go Credit Card',
    apply_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=72D604A6DC14650CBC0382E5D3916FEFAC9588579FD11A00&client=Rooms%20To%20Go&_gl=1*wa2kmw*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMTU4LjAuMC4w&intcmp=NoOff_Rooms To Go Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=72D604A6DC14650CBC0382E5D3916FEFAC9588579FD11A00&client=Rooms%20To%20Go&_gl=1*wa2kmw*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMTU4LjAuMC4w&intcmp=NoOff_Rooms To Go Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl:
      'https://etail.mysynchrony.com/cs/groups/public/documents/et_imagetype/etimg094702.jpg',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      '50 Months Special Financing* On purchases of $1,475 and up. Now through 2/17/25.  Rooms To Go requires a down payment equal to sales tax and delivery.',
    cardNetwork: null,
    issuer: 'Synchrony',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'rooms_to_go_credit_card.jpg',
  },
  [CreditCard.PAYPAL_CREDIT]: {
    id: CreditCard.PAYPAL_CREDIT,
    name: 'PayPal Credit',
    apply_link:
      'https://www.paypal.com/us/digital-wallet/ways-to-pay/credit-services/paypal-credit?intcmp=NoOff_PayPal Credit_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://www.paypal.com/us/digital-wallet/ways-to-pay/credit-services/paypal-credit?intcmp=NoOff_PayPal Credit_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link:
      'https://www.paypal.com/credit-application/paypal-credit/da/us/landing?intcmp=NoOff_PayPal%20Credit_credit%20cards_body-catalog-cards_ext',
    bank_name: 'Synchrony',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.paypalobjects.com/marketing/web23/us/en/ppe/paypal-credit/hero_size-mobile-up.jpg?quality=75&width=300',
    rewardsSummary:
      'PayPal Credit offers 6 months of special financing on purchases of $149 or more, with no interest if paid in full within 6 months.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      "PayPal Credit is a digital, reusable credit line that lets you buy now and pay over time.  Enjoy special financing and Purchase Protection on eligible purchases.  There's no annual fee.",
    cardNetwork: null,
    issuer: 'Synchrony Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'paypal_credit.jpg?quality=75&width=300',
  },
  [CreditCard.VERIZON_VISA_CARD]: {
    id: CreditCard.VERIZON_VISA_CARD,
    name: 'Verizon Visa\u00ae Card',
    apply_link:
      'https://www.verizon.com/solutions-and-services/verizon-visa-card?intcmp=NoOff_Verizon Visa Card_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://www.verizon.com/solutions-and-services/verizon-visa-card?intcmp=NoOff_Verizon Visa Card_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'cash_back',
    creditCardImageUrl: '',
    rewardsSummary:
      'Earn up to 4% cash back on purchases at grocery stores, gas stations, restaurants, and Verizon, plus 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'grocery',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'verizon',
        earnRate: 4.0,
        excludeMerchants: ['bill payment'],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Verizon Visa\u00ae Card offers rewards of up to 4% on various spending categories, including groceries, gas, dining, and Verizon purchases (excluding bill payments), and 1% on all other purchases.  There's no annual fee and no limit on rewards earned.  Rewards are redeemable towards Verizon purchases, including your bill.",
    cardNetwork: 'Visa',
    issuer: 'Synchrony Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'statement_credit',
        description:
          'Get $50 as a statement credit when you open an account and make one purchase in the first 90 days. Get an additional $100 statement credit when you spend $1,500 using your card in the first 90 days.',
        benefit_type: 'statement_credit',
        value: 150.0,
        value_unit: 'dollars',
        spend_requirement: '$1,500 in qualifying purchases within 90 days',
      },
      {
        name: 'Verizon bill discount',
        description:
          'New enrollees to Verizon\u2019s Auto Pay can get up to $10/mo off each eligible wireless phone line, up to 12 lines max (depending on plan) and/or $10/mo off each eligible Fios service.',
        benefit_type: 'statement_credit',
        value: 10.0,
        value_unit: 'dollars',
        spend_requirement:
          "Enrollment in Verizon's Auto Pay and paper-free billing",
      },
      {
        name: '0% financing',
        description:
          'Verizon Wireless customers get 0% financing with 12 equal monthly payments on accessory purchases, each totaling $100 or more, exclusively with a Verizon Visa\u00ae Card.',
        benefit_type: 'financing',
        value: null,
        value_unit: null,
        spend_requirement: '$100 or more on accessories',
      },
    ],
    signupBonus: [
      {
        spendRequirement: null,
        spendRequirementMonths: null,
        bonusValue: 50.0,
        bonusValueUnit: 'dollars',
        description:
          'Get a $50 statement credit when you open an account and make your first purchase within 90 days.  Get an additional $100 statement credit when you spend $1,500 in the first 90 days.',
      },
    ],
    cardType: 'personal',
  },
  [CreditCard.SYNCHRONY_LUXURY_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_LUXURY_CREDIT_CARD,
    name: 'Synchrony Luxury Credit Card',
    apply_link: 'https://www.mysynchrony.com/luxury/cardholder.html',
    learn_more_link: 'https://www.mysynchrony.com/luxury/cardholder.html',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary:
      'The Synchrony Luxury Credit Card allows you to make jewelry purchases and pay over time, accepted at over 4000 retailers nationwide.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'The Synchrony Luxury Credit Card lets you buy jewelry and pay over time with promotional financing available at participating retailers.  Enjoy dedicated credit limits, 24/7 online account access, and no annual fee. Find a retailer near you!',
    cardNetwork: null,
    issuer: 'Synchrony',
    selectableCategories: [],
    benefits: [
      {
        name: 'Promotional Financing',
        description:
          'Promotional financing is available at retailers that accept your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Dedicated credit limit',
        description: 'Dedicated credit limit',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '24/7 secure online account access',
        description: '24/7 secure online account access',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: '$0 fraud liability',
        description: '$0 fraud liability',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No annual fee',
        description: 'No annual fee',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free access to your credit score',
        description: 'Free access to your credit score',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.SYNCHRONY_SEWING__MORE_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_SEWING__MORE_CREDIT_CARD,
    name: 'Sewing & More credit card',
    apply_link:
      'https://www.sewingandmore.synchrony365.com?intcmp=NoOff_Synchrony Sewing & More Credit Card_credit cards_body-catalog-cards_synchrony_int',
    learn_more_link:
      'https://www.sewingandmore.synchrony365.com?intcmp=NoOff_Synchrony Sewing & More Credit Card_credit cards_body-catalog-cards_synchrony_int',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl:
      'https://www.sewingandmore.synchrony365.com/images/Card-SewingAndMore.png',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'Promotional financing with the Sewing & More credit card makes it easy to take the sewing machine and other crafty tools you need home\u2014today.*  Exclusive 6-month promotional financing on purchases of $150+ available every day with the Sewing & More credit card.  Additional options may be available; see a sewing retailer near you for details.',
    cardNetwork: null,
    issuer: 'Synchrony',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'synchrony_sewing__more_credit_card.png',
  },
  [CreditCard.JCPENNEY_CREDIT_CARD]: {
    id: CreditCard.JCPENNEY_CREDIT_CARD,
    name: 'JCPenney Credit Card',
    apply_link:
      'https://apply.syf.com/eapply/eapply.action?clientCode=JCPCON&sitecode=jcawe0y01&intcmp=NoOff_JCPenney Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://apply.syf.com/eapply/eapply.action?clientCode=JCPCON&sitecode=jcawe0y01&intcmp=NoOff_JCPenney Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://apply.syf.com/cs/groups/public/documents/et_imagetype/etimg062893.jpg',
    rewardsSummary:
      'Earn 1.5 JCPenney CashPass Points for every $1 spent at JCPenney stores or jcp.com, and redeem points for $10 JCPenney CashPass Rewards.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.5,
        excludeMerchants: [],
        spendCap: 2000,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The JCPenney Credit Card offers an extra 35% off select purchases upon approval, plus JCPenney Rewards where you earn 1.5 points per $1 spent at JCPenney.  Cardholders automatically enroll in the JCPenney Rewards program.',
    cardNetwork: 'Mastercard',
    issuer: 'Synchrony Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'jcpenney_credit_card.jpg',
  },
  [CreditCard.VENMO_VISA_CREDIT_CARD]: {
    id: CreditCard.VENMO_VISA_CREDIT_CARD,
    name: 'Venmo Credit Card',
    apply_link:
      'https://venmo.com/about/creditcard?intcmp=NoOff_Venmo Visa<sup>\u00ae</sup> Credit Card_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://venmo.com/about/creditcard?intcmp=NoOff_Venmo Visa<sup>\u00ae</sup> Credit Card_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link:
      'https://www.synchronybankterms.com/gecrbterms/html/VenmoApplyTerms_combo.htm?intcmp=NoOff_Venmo Visa<sup>\u00ae</sup> Credit Card_credit cards_body-catalog-cards_syfbank_int',
    bank_name: 'Synchrony',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://images.ctfassets.net/gkyt4bl1j2fs/2gmzLkSclqY22w0ax0APFI/2713c5d459bf612f8f1533915eef0327/Venmo_CC_Shot4_Fan_Multicolor_1_copy.png?w=1906&h=1312&q=50&fm=png&bg=transparent',
    rewardsSummary:
      'Get rewarded for everyday purchases with up to 3% cash back on eligible purchases, automatically earned across eight spend categories.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'topSpendCategory',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'secondSpendCategory',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Venmo Credit Card offers unlimited cash back rewards with up to 3% back on eligible purchases across eight categories.  Manage your card and rewards easily within the Venmo app, and pay with Apple Pay, Google Pay, or Samsung Pay.',
    cardNetwork: 'Visa',
    issuer: 'Synchrony Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Split the bill',
        description:
          'Your card comes with a unique QR code that links to your Venmo account. Have friends scan it to pay for their share of dinner.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Manage everything in the app',
        description:
          'Track spending, rewards, and crypto purchases right from your phone - all with Venmo.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Start earning cash back ASAP',
        description:
          'Once approved, you can find your virtual card number in the app, and shop online before your physical card arrives.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Tap into exclusive Visa\u00ae features',
        description:
          'Your card comes with Visa Credit Card benefits like touch-free shopping, worry-free security, and more. Plus, Visa Signature\u00ae cardholders get extra travel and lifestyle perks.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName:
      'venmo_visa_credit_card.png?w=1906&h=1312&q=50&fm=png&bg=transparent',
  },
  [CreditCard.SYNCHRONY_MUSIC__SOUND_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_MUSIC__SOUND_CREDIT_CARD,
    name: 'Synchrony Music & Sound Credit Card',
    apply_link: null,
    learn_more_link: null,
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.CARECREDIT_CREDIT_CARD]: {
    id: CreditCard.CARECREDIT_CREDIT_CARD,
    name: 'CareCredit Credit Card',
    apply_link:
      'https://www.carecredit.com/apply?intcmp=NoOff_CareCredit Credit Card_credit cards_body-catalog-cards_apply_int',
    learn_more_link:
      'https://www.carecredit.com/apply?intcmp=NoOff_CareCredit Credit Card_credit cards_body-catalog-cards_apply_int',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.MYWALGREENS_CREDIT_CARD]: {
    id: CreditCard.MYWALGREENS_CREDIT_CARD,
    name: 'myWalgreens Credit Card',
    apply_link:
      'https://www.walgreens.com/mywalgreens/cards/credit.jsp?BAN=SYFPP&sitecode=WGDCOMSFPP&intcmp=NoOff_myWalgreens Credit Card_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://www.walgreens.com/mywalgreens/cards/credit.jsp?BAN=SYFPP&sitecode=WGDCOMSFPP&intcmp=NoOff_myWalgreens Credit Card_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SYNCHRONY_HOME_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_HOME_CREDIT_CARD,
    name: 'Synchrony HOME Credit Card',
    apply_link: 'https://www.mysynchrony.com/home/partners.html',
    learn_more_link: 'https://www.mysynchrony.com/home/partners.html',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.QCARD_CREDIT_CARD]: {
    id: CreditCard.QCARD_CREDIT_CARD,
    name: 'QCard Credit Card',
    apply_link:
      'https://www.qvc.com/content/featured/q-card-benefits.html?qq=ft&intcmp=NoOff_QCard Credit Card_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://www.qvc.com/content/featured/q-card-benefits.html?qq=ft&intcmp=NoOff_QCard Credit Card_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SYNCHRONY_OUTDOORS_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_OUTDOORS_CREDIT_CARD,
    name: 'Synchrony Outdoors Credit Card',
    apply_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=39E71C5BFDC38A5D0C22AD55F56CC0A1B21099576CFF7183&client=Synchrony%20Outdoors&intcmp=NoOff_Synchrony Outdoors Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=39E71C5BFDC38A5D0C22AD55F56CC0A1B21099576CFF7183&client=Synchrony%20Outdoors&intcmp=NoOff_Synchrony Outdoors Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SPORTING_GOODS_CREDIT_CARDS]: {
    id: CreditCard.SPORTING_GOODS_CREDIT_CARDS,
    name: 'Sporting Goods Credit Cards',
    apply_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=7EDBAEB071977CE856069387CF8853DE55FE0127E8B97CB4&client=Synchrony&intcmp=NoOff_Sporting Goods Credit Cards_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=7EDBAEB071977CE856069387CF8853DE55FE0127E8B97CB4&client=Synchrony&intcmp=NoOff_Sporting Goods Credit Cards_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.MATTRESS_FIRM_CREDIT_CARD]: {
    id: CreditCard.MATTRESS_FIRM_CREDIT_CARD,
    name: 'Mattress Firm Credit Card',
    apply_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=82FDD7321D7D37B5C83C98E11098A58D7F15AE5299CD8361&client=MattressFirmt&_gl=1*512y2e*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMzE3LjAuMC4w&intcmp=NoOff_Mattress Firm Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=82FDD7321D7D37B5C83C98E11098A58D7F15AE5299CD8361&client=MattressFirmt&_gl=1*512y2e*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMzE3LjAuMC4w&intcmp=NoOff_Mattress Firm Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.PAYPAL_CASHBACK_WORLD_MASTERCARD]: {
    id: CreditCard.PAYPAL_CASHBACK_WORLD_MASTERCARD,
    name: 'PayPal Cashback World Mastercard\u00ae',
    apply_link:
      'https://www.paypal.com/credit-application/co/landing?intcmp=NoOff_PayPal Cashback World Mastercard\u00ae_credit cards_body-catalog-cards_ext',
    learn_more_link:
      'https://www.paypal.com/credit-application/co/landing?intcmp=NoOff_PayPal Cashback World Mastercard\u00ae_credit cards_body-catalog-cards_ext',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link:
      'https://www.synchronycredit.com/gecrbterms/html/PayPalCashbackRewardsTerms.htm?intcmp=NoOff_PayPal Cashback World Mastercard\u00ae_credit cards_body-catalog-cards_synchrony_int',
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SYNCHRONY_HOME_IMPROVEMENT_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_HOME_IMPROVEMENT_CREDIT_CARD,
    name: 'Synchrony Home Improvement Credit Card',
    apply_link: 'https://www.synchrony.com/marketplace/home-improvement/',
    learn_more_link: 'https://www.synchrony.com/marketplace/home-improvement/',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SYNCHRONY_PREMIER_WORLD_MASTERCARD]: {
    id: CreditCard.SYNCHRONY_PREMIER_WORLD_MASTERCARD,
    name: 'Synchrony Premier World Mastercard\u00ae',
    apply_link:
      'https://apply.syf.com/eapply/eapply.action?clientCode=SYFMCPREM&intcmp=NoOff_Synchrony Premier World Mastercard<sup>\u00ae</sup>_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://www.synchrony.com/sites/syc/financing/synchrony-mastercards',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SYNCHRONY_CAR_CARE_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_CAR_CARE_CREDIT_CARD,
    name: 'Synchrony Car Care Credit Card',
    apply_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=ABB75F4E7839CB18E21D8DFC208DC369EAF15F97ABA1C619&client=SynchronyCarCare&intcmp=NoOff_Synchrony Car Care Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    learn_more_link:
      'https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=ABB75F4E7839CB18E21D8DFC208DC369EAF15F97ABA1C619&client=SynchronyCarCare&intcmp=NoOff_Synchrony Car Care Credit Card_credit cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata',
    terms_and_conditions_button_text: 'Get Details',
    terms_and_conditions_link: null,
    bank_name: 'Synchrony',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.SYNCHRONY_SAMS_CLUB_CREDIT_CARD]: {
    id: CreditCard.SYNCHRONY_SAMS_CLUB_CREDIT_CARD,
    fees: {
      annualFeeAmountDollars: null,
      annualFeeFirstYear: null,
      aprDescription: null,
      aprLow: null,
      aprHigh: null,
      balanceTransferApr: null,
      balanceTransferFee: null,
      zeroAprPeriodMonths: null,
      hasForeignTransactionFee: true,
      foreignTransactionFeePercent: null,
    },
    bank_name: 'Synchrony',
    name: 'synchrony_sams_club_credit_card',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
  },
  [CreditCard.MY_GM_REWARDS_MASTERCARD]: {
    id: CreditCard.MY_GM_REWARDS_MASTERCARD,
    name: 'My GM Rewards Mastercard',
    apply_link:
      'https://www.marcus.com/us/en/credit-cards/apply?partner=GM&pid=7276&prd=cc&chl=wb&cid=allcardshero&proid=SXAA23AOCX11&',
    learn_more_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/my-gm-rewards-card?.html&',
    terms_and_conditions_button_text: 'See Benefit Terms',
    terms_and_conditions_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/myr-benefit-terms?proid=SXAA23AOCX11',
    bank_name: 'Goldman Sachs',
    rewardsType: 'points',
    creditCardImageUrl:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/my-gm-rewards-card/_jcr_content/root/responsivegrid_1357540861/core_image.coreimg.82.1280.png/1707507952145/gm-card-fanout-highres.png',
    rewardsSummary:
      'Earn 7 points per $1 spent at GM and 4 points per $1 spent everywhere else.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 4.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
      {
        category: 'travel.airline.general',
        earnRate: 7.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'points',
      },
    ],
    creditScore: null,
    cardSummary:
      'Earn 4X points on all purchases with no annual fee!\u00b2 Earn 15,000 bonus points after spending $1,000 on the My GM Rewards\u00ae Mastercard\u00ae in your first 3 months. Plus, 0% Intro APR on purchases for the first 9 months; thereafter, variable APR of 19.24% to 29.24%, and no annual fee.',
    cardNetwork: 'Mastercard',
    issuer: 'Goldman Sachs Bank USA',
    selectableCategories: [],
    benefits: [
      {
        name: 'vehicle detailing allowance',
        description: '$50 annual vehicle detailing allowance.',
        benefit_type: 'statement_credit',
        value: 50.0,
        value_unit: 'dollars',
        spend_requirement: null,
      },
      {
        name: 'World Elite Mastercard benefits',
        description: 'World Elite Mastercard benefits',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [
      {
        spendRequirement: 1000.0,
        spendRequirementMonths: 3,
        bonusValue: 15000,
        bonusValueUnit: 'points',
        description:
          'Earn 15,000 bonus points after spending $1,000 on the My GM Rewards\u00ae Mastercard\u00ae in your first 3 months.',
      },
    ],
    cardType: 'personal',
    imageName: 'my_gm_rewards_mastercard.png',
  },
  [CreditCard.GM_EXTENDED_FAMILY_MASTERCARD]: {
    id: CreditCard.GM_EXTENDED_FAMILY_MASTERCARD,
    name: 'gm_extended_family_mastercard',
    apply_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/gm-extended-family-card?&',
    learn_more_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/gm-extended-family-card?&',
    terms_and_conditions_button_text: 'See Benefit Terms',
    terms_and_conditions_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/efc-benefit-terms?proid=SX5A23AOCX01',
    bank_name: 'Goldman Sachs',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
  },
  [CreditCard.GM_BUSINESS_MASTERCARD]: {
    id: CreditCard.GM_BUSINESS_MASTERCARD,
    name: 'gm_business_mastercard',
    apply_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/gm-business-card?.html&',
    learn_more_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/gm-business-card?.html&',
    terms_and_conditions_button_text: 'See Benefit Terms',
    terms_and_conditions_link:
      'https://www.marcus.com/us/en/credit-cards/gm-cards/smb-750',
    bank_name: 'Goldman Sachs',
    rewardsType: 'unknown',
    creditCardImageUrl: '',
    rewardsSummary: null,
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary: null,
    cardNetwork: null,
    issuer: null,
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: null,
  },
  [CreditCard.APPLE_CARD]: {
    id: CreditCard.APPLE_CARD,
    name: 'Apple Card',
    apply_link:
      'https://card.apple.com/apply/application?referrer=cid%3Dapy-200-10000036&start=false',
    learn_more_link: 'https://www.apple.com/apple-card/',
    terms_and_conditions_link: 'https://www.apple.com/apple-card/',
    bank_name: 'Goldman Sachs',
    rewardsType: 'cash_back',
    creditCardImageUrl: '',
    rewardsSummary:
      'Apple Card offers Daily Cash back rewards on every purchase, with higher rates for Apple Pay and select merchants.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.airline.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'travel.hotel.general',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "Apple Card is a titanium credit card with no fees, offering Daily Cash back rewards (1%, 2%, or 3% depending on the merchant and payment method) and tools to help manage your finances.  It's integrated with Apple Pay and the Wallet app for easy use and tracking.",
    cardNetwork: 'Mastercard',
    issuer: 'Goldman Sachs Bank USA',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
  },
  [CreditCard.PLATINUM_X5_VISA]: {
    id: CreditCard.PLATINUM_X5_VISA,
    name: 'Credit One Bank Platinum X5 Visa Signature',
    apply_link: 'https://www.creditonebank.com/credit-cards/platinum-x5-visa',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/platinum-x5-visa',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link:
      'https://www.creditonebank.com/terms/7ae?pc=WL43',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-x5-visa-signature-ruby-red.png',
    rewardsSummary:
      'Earn 5% cash back on the first $5,000 in eligible purchases each year, then 1% on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 5000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 5000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'internetCablePhone',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 5000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Credit One Bank Platinum X5 Visa Signature card offers 5% cash back on the first $5,000 spent annually on gas, groceries, and other select categories, then 1% cash back on all other purchases.  It also features contactless payments and zero fraud liability.',
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Contactless Payment',
        description:
          'Make purchases quickly and securely with contactless payment.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Fraud Liability',
        description:
          'Credit One Bank will cover fraudulent charges made on your card.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: 'Access your credit score online for free.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: 'Manage your account easily with our mobile app.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description:
          'Customize your notifications to receive alerts for specific transactions.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: 'Choose a payment due date that works for you.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'platinum_x5_visa.png',
  },
  [CreditCard.CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD,
    name: 'Credit One Bank American Express\u00ae Card',
    apply_link:
      'https://www.creditonebank.com/credit-cards/american-express-card',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/american-express-card',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link:
      'https://www.creditonebank.com/terms/7gg?pc=WKS2',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/preferred-amex-cobalt.png',
    rewardsSummary: 'Earn unlimited 1% cash back rewards on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Credit One Bank American Express Card offers unlimited 1% cash back on all purchases, plus Retail Protection for eligible items damaged or stolen within 90 days of purchase.  Enjoy special benefits and American Express Offers for enhanced shopping experiences.',
    cardNetwork: 'American Express',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Retail Protection',
        description:
          'Retail Protection covers you if an eligible item is damaged or stolen within 90 days of purchase.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'American Express Offers',
        description:
          "Experience a more rewarding way to shop, dine, travel, and more with access to American Express Offers that feature some of the nation's top brands.",
        benefit_type: 'rotating_quarterly_rewards',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Payment',
        description: null,
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Fraud Liability',
        description: null,
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: null,
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: null,
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description: null,
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: null,
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'credit_one_bank_american_express_card.png',
  },
  [CreditCard.PLATINUM_VISA_FOR_REBUILDING_CREDIT]: {
    id: CreditCard.PLATINUM_VISA_FOR_REBUILDING_CREDIT,
    name: 'Platinum Visa For Rebuilding Credit',
    apply_link:
      'https://www.creditonebank.com/credit-cards/platinum-visa-for-rebuilding-credit',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/platinum-visa-for-rebuilding-credit',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link:
      'https://www.creditonebank.com/terms/7ddd?pc=WL52',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-visa-blue.png',
    rewardsSummary: 'Earn 1% cash back on eligible purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Platinum Visa\u00ae Credit Card is perfect for everyday purchases and helps you rebuild your credit.  It offers 1% cash back on eligible purchases and credit line increase opportunities.',
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'platinum_visa_for_rebuilding_credit.png',
  },
  [CreditCard.CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD,
    name: 'Credit One Bank Wander\u00ae American Express\u00ae Card',
    apply_link:
      'https://www.creditonebank.com/credit-cards/wander-american-express',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/wander-american-express',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link:
      'https://www.creditonebank.com/terms/7as?pc=WX89',
    bank_name: 'Credit One',
    rewardsType: 'amex_mr',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/wander-amex-ocean.png',
    rewardsSummary:
      'Earn 10X points on eligible hotels and car rentals booked through Credit One Bank travel partners, 5X points on eligible travel purchases, and 1X point on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.hotel',
        earnRate: 10.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'travel.airline.general',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'amex_mr',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Credit One Bank Wander American Express Card offers 10X points on eligible hotel and car rentals booked through Credit One Bank travel partners, 5X points on eligible travel purchases, and 1X point on all other purchases.  Redeem points for statement credits, gift cards, travel, merchandise, and more.  This card has a $95 annual fee and a variable APR of 28.99%.',
    cardNetwork: 'American Express',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Contactless Payment',
        description: 'Make purchases using contactless payment technology.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Fraud Liability',
        description:
          'Credit One Bank will not hold you responsible for unauthorized charges.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: 'Access your credit score online for free.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: 'Manage your account through a user-friendly mobile app.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description:
          'Set up customized notifications to stay informed about your account activity.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: 'Select a new payment due date that works best for you.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'credit_one_bank_wander_american_express_card.png',
  },
  [CreditCard.PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE]: {
    id: CreditCard.PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE,
    name: 'Platinum Rewards Visa with No Annual Fee',
    apply_link: 'https://www.creditonebank.com/credit-cards/platinum-no-fee',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/platinum-no-fee',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link: 'https://www.creditonebank.com/terms/7h?pc=WL39',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-no-fee.png',
    rewardsSummary:
      'This card earns 2% cash back on eligible purchases of gas, grocery, internet, cable and satellite TV, and mobile phone services.',
    rewardsEarnRates: [
      {
        category: 'gas',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'internetCablePhone',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      "The Platinum Rewards Visa with No Annual Fee offers 2% cash back on eligible purchases in key categories like gas, groceries, and utilities, plus 1% on all other purchases.  There's no annual fee, and the card comes with benefits like zero fraud liability and free online access to your credit score.",
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Zero Fraud Liability',
        description:
          'Credit One Bank will not hold you responsible for unauthorized charges.',
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: 'Access your credit score online at no additional cost.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: 'Manage your account easily through our mobile app.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description:
          'Set up custom alerts to stay informed about your account activity.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: 'Select a payment due date that works best for you.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'platinum_rewards_visa_with_no_annual_fee.png',
  },
  [CreditCard.PLATINUM_VISA]: {
    id: CreditCard.PLATINUM_VISA,
    name: 'Platinum Visa',
    apply_link:
      'https://www.creditonebank.com/credit-cards/platinum-suite-visa',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/platinum-suite-visa',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link: 'https://www.creditonebank.com/terms/7g?pc=WL40',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-suite-visa.png',
    rewardsSummary:
      'Earn unlimited 1% cash back rewards on eligible gas, grocery, mobile phone, internet, cable, and satellite TV service purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'internetCablePhone',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Platinum Visa\u00ae Credit Card offers unlimited 1% cash back rewards on eligible purchases, including gas, groceries, and everyday services.  Enjoy a free credit score and other valuable benefits.',
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Contactless Payment',
        description:
          'Make purchases quickly and securely with contactless payment.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Fraud Liability',
        description: 'You are not responsible for unauthorized charges.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: 'Access your credit score online at no cost.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: 'Manage your account conveniently through our mobile app.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description:
          'Set up custom alerts to stay informed about your account activity.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: 'Select a payment due date that works best for you.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'platinum_visa.png',
  },
  [CreditCard.SECURED_CARD]: {
    id: CreditCard.SECURED_CARD,
    name: 'Secured Card',
    apply_link: 'https://www.creditonebank.com/credit-cards/secured-card-visa',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/secured-card-visa',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link:
      'https://www.creditonebank.com/terms/7rr?pc=WSB1',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/secured-yellow.png',
    rewardsSummary:
      'Earn 1% cash back rewards on eligible gas and groceries as well as your monthly mobile phone, internet, cable, and satellite TV services.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'Build or rebuild credit and secure your financial future with our Secured Card.  Earn 1% cash back on eligible purchases and enjoy benefits like contactless payments and zero fraud liability. Your security deposit earns interest!',
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Zero Fraud Liability',
        description: "We'll cover you for unauthorized charges.",
        benefit_type: 'purchase_protection',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Contactless Payment',
        description: 'Make quick and easy payments with your contactless card.',
        benefit_type: 'contactless',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: 'Monitor your credit score for free.',
        benefit_type: 'credit_score',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: 'Manage your account on the go with our mobile app.',
        benefit_type: 'mobile_app',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description:
          'Set up custom alerts to stay informed about your account activity.',
        benefit_type: 'alerts',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: 'Select a payment due date that works best for you.',
        benefit_type: 'payment_due_date',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'secured_card.png',
  },
  [CreditCard.NASCAR_AMERICAN_EXPRESS_CARD]: {
    id: CreditCard.NASCAR_AMERICAN_EXPRESS_CARD,
    name: 'NASCAR\u00ae American Express\u00ae Card',
    apply_link:
      'https://www.creditonebank.com/credit-cards/american-express-nascar',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/american-express-nascar',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link:
      'https://www.creditonebank.com/pre-qualification/terms/nascar-amex-all-terms',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/nascar-amex.png',
    rewardsSummary: 'Earn unlimited 1% cash back rewards on all purchases.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Average to Excellent',
    cardSummary:
      "The NASCAR\u00ae American Express\u00ae Card offers unlimited 1% cash back on all purchases and comes with benefits like Retail Protection.  It's a great choice for NASCAR fans with average to excellent credit.",
    cardNetwork: 'American Express',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'nascar_american_express_card.png',
  },
  [CreditCard.VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD]: {
    id: CreditCard.VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD,
    name: 'Vegas Golden Knights Credit Card',
    apply_link:
      'https://www.creditonebank.com/credit-cards/vegas-golden-knights-visa',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/vegas-golden-knights-visa',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link: 'https://www.creditonebank.com/terms/4e?pc=WGM2',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/vbc-visa-gold.png',
    rewardsSummary:
      'Earn 1% cash back on eligible gas, groceries, mobile phone, internet, cable, and satellite TV services.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'grocery',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'internetCablePhone',
        earnRate: 0.01,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Vegas Golden Knights Credit Card offers 1% cash back on eligible purchases, including gas, groceries, and monthly services.  Show your team pride with this stunning card and enjoy exclusive offers and deals designed for Vegas Golden Knights fans.',
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'vegas_golden_knights_credit_card.png',
  },
  [CreditCard.BEST_FRIENDS_CREDIT_CARD]: {
    id: CreditCard.BEST_FRIENDS_CREDIT_CARD,
    name: 'Best Friends<sup>\u00ae</sup> Credit Card',
    apply_link: 'https://www.creditonebank.com/credit-cards/best-friends-visa',
    learn_more_link:
      'https://www.creditonebank.com/credit-cards/best-friends-visa',
    terms_and_conditions_button_text: 'Terms, fees & conditions',
    terms_and_conditions_link: 'https://www.creditonebank.com/terms/1m?pc=WB12',
    bank_name: 'Credit One',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/best-friends-orange.png',
    rewardsSummary:
      'Earn 5% cash back on eligible pet purchases up to $5,000 per year, then 1% thereafter, plus 1% of eligible purchases is donated to Best Friends Animal Society.',
    rewardsEarnRates: [
      {
        category: 'petPurchases',
        earnRate: 5.0,
        excludeMerchants: [],
        spendCap: 5000.0,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: 'Average to Excellent',
    cardSummary:
      'The Best Friends Credit Card offers 5% cash back on pet purchases (up to $5,000 per year), 1% cash back on all other purchases, and donates 1% of eligible purchases to Best Friends Animal Society.  It has a $0 annual fee and a variable APR.',
    cardNetwork: 'Visa',
    issuer: 'Credit One Bank',
    selectableCategories: [],
    benefits: [
      {
        name: 'Contactless Payment',
        description:
          'Make purchases quickly and easily with contactless payment.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Fraud Liability',
        description: 'You are protected from unauthorized charges.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Free Online Access to Credit Score',
        description: 'Monitor your credit score for free.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Easy-To-Use Mobile App',
        description: 'Manage your account on the go.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Customizable Notifications',
        description: 'Set up alerts for important account activity.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Choose a New Payment Due Date',
        description: 'Select a payment due date that works for you.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName: 'best_friends_credit_card.png',
  },
  [CreditCard.EVERGREENBY_FNBO_CREDIT_CARD]: {
    id: CreditCard.EVERGREENBY_FNBO_CREDIT_CARD,
    name: 'Evergreen<sup>\u00ae</sup>by FNBO Credit Card',
    apply_link: 'https://www.fnbo.com/personal-banking/credit-cards',
    learn_more_link:
      'https://www.fnbo.com/personal-banking/credit-cards/evergreen',
    terms_and_conditions_button_text: 'Summary of Credit Terms',
    terms_and_conditions_link:
      'https://www.firstbankcard.com/lynx/#/soct/XK6RTT9FBSJ5Z',
    bank_name: 'FNBO',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://s7d1.scene7.com/is/image/fnnistage/evergreen-1?ts=1729190341294&$TransparentPNG$&dpr=off',
    rewardsSummary: 'Earn unlimited 2% cash back on every purchase, every day.',
    rewardsEarnRates: [
      {
        category: 'allPurchases',
        earnRate: 2.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Evergreen<sup>\u00ae</sup>by FNBO Credit Card offers unlimited 2% cash back on every purchase, every day, with no annual fee.  A $200 cash bonus is available when you spend $1,000 in the first 3 billing cycles.',
    cardNetwork: 'Visa',
    issuer: 'First National Bank of Omaha (FNBO<sup>\u00ae</sup>)',
    selectableCategories: [],
    benefits: [
      {
        name: 'cash_bonus',
        description:
          'A $200 cash bonus is available when you spend $1,000 in the first 3 billing cycles.',
        benefit_type: 'statement_credit',
        value: 200.0,
        value_unit: 'dollars',
        spend_requirement: '$1,000',
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName:
      'evergreenby_fnbo_credit_card.com/is/image/fnnistage/evergreen-1?ts=1729190341294&$TransparentPNG$&dpr=off',
  },
  [CreditCard.GETAWAY_BY_FNBOCREDIT_CARD]: {
    id: CreditCard.GETAWAY_BY_FNBOCREDIT_CARD,
    name: 'Getaway by FNBO\u00ae Credit Card',
    apply_link: 'https://www.fnbo.com/personal-banking/credit-cards',
    learn_more_link:
      'https://www.fnbo.com/personal-banking/credit-cards/getaway',
    terms_and_conditions_button_text: 'Summary of Credit Terms',
    terms_and_conditions_link:
      'https://www.firstbankcard.com/lynx/#/soct/Y3WJZY42RTGMC',
    bank_name: 'FNBO',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://s7d1.scene7.com/is/image/fnnistage/getaway-mastercard-front?ts=1677689616898&$TransparentPNG$&dpr=off',
    rewardsSummary:
      'Earn unlimited 3x points per dollar spent on travel, dining and gas, and 1 point per dollar on all other purchases.',
    rewardsEarnRates: [
      {
        category: 'travel.general',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'dining',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'gas',
        earnRate: 3.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
      {
        category: 'allPurchases',
        earnRate: 1.0,
        excludeMerchants: [],
        spendCap: null,
        spendMinimum: null,
        minimumTransactionCount: null,
        minimumTransactionAmount: null,
        rewardsType: 'cash_back',
      },
    ],
    creditScore: null,
    cardSummary:
      'The Getaway by FNBO\u00ae Credit Card earns unlimited 3x points on travel, dining, and gas purchases and 1 point per dollar on all other purchases.  Enjoy a 0% introductory APR for 12 billing cycles on purchases and balance transfers, and redeem rewards for travel, cash back, or a deposit.',
    cardNetwork: 'Mastercard',
    issuer: 'First National Bank of Omaha (FNBO)',
    selectableCategories: [],
    benefits: [
      {
        name: '0% introductory APR',
        description:
          '0% introductory APR for the first 12 billing cycles on purchases and balance transfers after account is opened.',
        benefit_type: 'apr',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Rewards expiration',
        description: 'No Rewards expiration.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Foreign Transaction Fee',
        description: 'No Foreign Transaction Fee.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'No Annual Fee',
        description: 'No Annual Fee.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Airport Concierge',
        description:
          'Receive 15% savings on personalized airport services like a dedicated agent to escort you through the airport at over 700 airports worldwide.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Global Services',
        description:
          'Provides expert assistance, whenever and wherever, for a replacement card or emergency cash.',
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
      {
        name: 'Zero Liability',
        description:
          "Our 24/7 guarantee that you won't be held responsible for fraudulent charges made with your card or account information.",
        benefit_type: 'other',
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName:
      'getaway_by_fnbocredit_card.com/is/image/fnnistage/getaway-mastercard-front?ts=1677689616898&$TransparentPNG$&dpr=off',
  },
  [CreditCard.SECURED_VISACREDIT_CARD]: {
    id: CreditCard.SECURED_VISACREDIT_CARD,
    name: 'Secured Visa\u00ae Credit Card',
    apply_link:
      'https://www.fnbo.com/personal-banking/credit-cards/visa-secured-card',
    learn_more_link:
      'https://www.fnbo.com/personal-banking/credit-cards/visa-secured-card',
    terms_and_conditions_button_text: 'Summary of Credit Terms',
    terms_and_conditions_link:
      'https://www.firstbankcard.com/lynx/#/soct/W79BJMLFR4GK2',
    bank_name: 'FNBO',
    rewardsType: 'cash_back',
    creditCardImageUrl:
      'https://s7d1.scene7.com/is/image/fnnistage/visa-green-diamond?ts=1708542293578&$TransparentPNG$&dpr=off',
    rewardsSummary:
      'No annual fee and a chance to get your deposit back with good payment history.',
    rewardsEarnRates: [],
    creditScore: null,
    cardSummary:
      'No annual fee. Request your own credit limit with a deposit between $300 and $5,000.  With good payment history, you may be eligible for a credit limit increase and/or get your deposit back.',
    cardNetwork: 'Visa',
    issuer: 'First National Bank of Omaha (FNBO)',
    selectableCategories: [],
    benefits: [
      {
        name: 'Roadside Dispatch',
        description:
          'Provides 24-hour access to roadside assistance like tire changing, jump starting or towing. The fees for this pay-per-use service are pre-negotiated and available exclusively to Visa cardmembers.',
        benefit_type: null,
        value: null,
        value_unit: null,
        spend_requirement: null,
      },
    ],
    signupBonus: [],
    cardType: 'personal',
    imageName:
      'secured_visacredit_card.com/is/image/fnnistage/visa-green-diamond?ts=1708542293578&$TransparentPNG$&dpr=off',
  },
} as Record<CreditCard, RawCardData>;